/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += " supports-touch";
}

if (console && console.log) {
  console.log(
    "Impulse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function () {
  "use strict";

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener("transitionend", removeClass);

      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }

      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace
          ? "focusout." + options.namespace
          : "focusout",
        keydown: options.namespace
          ? "keydown." + options.namespace
          : "keydown.handleFocus",
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";

      if (options.container) {
        options.container.removeAttribute("tabindex");
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add("lock-scroll");
      el.on("touchmove" + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove("lock-scroll");
      var el = element ? element : document.documentElement;
      el.off("touchmove" + namespace);
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    var superScript =
      theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");

          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return "620x"; // default based on theme
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === "master") {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    function lazyloadImagePath(string) {
      var image;

      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }

      return image;
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath,
    };
  })();

  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove("loading", "loading--delayed");
      container.classList.add("loaded");
    }

    function checkForLazyloadedImage() {
      return container.querySelector(".lazyloaded");
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector("svg")) {
      setAsLoaded();
      return;
    }

    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: "link",
      script: "script",
    };

    var status = {
      requested: "requested",
      loaded: "loaded",
    };

    var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

    var libraries = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: types.script,
      },
      vimeo: {
        tagId: "vimeo-api",
        src: "https://player.vimeo.com/api/player.js",
        type: types.script,
      },
      shopifyXr: {
        tagId: "shopify-model-viewer-xr",
        src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
        type: types.script,
      },
      modelViewerUi: {
        tagId: "shopify-model-viewer-ui",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement("script");
      tag.src = library.src;
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement("link");
      tag.href = library.src;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // // Wrap tables so they become scrollable on small screens
    // document.querySelectorAll(".rte table").forEach((table) => {
    //   var wrapWith = document.createElement("div");
    //   wrapWith.classList.add("table-wrapper");
    //   theme.utils.wrap(table, wrapWith);
    // });

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("video-wrapper");
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll(".rte a img").forEach((img) => {
      img.parentNode.classList.add("rte__image");
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      this.container
        .querySelectorAll(this.singleOptionSelector)
        .forEach((el) => {
          el.addEventListener("change", this._onSelectChange.bind(this));
        });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container
          .querySelectorAll(this.singleOptionSelector)
          .forEach((el) => {
            var type = el.getAttribute("type");

            if (type === "radio" || type === "checkbox") {
              if (el.checked) {
                result.push({
                  value: el.value,
                  index: el.dataset.index,
                });
              }
            } else {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function (option) {
            if (match) {
              match = variant[option.index] === option.value;
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function () {
        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variant: variant,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: variant,
            },
          })
        );

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (
          !variant.featured_image ||
          variantImage.src === currentVariantImage.src
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantImageChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        if (
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value =
          variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container
          .querySelector(this.originalSelectorId)
          .dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady().then(function () {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent("vimeoReady"));
    });
  };

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false,
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
        document.addEventListener("vimeoReady", this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector("iframe");
        this.iframe.setAttribute("tabindex", "-1");

        this.videoPlayer.setMuted(true);

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
  };

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document
            .getElementById(this.divId)
            .closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === "sound") {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("youtubeSdk");
        document.addEventListener("youTubeReady", this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute("tabindex", "-1");

        if (this.options.style !== "sound") {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.playVideo === "function"
        ) {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.pauseVideo === "function"
        ) {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return YouTube;
  })();

  // Patch Flickity resize event for iOS15 jank fix
  (function () {
    var originalResizeMethod = Flickity.prototype.resize;
    var lastWidth = window.innerWidth;

    Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    };
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener("touchstart", function (i) {
      if (!i.target.closest(".flickity-slider")) {
        return (e = !1);
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY,
      };
    });

    document.body.addEventListener(
      "touchmove",
      function (i) {
        if (e && i.cancelable) {
          var n = {
            x: i.touches[0].pageX - t.x,
            y: i.touches[0].pageY - t.y,
          };
          Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
        }
      },
      { passive: !1 }
    );
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true) {
        if (searchParams) this.appendPreservedParams(searchParams);

        const sectionRenders = this.sections.map((section) => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = (cachedSection) => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(searchParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(
          `[AjaxRenderer] rendering from cache: url=${cachedSection.url}`
        );
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch((err) => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`
        );

        const newDom = new DOMParser().parseFromString(html, "text/html");
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === "string") {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach((id) => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach((paramName) => {
          const param = new URLSearchParams(window.location.search).get(
            paramName
          );

          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          "",
          `${window.location.pathname}${
            searchParams && "?".concat(searchParams)
          }`
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName: window.Shopify.theme.name,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }
  theme.cart = {
    getCart: function () {
      var url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());

      url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";

      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then(function (response) {
        return response.text();
      });
    },

    changeItem: function (key, qty) {
      return this._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(function (cart) {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          note: theme.cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
          attribute = "";
        }
      }
      return attribute.trim();
    },
  };

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: "[data-products]",
      qtySelector: ".js-qty__wrapper",
      discounts: "[data-discounts]",
      savings: "[data-savings]",
      subTotal: "[data-subtotal]",
      subTotal2: "[data-subtotal2]",
      cartCount: ".data-cartCount",
      cartCount2: ".data-cartCount2",

      cartBubble: ".cart-link__bubble",
      cartNote: '[name="note"]',
      termsCheckbox: ".cart__terms-checkbox",
      checkoutBtn: ".cart__checkout",
    };

    var classes = {
      btnLoading: "btn--loading",
    };

    var config = {
      requiresTerms: false,
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = ".cart-" + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.subtotal2 = form.querySelector(selectors.subTotal2);
      this.cartCount = form.querySelector(selectors.cartCount);
      this.cartCount2 = form.querySelector(selectors.cartCount2);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener(
          "cart:quantity" + this.namespace,
          this.quantityChanged.bind(this)
        );

        this.form.on("submit" + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener("change", function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener(
          "cart:build",
          function () {
            this.buildCart();
          }.bind(this)
        );
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        return {
          items: doc.querySelector(".cart__items"),
          discounts: doc.querySelector(".cart__discounts"),
        };
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var subtotal2 = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove("is-empty");
        } else {
          this.wrapper.classList.add("is-empty");
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = "";
        this.products.append(items);

        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(
          subtotal,
          theme.settings.moneyFormat
        );
        this.subtotal2.innerHTML = theme.Currency.formatMoney(
          subtotal2,
          theme.settings.moneyFormat
        );
        this.cartCount.innerHTML = count;
        this.cartCount2.innerHTML = count;

        this.reInit();

        if (window.AOS) {
          AOS.refreshHard();
        }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = "";
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add("is-loading");
        }

        theme.cart
          .changeItem(key, qty)
          .then(
            function (cart) {
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              this.buildCart();

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {});
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML =
          theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSubtotal2: function (subtotal2) {
        this.form.querySelector(selectors.subTotal2).innerHTML =
          theme.Currency.formatMoney(subtotal2, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
          this.savings.classList.remove("hide");
          this.savings.innerHTML = theme.strings.cartSavings.replace(
            "[savings]",
            amount
          );
        } else {
          this.savings.classList.add("hide");
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll(".cart-link__bubble-num");

        if (countEls.length) {
          countEls.forEach((el) => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach((b) => {
              b.classList.add("cart-link__bubble--visible");
            });
          } else {
            bubbles.forEach((b) => {
              b.classList.remove("cart-link__bubble--visible");
            });
          }
        }
      },
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: ".collapsible-trigger",
      module: ".collapsible-content",
      moduleInner: ".collapsible-content__inner",
      tabs: ".collapsible-trigger--tab",
    };

    var classes = {
      hide: "hide",
      open: "is-open",
      autoHeight: "collapsible--auto-height",
      tabs: "collapsible-trigger--tab",
    };

    var namespace = ".collapsible";

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute("aria-expanded", state);

        trigger.off("click" + namespace);
        trigger.on("click" + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute("aria-controls");
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll(
          '[data-id="' + moduleId + '"]'
        );
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector(
            '[data-id="' + moduleId + '"]'
          );
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document
          .querySelectorAll(
            selectors.tabs + '[data-id="' + el.dataset.id + '"]'
          )
          .forEach((el) => {
            el.classList.remove(classes.open);
            newModule = document.querySelector(
              "#" + el.getAttribute("aria-controls")
            );
            setTransitionHeight(newModule, 0, true);
          });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute("aria-expanded", !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector(".spr-summary-actions-newreview");
        if (!btn) {
          return;
        }
        btn.off("click" + namespace);
        btn.on("click" + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + "px";
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css("height", "auto");
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: "[data-disclosure-form]",
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute("aria-expanded", false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute(
          "aria-expanded",
          !ariaExpanded
        );
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          "click",
          this.eventHandlers.onBodyClick
        );
      },
    });

    return Disclosure;
  })();

  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + name,
        openClass: "js-drawer-open",
        closingClass: "js-drawer-closing",
        activeDrawer: "drawer--is-open",
        namespace: ".drawer-" + name,
      };

      this.nodes = {
        page: document.querySelector("#MainContent"),
      };

      this.drawer = document.querySelector("#" + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach((openBtn) => {
          openBtn.setAttribute("aria-expanded", "false");
          openBtn.addEventListener("click", this.open.bind(this));
        });

        this.drawer
          .querySelector(this.config.close)
          .addEventListener("click", this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener(
          "modalOpen",
          function () {
            this.close();
          }.bind(this)
        );
      },

      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute("aria-expanded", "true");
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute("aria-expanded", "true");
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.add(this.config.activeDrawer);
          }.bind(this)
        );

        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerOpen"));
        document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id));

        this.bindEvents();
      },

      close: function (evt) {
        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest(".js-drawer-close")) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest(".drawer")) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.remove(this.config.activeDrawer);
          }.bind(this)
        );

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        window.setTimeout(
          function () {
            document.documentElement.classList.remove(this.config.closingClass);
            if (
              this.activeSource &&
              this.activeSource.getAttribute("aria-expanded")
            ) {
              this.activeSource.setAttribute("aria-expanded", "false");
              this.activeSource.focus();
            }
          }.bind(this),
          500
        );

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        this.unbindEvents();
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on(
          "click" + this.config.namespace,
          function (evt) {
            this.close(evt);
            return;
          }.bind(this)
        );

        // Pressing escape closes drawer
        window.on(
          "keyup" + this.config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off("click" + this.config.namespace);
        window.off("keyup" + this.config.namespace);

        theme.a11y.unlockMobileScrolling(
          this.config.namespace,
          this.nodes.page
        );
      },
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + name,
        openClass: "modal--is-active",
        closingClass: "modal--is-closing",
        bodyOpenClass: ["modal-open"],
        bodyOpenSolidClass: "modal-open--solid",
        bodyClosingClass: "modal-closing",
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector(".modal__inner");

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener("click", this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        "drawerOpen",
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = true;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          "aria-expanded",
          "true"
        );
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (evt.target.closest(".modal__inner")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          );
          this.modal.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false").focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        );
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        "keyup.modal",
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on("click.modal", this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");

      if (this.config.closeOffContentClick) {
        this.modal.off(".modal");
      }
    };

    return Modal;
  })();

  theme.parallaxSections = {};

  theme.Parallax = (function () {
    var speed = 0.85;
    var reset = false;

    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector(".parallax-image");
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;

      if (!this.container || !this.image) {
        return;
      }

      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener(
          "matchSmall",
          function () {
            this.destroy();
          }.bind(this)
        );

        document.addEventListener(
          "unmatchSmall",
          function () {
            this.init(true);
          }.bind(this)
        );
      }

      this.init(this.desktopOnly);
    }

    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function (desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }

        this.isInit = true;

        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }

        // Set position on page load
        this.setSizes();
        this.scrollHandler();

        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              this.isVisible = entry.isIntersecting;
              if (this.isVisible) {
                window.on("scroll" + this.namespace, this.onScroll.bind(this));
              } else {
                window.off("scroll" + this.namespace);
              }
            });
          },
          { rootMargin: "200px 0px 200px 0px" }
        );

        observer.observe(this.container);

        window.on(
          "resize" + this.namespace,
          theme.utils.debounce(250, this.setSizes.bind(this))
        );

        document.addEventListener(
          "shopify:section:reorder",
          theme.utils.debounce(250, this.onReorder.bind(this))
        );
      },

      onScroll: function () {
        if (!this.isVisible) {
          return;
        }

        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }

        requestAnimationFrame(this.scrollHandler.bind(this));
      },

      scrollHandler: function () {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform =
          "translate3d(0, " + shiftDistance + "px, 0)";
      },

      setSizes: function () {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },

      onReorder: function () {
        this.setSizes();
        this.onScroll();
      },

      destroy: function () {
        this.image.style.transform = "none";
        window.off("scroll" + this.namespace);
        window.off("resize" + this.namespace);
      },
    });

    return parallax;
  })();

  if (typeof window.noUiSlider === "undefined") {
    throw new Error(
      "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
    );
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: ".price-range",
      priceRangeSlider: ".price-range__slider",
      priceRangeInputMin: ".price-range__input-min",
      priceRangeInputMax: ".price-range__input-max",
      priceRangeDisplayMin: ".price-range__display-min",
      priceRangeDisplayMax: ".price-range__display-max",
    };

    function PriceRange(
      container,
      { onChange, onUpdate, ...sliderOptions } = {}
    ) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains("price-range")) {
          throw new Error(
            "You must instantiate PriceRange with a valid container"
          );
        }

        this.formEl = this.container.closest("form");
        this.sliderEl = this.container.querySelector(
          selectors.priceRangeSlider
        );
        this.inputMinEl = this.container.querySelector(
          selectors.priceRangeInputMin
        );
        this.inputMaxEl = this.container.querySelector(
          selectors.priceRangeInputMax
        );
        this.displayMinEl = this.container.querySelector(
          selectors.priceRangeDisplayMin
        );
        this.displayMaxEl = this.container.querySelector(
          selectors.priceRangeDisplayMax
        );

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue =
          parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (
          this.sliderEl &&
          this.sliderEl.noUiSlider &&
          typeof this.sliderEl.noUiSlider.destroy === "function"
        ) {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on("update", (values) => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on("change", (values) => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-to-cart";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");

        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
              }

              status.loading = false;
              this.addToCart.classList.remove("btn--loading");

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: "[data-product-single-media-group]",
      xrButton: "[data-shopify-xr]",
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector("model-viewer");
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: setupShopifyXr,
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load("modelViewerUiStyles");
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector("#ModelJson-" + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener("mediaVisible", function () {
        xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener("mediaHidden", function () {
        xrButton.element.setAttribute(
          "data-shopify-model3d-id",
          xrButton.defaultId
        );
        model.modelViewerUi.pause();
      });

      model.container.addEventListener("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute("min") || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this)
        );

        this.minus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this)
        );

        this.input.addEventListener(
          "change",
          function (evt) {
            this._change(this._getQty());
          }.bind(this)
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll(".grid-product");

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach((product) => {
      product.addEventListener("mouseover", productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      //if (!theme.config.bpSmall) {
      el.removeEventListener("mouseover", productMouseover);
      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var handle = el.dataset.productHandle;
      var btn = el.querySelector(".quick-product__btn");
      theme.preloadProductModal(handle, productId, btn);
      //}
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById("QuickShopHolder-" + handle);
    var url = theme.routes.home + "/products/" + handle + "?view=modal";

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace("//", "/");

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var div = doc.querySelector(
          '.product-section[data-product-handle="' + handle + '"]'
        );

        if (!holder) {
          return;
        }

        holder.innerHTML = "";
        holder.append(div);

        // Setup quick view modal
        var modalId = "QuickShopModal-" + productId;
        var name = "quick-modal-" + productId;
        new theme.Modals(modalId, name);

        // Register product template inside quick view
        theme.sections.register("product", theme.Product, holder);

        // Register collapsible elements
        theme.collapsibles.init();

        // Register potential video modal links (when video has sound)
        theme.videoModal();

        if (btn) {
          btn.classList.remove("quick-product__btn--not-ready");
        }
      });
  };

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: "animate-out",
      isPaused: "is-paused",
      isActive: "is-active",
    };

    var selectors = {
      allSlides: ".slideshow__slide",
      currentSlide: ".is-selected",
      wrapper: ".slideshow-wrapper",
      pauseButton: ".slideshow__pause",
    };

    var productSelectors = {
      thumb: ".product__thumb-item:not(.hide)",
      links: ".product__thumb-item:not(.hide) a",
      arrow: ".product__thumb-arrow",
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        );
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        );
        this.arrows = this.args.childNav.querySelectorAll(
          productSelectors.arrow
        );
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        "resize",
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) {
          AOS.refresh();
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            "transitionend",
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle("hide", index === 0);
          this.arrows[1].classList.toggle(
            "hide",
            index === this.childNavLinks.length - 1
          );
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add("is-active");

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute("data-index", i);

          link.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "focus",
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "keydown",
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener("click", this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains("product__thumb-arrow--prev")
        ) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: "disabled",
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on(
          "variantChange" + this.namespace,
          this.setAvailability.bind(this)
        );

        // Set default state based on current selected variant
        this.setAvailability(null, this.currentVariantObject);
      },

      setAvailability: function (evt, variant) {
        if (evt) {
          var variant = evt.detail.variant;
        }

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: [],
        };

        var ignoreIndex = null;
        var availableVariants = this.variantsObject.filter(function (el) {
          if (!variant || variant.id === el.id) {
            return false;
          }

          if (
            variant.option2 === el.option2 &&
            variant.option3 === el.option3
          ) {
            return true;
          }

          if (
            variant.option1 === el.option1 &&
            variant.option3 === el.option3
          ) {
            return true;
          }

          if (
            variant.option1 === el.option1 &&
            variant.option2 === el.option2
          ) {
            return true;
          }
        });

        var variantObject = {
          variant: variant,
        };

        var variants = Object.assign({}, { variant }, availableVariants);

        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.container
          .querySelectorAll(".variant-input-wrap")
          .forEach((group) => {
            this.disableVariantGroup(group);
          });

        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property];
            if (!item) {
              return;
            }

            var value1 = item.option1;
            var value2 = item.option2;
            var value3 = item.option3;
            var soldOut = item.available === false;

            if (value1 && ignoreIndex !== "option1") {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut,
              });
            }
            if (value2 && ignoreIndex !== "option2") {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut,
              });
            }
            if (value3 && ignoreIndex !== "option3") {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut,
              });
            }
          }
        }

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + option + '"]'
        );

        // Loop through each option value
        values.forEach((obj) => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOptionByValue: function (array, index) {
        var group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + index + '"]'
        );

        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i]);
        }
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(
          /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
          "\\$1"
        );

        if (this.type === "dropdown") {
          group.querySelector('option[value="' + value + '"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector(
            '.variant-input[data-value="' + value + '"]'
          );
          var input = buttonGroup.querySelector("input");
          var label = buttonGroup.querySelector("label");

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },

      disableVariantGroup: function (group) {
        if (this.type === "dropdown") {
          group.querySelectorAll("option").forEach((option) => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll("input").forEach((input) => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll("label").forEach((label) => {
            label.classList.add(classes.disabled);
          });
        }
      },
    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;

    var videoHolderId = "VideoHolder";
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: ".product-video-trigger--mp4",
      mp4Player: ".product-video-mp4-sound",
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load("youtubeSdk");
    }

    var modal = new theme.Modals("VideoModal", "video-modal", {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "video-modal-open"],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerYouTubeModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener("click", triggerMp4Modal);
    });

    document.addEventListener("modalClose.VideoModal", closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute("href"));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: "sound",
        events: {
          onReady: onYoutubeReady,
        },
      });
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove("hide");

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector("video").play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = "";
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? "right" : "left",
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById("AnnouncementSlider");
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === "true") {
        initSlider();
      }

      document.addEventListener("matchSmall", function () {
        unload();
        initSlider();
      });

      document.addEventListener("unmatchSmall", function () {
        unload();
        if (bar.dataset.compact === "true") {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector("#AnnouncementSlide-" + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === "function") {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === "function") {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === "function") {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById("RecoverPasswordForm")
        .classList.toggle("hide");
      var loginForm = document
        .getElementById("CustomerLoginForm")
        .classList.toggle("hide");
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById("RecoverPassword");
      if (recoverForm) {
        recoverForm.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        "HideRecoverPasswordLink"
      );
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector(".reset-password-success");

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById("ResetSuccess").classList.remove("hide");
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById("AddressNewForm");
      var addressForms = document.querySelectorAll(".js-address-form");

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll(".js-address-country").forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll(".address-new-toggle").forEach((el) => {
        el.addEventListener("click", function () {
          newAddressForm.classList.toggle("hide");
          $(".address-new-toggle").toggleClass("active");
        });
      });

      document.querySelectorAll(".address-edit-toggle").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document
            .getElementById("EditAddress_" + formId)
            .classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-delete").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (
            confirm(
              confirmMessage || "Are you sure you wish to delete this address?"
            )
          ) {
            if (Shopify) {
              Shopify.postLink("/account" + formId, {
                parameters: { _method: "delete" },
              });
            }
          }
        });
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: "#CartDrawer",
      form: "#CartDrawerForm",
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers("CartDrawer", "cart");

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            this.cartForm.buildCart();
            this.open();
          }.bind(this)
        );

        // Dev-friendly way to open cart
        document.addEventListener("cart:open", this.open.bind(this));
        document.addEventListener("cart:close", this.close.bind(this));
      },

      open: function () {
        this.drawer.open();
      },

      close: function () {
        this.drawer.close();
      },
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: "#HeaderWrapper",
      siteHeader: "#SiteHeader",
      searchBtn: ".js-search-header",
      closeSearch: "#SearchClose",
      searchContainer: ".site-header__search-container",
      logo: "#LogoContainer img",
      megamenu: ".megamenu",
      navItems: ".site-nav__item",
      navLinks: ".site-nav__link",
      navLinksWithDropdown: ".site-nav__link--has-dropdown",
      navDropdownLinks: ".site-nav__dropdown-link--second-level",
    };

    var classes = {
      hasDropdownClass: "site-nav--has-dropdown",
      hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
      dropdownActive: "is-focused",
    };

    var config = {
      namespace: ".siteNav",
      wrapperOverlayed: false,
      overlayedClass: "is-light",
      overlayEnabledClass: "header-wrapper--sticky",
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: "site-header--stuck",
      stickyHeaderWrapper: "StickyHeaderWrap",
      openTransitionClass: "site-header--opening",
      lastScroll: 0,
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = siteHeader.dataset.sticky === "true";
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(
          config.overlayedClass
        );
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = siteHeader.dataset.overlay === "true";
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (
          document.body.classList.contains("template-collection") &&
          !document.querySelector(".collection-hero")
        ) {
          this.disableOverlayHeader();
        }
      }

      accessibleDropdowns();
      searchDrawer();

      window.on("load" + config.namespace, resizeLogo);
      window.on(
        "resize" + config.namespace,
        theme.utils.debounce(150, resizeLogo)
      );
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(
        config.overlayEnabledClass,
        config.overlayedClass
      );
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach((nav) => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < largestMegaNav + 120) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement("div");
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderHeight();

      window.on(
        "resize" + config.namespace,
        theme.utils.debounce(50, stickyHeaderHeight)
      );
      window.on(
        "scroll" + config.namespace,
        theme.utils.throttle(20, stickyHeaderScroll)
      );

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector(
        "#" + config.stickyHeaderWrapper
      );
      stickyHeader.style.height = h + "px";
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document
          .querySelectorAll(selectors.navLinksWithDropdown)
          .forEach((el) => {
            el.on("touchend" + config.namespace, function (evt) {
              var parent = evt.currentTarget.parentNode;
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeDropdowns();
                openFirstLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            });
          });
      }

      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach((el) => {
        el.on("focusin" + config.namespace, accessibleMouseEvent);
        el.on("mouseover" + config.namespace, accessibleMouseEvent);
        el.on("mouseleave" + config.namespace, closeDropdowns);
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
        if (theme.config.isTouch) {
          el.on("touchend" + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute("href"));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on("focusin" + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        });
      });

      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on("touchend" + config.namespace, function () {
          closeDropdowns();
        });

        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach((el) => {
          el.on("touchend" + config.namespace, function (evt) {
            evt.stopImmediatePropagation();
          });
        });
      }

      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? "touchend" : "click";
            closeOnClickActive = true;
            document.documentElement.on(
              eventType + config.namespace,
              function () {
                closeDropdowns();
                document.documentElement.off(eventType + config.namespace);
                closeOnClickActive = false;
              }.bind(this)
            );
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (
          parent.classList.contains(classes.hasSubDropdownClass) ||
          skipCheck
        ) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach((el) => {
          el.classList.remove(classes.dropdownActive);
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach((btn) => {
        btn.addEventListener("click", openSearchDrawer);
      });

      document
        .querySelector(selectors.closeSearch)
        .addEventListener("click", closeSearchDrawer);
    }

    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(
        container,
        function () {
          container.classList.add("is-active");
        }.bind(this)
      );

      document.documentElement.classList.add(
        "js-drawer-open",
        "js-drawer-open--search"
      );

      setTimeout(function () {
        theme.a11y.trapFocus({
          container: container,
          namespace: "header_search",
          elementToFocus: container.querySelector(".site-header__search-input"),
        });
      }, 100);

      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (
        theme.config.bpSmall &&
        config.stickyEnabled &&
        config.lastScroll < 300
      ) {
        window.scrollTo(0, 0);
      }

      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);

      bindSearchEvents();
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains("site-header__search-btn")) {
              break;
            }

            if (path[i].classList.contains("site-header__search-container")) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add("js-drawer-closing");
      document.documentElement.classList.remove(
        "js-drawer-open",
        "js-drawer-open--search"
      );

      window.setTimeout(
        function () {
          document.documentElement.classList.remove("js-drawer-closing");
        }.bind(this),
        500
      );

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(
        container,
        function () {
          container.classList.remove("is-active");
        }.bind(this)
      );

      theme.a11y.removeTrapFocus({
        container: container,
        namespace: "header_search",
      });

      theme.a11y.unlockMobileScrolling(config.namespace);

      unbindSearchEvents();
    }

    function bindSearchEvents() {
      window.on(
        "keyup" + config.namespace,
        function (evt) {
          if (evt.keyCode === 27) {
            closeSearchDrawer();
          }
        }.bind(this)
      );

      // Clicking out of container closes it
      document.documentElement.on(
        "click" + config.namespace,
        function (evt) {
          closeSearchDrawer(evt);
        }.bind(this)
      );
    }

    function unbindSearchEvents() {
      window.off("keyup" + config.namespace);
      document.documentElement.off("click" + config.namespace);
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach((logo) => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest(".header-item").clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        } else {
          logo.removeAttribute("style");
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove("unloading");
      document.querySelectorAll(".cart__checkout").forEach((el) => {
        el.classList.remove("btn--loading");
      });
    }
  };

  theme.predictiveSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;
    var namespace = ".predictive";

    var selectors = {
      form: "#HeaderSearchForm",
      input: 'input[type="search"]',
      wrapper: "#PredictiveWrapper",
      resultDiv: "#PredictiveResults",

      searchButton: "[data-predictive-search-button]",
    };

    var cache = {};
    var config = {
      imageSize: "square",
    };

    var classes = {
      isActive: "predicitive-active",
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      // Only some languages support predictive search
      if (document.getElementById("shopify-features")) {
        var supportedShopifyFeatures = JSON.parse(
          document.getElementById("shopify-features").innerHTML
        );
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      cache.wrapper = document.querySelector(selectors.wrapper);

      if (!cache.wrapper) {
        return;
      }

      config.imageSize = cache.wrapper.dataset.imageSize;

      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute("autocomplete", "off");
      cache.form.on("submit" + namespace, submitSearch);

      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on("keyup" + namespace, handleKeyup);

      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on("click" + namespace, triggerSearch);

      cache.results = document.querySelector(selectors.resultDiv);
    }

    function reset() {
      cache.wrapper.classList.add("hide");
      cache.results.innerHTML = "";
      clearTimeout(searchTimeout);
    }

    function triggerSearch() {
      cache.form.submit();
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += "*";
      }

      var params = paramUrl(obj);

      window.location.href = `${theme.routes.search}?${params}`;
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
    }

    function search() {
      var keyword = cache.input.value;

      if (keyword === "") {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        q: q,
        "resources[type]": theme.settings.predictiveSearchType,
        "resources[limit]": 4,
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]":
          "title,product_type,variants.title,vendor",
      };

      var params = paramUrl(searchObj);

      fetch("/search/suggest.json?" + params)
        .then((response) => response.json())
        .then((suggestions) => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          cache.wrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              case "collections":
                data[type] = buildCollections(results);
                break;
              case "pages":
                data[type] = buildPages(results);
                break;
              case "articles":
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = "";
          cache.results.innerHTML = output;
        });
    }

    function buildProducts(results) {
      var output = "";
      var products = [];

      console.log(products);

      results.forEach((product) => {
        var new_product = {
          title: product.title,
          vendor: product.vendor,
          url: product.url,
          handle: product.handle,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio,
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(
          products,
          "small--one-half medium-up--one-quarter",
          4,
          config.imageSize
        );

        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = "";

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function buildPages(pages) {
      var output = "";

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = "";

      articles.forEach((article) => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(
            article.image,
            "200x200_crop_center"
          );
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = "";

      if (data.products && data.products !== "") {
        output += data.products;
      }

      if (data.collections && data.collections !== "") {
        output += data.collections;
      }

      if (data.pages && data.pages !== "") {
        output += data.pages;
      }

      if (data.articles && data.articles !== "") {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }

    return {
      init: init,
    };
  })();

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSize) {
    var output = "";
    var count = 0;
    items.forEach((product) => {
      count = count + 1;

      var image = theme.buildProductImage(product, imageSize);

      var handle_name = product.handle;
      var product_title = "";

      /*jQuery.get('/products/' + handle_name  + '?view=metafield', function (product) {
        //console.log('/products/' + handle_name  + '?view=metafield')
        //console.log(product);
        product_title = $(product).find(".product_meta_title_new h2").html();
        if(product_title != ""){
        	product_title = product_title
        } 
        else{
        	product_title = product.title
        }
        
        $(".row-of-"+count).find(".grid-product__title").html(product_title);
      });*/

      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate row-of-${count}" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__vendor" id="current-vender-${product.handle}"></div>
                <div class="grid-product__title" id="current-product-${product.handle}"></div>
                <div class="grid-product__handmade">HANDMADE IN GERMANY</div>
              </div>
            </a>
          </div>
        </div>
      `;

      output += markup;

      let url =
        window.location.origin +
        "/products/" +
        product.handle +
        "?view=metafield";

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          // Convert the HTML string into a document object
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const product_metafield_title = doc.querySelector(
            ".grid-product__title"
          ).textContent;
          const product_metafield_vender = doc.querySelector(
            ".grid-product__vendor"
          ).textContent;

          setTimeout(function () {
            if (document.getElementById(`current-product-${product.handle}`)) {
              document.getElementById(
                `current-product-${product.handle}`
              ).innerHTML = product_metafield_title;
            }
            if (document.getElementById(`current-vender-${product.handle}`)) {
              document.getElementById(
                `current-vender-${product.handle}`
              ).innerHTML = product_metafield_vender;
            }
          }, 500);
        });
    });

    return output;
  };

  theme.buildProductImage = function (product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = "";

    if (size === "natural") {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = "lazyload";
      if (!theme.settings.productImageCover) {
        classes += " grid__image-contain";
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
    }

    return output;
  };

  theme.buildCollectionItem = function (items) {
    var output = "";

    items.forEach((collection) => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPageItem = function (items) {
    var output = "";

    items.forEach((page) => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildArticleItem = function (items, imageSize) {
    var output = "";

    items.forEach((article) => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPredictiveImage = function (obj) {
    var imageMarkup = "";
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  };

  theme.Maps = (function () {
    var config = {
      zoom: 14,
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {};

    var selectors = {
      section: '[data-section-type="map"]',
      map: "[data-map]",
      mapOverlay: ".map-section__overlay",
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }

      document.querySelectorAll(selectors.section).forEach((section) => {
        section.classList.add("map-section--load-error");
      });

      document.querySelectorAll(selectors.map).forEach((map) => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError);
    };

    window.mapError = function (error) {
      var message = document.createElement("div");
      message.classList.add("map-section__error", "errors", "text-center");
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach((overlay) => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll(".map-section__link").forEach((link) => {
        link.classList.add("hide");
      });
    };

    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.namespace = ".map-" + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;

      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError,
      };

      if (!this.key) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20,
      });
    }

    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach((instance) => {
        instance.createMap();
      });
    }

    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting;

      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function () {
        if (apiStatus === "loaded") {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== "loading") {
            apiStatus = "loading";
            if (
              typeof window.google === "undefined" ||
              typeof window.google.maps === "undefined"
            ) {
              var script = document.createElement("script");
              script.onload = function () {
                apiStatus = "loaded";
                initAllMaps();
              };
              script.src =
                "https://maps.googleapis.com/maps/api/js?key=" + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      createMap: function () {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function (results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: "none",
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true,
              };

              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter(),
              });

              google.maps.event.addDomListener(
                window,
                "resize",
                theme.utils.debounce(250, function () {
                  google.maps.event.trigger(map, "resize");
                  map.setCenter(center);
                  mapDiv.removeAttribute("style");
                })
              );

              if (Shopify.designMode) {
                if (window.AOS) {
                  AOS.refreshHard();
                }
              }
            }.bind(this)
          )
          .catch(function (status) {
            var errorMessage;

            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = errors.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                errorMessage = errors.addressQueryLimit;
                break;
              case "REQUEST_DENIED":
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      onUnload: function () {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, "resize");
        }
      },
    });

    return Map;
  })();

  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute("data-section-id");
      this.cookieName = "newsletter-" + sectionId;

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === "/challenge") {
        return;
      }

      // Prevent popup on password page
      if (window.location.pathname === "/password") {
        return;
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode,
      };

      this.modal = new theme.Modals(
        "NewsletterPopup-" + sectionId,
        "newsletter-popup-modal"
      );

      // Set cookie if optional button is clicked
      var btn = container.querySelector(".popup-cta a");
      if (btn) {
        btn.addEventListener(
          "click",
          function () {
            this.closePopup(true);
          }.bind(this)
        );
      }

      // Open modal if errors or success message exist
      if (
        container.querySelector(".errors") ||
        container.querySelector(".note--success")
      ) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector(".note--success")) {
        this.closePopup(true);
        return;
      }

      document.addEventListener(
        "modalClose." + container.id,
        this.closePopup.bind(this)
      );

      if (!this.data.cookie || this.data.testMode === "true") {
        this.initPopupDelay();
      }
    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (Shopify && Shopify.designMode) {
          return;
        }
        setTimeout(
          function () {
            this.modal.open();
          }.bind(this),
          this.data.secondsBeforeShow * 1000
        );
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === "true") {
          Cookies.remove(this.cookieName, { path: "/" });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, "opened", { path: "/", expires: expiry });
      },

      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      },
    });

    return NewsletterPopup;
  })();

  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector("#LoginModal")) {
          return;
        }

        var passwordModal = new theme.Modals("LoginModal", "login-modal", {
          focusIdOnOpen: "password",
          solid: true,
        });

        // Open modal if errors exist
        if (document.querySelectorAll(".errors").length) {
          passwordModal.open();
        }
      },
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: ".js-photoswipe__zoom",
      images: ".photoswipe__image",
      slideshowTrack: ".flickity-viewport ",
      activeImage: ".is-selected",
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = ".photoswipe-" + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === "false") {
        return;
      }

      if (container.dataset.hasSlideshow === "true") {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container
          .querySelectorAll(selectors.trigger)
          .forEach((trigger) => {
            trigger.on("click" + this.namespace, this.triggerClick.bind(this));
          });
      },

      triggerClick: function (evt) {
        this.items = this.getImageData();

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget;

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
              selectors.slideshowTrack + selectors.images
            )
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute("data-photoswipe-src"),
            w: el.getAttribute("data-photoswipe-width"),
            h: el.getAttribute("data-photoswipe-height"),
            el: el,
            initialZoomLevel: 0.5,
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll(".pswp")[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: "zoom",
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        this.gallery.listen("afterChange", this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(
          new CustomEvent("photoswipe:afterChange", {
            detail: {
              index: index,
            },
          })
        );
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add("pswp-open-in-ios");

        window.addEventListener("resize", this.syncHeight);

        this.gallery.listen("destroy", () => {
          document.documentElement.classList.remove("pswp-open-in-ios");
          window.scrollTo(0, initialScrollPos);
        });
      },
    });

    return Photoswipe;
  })();

  theme.Recommendations = (function () {
    var selectors = {
      placeholder: ".product-recommendations-placeholder",
      sectionClass: " .product-recommendations",
      productResults: ".grid-product",
    };

    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.url = container.dataset.url;

      selectors.recommendations = "Recommendations-" + this.sectionId;

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500,
      });
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations);

        if (!section || section.dataset.enable === "false") {
          return;
        }

        var id = section.dataset.productId;
        var limit = section.dataset.limit;

        var url =
          this.url +
          "?section_id=product-recommendations&limit=" +
          limit +
          "&product_id=" +
          id;

        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass);
          if (wrapper) {
            wrapper.innerHTML = "";
          }
        }

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              // Convert the HTML string into a document object
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var div = doc.querySelector(selectors.sectionClass);
              var placeholder = section.querySelector(selectors.placeholder);
              if (!placeholder) {
                return;
              }

              placeholder.innerHTML = "";

              if (!div) {
                this.container.classList.add("hide");
                if (AOS) {
                  AOS.refreshHard();
                }
                return;
              }

              placeholder.appendChild(div);

              theme.reinitProductGridItem(section);

              document.dispatchEvent(
                new CustomEvent("recommendations:loaded", {
                  detail: {
                    section: section,
                  },
                })
              );

              // If no results, hide the entire section
              var results = div.querySelectorAll(selectors.productResults);
              if (results.length === 0) {
                this.container.classList.add("hide");
              }
            }.bind(this)
          );
      },
    });

    return Recommendations;
  })();

  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: ".parallax-container",
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#Slideshow-" + sectionId);
      this.namespace = "." + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) {
        return;
      }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(
        sectionEl.parentElement.children,
        sectionEl
      );

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this),
        });
      }
    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll(".slideshow__slide");

        if (this.container.hasAttribute("data-immediate-load")) {
          this.slideshow.classList.remove("loading", "loading--delayed");
          this.slideshow.classList.add("loaded");
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
            pageDots: this.slideshow.hasAttribute("data-dots"),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay:
              this.slideshow.dataset.autoplay === "true"
                ? parseInt(this.slideshow.dataset.speed)
                : false,
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add("is-selected");
        }

        if (this.container.hasAttribute("data-parallax")) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(
            function (el, i) {
              new theme.Parallax(el, {
                namespace: this.namespace + "-parallax-" + i,
              });
            }.bind(this)
          );
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          ".slideshow__slide--" + evt.detail.blockId
        );
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === "function") {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(
            function () {
              if (this.flickity && typeof this.flickity.pause === "function") {
                this.flickity.pause();
              }
            }.bind(this),
            1000
          );
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      },
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: ".js-drawer-open-availability",
      modalOpenBtn: ".js-modal-open-availability",
      productTitle: "[data-availability-product-title]",
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign(
      {},
      StoreAvailability.prototype,
      {
        updateContent: function (variantId) {
          var variantSectionUrl =
            this.baseUrl +
            "/variants/" +
            variantId +
            "/?section_id=store-availability";

          var self = this;

          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (html.trim() === "") {
                this.container.innerHTML = "";
                return;
              }

              self.container.innerHTML = html;
              self.container.innerHTML =
                self.container.firstElementChild.innerHTML;

              // Setup drawer if have open button
              if (self.container.querySelector(selectors.drawerOpenBtn)) {
                self.drawer = new theme.Drawers(
                  "StoreAvailabilityDrawer",
                  "availability"
                );
              }

              // Setup modal if have open button
              if (self.container.querySelector(selectors.modalOpenBtn)) {
                self.modal = new theme.Modals(
                  "StoreAvailabilityModal",
                  "availability"
                );
              }

              var title = self.container.querySelector(selectors.productTitle);
              if (title) {
                title.textContent = self.productTitle;
              }
            });
        },
      }
    );

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: ".video-parent-section",
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.namespace = ".video-" + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500,
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector(".video-div");
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case "youtube":
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case "vimeo":
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case "mp4":
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
          videoId: videoId,
          videoParent: selectors.videoParent,
        });
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          "Vimeo-" + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent,
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = "Mp4Video-" + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add("loaded");

          var playPromise = document.querySelector("#" + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise
              .then(function () {
                // playback normal
              })
              .catch(function () {
                mp4Div.setAttribute("controls", "");
                parent.classList.add("video-interactable");
              });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace("shopify-section-", "");
        if (
          this.videoObject &&
          typeof this.videoObject.destroy === "function"
        ) {
          this.videoObject.destroy();
        }
      },
    });

    return videoSection;
  })();

  theme.BackgroundImage = (function () {
    var selectors = {
      parallaxContainer: ".parallax-container",
    };

    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }

      var sectionId = container.getAttribute("data-section-id");
      this.namespace = "." + sectionId;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
      });
    }

    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function () {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(
            selectors.parallaxContainer
          );
          var args = {
            namespace: this.namespace + "-parallax",
            desktopOnly: true,
          };

          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          );
        }
      },

      onUnload: function (evt) {
        if (!this.container) {
          return;
        }
        if (
          theme.parallaxSections[this.namespace] &&
          typeof theme.parallaxSections[this.namespace].destroy === "function"
        ) {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      },
    });

    return backgroundImage;
  })();

  theme.Blog = (function () {
    function Blog(container) {
      this.tagFilters();
    }

    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function () {
        var filterBy = document.getElementById("BlogTagFilter");

        if (!filterBy) {
          return;
        }

        filterBy.addEventListener("change", function () {
          location.href = filterBy.value;
        });
      },
    });

    return Blog;
  })();

  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = ".collection-header";

      var heroImageContainer = container.querySelector(".collection-hero");
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);

        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector(
            ".parallax-container"
          );
          var args = {
            namespace: this.namespace + "-parallax",
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          );
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector(".header-wrapper");
          if (!header.classList.contains("header-wrapper--overlay")) {
            location.reload();
          }
        }
      },

      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      },
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: "#CollectionSidebar",
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign(
      {},
      CollectionSidebar.prototype,
      {
        init: function () {
          // Do not load when no sidebar exists
          if (!this.container) {
            return;
          }

          this.onUnload();

          drawerStyle = this.container.dataset.style === "drawer";
          theme.FilterDrawer = new theme.Drawers(
            "FilterDrawer",
            "collection-filters",
            true
          );
        },

        forceReload: function () {
          this.init();
        },

        onSelect: function () {
          if (theme.FilterDrawer) {
            if (!drawerStyle) {
              theme.FilterDrawer.close();
              return;
            }

            if (drawerStyle || theme.config.bpSmall) {
              theme.FilterDrawer.open();
            }
          }
        },

        onDeselect: function () {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }
        },

        onUnload: function () {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }
        },
      }
    );

    return CollectionSidebar;
  })();

  theme.Collection = (function () {
    var isAnimating = false;

    var selectors = {
      sortSelect: "#SortBy",

      colorSwatchImage: ".grid-product__color-image",
      colorSwatch: ".color-swatch--with-image",

      collectionGrid: ".collection-grid__wrapper",
      trigger: ".collapsible-trigger",
      sidebar: "#CollectionSidebar",
      filterSidebar: ".collapsible-content--sidebar",
      activeTagList: ".tag-list--active-tags",
      tags: ".tag-list input",
      activeTags: ".tag-list a",
      tagsForm: ".filter-form",
      filters: ".collection-filter",
      priceRange: ".price-range",
    };

    var classes = {
      activeTag: "tag--active",
      removeTagParent: "tag--remove",
      filterSidebar: "collapsible-content--sidebar",
      isOpen: "is-open",
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.namespace = ".collection-" + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: "CollectionAjaxContent",
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
        preserveParams: ["sort_by", "q", "options[prefix]", "type"],
      });

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function () {
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on(
            "change" + this.namespace,
            this.onSortChange.bind(this)
          );
          this.initParams();
        }
      },

      initParams: function () {
        this.queryParams = {};

        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split("&");
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split("=");
            if (aKeyValue.length > 1) {
              this.queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute("data-default-sortby");
      },

      onSortChange: function () {
        this.queryParams.sort_by = this.getSortValue();

        if (this.queryParams.page) {
          delete this.queryParams.page;
        }

        window.location.search = decodeURIComponent(
          new URLSearchParams(Object.entries(this.queryParams))
        );
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(
          selectors.colorSwatchImage
        );
        if (!colorImages.length) {
          return;
        }

        this.container
          .querySelectorAll(selectors.colorSwatch)
          .forEach((swatch) => {
            swatch.addEventListener("mouseenter", function () {
              var id = swatch.dataset.variantId;
              var image = swatch.dataset.variantImage;
              var el = document.querySelector(
                ".grid-product__color-image--" + id
              );
              el.style.backgroundImage = "url(" + image + ")";
              el.classList.add("is-active");
            });
            swatch.addEventListener("mouseleave", function () {
              var id = swatch.dataset.variantId;
              document
                .querySelector(".grid-product__color-image--" + id)
                .classList.remove("is-active");
            });
          });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          window.on(
            "resize",
            theme.utils.debounce(500, this.setFilterStickyPosition)
          );
        }

        document.querySelectorAll(selectors.activeTags).forEach((tag) => {
          tag.addEventListener("click", this.tagClick.bind(this));
        });

        document.querySelectorAll(selectors.tagsForm).forEach((form) => {
          form.addEventListener("input", this.onFormSubmit.bind(this));
        });
      },

      initPriceRange: function () {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach(
          (el) =>
            new theme.PriceRange(el, {
              // onChange passes in formData
              onChange: this.renderFromFormData.bind(this),
            })
        );
      },

      tagClick: function (evt) {
        var el = evt.currentTarget;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains("no-ajax")) {
          return;
        }

        evt.preventDefault();

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        const newUrl = new URL(el.href);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      onFormSubmit: function (evt) {
        var el = evt.target;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains("no-ajax")) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.closest("li");
        const formEl = el.closest("form");
        const formData = new FormData(formEl);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`
          )
        ).map((trigger) => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function (parent, el) {
        const textEl = parent.querySelector(".tag__text");

        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest("li").classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document
              .querySelectorAll(selectors.activeTagList)
              .forEach((list) => {
                const newTag = document.createElement("li");
                const newTagLink = document.createElement("a");
                newTag.classList.add("tag", "tag--remove");
                newTagLink.classList.add("btn", "btn--small");
                newTagLink.innerText = textEl.innerText;
                newTag.appendChild(newTagLink);

                list.appendChild(newTag);
              });
          }
        }
      },

      renderFromFormData: function (formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function (newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach((selector) => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML =
          newContentEl.innerHTML;
      },

      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = "auto";
        }

        el.classList.add(classes.isOpen);
      },

      renderCollectionPage: function (searchParams, updateURLHash = true) {
        // If on vendor page, make sure to pass the q param
        if (window.location.href.indexOf("collections/vendors") > -1) {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const vendor = urlParams.get("q");
          if (vendor) {
            searchParams.append("q", vendor);
          }
        }

        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit("collection-grid");
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();

            isAnimating = false;
          });
      },

      bindBackButton: function () {
        // Ajax page on back button
        window.off("popstate" + this.namespace);
        window.on(
          "popstate" + this.namespace,
          function (state) {
            if (state) {
              const newUrl = new URL(window.location.href);
              this.renderCollectionPage(newUrl.searchParams, false);
            }
          }.bind(this)
        );
      },

      updateScroll: function (animate) {
        var scrollToElement = document.querySelector("[data-scroll-to]");
        var scrollTo = scrollToElement && scrollToElement.offsetTop;

        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters on desktop
          scrollTo -= 60;
        } else {
          scrollTo += 1;
        }

        if (theme.config.stickyHeader) {
          var headerHeight =
            document.querySelector(".site-header").offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: "smooth" });
        } else {
          window.scrollTo({ top: scrollTo });
        }
      },

      setFilterStickyPosition: function () {
        var headerHeight = document.querySelector(".site-header").offsetHeight;
        document.querySelector(selectors.filters).style.top =
          headerHeight + 10 + "px";

        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector(".grid__item--sidebar");
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + "px";
        }
      },

      forceReload: function () {
        this.init();
      },

      startLoading: function () {
        document
          .querySelector(selectors.collectionGrid)
          .classList.add("unload");
      },
    });

    return Collection;
  })();

  theme.FooterSection = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector(
          ".footer__newsletter-input"
        );
        if (newsletterInput) {
          newsletterInput.addEventListener("keyup", function () {
            newsletterInput.classList.add("footer__newsletter-input--active");
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit("slideshow-section");

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers("NavDrawer", "nav");
        if (theme.settings.cartType === "drawer") {
          if (!document.body.classList.contains("template-cart")) {
            new theme.CartDrawer();
          }
        }

        theme.collapsibles.init(document.getElementById("NavDrawer"));
      },

      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },

      onUnload: function () {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: "on-sale",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      interactable: "video-interactable",
      visuallyHide: "visually-invisible",
    };

    var selectors = {
      productVideo: ".product__video",
      videoParent: ".product__video-wrapper",
      slide: ".product-main-slide",
      currentSlide: ".is-selected",
      startingSlide: ".starting-slide",
      variantType: ".variant-wrapper",
      blocks: "[data-product-blocks]",
      blocksHolder: "[data-blocks-holder]",
    };

    function Product(container) {
      this.container = container;
      var sectionId = (this.sectionId =
        container.getAttribute("data-section-id"));
      var productId = (this.productId =
        container.getAttribute("data-product-id"));

      this.inModal = container.dataset.modal === "true";
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: ".product-" + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "620x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickShopModal-" + productId);
      }

      this.selectors = {
        variantsJson: "[data-variant-json]",
        currentVariantJson: "[data-current-variant-json]",
        form: ".product-single__form",

        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: "[data-product-thumb]",
        thumbSlider: "[data-product-thumbs]",
        thumbScroller: ".product__thumbs--scroller",
        mainSlider: "[data-product-photos]",
        imageContainer: "[data-product-images]",
        productImageMain: "[data-product-image-main]",

        priceWrapper: "[data-product-price-wrap]",
        price: "[data-product-price]",
        comparePrice: "[data-compare-price]",
        savePrice: "[data-save-price]",
        priceA11y: "[data-a11y-price]",
        comparePriceA11y: "[data-compare-price-a11y]",
        unitWrapper: "[data-unit-price-wrapper]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-base]",
        sku: "[data-sku]",
        inventory: "[data-product-inventory]",
        incomingInventory: "[data-incoming-inventory]",
        colorLabel: "[data-variant-color-label]",

        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",

        originalSelectorId: "[data-product-select]",
        singleOptionSelector: "[data-variant-input]",
        variantColorSwatch: ".variant__input--color-swatch",

        availabilityContainer: "[data-store-availability-holder]",
      };

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider.querySelector("img");

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener(
            "modalOpen.QuickShopModal-" + this.productId,
            this.openModalProduct.bind(this)
          );
          document.addEventListener(
            "modalClose.QuickShopModal-" + this.productId,
            this.closeModalProduct.bind(this)
          );
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(
            this.selectors.thumbScroller
          ),
          productImageMain: this.container.querySelector(
            this.selectors.productImageMain
          ),

          // Price-related
          priceWrapper: this.container.querySelector(
            this.selectors.priceWrapper
          ),
          comparePriceA11y: this.container.querySelector(
            this.selectors.comparePriceA11y
          ),
          comparePrice: this.container.querySelector(
            this.selectors.comparePrice
          ),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        );
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute("data-product-handle");
        var url = this.container.getAttribute("data-product-url");
        var aspectRatio = this.container.getAttribute("data-aspect-ratio");
        var featuredImage = this.container.getAttribute("data-img-url");

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
        };

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(
            "theme-recent",
            JSON.stringify(theme.recentlyViewed.recent)
          );
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(
          this.selectors.variantsJson
        );

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
        };

        var swatches = this.container.querySelectorAll(
          this.selectors.variantColorSwatch
        );
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              "change",
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateAvailability.bind(this)
          );
        }

        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateCartButton.bind(this)
        );
        this.container.on(
          "variantImageChange" + this.settings.namespace,
          this.updateVariantImage.bind(this)
        );
        this.container.on(
          "variantPriceChange" + this.settings.namespace,
          this.updatePrice.bind(this)
        );
        this.container.on(
          "variantUnitPriceChange" + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        );

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on(
            "variantSKUChange" + this.settings.namespace,
            this.updateSku.bind(this)
          );
        }

        var inventoryEl = this.container.querySelector(
          this.selectors.inventory
        );
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateInventory.bind(this)
          );
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(
            this.selectors.currentVariantJson
          );

          if (currentVariantJson) {
            var variantType = this.container.querySelector(
              selectors.variantType
            );

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' +
              this.settings.imageSetName +
              '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on(
              "variantChange" + this.settings.namespace,
              this.updateImageSet.bind(this)
            );
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
          new theme.QtySelector(el, {
            namespace: ".product",
          });
        });
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === "drawer") {
          new theme.AjaxProduct(this.cache.form);
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(
          this.selectors.colorLabel + `[data-index="${index}"`
        ).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(
          this.selectors.addToCartText
        );

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          );

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            );
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            this.cache.priceA11y.setAttribute("aria-hidden", "false");

            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == "percent") {
              savings =
                Math.round((savings * 100) / variant.compare_at_price) + "%";
            } else {
              savings = theme.Currency.formatMoney(
                savings,
                theme.settings.moneyFormat
              );
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
              "[saved_amount]",
              savings
            );
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            this.cache.priceA11y.setAttribute("aria-hidden", "true");
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            );
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.hidden);
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ));
        var set = this.settings.imageSetName + "_" + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        );

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll(".product__thumb-item")
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
          });
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = "";

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === "continue"
        ) {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (
          variant.inventory_management === "shopify" &&
          window.inventories &&
          window.inventories[this.productId]
        ) {
          var variantInventoryObject =
            window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === "continue") {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, showInventory, quantity);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming === "true" &&
            quantity <= this.settings.inventoryThreshold
          ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          );
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest(".product-block");

        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add("inventory--low");
          el.textContent = theme.strings.stockLabel.replace("[count]", qty);
        } else {
          el.parentNode.classList.remove("inventory--low");
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest(".product-block");

        if (!el) {
          return;
        }

        var textEl = el.querySelector(".js-incoming-text");

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace("[date]", date)
            : theme.strings.willBeInStockAfter.replace("[date]", date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(
          selectors.productVideo
        );

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType;
          if (type === "youtube") {
            this.initYoutubeVideo(vid);
          } else if (type === "mp4") {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== "sound") {
          player.mute();
        }

        obj.parent.classList.remove("loading");
        obj.parent.classList.add("loaded");

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add("video-interactable");
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === "true") {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: "mp4",
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === "function") {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === "mp4") {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute("data-video-type");
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute("controls", "");
              player
                .closest(selectors.videoParent)
                .setAttribute("data-video-style", "unmuted");
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        if (player && typeof player.pause === "function") {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        );
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        );

        var newImage = this.container.querySelector(
          '.product__thumb[data-id="' + variant.featured_media.id + '"]'
        );
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === "undefined") {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (
          this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
        ) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add("is-selected");
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(
            selectors.startingSlide
          );
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          adaptiveHeight: false,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === "beside",
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        );
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' +
            this.settings.currentSlideIndex +
            '"]'
        );

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName
          ? this.cache.mainSlider.querySelectorAll(
              ".flickity-slider .product-main-slide"
            )[index]
          : this.cache.mainSlider.querySelector(
              '.product-main-slide[data-index="' + index + '"]'
            );

        prevSlide.setAttribute("tabindex", "-1");
        nextSlide.setAttribute("tabindex", 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent("mediaHidden", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== "sound"
            ) {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent("mediaVisible", {
              bubbles: true,
              cancelable: true,
            })
          );
          slide
            .querySelector(".shopify-model-viewer-ui__button")
            .setAttribute("tabindex", 0);
          slide
            .querySelector(".product-single__close-media")
            .setAttribute("tabindex", 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute("data-index");
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(
            selectors.blocksHolder
          );
          var url = this.blocksHolder.dataset.url;

          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var blocks = doc.querySelector(selectors.blocks);

                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll("[id]").forEach((el) => {
                  // Update input `id`
                  var val = el.getAttribute("id");
                  el.setAttribute("id", val + "-modal");

                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute("for", val + "-modal");
                  }

                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(
                    `[aria-controls="${val}"]`
                  );
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute(
                      "aria-controls",
                      val + "-modal"
                    );
                  }
                });

                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                var formId = form.getAttribute("id");
                blocks.querySelectorAll("[form]").forEach((el) => {
                  el.setAttribute("form", formId);
                });

                this.blocksHolder.innerHTML = "";
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add("product-form-holder--loaded");

                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent("quickview:loaded", {
                    detail: {
                      productId: this.sectionId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                "quickview:loaded",
                function (evt) {
                  if (evt.detail.productId === this.sectionId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(
          new CustomEvent("quickview:open", {
            detail: {
              initialized: initialized,
              productId: this.sectionId,
            },
          })
        );
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container
          .querySelectorAll(".js-product-inventory-data")
          .forEach((el) => {
            var productId = el.dataset.productId;
            window.inventories[productId] = {};

            el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
              window.inventories[productId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                policy: el.dataset.policy,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              };
            });
          });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        );
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ":not(." +
                self.classes.hidden +
                ")"
            );
            currentMedia.dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            "click",
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              );
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        var modelViewers = this.container.querySelectorAll("model-viewer");
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },
    });

    return Product;
  })();

  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.namespace = ".recently-viewed" + this.sectionId;
      this.gridItemWidth = this.container.getAttribute("data-grid-item-class");
      this.rowOf = this.container.getAttribute("data-row-of");

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (
          Object.keys(theme.recentlyViewed.recent).length === 0 &&
          theme.recentlyViewed.recent.constructor === Object
        ) {
          // No previous history on page load, so bail
          this.container.classList.add("hide");
          return;
        }

        this.outputContainer = document.getElementById(
          "RecentlyViewed-" + this.sectionId
        );
        this.handle = this.container.getAttribute("data-product-handle");

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(
          function (handle) {
            if (handle !== "undefined") {
              promises.push(this.getProductInfo(handle));
            }
          }.bind(this)
        );

        Promise.all(promises).then(
          function (result) {
            this.setupOutput(result);
            this.captureProductDetails(result);
          }.bind(this)
        );
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch("/products/" + handle + ".js")
              .then(function (response) {
                return response.text();
              })
              .then(function (product) {
                resolve(product);
              });
          }
        });
      },

      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute("data-recent-count");

        var i = 0;

        Object.keys(products).forEach(
          function (key) {
            if (!products[key]) {
              return;
            }
            var product = JSON.parse(products[key]);

            // Ignore current product
            if (product.handle === this.handle) {
              return;
            }

            // Ignore undefined key
            if (typeof product.handle == "undefined") {
              return;
            }

            i++;

            // New or formatted properties
            product.url = theme.recentlyViewed.recent[product.handle]
              ? theme.recentlyViewed.recent[product.handle].url
              : product.url;
            product.image_responsive_url =
              theme.recentlyViewed.recent[product.handle].featuredImage;
            product.image_aspect_ratio =
              theme.recentlyViewed.recent[product.handle].aspectRatio;

            // Unit pricing checks first variant
            var firstVariant = product.variants[0];
            if (firstVariant && firstVariant.unit_price) {
              var baseUnit = "";

              if (firstVariant.unit_price_measurement) {
                if (firstVariant.unit_price_measurement.reference_value != 1) {
                  baseUnit +=
                    firstVariant.unit_price_measurement.reference_value + " ";
                }
                baseUnit += firstVariant.unit_price_measurement.reference_unit;
              }

              product.unit_price = theme.Currency.formatMoney(
                firstVariant.unit_price
              );
              if (baseUnit != "") {
                product.unit_price += "/" + baseUnit;
              }
            }

            allProducts.unshift(product);
          }.bind(this)
        );

        if (allProducts.length === 0) {
          this.container.classList.add("hide");
          return;
        }

        var productMarkup = theme.buildProductGridItem(
          allProducts.slice(0, limit),
          this.gridItemWidth,
          this.rowOf
        );

        this.outputContainer.innerHTML = productMarkup;

        if (AOS) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function (products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem(
            "recent-products",
            JSON.stringify(theme.recentlyViewed.productInfo)
          );
        }
      },

      onUnload: function () {
        init = false;
      },
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function () {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#Testimonials-" + sectionId);
      this.namespace = ".testimonial-" + sectionId;

      if (!this.slideshow) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function () {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(
            function () {
              this.flickity.goToSlide(1);
            }.bind(this),
            1000
          );
        }
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          ".testimonials-slide--" + evt.detail.blockId
        );
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === "function") {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },
    });

    return Testimonials;
  })();

  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    var storage;
    if (type === "session") {
      storage = window.sessionStorage;
    }
    if (type === "local") {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported("session");
  theme.config.hasLocalStorage = theme.isStorageSupported("local");
  AOS.init({
    easing: "ease-out-quad",
    once: true,
    offset: 60,
    disableMutationObserver: true,
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage =
      window.localStorage.getItem("theme-recent");

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(
        theme.recentlyViewed.localStorage
      );
    }
  }

  theme.recentlyViewed.productInfo =
    theme.config.hasSessionStorage && sessionStorage["recent-products"]
      ? JSON.parse(sessionStorage["recent-products"])
      : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register("slideshow-section", theme.SlideshowSection);
    theme.sections.register("header", theme.HeaderSection);
    theme.sections.register("product", theme.Product);
    theme.sections.register("blog", theme.Blog);
    theme.sections.register("password-header", theme.PasswordHeader);
    theme.sections.register("photoswipe", theme.Photoswipe);
    theme.sections.register("product-recommendations", theme.Recommendations);
    theme.sections.register("background-image", theme.BackgroundImage);
    theme.sections.register("testimonials", theme.Testimonials);
    theme.sections.register("video-section", theme.VideoSection);
    theme.sections.register("map", theme.Maps);
    theme.sections.register("footer-section", theme.FooterSection);
    theme.sections.register("store-availability", theme.StoreAvailability);
    theme.sections.register("recently-viewed", theme.RecentlyViewed);
    theme.sections.register("newsletter-popup", theme.NewsletterPopup);
    theme.sections.register("collection-header", theme.CollectionHeader);
    theme.sections.register("collection-grid", theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains("template-cart")) {
      var cartPageForm = document.getElementById("CartPageForm");
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
  "use strict";
  var n = [],
    r = e.document,
    i = Object.getPrototypeOf,
    o = n.slice,
    a = n.concat,
    s = n.push,
    u = n.indexOf,
    l = {},
    c = l.toString,
    f = l.hasOwnProperty,
    p = f.toString,
    d = p.call(Object),
    h = {},
    g = function e(t) {
      return "function" == typeof t && "number" != typeof t.nodeType;
    },
    y = function e(t) {
      return null != t && t === t.window;
    },
    v = { type: !0, src: !0, noModule: !0 };
  function m(e, t, n) {
    var i,
      o = (t = t || r).createElement("script");
    if (((o.text = e), n)) for (i in v) n[i] && (o[i] = n[i]);
    t.head.appendChild(o).parentNode.removeChild(o);
  }
  function x(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? l[c.call(e)] || "object"
      : typeof e;
  }
  var b = "3.3.1",
    w = function (e, t) {
      return new w.fn.init(e, t);
    },
    T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (w.fn = w.prototype =
    {
      jquery: "3.3.1",
      constructor: w,
      length: 0,
      toArray: function () {
        return o.call(this);
      },
      get: function (e) {
        return null == e
          ? o.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = w.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return w.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          w.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: n.sort,
      splice: n.splice,
    }),
    (w.extend = w.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            "object" == typeof a || g(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (n = a[t]),
                a !== (r = e[t]) &&
                  (l && r && (w.isPlainObject(r) || (i = Array.isArray(r)))
                    ? (i
                        ? ((i = !1), (o = n && Array.isArray(n) ? n : []))
                        : (o = n && w.isPlainObject(n) ? n : {}),
                      (a[t] = w.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    w.extend({
      expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || "[object Object]" !== c.call(e)) &&
          (!(t = i(e)) ||
            ("function" ==
              typeof (n = f.call(t, "constructor") && t.constructor) &&
              p.call(n) === d))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e) {
        m(e);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (C(e)) {
          for (n = e.length; r < n; r++)
            if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      trim: function (e) {
        return null == e ? "" : (e + "").replace(T, "");
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (C(Object(e))
              ? w.merge(n, "string" == typeof e ? [e] : e)
              : s.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : u.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
          (r = !t(e[o], o)) !== s && i.push(e[o]);
        return i;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          s = [];
        if (C(e))
          for (r = e.length; o < r; o++)
            null != (i = t(e[o], o, n)) && s.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && s.push(i);
        return a.apply([], s);
      },
      guid: 1,
      support: h,
    }),
    "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        l["[object " + t + "]"] = t.toLowerCase();
      }
    );
  function C(e) {
    var t = !!e && "length" in e && e.length,
      n = x(e);
    return (
      !g(e) &&
      !y(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && t > 0 && t - 1 in e))
    );
  }
  var E = (function (e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      y,
      v,
      m,
      x,
      b = "sizzle" + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      E = ae(),
      k = ae(),
      S = ae(),
      D = function (e, t) {
        return e === t && (f = !0), 0;
      },
      N = {}.hasOwnProperty,
      A = [],
      j = A.pop,
      q = A.push,
      L = A.push,
      H = A.slice,
      O = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      P =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
      I =
        "\\[" +
        M +
        "*(" +
        R +
        ")(?:" +
        M +
        "*([*^$|!~]?=)" +
        M +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        R +
        "))|)" +
        M +
        "*\\]",
      W =
        ":(" +
        R +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        I +
        ")*)|.*)\\)|)",
      $ = new RegExp(M + "+", "g"),
      B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      F = new RegExp("^" + M + "*," + M + "*"),
      _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
      X = new RegExp(W),
      U = new RegExp("^" + R + "$"),
      V = {
        ID: new RegExp("^#(" + R + ")"),
        CLASS: new RegExp("^\\.(" + R + ")"),
        TAG: new RegExp("^(" + R + "|[*])"),
        ATTR: new RegExp("^" + I),
        PSEUDO: new RegExp("^" + W),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            M +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            M +
            "*(?:([+-]|)" +
            M +
            "*(\\d+)|))" +
            M +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + P + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            M +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            M +
            "*((?:-\\d)?\\d*)" +
            M +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      G = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Q = /^[^{]+\{\s*\[native \w/,
      J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      K = /[+~]/,
      Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
      ee = function (e, t, n) {
        var r = "0x" + t - 65536;
        return r !== r || n
          ? t
          : r < 0
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
      },
      te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ne = function (e, t) {
        return t
          ? "\0" === e
            ? "\ufffd"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      re = function () {
        p();
      },
      ie = me(
        function (e) {
          return !0 === e.disabled && ("form" in e || "label" in e);
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      L.apply((A = H.call(w.childNodes)), w.childNodes),
        A[w.childNodes.length].nodeType;
    } catch (e) {
      L = {
        apply: A.length
          ? function (e, t) {
              q.apply(e, H.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            },
      };
    }
    function oe(e, t, r, i) {
      var o,
        s,
        l,
        c,
        f,
        h,
        v,
        m = t && t.ownerDocument,
        T = t ? t.nodeType : 9;
      if (
        ((r = r || []),
        "string" != typeof e || !e || (1 !== T && 9 !== T && 11 !== T))
      )
        return r;
      if (
        !i &&
        ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)
      ) {
        if (11 !== T && (f = J.exec(e)))
          if ((o = f[1])) {
            if (9 === T) {
              if (!(l = t.getElementById(o))) return r;
              if (l.id === o) return r.push(l), r;
            } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o)
              return r.push(l), r;
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
            if (
              (o = f[3]) &&
              n.getElementsByClassName &&
              t.getElementsByClassName
            )
              return L.apply(r, t.getElementsByClassName(o)), r;
          }
        if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
          if (1 !== T) (m = t), (v = e);
          else if ("object" !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute("id"))
              ? (c = c.replace(te, ne))
              : t.setAttribute("id", (c = b)),
              (s = (h = a(e)).length);
            while (s--) h[s] = "#" + c + " " + ve(h[s]);
            (v = h.join(",")), (m = (K.test(e) && ge(t.parentNode)) || t);
          }
          if (v)
            try {
              return L.apply(r, m.querySelectorAll(v)), r;
            } catch (e) {
            } finally {
              c === b && t.removeAttribute("id");
            }
        }
      }
      return u(e.replace(B, "$1"), t, r, i);
    }
    function ae() {
      var e = [];
      function t(n, i) {
        return (
          e.push(n + " ") > r.cacheLength && delete t[e.shift()],
          (t[n + " "] = i)
        );
      }
      return t;
    }
    function se(e) {
      return (e[b] = !0), e;
    }
    function ue(e) {
      var t = d.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function le(e, t) {
      var n = e.split("|"),
        i = n.length;
      while (i--) r.attrHandle[n[i]] = t;
    }
    function ce(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function fe(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ("input" === n || "button" === n) && t.type === e;
      };
    }
    function de(e) {
      return function (t) {
        return "form" in t
          ? t.parentNode && !1 === t.disabled
            ? "label" in t
              ? "label" in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && ie(t) === e)
            : t.disabled === e
          : "label" in t && t.disabled === e;
      };
    }
    function he(e) {
      return se(function (t) {
        return (
          (t = +t),
          se(function (n, r) {
            var i,
              o = e([], n.length, t),
              a = o.length;
            while (a--) n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
          })
        );
      });
    }
    function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }
    (n = oe.support = {}),
      (o = oe.isXML =
        function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && "HTML" !== t.nodeName;
        }),
      (p = oe.setDocument =
        function (e) {
          var t,
            i,
            a = e ? e.ownerDocument || e : w;
          return a !== d && 9 === a.nodeType && a.documentElement
            ? ((d = a),
              (h = d.documentElement),
              (g = !o(d)),
              w !== d &&
                (i = d.defaultView) &&
                i.top !== i &&
                (i.addEventListener
                  ? i.addEventListener("unload", re, !1)
                  : i.attachEvent && i.attachEvent("onunload", re)),
              (n.attributes = ue(function (e) {
                return (e.className = "i"), !e.getAttribute("className");
              })),
              (n.getElementsByTagName = ue(function (e) {
                return (
                  e.appendChild(d.createComment("")),
                  !e.getElementsByTagName("*").length
                );
              })),
              (n.getElementsByClassName = Q.test(d.getElementsByClassName)),
              (n.getById = ue(function (e) {
                return (
                  (h.appendChild(e).id = b),
                  !d.getElementsByName || !d.getElementsByName(b).length
                );
              })),
              n.getById
                ? ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      return e.getAttribute("id") === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && g) {
                      var n = t.getElementById(e);
                      return n ? [n] : [];
                    }
                  }))
                : ((r.filter.ID = function (e) {
                    var t = e.replace(Z, ee);
                    return function (e) {
                      var n =
                        "undefined" != typeof e.getAttributeNode &&
                        e.getAttributeNode("id");
                      return n && n.value === t;
                    };
                  }),
                  (r.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && g) {
                      var n,
                        r,
                        i,
                        o = t.getElementById(e);
                      if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                          return [o];
                        (i = t.getElementsByName(e)), (r = 0);
                        while ((o = i[r++]))
                          if ((n = o.getAttributeNode("id")) && n.value === e)
                            return [o];
                      }
                      return [];
                    }
                  })),
              (r.find.TAG = n.getElementsByTagName
                ? function (e, t) {
                    return "undefined" != typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : n.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var n,
                      r = [],
                      i = 0,
                      o = t.getElementsByTagName(e);
                    if ("*" === e) {
                      while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                      return r;
                    }
                    return o;
                  }),
              (r.find.CLASS =
                n.getElementsByClassName &&
                function (e, t) {
                  if ("undefined" != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e);
                }),
              (v = []),
              (y = []),
              (n.qsa = Q.test(d.querySelectorAll)) &&
                (ue(function (e) {
                  (h.appendChild(e).innerHTML =
                    "<a id='" +
                    b +
                    "'></a><select id='" +
                    b +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      y.push("[*^$]=" + M + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      y.push("\\[" + M + "*(?:value|" + P + ")"),
                    e.querySelectorAll("[id~=" + b + "-]").length ||
                      y.push("~="),
                    e.querySelectorAll(":checked").length || y.push(":checked"),
                    e.querySelectorAll("a#" + b + "+*").length ||
                      y.push(".#.+[+~]");
                }),
                ue(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = d.createElement("input");
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length &&
                      y.push("name" + M + "*[*^$|!~]?="),
                    2 !== e.querySelectorAll(":enabled").length &&
                      y.push(":enabled", ":disabled"),
                    (h.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(":disabled").length &&
                      y.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    y.push(",.*:");
                })),
              (n.matchesSelector = Q.test(
                (m =
                  h.matches ||
                  h.webkitMatchesSelector ||
                  h.mozMatchesSelector ||
                  h.oMatchesSelector ||
                  h.msMatchesSelector)
              )) &&
                ue(function (e) {
                  (n.disconnectedMatch = m.call(e, "*")),
                    m.call(e, "[s!='']:x"),
                    v.push("!=", W);
                }),
              (y = y.length && new RegExp(y.join("|"))),
              (v = v.length && new RegExp(v.join("|"))),
              (t = Q.test(h.compareDocumentPosition)),
              (x =
                t || Q.test(h.contains)
                  ? function (e, t) {
                      var n = 9 === e.nodeType ? e.documentElement : e,
                        r = t && t.parentNode;
                      return (
                        e === r ||
                        !(
                          !r ||
                          1 !== r.nodeType ||
                          !(n.contains
                            ? n.contains(r)
                            : e.compareDocumentPosition &&
                              16 & e.compareDocumentPosition(r))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t) while ((t = t.parentNode)) if (t === e) return !0;
                      return !1;
                    }),
              (D = t
                ? function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var r =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      r ||
                      (1 &
                        (r =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!n.sortDetached && t.compareDocumentPosition(e) === r)
                        ? e === d || (e.ownerDocument === w && x(w, e))
                          ? -1
                          : t === d || (t.ownerDocument === w && x(w, t))
                          ? 1
                          : c
                          ? O(c, e) - O(c, t)
                          : 0
                        : 4 & r
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (f = !0), 0;
                    var n,
                      r = 0,
                      i = e.parentNode,
                      o = t.parentNode,
                      a = [e],
                      s = [t];
                    if (!i || !o)
                      return e === d
                        ? -1
                        : t === d
                        ? 1
                        : i
                        ? -1
                        : o
                        ? 1
                        : c
                        ? O(c, e) - O(c, t)
                        : 0;
                    if (i === o) return ce(e, t);
                    n = e;
                    while ((n = n.parentNode)) a.unshift(n);
                    n = t;
                    while ((n = n.parentNode)) s.unshift(n);
                    while (a[r] === s[r]) r++;
                    return r
                      ? ce(a[r], s[r])
                      : a[r] === w
                      ? -1
                      : s[r] === w
                      ? 1
                      : 0;
                  }),
              d)
            : d;
        }),
      (oe.matches = function (e, t) {
        return oe(e, null, null, t);
      }),
      (oe.matchesSelector = function (e, t) {
        if (
          ((e.ownerDocument || e) !== d && p(e),
          (t = t.replace(z, "='$1']")),
          n.matchesSelector &&
            g &&
            !S[t + " "] &&
            (!v || !v.test(t)) &&
            (!y || !y.test(t)))
        )
          try {
            var r = m.call(e, t);
            if (
              r ||
              n.disconnectedMatch ||
              (e.document && 11 !== e.document.nodeType)
            )
              return r;
          } catch (e) {}
        return oe(t, d, null, [e]).length > 0;
      }),
      (oe.contains = function (e, t) {
        return (e.ownerDocument || e) !== d && p(e), x(e, t);
      }),
      (oe.attr = function (e, t) {
        (e.ownerDocument || e) !== d && p(e);
        var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
        return void 0 !== o
          ? o
          : n.attributes || !g
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null;
      }),
      (oe.escape = function (e) {
        return (e + "").replace(te, ne);
      }),
      (oe.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e);
      }),
      (oe.uniqueSort = function (e) {
        var t,
          r = [],
          i = 0,
          o = 0;
        if (
          ((f = !n.detectDuplicates),
          (c = !n.sortStable && e.slice(0)),
          e.sort(D),
          f)
        ) {
          while ((t = e[o++])) t === e[o] && (i = r.push(o));
          while (i--) e.splice(r[i], 1);
        }
        return (c = null), e;
      }),
      (i = oe.getText =
        function (e) {
          var t,
            n = "",
            r = 0,
            o = e.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else while ((t = e[r++])) n += i(t);
          return n;
        }),
      ((r = oe.selectors =
        {
          cacheLength: 50,
          createPseudo: se,
          match: V,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(Z, ee)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || oe.error(e[0]),
                    (e[4] = +(e[4]
                      ? e[5] + (e[6] || 1)
                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && oe.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                n = !e[6] && e[2];
              return V.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : n &&
                      X.test(n) &&
                      (t = a(n, !0)) &&
                      (t = n.indexOf(")", n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                  e.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(Z, ee).toLowerCase();
              return "*" === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = E[e + " "];
              return (
                t ||
                ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                  E(e, function (e) {
                    return t.test(
                      ("string" == typeof e.className && e.className) ||
                        ("undefined" != typeof e.getAttribute &&
                          e.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (e, t, n) {
              return function (r) {
                var i = oe.attr(r, e);
                return null == i
                  ? "!=" === t
                  : !t ||
                      ((i += ""),
                      "=" === t
                        ? i === n
                        : "!=" === t
                        ? i !== n
                        : "^=" === t
                        ? n && 0 === i.indexOf(n)
                        : "*=" === t
                        ? n && i.indexOf(n) > -1
                        : "$=" === t
                        ? n && i.slice(-n.length) === n
                        : "~=" === t
                        ? (" " + i.replace($, " ") + " ").indexOf(n) > -1
                        : "|=" === t &&
                          (i === n || i.slice(0, n.length + 1) === n + "-"));
              };
            },
            CHILD: function (e, t, n, r, i) {
              var o = "nth" !== e.slice(0, 3),
                a = "last" !== e.slice(-4),
                s = "of-type" === t;
              return 1 === r && 0 === i
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p,
                      d,
                      h,
                      g = o !== a ? "nextSibling" : "previousSibling",
                      y = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      m = !u && !s,
                      x = !1;
                    if (y) {
                      if (o) {
                        while (g) {
                          p = t;
                          while ((p = p[g]))
                            if (
                              s
                                ? p.nodeName.toLowerCase() === v
                                : 1 === p.nodeType
                            )
                              return !1;
                          h = g = "only" === e && !h && "nextSibling";
                        }
                        return !0;
                      }
                      if (((h = [a ? y.firstChild : y.lastChild]), a && m)) {
                        (x =
                          (d =
                            (l =
                              (c =
                                (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T &&
                            l[1]) && l[2]),
                          (p = d && y.childNodes[d]);
                        while (
                          (p = (++d && p && p[g]) || (x = d = 0) || h.pop())
                        )
                          if (1 === p.nodeType && ++x && p === t) {
                            c[e] = [T, d, x];
                            break;
                          }
                      } else if (
                        (m &&
                          (x = d =
                            (l =
                              (c =
                                (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T &&
                            l[1]),
                        !1 === x)
                      )
                        while (
                          (p = (++d && p && p[g]) || (x = d = 0) || h.pop())
                        )
                          if (
                            (s
                              ? p.nodeName.toLowerCase() === v
                              : 1 === p.nodeType) &&
                            ++x &&
                            (m &&
                              ((c =
                                (f = p[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] = [T, x]),
                            p === t)
                          )
                            break;
                      return (x -= i) === r || (x % r == 0 && x / r >= 0);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var n,
                i =
                  r.pseudos[e] ||
                  r.setFilters[e.toLowerCase()] ||
                  oe.error("unsupported pseudo: " + e);
              return i[b]
                ? i(t)
                : i.length > 1
                ? ((n = [e, e, "", t]),
                  r.setFilters.hasOwnProperty(e.toLowerCase())
                    ? se(function (e, n) {
                        var r,
                          o = i(e, t),
                          a = o.length;
                        while (a--) e[(r = O(e, o[a]))] = !(n[r] = o[a]);
                      })
                    : function (e) {
                        return i(e, 0, n);
                      })
                : i;
            },
          },
          pseudos: {
            not: se(function (e) {
              var t = [],
                n = [],
                r = s(e.replace(B, "$1"));
              return r[b]
                ? se(function (e, t, n, i) {
                    var o,
                      a = r(e, null, i, []),
                      s = e.length;
                    while (s--) (o = a[s]) && (e[s] = !(t[s] = o));
                  })
                : function (e, i, o) {
                    return (
                      (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop()
                    );
                  };
            }),
            has: se(function (e) {
              return function (t) {
                return oe(e, t).length > 0;
              };
            }),
            contains: se(function (e) {
              return (
                (e = e.replace(Z, ee)),
                function (t) {
                  return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
                }
              );
            }),
            lang: se(function (e) {
              return (
                U.test(e || "") || oe.error("unsupported lang: " + e),
                (e = e.replace(Z, ee).toLowerCase()),
                function (t) {
                  var n;
                  do {
                    if (
                      (n = g
                        ? t.lang
                        : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                    )
                      return (
                        (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                      );
                  } while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function (e) {
              return e === h;
            },
            focus: function (e) {
              return (
                e === d.activeElement &&
                (!d.hasFocus || d.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: de(!1),
            disabled: de(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return (
                ("input" === t && !!e.checked) ||
                ("option" === t && !!e.selected)
              );
            },
            selected: function (e) {
              return (
                e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
              );
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling)
                if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !r.pseudos.empty(e);
            },
            header: function (e) {
              return Y.test(e.nodeName);
            },
            input: function (e) {
              return G.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t && "button" === e.type) || "button" === t;
            },
            text: function (e) {
              var t;
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) ||
                  "text" === t.toLowerCase())
              );
            },
            first: he(function () {
              return [0];
            }),
            last: he(function (e, t) {
              return [t - 1];
            }),
            eq: he(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: he(function (e, t) {
              for (var n = 0; n < t; n += 2) e.push(n);
              return e;
            }),
            odd: he(function (e, t) {
              for (var n = 1; n < t; n += 2) e.push(n);
              return e;
            }),
            lt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; --r >= 0; ) e.push(r);
              return e;
            }),
            gt: he(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
              return e;
            }),
          },
        }).pseudos.nth = r.pseudos.eq);
    for (t in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      r.pseudos[t] = fe(t);
    for (t in { submit: !0, reset: !0 }) r.pseudos[t] = pe(t);
    function ye() {}
    (ye.prototype = r.filters = r.pseudos),
      (r.setFilters = new ye()),
      (a = oe.tokenize =
        function (e, t) {
          var n,
            i,
            o,
            a,
            s,
            u,
            l,
            c = k[e + " "];
          if (c) return t ? 0 : c.slice(0);
          (s = e), (u = []), (l = r.preFilter);
          while (s) {
            (n && !(i = F.exec(s))) ||
              (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
              (n = !1),
              (i = _.exec(s)) &&
                ((n = i.shift()),
                o.push({ value: n, type: i[0].replace(B, " ") }),
                (s = s.slice(n.length)));
            for (a in r.filter)
              !(i = V[a].exec(s)) ||
                (l[a] && !(i = l[a](i))) ||
                ((n = i.shift()),
                o.push({ value: n, type: a, matches: i }),
                (s = s.slice(n.length)));
            if (!n) break;
          }
          return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
        });
    function ve(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
      return r;
    }
    function me(e, t, n) {
      var r = t.dir,
        i = t.next,
        o = i || r,
        a = n && "parentNode" === o,
        s = C++;
      return t.first
        ? function (t, n, i) {
            while ((t = t[r])) if (1 === t.nodeType || a) return e(t, n, i);
            return !1;
          }
        : function (t, n, u) {
            var l,
              c,
              f,
              p = [T, s];
            if (u) {
              while ((t = t[r]))
                if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
            } else
              while ((t = t[r]))
                if (1 === t.nodeType || a)
                  if (
                    ((f = t[b] || (t[b] = {})),
                    (c = f[t.uniqueID] || (f[t.uniqueID] = {})),
                    i && i === t.nodeName.toLowerCase())
                  )
                    t = t[r] || t;
                  else {
                    if ((l = c[o]) && l[0] === T && l[1] === s)
                      return (p[2] = l[2]);
                    if (((c[o] = p), (p[2] = e(t, n, u)))) return !0;
                  }
            return !1;
          };
    }
    function xe(e) {
      return e.length > 1
        ? function (t, n, r) {
            var i = e.length;
            while (i--) if (!e[i](t, n, r)) return !1;
            return !0;
          }
        : e[0];
    }
    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n);
      return n;
    }
    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Te(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = Te(r)),
        i && !i[b] && (i = Te(i, o)),
        se(function (o, a, s, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || "*", s.nodeType ? [s] : s, []),
            y = !e || (!o && t) ? g : we(g, p, e, s, u),
            v = n ? (i || (o ? e : h || r) ? [] : a) : y;
          if ((n && n(y, v, s, u), r)) {
            (l = we(v, d)), r(l, [], s, u), (c = l.length);
            while (c--) (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
          if (o) {
            if (i || e) {
              if (i) {
                (l = []), (c = v.length);
                while (c--) (f = v[c]) && l.push((y[c] = f));
                i(null, (v = []), l, u);
              }
              c = v.length;
              while (c--)
                (f = v[c]) &&
                  (l = i ? O(o, f) : p[c]) > -1 &&
                  (o[l] = !(a[l] = f));
            }
          } else (v = we(v === a ? v.splice(h, v.length) : v)), i ? i(null, a, v, u) : L.apply(a, v);
        })
      );
    }
    function Ce(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          a = r.relative[e[0].type],
          s = a || r.relative[" "],
          u = a ? 1 : 0,
          c = me(
            function (e) {
              return e === t;
            },
            s,
            !0
          ),
          f = me(
            function (e) {
              return O(t, e) > -1;
            },
            s,
            !0
          ),
          p = [
            function (e, n, r) {
              var i =
                (!a && (r || n !== l)) ||
                ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
              return (t = null), i;
            },
          ];
        u < o;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [me(xe(p), n)];
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) if (r.relative[e[i].type]) break;
            return Te(
              u > 1 && xe(p),
              u > 1 &&
                ve(
                  e
                    .slice(0, u - 1)
                    .concat({ value: " " === e[u - 2].type ? "*" : "" })
                ).replace(B, "$1"),
              n,
              u < i && Ce(e.slice(u, i)),
              i < o && Ce((e = e.slice(i))),
              i < o && ve(e)
            );
          }
          p.push(n);
        }
      return xe(p);
    }
    function Ee(e, t) {
      var n = t.length > 0,
        i = e.length > 0,
        o = function (o, a, s, u, c) {
          var f,
            h,
            y,
            v = 0,
            m = "0",
            x = o && [],
            b = [],
            w = l,
            C = o || (i && r.find.TAG("*", c)),
            E = (T += null == w ? 1 : Math.random() || 0.1),
            k = C.length;
          for (
            c && (l = a === d || a || c);
            m !== k && null != (f = C[m]);
            m++
          ) {
            if (i && f) {
              (h = 0), a || f.ownerDocument === d || (p(f), (s = !g));
              while ((y = e[h++]))
                if (y(f, a || d, s)) {
                  u.push(f);
                  break;
                }
              c && (T = E);
            }
            n && ((f = !y && f) && v--, o && x.push(f));
          }
          if (((v += m), n && m !== v)) {
            h = 0;
            while ((y = t[h++])) y(x, b, a, s);
            if (o) {
              if (v > 0) while (m--) x[m] || b[m] || (b[m] = j.call(u));
              b = we(b);
            }
            L.apply(u, b),
              c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
          }
          return c && ((T = E), (l = w)), x;
        };
      return n ? se(o) : o;
    }
    return (
      (s = oe.compile =
        function (e, t) {
          var n,
            r = [],
            i = [],
            o = S[e + " "];
          if (!o) {
            t || (t = a(e)), (n = t.length);
            while (n--) (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
            (o = S(e, Ee(i, r))).selector = e;
          }
          return o;
        }),
      (u = oe.select =
        function (e, t, n, i) {
          var o,
            u,
            l,
            c,
            f,
            p = "function" == typeof e && e,
            d = !i && a((e = p.selector || e));
          if (((n = n || []), 1 === d.length)) {
            if (
              (u = d[0] = d[0].slice(0)).length > 2 &&
              "ID" === (l = u[0]).type &&
              9 === t.nodeType &&
              g &&
              r.relative[u[1].type]
            ) {
              if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0]))
                return n;
              p && (t = t.parentNode), (e = e.slice(u.shift().value.length));
            }
            o = V.needsContext.test(e) ? 0 : u.length;
            while (o--) {
              if (((l = u[o]), r.relative[(c = l.type)])) break;
              if (
                (f = r.find[c]) &&
                (i = f(
                  l.matches[0].replace(Z, ee),
                  (K.test(u[0].type) && ge(t.parentNode)) || t
                ))
              ) {
                if ((u.splice(o, 1), !(e = i.length && ve(u))))
                  return L.apply(n, i), n;
                break;
              }
            }
          }
          return (
            (p || s(e, d))(
              i,
              t,
              !g,
              n,
              !t || (K.test(e) && ge(t.parentNode)) || t
            ),
            n
          );
        }),
      (n.sortStable = b.split("").sort(D).join("") === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ue(function (e) {
        return 1 & e.compareDocumentPosition(d.createElement("fieldset"));
      })),
      ue(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        le("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (n.attributes &&
        ue(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        le("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ue(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        le(P, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      oe
    );
  })(e);
  (w.find = E),
    (w.expr = E.selectors),
    (w.expr[":"] = w.expr.pseudos),
    (w.uniqueSort = w.unique = E.uniqueSort),
    (w.text = E.getText),
    (w.isXMLDoc = E.isXML),
    (w.contains = E.contains),
    (w.escapeSelector = E.escape);
  var k = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && w(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    S = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    D = w.expr.match.needsContext;
  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function j(e, t, n) {
    return g(t)
      ? w.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n;
        })
      : t.nodeType
      ? w.grep(e, function (e) {
          return (e === t) !== n;
        })
      : "string" != typeof t
      ? w.grep(e, function (e) {
          return u.call(t, e) > -1 !== n;
        })
      : w.filter(t, e, n);
  }
  (w.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? w.find.matchesSelector(r, e)
          ? [r]
          : []
        : w.find.matches(
            e,
            w.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    w.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ("string" != typeof e)
          return this.pushStack(
            w(e).filter(function () {
              for (t = 0; t < r; t++) if (w.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) w.find(e, i[t], n);
        return r > 1 ? w.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(j(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(j(this, e || [], !0));
      },
      is: function (e) {
        return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1)
          .length;
      },
    });
  var q,
    L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((w.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || q), "string" == typeof e)) {
      if (
        !(i =
          "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
            ? [null, e, null]
            : L.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof w ? t[0] : t),
          w.merge(
            this,
            w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)
          ),
          A.test(i[1]) && w.isPlainObject(t))
        )
          for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (
        (o = r.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : g(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(w)
      : w.makeArray(e, this);
  }).prototype = w.fn),
    (q = w(r));
  var H = /^(?:parents|prev(?:Until|All))/,
    O = { children: !0, contents: !0, next: !0, prev: !0 };
  w.fn.extend({
    has: function (e) {
      var t = w(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (w.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = "string" != typeof e && w(e);
      if (!D.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a
                ? a.index(n) > -1
                : 1 === n.nodeType && w.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? u.call(w(e), this[0])
          : u.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  });
  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  w.each(
    {
      parent: function (e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function (e) {
        return k(e, "parentNode");
      },
      parentsUntil: function (e, t, n) {
        return k(e, "parentNode", n);
      },
      next: function (e) {
        return P(e, "nextSibling");
      },
      prev: function (e) {
        return P(e, "previousSibling");
      },
      nextAll: function (e) {
        return k(e, "nextSibling");
      },
      prevAll: function (e) {
        return k(e, "previousSibling");
      },
      nextUntil: function (e, t, n) {
        return k(e, "nextSibling", n);
      },
      prevUntil: function (e, t, n) {
        return k(e, "previousSibling", n);
      },
      siblings: function (e) {
        return S((e.parentNode || {}).firstChild, e);
      },
      children: function (e) {
        return S(e.firstChild);
      },
      contents: function (e) {
        return N(e, "iframe")
          ? e.contentDocument
          : (N(e, "template") && (e = e.content || e),
            w.merge([], e.childNodes));
      },
    },
    function (e, t) {
      w.fn[e] = function (n, r) {
        var i = w.map(this, t, n);
        return (
          "Until" !== e.slice(-5) && (r = n),
          r && "string" == typeof r && (i = w.filter(r, i)),
          this.length > 1 &&
            (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()),
          this.pushStack(i)
        );
      };
    }
  );
  var M = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    var t = {};
    return (
      w.each(e.match(M) || [], function (e, n) {
        t[n] = !0;
      }),
      t
    );
  }
  w.Callbacks = function (e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e);
    var t,
      n,
      r,
      i,
      o = [],
      a = [],
      s = -1,
      u = function () {
        for (i = i || e.once, r = t = !0; a.length; s = -1) {
          n = a.shift();
          while (++s < o.length)
            !1 === o[s].apply(n[0], n[1]) &&
              e.stopOnFalse &&
              ((s = o.length), (n = !1));
        }
        e.memory || (n = !1), (t = !1), i && (o = n ? [] : "");
      },
      l = {
        add: function () {
          return (
            o &&
              (n && !t && ((s = o.length - 1), a.push(n)),
              (function t(n) {
                w.each(n, function (n, r) {
                  g(r)
                    ? (e.unique && l.has(r)) || o.push(r)
                    : r && r.length && "string" !== x(r) && t(r);
                });
              })(arguments),
              n && !t && u()),
            this
          );
        },
        remove: function () {
          return (
            w.each(arguments, function (e, t) {
              var n;
              while ((n = w.inArray(t, o, n)) > -1)
                o.splice(n, 1), n <= s && s--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? w.inArray(e, o) > -1 : o.length > 0;
        },
        empty: function () {
          return o && (o = []), this;
        },
        disable: function () {
          return (i = a = []), (o = n = ""), this;
        },
        disabled: function () {
          return !o;
        },
        lock: function () {
          return (i = a = []), n || t || (o = n = ""), this;
        },
        locked: function () {
          return !!i;
        },
        fireWith: function (e, n) {
          return (
            i ||
              ((n = [e, (n = n || []).slice ? n.slice() : n]),
              a.push(n),
              t || u()),
            this
          );
        },
        fire: function () {
          return l.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!r;
        },
      };
    return l;
  };
  function I(e) {
    return e;
  }
  function W(e) {
    throw e;
  }
  function $(e, t, n, r) {
    var i;
    try {
      e && g((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && g((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  w.extend({
    Deferred: function (t) {
      var n = [
          [
            "notify",
            "progress",
            w.Callbacks("memory"),
            w.Callbacks("memory"),
            2,
          ],
          [
            "resolve",
            "done",
            w.Callbacks("once memory"),
            w.Callbacks("once memory"),
            0,
            "resolved",
          ],
          [
            "reject",
            "fail",
            w.Callbacks("once memory"),
            w.Callbacks("once memory"),
            1,
            "rejected",
          ],
        ],
        r = "pending",
        i = {
          state: function () {
            return r;
          },
          always: function () {
            return o.done(arguments).fail(arguments), this;
          },
          catch: function (e) {
            return i.then(null, e);
          },
          pipe: function () {
            var e = arguments;
            return w
              .Deferred(function (t) {
                w.each(n, function (n, r) {
                  var i = g(e[r[4]]) && e[r[4]];
                  o[r[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && g(e.promise)
                      ? e
                          .promise()
                          .progress(t.notify)
                          .done(t.resolve)
                          .fail(t.reject)
                      : t[r[0] + "With"](this, i ? [e] : arguments);
                  });
                }),
                  (e = null);
              })
              .promise();
          },
          then: function (t, r, i) {
            var o = 0;
            function a(t, n, r, i) {
              return function () {
                var s = this,
                  u = arguments,
                  l = function () {
                    var e, l;
                    if (!(t < o)) {
                      if ((e = r.apply(s, u)) === n.promise())
                        throw new TypeError("Thenable self-resolution");
                      (l =
                        e &&
                        ("object" == typeof e || "function" == typeof e) &&
                        e.then),
                        g(l)
                          ? i
                            ? l.call(e, a(o, n, I, i), a(o, n, W, i))
                            : (o++,
                              l.call(
                                e,
                                a(o, n, I, i),
                                a(o, n, W, i),
                                a(o, n, I, n.notifyWith)
                              ))
                          : (r !== I && ((s = void 0), (u = [e])),
                            (i || n.resolveWith)(s, u));
                    }
                  },
                  c = i
                    ? l
                    : function () {
                        try {
                          l();
                        } catch (e) {
                          w.Deferred.exceptionHook &&
                            w.Deferred.exceptionHook(e, c.stackTrace),
                            t + 1 >= o &&
                              (r !== W && ((s = void 0), (u = [e])),
                              n.rejectWith(s, u));
                        }
                      };
                t
                  ? c()
                  : (w.Deferred.getStackHook &&
                      (c.stackTrace = w.Deferred.getStackHook()),
                    e.setTimeout(c));
              };
            }
            return w
              .Deferred(function (e) {
                n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                  n[1][3].add(a(0, e, g(t) ? t : I)),
                  n[2][3].add(a(0, e, g(r) ? r : W));
              })
              .promise();
          },
          promise: function (e) {
            return null != e ? w.extend(e, i) : i;
          },
        },
        o = {};
      return (
        w.each(n, function (e, t) {
          var a = t[2],
            s = t[5];
          (i[t[1]] = a.add),
            s &&
              a.add(
                function () {
                  r = s;
                },
                n[3 - e][2].disable,
                n[3 - e][3].disable,
                n[0][2].lock,
                n[0][3].lock
              ),
            a.add(t[3].fire),
            (o[t[0]] = function () {
              return (
                o[t[0] + "With"](this === o ? void 0 : this, arguments), this
              );
            }),
            (o[t[0] + "With"] = a.fireWith);
        }),
        i.promise(o),
        t && t.call(o, o),
        o
      );
    },
    when: function (e) {
      var t = arguments.length,
        n = t,
        r = Array(n),
        i = o.call(arguments),
        a = w.Deferred(),
        s = function (e) {
          return function (n) {
            (r[e] = this),
              (i[e] = arguments.length > 1 ? o.call(arguments) : n),
              --t || a.resolveWith(r, i);
          };
        };
      if (
        t <= 1 &&
        ($(e, a.done(s(n)).resolve, a.reject, !t),
        "pending" === a.state() || g(i[n] && i[n].then))
      )
        return a.then();
      while (n--) $(i[n], s(n), a.reject);
      return a.promise();
    },
  });
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (w.Deferred.exceptionHook = function (t, n) {
    e.console &&
      e.console.warn &&
      t &&
      B.test(t.name) &&
      e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }),
    (w.readyException = function (t) {
      e.setTimeout(function () {
        throw t;
      });
    });
  var F = w.Deferred();
  (w.fn.ready = function (e) {
    return (
      F.then(e)["catch"](function (e) {
        w.readyException(e);
      }),
      this
    );
  }),
    w.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --w.readyWait : w.isReady) ||
          ((w.isReady = !0),
          (!0 !== e && --w.readyWait > 0) || F.resolveWith(r, [w]));
      },
    }),
    (w.ready.then = F.then);
  function _() {
    r.removeEventListener("DOMContentLoaded", _),
      e.removeEventListener("load", _),
      w.ready();
  }
  "complete" === r.readyState ||
  ("loading" !== r.readyState && !r.documentElement.doScroll)
    ? e.setTimeout(w.ready)
    : (r.addEventListener("DOMContentLoaded", _),
      e.addEventListener("load", _));
  var z = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ("object" === x(n)) {
        i = !0;
        for (s in n) z(e, t, s, n[s], !0, o, a);
      } else if (
        void 0 !== r &&
        ((i = !0),
        g(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(w(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    X = /^-ms-/,
    U = /-([a-z])/g;
  function V(e, t) {
    return t.toUpperCase();
  }
  function G(e) {
    return e.replace(X, "ms-").replace(U, V);
  }
  var Y = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function Q() {
    this.expando = w.expando + Q.uid++;
  }
  (Q.uid = 1),
    (Q.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ("string" == typeof t) i[G(t)] = n;
        else for (r in t) i[G(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][G(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(G)
              : (t = G(t)) in r
              ? [t]
              : t.match(M) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || w.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !w.isEmptyObject(t);
      },
    });
  var J = new Q(),
    K = new Q(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ee = /[A-Z]/g;
  function te(e) {
    return (
      "true" === e ||
      ("false" !== e &&
        ("null" === e
          ? null
          : e === +e + ""
          ? +e
          : Z.test(e)
          ? JSON.parse(e)
          : e))
    );
  }
  function ne(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(ee, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n = te(n);
        } catch (e) {}
        K.set(e, t, n);
      } else n = void 0;
    return n;
  }
  w.extend({
    hasData: function (e) {
      return K.hasData(e) || J.hasData(e);
    },
    data: function (e, t, n) {
      return K.access(e, t, n);
    },
    removeData: function (e, t) {
      K.remove(e, t);
    },
    _data: function (e, t, n) {
      return J.access(e, t, n);
    },
    _removeData: function (e, t) {
      J.remove(e, t);
    },
  }),
    w.fn.extend({
      data: function (e, t) {
        var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === e) {
          if (
            this.length &&
            ((i = K.get(o)), 1 === o.nodeType && !J.get(o, "hasDataAttrs"))
          ) {
            n = a.length;
            while (n--)
              a[n] &&
                0 === (r = a[n].name).indexOf("data-") &&
                ((r = G(r.slice(5))), ne(o, r, i[r]));
            J.set(o, "hasDataAttrs", !0);
          }
          return i;
        }
        return "object" == typeof e
          ? this.each(function () {
              K.set(this, e);
            })
          : z(
              this,
              function (t) {
                var n;
                if (o && void 0 === t) {
                  if (void 0 !== (n = K.get(o, e))) return n;
                  if (void 0 !== (n = ne(o, e))) return n;
                } else
                  this.each(function () {
                    K.set(this, e, t);
                  });
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e);
        });
      },
    }),
    w.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (r = J.get(e, t)),
            n &&
              (!r || Array.isArray(n)
                ? (r = J.access(e, t, w.makeArray(n)))
                : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function () {
            w.dequeue(e, t);
          };
        "inprogress" === i && ((i = n.shift()), r--),
          i &&
            ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(e, a, o)),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return (
          J.get(e, n) ||
          J.access(e, n, {
            empty: w.Callbacks("once memory").add(function () {
              J.remove(e, [t + "queue", n]);
            }),
          })
        );
      },
    }),
    w.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return (
          "string" != typeof e && ((t = e), (e = "fx"), n--),
          arguments.length < n
            ? w.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e),
                  "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          w.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
        while (a--)
          (n = J.get(o[a], e + "queueHooks")) &&
            n.empty &&
            (r++, n.empty.add(s));
        return s(), i.promise(t);
      },
    });
  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
    oe = ["Top", "Right", "Bottom", "Left"],
    ae = function (e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display &&
          w.contains(e.ownerDocument, e) &&
          "none" === w.css(e, "display"))
      );
    },
    se = function (e, t, n, r) {
      var i,
        o,
        a = {};
      for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
      i = n.apply(e, r || []);
      for (o in t) e.style[o] = a[o];
      return i;
    };
  function ue(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return w.css(e, t, "");
          },
      u = s(),
      l = (n && n[3]) || (w.cssNumber[t] ? "" : "px"),
      c = (w.cssNumber[t] || ("px" !== l && +u)) && ie.exec(w.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        w.style(e, t, c + l),
          (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
          (c /= o);
      (c *= 2), w.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var le = {};
  function ce(e) {
    var t,
      n = e.ownerDocument,
      r = e.nodeName,
      i = le[r];
    return (
      i ||
      ((t = n.body.appendChild(n.createElement(r))),
      (i = w.css(t, "display")),
      t.parentNode.removeChild(t),
      "none" === i && (i = "block"),
      (le[r] = i),
      i)
    );
  }
  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
      (r = e[o]).style &&
        ((n = r.style.display),
        t
          ? ("none" === n &&
              ((i[o] = J.get(r, "display") || null),
              i[o] || (r.style.display = "")),
            "" === r.style.display && ae(r) && (i[o] = ce(r)))
          : "none" !== n && ((i[o] = "none"), J.set(r, "display", n)));
    for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
    return e;
  }
  w.fn.extend({
    show: function () {
      return fe(this, !0);
    },
    hide: function () {
      return fe(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? w(this).show() : w(this).hide();
          });
    },
  });
  var pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i,
    ge = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
  (ge.optgroup = ge.option),
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td);
  function ye(e, t) {
    var n;
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && N(e, t)) ? w.merge([e], n) : n
    );
  }
  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
  }
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o,
        a,
        s,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        d = 0,
        h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ("object" === x(o)) w.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement("div"))),
            (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          w.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
        } else p.push(t.createTextNode(o));
    (f.textContent = ""), (d = 0);
    while ((o = p[d++]))
      if (r && w.inArray(o, r) > -1) i && i.push(o);
      else if (
        ((l = w.contains(o.ownerDocument, o)),
        (a = ye(f.appendChild(o), "script")),
        l && ve(a),
        n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || "") && n.push(o);
      }
    return f;
  }
  !(function () {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
      t = r.createElement("input");
    t.setAttribute("type", "radio"),
      t.setAttribute("checked", "checked"),
      t.setAttribute("name", "t"),
      e.appendChild(t),
      (h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (e.innerHTML = "<textarea>x</textarea>"),
      (h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
  })();
  var be = r.documentElement,
    we = /^key/,
    Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Ce = /^([^.]*)(?:\.(.+)|)/;
  function Ee() {
    return !0;
  }
  function ke() {
    return !1;
  }
  function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }
  function De(e, t, n, r, i, o) {
    var a, s;
    if ("object" == typeof t) {
      "string" != typeof n && ((r = r || n), (n = void 0));
      for (s in t) De(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ke;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return w().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = w.guid++))),
      e.each(function () {
        w.event.add(this, t, i, r, n);
      })
    );
  }
  (w.event = {
    global: {},
    add: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.get(e);
      if (y) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && w.find.matchesSelector(be, i),
          n.guid || (n.guid = w.guid++),
          (u = y.events) || (u = y.events = {}),
          (a = y.handle) ||
            (a = y.handle =
              function (t) {
                return "undefined" != typeof w && w.event.triggered !== t.type
                  ? w.event.dispatch.apply(e, arguments)
                  : void 0;
              }),
          (l = (t = (t || "").match(M) || [""]).length);
        while (l--)
          (d = g = (s = Ce.exec(t[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d &&
              ((f = w.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = w.event.special[d] || {}),
              (c = w.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && w.expr.match.needsContext.test(i),
                  namespace: h.join("."),
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                  (e.addEventListener && e.addEventListener(d, a))),
              f.add &&
                (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (w.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.hasData(e) && J.get(e);
      if (y && (u = y.events)) {
        l = (t = (t || "").match(M) || [""]).length;
        while (l--)
          if (
            ((s = Ce.exec(t[l]) || []),
            (d = g = s[1]),
            (h = (s[2] || "").split(".").sort()),
            d)
          ) {
            (f = w.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s =
                s[2] &&
                new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, y.handle)) ||
                w.removeEvent(e, d, y.handle),
              delete u[d]);
          } else for (d in u) w.event.remove(e, d + t[l], n, r, !0);
        w.isEmptyObject(u) && J.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t = w.event.fix(e),
        n,
        r,
        i,
        o,
        a,
        s,
        u = new Array(arguments.length),
        l = (J.get(this, "events") || {})[t.type] || [],
        c = w.event.special[t.type] || {};
      for (u[0] = t, n = 1; n < arguments.length; n++) u[n] = arguments[n];
      if (
        ((t.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, t))
      ) {
        (s = w.event.handlers.call(this, t, l)), (n = 0);
        while ((o = s[n++]) && !t.isPropagationStopped()) {
          (t.currentTarget = o.elem), (r = 0);
          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
            (t.rnamespace && !t.rnamespace.test(a.namespace)) ||
              ((t.handleObj = a),
              (t.data = a.data),
              void 0 !==
                (i = (
                  (w.event.special[a.origType] || {}).handle || a.handler
                ).apply(o.elem, u)) &&
                !1 === (t.result = i) &&
                (t.preventDefault(), t.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !("click" === e.type && e.button >= 1))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + " ")] &&
                (a[i] = r.needsContext
                  ? w(i, this).index(l) > -1
                  : w.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({ elem: l, handlers: o });
          }
      return (
        (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
      );
    },
    addProp: function (e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t,
          });
        },
      });
    },
    fix: function (e) {
      return e[w.expando] ? e : new w.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          if (this !== Se() && this.focus) return this.focus(), !1;
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          if (this === Se() && this.blur) return this.blur(), !1;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          if ("checkbox" === this.type && this.click && N(this, "input"))
            return this.click(), !1;
        },
        _default: function (e) {
          return N(e.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (w.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (w.Event = function (e, t) {
      if (!(this instanceof w.Event)) return new w.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ee
              : ke),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && w.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[w.expando] = !0);
    }),
    (w.Event.prototype = {
      constructor: w.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ee),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ee),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ee),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    w.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Te.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      w.event.addProp
    ),
    w.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, t) {
        w.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
            return (
              (i && (i === r || w.contains(r, i))) ||
                ((e.type = o.origType),
                (n = o.handler.apply(this, arguments)),
                (e.type = t)),
              n
            );
          },
        };
      }
    ),
    w.fn.extend({
      on: function (e, t, n, r) {
        return De(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return De(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            w(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ke),
          this.each(function () {
            w.event.remove(this, e, n, t);
          })
        );
      },
    });
  var Ne =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Ae = /<script|<style|<link/i,
    je = /checked\s*(?:[^=]|=\s*.checked.)/i,
    qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function Le(e, t) {
    return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr")
      ? w(e).children("tbody")[0] || e
      : e;
  }
  function He(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function Oe(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Pe(e, t) {
    var n, r, i, o, a, s, u, l;
    if (1 === t.nodeType) {
      if (
        J.hasData(e) &&
        ((o = J.access(e)), (a = J.set(t, o)), (l = o.events))
      ) {
        delete a.handle, (a.events = {});
        for (i in l)
          for (n = 0, r = l[i].length; n < r; n++) w.event.add(t, i, l[i][n]);
      }
      K.hasData(e) && ((s = K.access(e)), (u = w.extend({}, s)), K.set(t, u));
    }
  }
  function Me(e, t) {
    var n = t.nodeName.toLowerCase();
    "input" === n && pe.test(e.type)
      ? (t.checked = e.checked)
      : ("input" !== n && "textarea" !== n) ||
        (t.defaultValue = e.defaultValue);
  }
  function Re(e, t, n, r) {
    t = a.apply([], t);
    var i,
      o,
      s,
      u,
      l,
      c,
      f = 0,
      p = e.length,
      d = p - 1,
      y = t[0],
      v = g(y);
    if (v || (p > 1 && "string" == typeof y && !h.checkClone && je.test(y)))
      return e.each(function (i) {
        var o = e.eq(i);
        v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
      });
    if (
      p &&
      ((i = xe(t, e[0].ownerDocument, !1, e, r)),
      (o = i.firstChild),
      1 === i.childNodes.length && (i = o),
      o || r)
    ) {
      for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++)
        (l = i),
          f !== d &&
            ((l = w.clone(l, !0, !0)), u && w.merge(s, ye(l, "script"))),
          n.call(e[f], l, f);
      if (u)
        for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++)
          (l = s[f]),
            he.test(l.type || "") &&
              !J.access(l, "globalEval") &&
              w.contains(c, l) &&
              (l.src && "module" !== (l.type || "").toLowerCase()
                ? w._evalUrl && w._evalUrl(l.src)
                : m(l.textContent.replace(qe, ""), c, l));
    }
    return e;
  }
  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || w.cleanData(ye(r)),
        r.parentNode &&
          (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")),
          r.parentNode.removeChild(r));
    return e;
  }
  w.extend({
    htmlPrefilter: function (e) {
      return e.replace(Ne, "<$1></$2>");
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s = e.cloneNode(!0),
        u = w.contains(e.ownerDocument, e);
      if (
        !(
          h.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          w.isXMLDoc(e)
        )
      )
        for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++)
          Me(o[r], a[r]);
      if (t)
        if (n)
          for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++)
            Pe(o[r], a[r]);
        else Pe(e, s);
      return (
        (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")), s
      );
    },
    cleanData: function (e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (Y(n)) {
          if ((t = n[J.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            n[J.expando] = void 0;
          }
          n[K.expando] && (n[K.expando] = void 0);
        }
    },
  }),
    w.fn.extend({
      detach: function (e) {
        return Ie(this, e, !0);
      },
      remove: function (e) {
        return Ie(this, e);
      },
      text: function (e) {
        return z(
          this,
          function (e) {
            return void 0 === e
              ? w.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Re(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            Le(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Re(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = Le(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Re(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (w.cleanData(ye(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return w.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return z(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Ae.test(e) &&
              !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = w.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (w.cleanData(ye(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return Re(
          this,
          arguments,
          function (t) {
            var n = this.parentNode;
            w.inArray(this, e) < 0 &&
              (w.cleanData(ye(this)), n && n.replaceChild(t, this));
          },
          e
        );
      },
    }),
    w.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, t) {
        w.fn[e] = function (e) {
          for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
            (n = a === o ? this : this.clone(!0)),
              w(i[a])[t](n),
              s.apply(r, n.get());
          return this.pushStack(r);
        };
      }
    );
  var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
    $e = function (t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    Be = new RegExp(oe.join("|"), "i");
  !(function () {
    function t() {
      if (c) {
        (l.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (c.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          be.appendChild(l).appendChild(c);
        var t = e.getComputedStyle(c);
        (i = "1%" !== t.top),
          (u = 12 === n(t.marginLeft)),
          (c.style.right = "60%"),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (c.style.position = "absolute"),
          (a = 36 === c.offsetWidth || "absolute"),
          be.removeChild(l),
          (c = null);
      }
    }
    function n(e) {
      return Math.round(parseFloat(e));
    }
    var i,
      o,
      a,
      s,
      u,
      l = r.createElement("div"),
      c = r.createElement("div");
    c.style &&
      ((c.style.backgroundClip = "content-box"),
      (c.cloneNode(!0).style.backgroundClip = ""),
      (h.clearCloneStyle = "content-box" === c.style.backgroundClip),
      w.extend(h, {
        boxSizingReliable: function () {
          return t(), o;
        },
        pixelBoxStyles: function () {
          return t(), s;
        },
        pixelPosition: function () {
          return t(), i;
        },
        reliableMarginLeft: function () {
          return t(), u;
        },
        scrollboxSize: function () {
          return t(), a;
        },
      }));
  })();
  function Fe(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || $e(e)) &&
        ("" !== (a = n.getPropertyValue(t) || n[t]) ||
          w.contains(e.ownerDocument, e) ||
          (a = w.style(e, t)),
        !h.pixelBoxStyles() &&
          We.test(a) &&
          Be.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + "" : a
    );
  }
  function _e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  var ze = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ue = { position: "absolute", visibility: "hidden", display: "block" },
    Ve = { letterSpacing: "0", fontWeight: "400" },
    Ge = ["Webkit", "Moz", "ms"],
    Ye = r.createElement("div").style;
  function Qe(e) {
    if (e in Ye) return e;
    var t = e[0].toUpperCase() + e.slice(1),
      n = Ge.length;
    while (n--) if ((e = Ge[n] + t) in Ye) return e;
  }
  function Je(e) {
    var t = w.cssProps[e];
    return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }
  function Ke(e, t, n) {
    var r = ie.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }
  function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? "border" : "content")) return 0;
    for (; a < 4; a += 2)
      "margin" === n && (u += w.css(e, n + oe[a], !0, i)),
        r
          ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)),
            "margin" !== n &&
              (u -= w.css(e, "border" + oe[a] + "Width", !0, i)))
          : ((u += w.css(e, "padding" + oe[a], !0, i)),
            "padding" !== n
              ? (u += w.css(e, "border" + oe[a] + "Width", !0, i))
              : (s += w.css(e, "border" + oe[a] + "Width", !0, i)));
    return (
      !r &&
        o >= 0 &&
        (u += Math.max(
          0,
          Math.ceil(
            e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5
          )
        )),
      u
    );
  }
  function et(e, t, n) {
    var r = $e(e),
      i = Fe(e, t, r),
      o = "border-box" === w.css(e, "boxSizing", !1, r),
      a = o;
    if (We.test(i)) {
      if (!n) return i;
      i = "auto";
    }
    return (
      (a = a && (h.boxSizingReliable() || i === e.style[t])),
      ("auto" === i ||
        (!parseFloat(i) && "inline" === w.css(e, "display", !1, r))) &&
        ((i = e["offset" + t[0].toUpperCase() + t.slice(1)]), (a = !0)),
      (i = parseFloat(i) || 0) +
        Ze(e, t, n || (o ? "border" : "content"), a, r, i) +
        "px"
    );
  }
  w.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Fe(e, "opacity");
            return "" === n ? "1" : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = G(t),
          u = Xe.test(t),
          l = e.style;
        if (
          (u || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]), void 0 === n)
        )
          return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" == (o = typeof n) &&
          (i = ie.exec(n)) &&
          i[1] &&
          ((n = ue(e, t, i)), (o = "number")),
          null != n &&
            n === n &&
            ("number" === o &&
              (n += (i && i[3]) || (w.cssNumber[s] ? "" : "px")),
            h.clearCloneStyle ||
              "" !== n ||
              0 !== t.indexOf("background") ||
              (l[t] = "inherit"),
            (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = G(t);
      return (
        Xe.test(t) || (t = Je(s)),
        (a = w.cssHooks[t] || w.cssHooks[s]) &&
          "get" in a &&
          (i = a.get(e, !0, n)),
        void 0 === i && (i = Fe(e, t, r)),
        "normal" === i && t in Ve && (i = Ve[t]),
        "" === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    },
  }),
    w.each(["height", "width"], function (e, t) {
      w.cssHooks[t] = {
        get: function (e, n, r) {
          if (n)
            return !ze.test(w.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? et(e, t, r)
              : se(e, Ue, function () {
                  return et(e, t, r);
                });
        },
        set: function (e, n, r) {
          var i,
            o = $e(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            s = r && Ze(e, t, r, a, o);
          return (
            a &&
              h.scrollboxSize() === o.position &&
              (s -= Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(o[t]) -
                  Ze(e, t, "border", !1, o) -
                  0.5
              )),
            s &&
              (i = ie.exec(n)) &&
              "px" !== (i[3] || "px") &&
              ((e.style[t] = n), (n = w.css(e, t))),
            Ke(e, n, s)
          );
        },
      };
    }),
    (w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Fe(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              se(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    w.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
      (w.cssHooks[e + t] = {
        expand: function (n) {
          for (
            var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n];
            r < 4;
            r++
          )
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
          return i;
        },
      }),
        "margin" !== e && (w.cssHooks[e + t].set = Ke);
    }),
    w.fn.extend({
      css: function (e, t) {
        return z(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = $e(e), i = t.length; a < i; a++)
                o[t[a]] = w.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
          },
          e,
          t,
          arguments.length > 1
        );
      },
    });
  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }
  (w.Tween = tt),
    (tt.prototype = {
      constructor: tt,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || w.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (w.cssNumber[n] ? "" : "px"));
      },
      cur: function () {
        var e = tt.propHooks[this.prop];
        return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = tt.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                w.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : tt.propHooks._default.set(this),
          this
        );
      },
    }),
    (tt.prototype.init.prototype = tt.prototype),
    (tt.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = w.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          w.fx.step[e.prop]
            ? w.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : w.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }),
    (tt.propHooks.scrollTop = tt.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (w.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (w.fx = tt.prototype.init),
    (w.fx.step = {});
  var nt,
    rt,
    it = /^(?:toggle|show|hide)$/,
    ot = /queueHooks$/;
  function at() {
    rt &&
      (!1 === r.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(at)
        : e.setTimeout(at, w.fx.interval),
      w.fx.tick());
  }
  function st() {
    return (
      e.setTimeout(function () {
        nt = void 0;
      }),
      (nt = Date.now())
    );
  }
  function ut(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; r < 4; r += 2 - t)
      i["margin" + (n = oe[r])] = i["padding" + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function lt(e, t, n) {
    for (
      var r,
        i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]),
        o = 0,
        a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ct(e, t, n) {
    var r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f = "width" in t || "height" in t,
      p = this,
      d = {},
      h = e.style,
      g = e.nodeType && ae(e),
      y = J.get(e, "fxshow");
    n.queue ||
      (null == (a = w._queueHooks(e, "fx")).unqueued &&
        ((a.unqueued = 0),
        (s = a.empty.fire),
        (a.empty.fire = function () {
          a.unqueued || s();
        })),
      a.unqueued++,
      p.always(function () {
        p.always(function () {
          a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
        });
      }));
    for (r in t)
      if (((i = t[r]), it.test(i))) {
        if (
          (delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))
        ) {
          if ("show" !== i || !y || void 0 === y[r]) continue;
          g = !0;
        }
        d[r] = (y && y[r]) || w.style(e, r);
      }
    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f &&
        1 === e.nodeType &&
        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
        null == (l = y && y.display) && (l = J.get(e, "display")),
        "none" === (c = w.css(e, "display")) &&
          (l
            ? (c = l)
            : (fe([e], !0),
              (l = e.style.display || l),
              (c = w.css(e, "display")),
              fe([e]))),
        ("inline" === c || ("inline-block" === c && null != l)) &&
          "none" === w.css(e, "float") &&
          (u ||
            (p.done(function () {
              h.display = l;
            }),
            null == l && ((c = h.display), (l = "none" === c ? "" : c))),
          (h.display = "inline-block"))),
        n.overflow &&
          ((h.overflow = "hidden"),
          p.always(function () {
            (h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2]);
          })),
        (u = !1);
      for (r in d)
        u ||
          (y
            ? "hidden" in y && (g = y.hidden)
            : (y = J.access(e, "fxshow", { display: l })),
          o && (y.hidden = !g),
          g && fe([e], !0),
          p.done(function () {
            g || fe([e]), J.remove(e, "fxshow");
            for (r in d) w.style(e, r, d[r]);
          })),
          (u = lt(g ? y[r] : 0, r, p)),
          r in y || ((y[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
    }
  }
  function ft(e, t) {
    var n, r, i, o, a;
    for (n in e)
      if (
        ((r = G(n)),
        (i = t[r]),
        (o = e[n]),
        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
        n !== r && ((e[r] = o), delete e[n]),
        (a = w.cssHooks[r]) && "expand" in a)
      ) {
        (o = a.expand(o)), delete e[r];
        for (n in o) n in e || ((e[n] = o[n]), (t[n] = i));
      } else t[r] = i;
  }
  function pt(e, t, n) {
    var r,
      i,
      o = 0,
      a = pt.prefilters.length,
      s = w.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (i) return !1;
        for (
          var t = nt || st(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            a = l.tweens.length;
          o < a;
          o++
        )
          l.tweens[o].run(r);
        return (
          s.notifyWith(e, [l, r, n]),
          r < 1 && a
            ? n
            : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
        );
      },
      l = s.promise({
        elem: e,
        props: w.extend({}, t),
        opts: w.extend(!0, { specialEasing: {}, easing: w.easing._default }, n),
        originalProperties: t,
        originalOptions: n,
        startTime: nt || st(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var r = w.Tween(
            e,
            l.opts,
            t,
            n,
            l.opts.specialEasing[t] || l.opts.easing
          );
          return l.tweens.push(r), r;
        },
        stop: function (t) {
          var n = 0,
            r = t ? l.tweens.length : 0;
          if (i) return this;
          for (i = !0; n < r; n++) l.tweens[n].run(1);
          return (
            t
              ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t]))
              : s.rejectWith(e, [l, t]),
            this
          );
        },
      }),
      c = l.props;
    for (ft(c, l.opts.specialEasing); o < a; o++)
      if ((r = pt.prefilters[o].call(l, e, c, l.opts)))
        return (
          g(r.stop) &&
            (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
          r
        );
    return (
      w.map(c, lt, l),
      g(l.opts.start) && l.opts.start.call(e, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      w.fx.timer(w.extend(u, { elem: e, anim: l, queue: l.opts.queue })),
      l
    );
  }
  (w.Animation = w.extend(pt, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t);
          return ue(n.elem, e, ie.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      g(e) ? ((t = e), (e = ["*"])) : (e = e.match(M));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]),
          (pt.tweeners[n] = pt.tweeners[n] || []),
          pt.tweeners[n].unshift(t);
    },
    prefilters: [ct],
    prefilter: function (e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    },
  })),
    (w.speed = function (e, t, n) {
      var r =
        e && "object" == typeof e
          ? w.extend({}, e)
          : {
              complete: n || (!n && t) || (g(e) && e),
              duration: e,
              easing: (n && t) || (t && !g(t) && t),
            };
      return (
        w.fx.off
          ? (r.duration = 0)
          : "number" != typeof r.duration &&
            (r.duration in w.fx.speeds
              ? (r.duration = w.fx.speeds[r.duration])
              : (r.duration = w.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function () {
          g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
        }),
        r
      );
    }),
    w.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function (e, t, n, r) {
        var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function () {
            var t = pt(this, w.extend({}, e), o);
            (i || J.get(this, "finish")) && t.stop(!0);
          };
        return (
          (a.finish = a),
          i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        );
      },
      stop: function (e, t, n) {
        var r = function (e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          "string" != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || "fx", []),
          this.each(function () {
            var t = !0,
              i = null != e && e + "queueHooks",
              o = w.timers,
              a = J.get(this);
            if (i) a[i] && a[i].stop && r(a[i]);
            else for (i in a) a[i] && a[i].stop && ot.test(i) && r(a[i]);
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
            (!t && n) || w.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function () {
            var t,
              n = J.get(this),
              r = n[e + "queue"],
              i = n[e + "queueHooks"],
              o = w.timers,
              a = r ? r.length : 0;
            for (
              n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this &&
                o[t].queue === e &&
                (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; t < a; t++)
              r[t] && r[t].finish && r[t].finish.call(this);
            delete n.finish;
          })
        );
      },
    }),
    w.each(["toggle", "show", "hide"], function (e, t) {
      var n = w.fn[t];
      w.fn[t] = function (e, r, i) {
        return null == e || "boolean" == typeof e
          ? n.apply(this, arguments)
          : this.animate(ut(t, !0), e, r, i);
      };
    }),
    w.each(
      {
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, t) {
        w.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }
    ),
    (w.timers = []),
    (w.fx.tick = function () {
      var e,
        t = 0,
        n = w.timers;
      for (nt = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || w.fx.stop(), (nt = void 0);
    }),
    (w.fx.timer = function (e) {
      w.timers.push(e), w.fx.start();
    }),
    (w.fx.interval = 13),
    (w.fx.start = function () {
      rt || ((rt = !0), at());
    }),
    (w.fx.stop = function () {
      rt = null;
    }),
    (w.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (w.fn.delay = function (t, n) {
      return (
        (t = w.fx ? w.fx.speeds[t] || t : t),
        (n = n || "fx"),
        this.queue(n, function (n, r) {
          var i = e.setTimeout(n, t);
          r.stop = function () {
            e.clearTimeout(i);
          };
        })
      );
    }),
    (function () {
      var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"));
      (e.type = "checkbox"),
        (h.checkOn = "" !== e.value),
        (h.optSelected = t.selected),
        ((e = r.createElement("input")).value = "t"),
        (e.type = "radio"),
        (h.radioValue = "t" === e.value);
    })();
  var dt,
    ht = w.expr.attrHandle;
  w.fn.extend({
    attr: function (e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    },
    removeAttr: function (e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    },
  }),
    w.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return "undefined" == typeof e.getAttribute
            ? w.prop(e, t, n)
            : ((1 === o && w.isXMLDoc(e)) ||
                (i =
                  w.attrHooks[t.toLowerCase()] ||
                  (w.expr.match.bool.test(t) ? dt : void 0)),
              void 0 !== n
                ? null === n
                  ? void w.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = w.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!h.radioValue && "radio" === t && N(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(M);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      },
    }),
    (dt = {
      set: function (e, t, n) {
        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = ht[t] || w.find.attr;
      ht[t] = function (e, t, r) {
        var i,
          o,
          a = t.toLowerCase();
        return (
          r ||
            ((o = ht[a]),
            (ht[a] = i),
            (i = null != n(e, t, r) ? a : null),
            (ht[a] = o)),
          i
        );
      };
    });
  var gt = /^(?:input|select|textarea|button)$/i,
    yt = /^(?:a|area)$/i;
  w.fn.extend({
    prop: function (e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    },
  }),
    w.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && w.isXMLDoc(e)) ||
              ((t = w.propFix[t] || t), (i = w.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = w.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : gt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    h.optSelected ||
      (w.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    w.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        w.propFix[this.toLowerCase()] = this;
      }
    );
  function vt(e) {
    return (e.match(M) || []).join(" ");
  }
  function mt(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function xt(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : [];
  }
  w.fn.extend({
    addClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).addClass(e.call(this, t, mt(this)));
        });
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0;
            while ((o = t[a++])) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
            i !== (s = vt(r)) && n.setAttribute("class", s);
          }
      return this;
    },
    removeClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function (t) {
          w(this).removeClass(e.call(this, t, mt(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0;
            while ((o = t[a++]))
              while (r.indexOf(" " + o + " ") > -1)
                r = r.replace(" " + o + " ", " ");
            i !== (s = vt(r)) && n.setAttribute("class", s);
          }
      return this;
    },
    toggleClass: function (e, t) {
      var n = typeof e,
        r = "string" === n || Array.isArray(e);
      return "boolean" == typeof t && r
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : g(e)
        ? this.each(function (n) {
            w(this).toggleClass(e.call(this, n, mt(this), t), t);
          })
        : this.each(function () {
            var t, i, o, a;
            if (r) {
              (i = 0), (o = w(this)), (a = xt(e));
              while ((t = a[i++]))
                o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else (void 0 !== e && "boolean" !== n) || ((t = mt(this)) && J.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""));
          });
    },
    hasClass: function (e) {
      var t,
        n,
        r = 0;
      t = " " + e + " ";
      while ((n = this[r++]))
        if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1)
          return !0;
      return !1;
    },
  });
  var bt = /\r/g;
  w.fn.extend({
    val: function (e) {
      var t,
        n,
        r,
        i = this[0];
      {
        if (arguments.length)
          return (
            (r = g(e)),
            this.each(function (n) {
              var i;
              1 === this.nodeType &&
                (null == (i = r ? e.call(this, n, w(this).val()) : e)
                  ? (i = "")
                  : "number" == typeof i
                  ? (i += "")
                  : Array.isArray(i) &&
                    (i = w.map(i, function (e) {
                      return null == e ? "" : e + "";
                    })),
                ((t =
                  w.valHooks[this.type] ||
                  w.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, i, "value")) ||
                  (this.value = i));
            })
          );
        if (i)
          return (t =
            w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (n = t.get(i, "value"))
            ? n
            : "string" == typeof (n = i.value)
            ? n.replace(bt, "")
            : null == n
            ? ""
            : n;
      }
    },
  }),
    w.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = w.find.attr(e, "value");
            return null != t ? t : vt(w.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))
              ) {
                if (((t = w(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected =
                w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    w.each(["radio", "checkbox"], function () {
      (w.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = w.inArray(w(e).val(), t) > -1);
        },
      }),
        h.checkOn ||
          (w.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (h.focusin = "onfocusin" in e);
  var wt = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function (e) {
      e.stopPropagation();
    };
  w.extend(w.event, {
    trigger: function (t, n, i, o) {
      var a,
        s,
        u,
        l,
        c,
        p,
        d,
        h,
        v = [i || r],
        m = f.call(t, "type") ? t.type : t,
        x = f.call(t, "namespace") ? t.namespace.split(".") : [];
      if (
        ((s = h = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !wt.test(m + w.event.triggered) &&
          (m.indexOf(".") > -1 && ((m = (x = m.split(".")).shift()), x.sort()),
          (c = m.indexOf(":") < 0 && "on" + m),
          (t = t[w.expando] ? t : new w.Event(m, "object" == typeof t && t)),
          (t.isTrigger = o ? 2 : 3),
          (t.namespace = x.join(".")),
          (t.rnamespace = t.namespace
            ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : w.makeArray(n, [t])),
          (d = w.event.special[m] || {}),
          o || !d.trigger || !1 !== d.trigger.apply(i, n)))
      ) {
        if (!o && !d.noBubble && !y(i)) {
          for (
            l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode);
            s;
            s = s.parentNode
          )
            v.push(s), (u = s);
          u === (i.ownerDocument || r) &&
            v.push(u.defaultView || u.parentWindow || e);
        }
        a = 0;
        while ((s = v[a++]) && !t.isPropagationStopped())
          (h = s),
            (t.type = a > 1 ? l : d.bindType || m),
            (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) &&
              p.apply(s, n),
            (p = c && s[c]) &&
              p.apply &&
              Y(s) &&
              ((t.result = p.apply(s, n)),
              !1 === t.result && t.preventDefault());
        return (
          (t.type = m),
          o ||
            t.isDefaultPrevented() ||
            (d._default && !1 !== d._default.apply(v.pop(), n)) ||
            !Y(i) ||
            (c &&
              g(i[m]) &&
              !y(i) &&
              ((u = i[c]) && (i[c] = null),
              (w.event.triggered = m),
              t.isPropagationStopped() && h.addEventListener(m, Tt),
              i[m](),
              t.isPropagationStopped() && h.removeEventListener(m, Tt),
              (w.event.triggered = void 0),
              u && (i[c] = u))),
          t.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 });
      w.event.trigger(r, null, t);
    },
  }),
    w.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          w.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return w.event.trigger(e, t, n, !0);
      },
    }),
    h.focusin ||
      w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        var n = function (e) {
          w.event.simulate(t, e.target, w.event.fix(e));
        };
        w.event.special[t] = {
          setup: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t);
            i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
          },
          teardown: function () {
            var r = this.ownerDocument || this,
              i = J.access(r, t) - 1;
            i
              ? J.access(r, t, i)
              : (r.removeEventListener(e, n, !0), J.remove(r, t));
          },
        };
      });
  var Ct = e.location,
    Et = Date.now(),
    kt = /\?/;
  w.parseXML = function (t) {
    var n;
    if (!t || "string" != typeof t) return null;
    try {
      n = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (e) {
      n = void 0;
    }
    return (
      (n && !n.getElementsByTagName("parsererror").length) ||
        w.error("Invalid XML: " + t),
      n
    );
  };
  var St = /\[\]$/,
    Dt = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    At = /^(?:input|select|textarea|keygen)/i;
  function jt(e, t, n, r) {
    var i;
    if (Array.isArray(t))
      w.each(t, function (t, i) {
        n || St.test(e)
          ? r(e, i)
          : jt(
              e + "[" + ("object" == typeof i && null != i ? t : "") + "]",
              i,
              n,
              r
            );
      });
    else if (n || "object" !== x(t)) r(e, t);
    else for (i in t) jt(e + "[" + i + "]", t[i], n, r);
  }
  (w.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = g(t) ? t() : t;
        r[r.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };
    if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
      w.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return r.join("&");
  }),
    w.fn.extend({
      serialize: function () {
        return w.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = w.prop(this, "elements");
          return e ? w.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !w(this).is(":disabled") &&
              At.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = w(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? w.map(n, function (e) {
                  return { name: t.name, value: e.replace(Dt, "\r\n") };
                })
              : { name: t.name, value: n.replace(Dt, "\r\n") };
          })
          .get();
      },
    });
  var qt = /%20/g,
    Lt = /#.*$/,
    Ht = /([?&])_=[^&]*/,
    Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Mt = /^(?:GET|HEAD)$/,
    Rt = /^\/\//,
    It = {},
    Wt = {},
    $t = "*/".concat("*"),
    Bt = r.createElement("a");
  Bt.href = Ct.href;
  function Ft(e) {
    return function (t, n) {
      "string" != typeof t && ((n = t), (t = "*"));
      var r,
        i = 0,
        o = t.toLowerCase().match(M) || [];
      if (g(n))
        while ((r = o[i++]))
          "+" === r[0]
            ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n);
    };
  }
  function _t(e, t, n, r) {
    var i = {},
      o = e === Wt;
    function a(s) {
      var u;
      return (
        (i[s] = !0),
        w.each(e[s] || [], function (e, s) {
          var l = s(t, n, r);
          return "string" != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), a(l), !1);
        }),
        u
      );
    }
    return a(t.dataTypes[0]) || (!i["*"] && a("*"));
  }
  function zt(e, t) {
    var n,
      r,
      i = w.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && w.extend(!0, e, r), e;
  }
  function Xt(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.contents,
      u = e.dataTypes;
    while ("*" === u[0])
      u.shift(),
        void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
    if (r)
      for (i in s)
        if (s[i] && s[i].test(r)) {
          u.unshift(i);
          break;
        }
    if (u[0] in n) o = u[0];
    else {
      for (i in n) {
        if (!u[0] || e.converters[i + " " + u[0]]) {
          o = i;
          break;
        }
        a || (a = i);
      }
      o = o || a;
    }
    if (o) return o !== u[0] && u.unshift(o), n[o];
  }
  function Ut(e, t, n, r) {
    var i,
      o,
      a,
      s,
      u,
      l = {},
      c = e.dataTypes.slice();
    if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
    o = c.shift();
    while (o)
      if (
        (e.responseFields[o] && (n[e.responseFields[o]] = t),
        !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
        (u = o),
        (o = c.shift()))
      )
        if ("*" === o) o = u;
        else if ("*" !== u && u !== o) {
          if (!(a = l[u + " " + o] || l["* " + o]))
            for (i in l)
              if (
                (s = i.split(" "))[1] === o &&
                (a = l[u + " " + s[0]] || l["* " + s[0]])
              ) {
                !0 === a
                  ? (a = l[i])
                  : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                break;
              }
          if (!0 !== a)
            if (a && e["throws"]) t = a(t);
            else
              try {
                t = a(t);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: a ? e : "No conversion from " + u + " to " + o,
                };
              }
        }
    return { state: "success", data: t };
  }
  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: "GET",
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": $t,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON",
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": w.parseXML,
      },
      flatOptions: { url: !0, context: !0 },
    },
    ajaxSetup: function (e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function (t, n) {
      "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h = w.ajaxSetup({}, n),
        g = h.context || h,
        y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
        v = w.Deferred(),
        m = w.Callbacks("once memory"),
        x = h.statusCode || {},
        b = {},
        T = {},
        C = "canceled",
        E = {
          readyState: 0,
          getResponseHeader: function (e) {
            var t;
            if (c) {
              if (!s) {
                s = {};
                while ((t = Ot.exec(a))) s[t[1].toLowerCase()] = t[2];
              }
              t = s[e.toLowerCase()];
            }
            return null == t ? null : t;
          },
          getAllResponseHeaders: function () {
            return c ? a : null;
          },
          setRequestHeader: function (e, t) {
            return (
              null == c &&
                ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e),
                (b[e] = t)),
              this
            );
          },
          overrideMimeType: function (e) {
            return null == c && (h.mimeType = e), this;
          },
          statusCode: function (e) {
            var t;
            if (e)
              if (c) E.always(e[E.status]);
              else for (t in e) x[t] = [x[t], e[t]];
            return this;
          },
          abort: function (e) {
            var t = e || C;
            return i && i.abort(t), k(0, t), this;
          },
        };
      if (
        (v.promise(E),
        (h.url = ((t || h.url || Ct.href) + "").replace(
          Rt,
          Ct.protocol + "//"
        )),
        (h.type = n.method || n.type || h.method || h.type),
        (h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""]),
        null == h.crossDomain)
      ) {
        l = r.createElement("a");
        try {
          (l.href = h.url),
            (l.href = l.href),
            (h.crossDomain =
              Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host);
        } catch (e) {
          h.crossDomain = !0;
        }
      }
      if (
        (h.data &&
          h.processData &&
          "string" != typeof h.data &&
          (h.data = w.param(h.data, h.traditional)),
        _t(It, h, n, E),
        c)
      )
        return E;
      (f = w.event && h.global) &&
        0 == w.active++ &&
        w.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Mt.test(h.type)),
        (o = h.url.replace(Lt, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 ===
              (h.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (h.data = h.data.replace(qt, "+"))
          : ((d = h.url.slice(o.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((o += (kt.test(o) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(Ht, "$1")),
              (d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d)),
            (h.url = o + d)),
        h.ifModified &&
          (w.lastModified[o] &&
            E.setRequestHeader("If-Modified-Since", w.lastModified[o]),
          w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          E.setRequestHeader("Content-Type", h.contentType),
        E.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] +
                ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "")
            : h.accepts["*"]
        );
      for (p in h.headers) E.setRequestHeader(p, h.headers[p]);
      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c))
        return E.abort();
      if (
        ((C = "abort"),
        m.add(h.complete),
        E.done(h.success),
        E.fail(h.error),
        (i = _t(Wt, h, n, E)))
      ) {
        if (((E.readyState = 1), f && y.trigger("ajaxSend", [E, h]), c))
          return E;
        h.async &&
          h.timeout > 0 &&
          (u = e.setTimeout(function () {
            E.abort("timeout");
          }, h.timeout));
        try {
          (c = !1), i.send(b, k);
        } catch (e) {
          if (c) throw e;
          k(-1, e);
        }
      } else k(-1, "No Transport");
      function k(t, n, r, s) {
        var l,
          p,
          d,
          b,
          T,
          C = n;
        c ||
          ((c = !0),
          u && e.clearTimeout(u),
          (i = void 0),
          (a = s || ""),
          (E.readyState = t > 0 ? 4 : 0),
          (l = (t >= 200 && t < 300) || 304 === t),
          r && (b = Xt(h, E, r)),
          (b = Ut(h, b, E, l)),
          l
            ? (h.ifModified &&
                ((T = E.getResponseHeader("Last-Modified")) &&
                  (w.lastModified[o] = T),
                (T = E.getResponseHeader("etag")) && (w.etag[o] = T)),
              204 === t || "HEAD" === h.type
                ? (C = "nocontent")
                : 304 === t
                ? (C = "notmodified")
                : ((C = b.state), (p = b.data), (l = !(d = b.error))))
            : ((d = C), (!t && C) || ((C = "error"), t < 0 && (t = 0))),
          (E.status = t),
          (E.statusText = (n || C) + ""),
          l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
          E.statusCode(x),
          (x = void 0),
          f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]),
          m.fireWith(g, [E, C]),
          f &&
            (y.trigger("ajaxComplete", [E, h]),
            --w.active || w.event.trigger("ajaxStop")));
      }
      return E;
    },
    getJSON: function (e, t, n) {
      return w.get(e, t, n, "json");
    },
    getScript: function (e, t) {
      return w.get(e, void 0, t, "script");
    },
  }),
    w.each(["get", "post"], function (e, t) {
      w[t] = function (e, n, r, i) {
        return (
          g(n) && ((i = i || r), (r = n), (n = void 0)),
          w.ajax(
            w.extend(
              { url: e, type: t, dataType: i, data: n, success: r },
              w.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    (w._evalUrl = function (e) {
      return w.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    w.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (e) {
        return g(e)
          ? this.each(function (t) {
              w(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = w(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = g(e);
        return this.each(function (n) {
          w(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              w(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (w.expr.pseudos.hidden = function (e) {
      return !w.expr.pseudos.visible(e);
    }),
    (w.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (w.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var Vt = { 0: 200, 1223: 204 },
    Gt = w.ajaxSettings.xhr();
  (h.cors = !!Gt && "withCredentials" in Gt),
    (h.ajax = Gt = !!Gt),
    w.ajaxTransport(function (t) {
      var n, r;
      if (h.cors || (Gt && !t.crossDomain))
        return {
          send: function (i, o) {
            var a,
              s = t.xhr();
            if (
              (s.open(t.type, t.url, t.async, t.username, t.password),
              t.xhrFields)
            )
              for (a in t.xhrFields) s[a] = t.xhrFields[a];
            t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
              t.crossDomain ||
                i["X-Requested-With"] ||
                (i["X-Requested-With"] = "XMLHttpRequest");
            for (a in i) s.setRequestHeader(a, i[a]);
            (n = function (e) {
              return function () {
                n &&
                  ((n =
                    r =
                    s.onload =
                    s.onerror =
                    s.onabort =
                    s.ontimeout =
                    s.onreadystatechange =
                      null),
                  "abort" === e
                    ? s.abort()
                    : "error" === e
                    ? "number" != typeof s.status
                      ? o(0, "error")
                      : o(s.status, s.statusText)
                    : o(
                        Vt[s.status] || s.status,
                        s.statusText,
                        "text" !== (s.responseType || "text") ||
                          "string" != typeof s.responseText
                          ? { binary: s.response }
                          : { text: s.responseText },
                        s.getAllResponseHeaders()
                      ));
              };
            }),
              (s.onload = n()),
              (r = s.onerror = s.ontimeout = n("error")),
              void 0 !== s.onabort
                ? (s.onabort = r)
                : (s.onreadystatechange = function () {
                    4 === s.readyState &&
                      e.setTimeout(function () {
                        n && r();
                      });
                  }),
              (n = n("abort"));
            try {
              s.send((t.hasContent && t.data) || null);
            } catch (e) {
              if (n) throw e;
            }
          },
          abort: function () {
            n && n();
          },
        };
    }),
    w.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    w.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return w.globalEval(e), e;
        },
      },
    }),
    w.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    w.ajaxTransport("script", function (e) {
      if (e.crossDomain) {
        var t, n;
        return {
          send: function (i, o) {
            (t = w("<script>")
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (n = function (e) {
                  t.remove(),
                    (n = null),
                    e && o("error" === e.type ? 404 : 200, e.type);
                })
              )),
              r.head.appendChild(t[0]);
          },
          abort: function () {
            n && n();
          },
        };
      }
    });
  var Yt = [],
    Qt = /(=)\?(?=&|$)|\?\?/;
  w.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Yt.pop() || w.expando + "_" + Et++;
      return (this[e] = !0), e;
    },
  }),
    w.ajaxPrefilter("json jsonp", function (t, n, r) {
      var i,
        o,
        a,
        s =
          !1 !== t.jsonp &&
          (Qt.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 ===
                (t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Qt.test(t.data) &&
              "data");
      if (s || "jsonp" === t.dataTypes[0])
        return (
          (i = t.jsonpCallback =
            g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          s
            ? (t[s] = t[s].replace(Qt, "$1" + i))
            : !1 !== t.jsonp &&
              (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
          (t.converters["script json"] = function () {
            return a || w.error(i + " was not called"), a[0];
          }),
          (t.dataTypes[0] = "json"),
          (o = e[i]),
          (e[i] = function () {
            a = arguments;
          }),
          r.always(function () {
            void 0 === o ? w(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Yt.push(i)),
              a && g(o) && o(a[0]),
              (a = o = void 0);
          }),
          "script"
        );
    }),
    (h.createHTMLDocument = (function () {
      var e = r.implementation.createHTMLDocument("").body;
      return (
        (e.innerHTML = "<form></form><form></form>"), 2 === e.childNodes.length
      );
    })()),
    (w.parseHTML = function (e, t, n) {
      if ("string" != typeof e) return [];
      "boolean" == typeof t && ((n = t), (t = !1));
      var i, o, a;
      return (
        t ||
          (h.createHTMLDocument
            ? (((i = (t =
                r.implementation.createHTMLDocument("")).createElement(
                "base"
              )).href = r.location.href),
              t.head.appendChild(i))
            : (t = r)),
        (o = A.exec(e)),
        (a = !n && []),
        o
          ? [t.createElement(o[1])]
          : ((o = xe([e], t, a)),
            a && a.length && w(a).remove(),
            w.merge([], o.childNodes))
      );
    }),
    (w.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
      return (
        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        g(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (i = "POST"),
        a.length > 0 &&
          w
            .ajax({ url: e, type: i || "GET", dataType: "html", data: t })
            .done(function (e) {
              (o = arguments),
                a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    w.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        w.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    (w.expr.pseudos.animated = function (e) {
      return w.grep(w.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (w.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, "position"),
          f = w(e),
          p = {};
        "static" === c && (e.style.position = "relative"),
          (s = f.offset()),
          (o = w.css(e, "top")),
          (u = w.css(e, "left")),
          (l =
            ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1)
            ? ((a = (r = f.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          g(t) && (t = t.call(e, n, w.extend({}, s))),
          null != t.top && (p.top = t.top - s.top + a),
          null != t.left && (p.left = t.left - s.left + i),
          "using" in t ? t.using.call(e, p) : f.css(p);
      },
    }),
    w.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                w.offset.setOffset(this, e, t);
              });
        var t,
          n,
          r = this[0];
        if (r)
          return r.getClientRects().length
            ? ((t = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
            : { top: 0, left: 0 };
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };
          if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();
          else {
            (t = this.offset()),
              (n = r.ownerDocument),
              (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === w.css(e, "position")
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0)),
              (i.left += w.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - i.top - w.css(r, "marginTop", !0),
            left: t.left - i.left - w.css(r, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && "static" === w.css(e, "position")) e = e.offsetParent;
          return e || be;
        });
      },
    }),
    w.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (e, t) {
        var n = "pageYOffset" === t;
        w.fn[e] = function (r) {
          return z(
            this,
            function (e, r, i) {
              var o;
              if (
                (y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView),
                void 0 === i)
              )
                return o ? o[t] : e[r];
              o
                ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset)
                : (e[r] = i);
            },
            e,
            r,
            arguments.length
          );
        };
      }
    ),
    w.each(["top", "left"], function (e, t) {
      w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
        if (n)
          return (n = Fe(e, t)), We.test(n) ? w(e).position()[t] + "px" : n;
      });
    }),
    w.each({ Height: "height", Width: "width" }, function (e, t) {
      w.each(
        { padding: "inner" + e, content: t, "": "outer" + e },
        function (n, r) {
          w.fn[r] = function (i, o) {
            var a = arguments.length && (n || "boolean" != typeof i),
              s = n || (!0 === i || !0 === o ? "margin" : "border");
            return z(
              this,
              function (t, n, i) {
                var o;
                return y(t)
                  ? 0 === r.indexOf("outer")
                    ? t["inner" + e]
                    : t.document.documentElement["client" + e]
                  : 9 === t.nodeType
                  ? ((o = t.documentElement),
                    Math.max(
                      t.body["scroll" + e],
                      o["scroll" + e],
                      t.body["offset" + e],
                      o["offset" + e],
                      o["client" + e]
                    ))
                  : void 0 === i
                  ? w.css(t, n, s)
                  : w.style(t, n, i, s);
              },
              t,
              a ? i : void 0,
              a
            );
          };
        }
      );
    }),
    w.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, t) {
        w.fn[t] = function (e, n) {
          return arguments.length > 0
            ? this.on(t, null, e, n)
            : this.trigger(t);
        };
      }
    ),
    w.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    w.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      },
    }),
    (w.proxy = function (e, t) {
      var n, r, i;
      if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (r = o.call(arguments, 2)),
          (i = function () {
            return e.apply(t || this, r.concat(o.call(arguments)));
          }),
          (i.guid = e.guid = e.guid || w.guid++),
          i
        );
    }),
    (w.holdReady = function (e) {
      e ? w.readyWait++ : w.ready(!0);
    }),
    (w.isArray = Array.isArray),
    (w.parseJSON = JSON.parse),
    (w.nodeName = N),
    (w.isFunction = g),
    (w.isWindow = y),
    (w.camelCase = G),
    (w.type = x),
    (w.now = Date.now),
    (w.isNumeric = function (e) {
      var t = w.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return w;
      });
  var Jt = e.jQuery,
    Kt = e.$;
  return (
    (w.noConflict = function (t) {
      return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
    }),
    t || (e.jQuery = e.$ = w),
    w
  );
});

/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!(function (a, b, c, d) {
  function e(b, c) {
    (this.settings = null),
      (this.options = a.extend({}, e.Defaults, c)),
      (this.$element = a(b)),
      (this._handlers = {}),
      (this._plugins = {}),
      (this._supress = {}),
      (this._current = null),
      (this._speed = null),
      (this._coordinates = []),
      (this._breakpoint = null),
      (this._width = null),
      (this._items = []),
      (this._clones = []),
      (this._mergers = []),
      (this._widths = []),
      (this._invalidated = {}),
      (this._pipe = []),
      (this._drag = {
        time: null,
        target: null,
        pointer: null,
        stage: { start: null, current: null },
        direction: null,
      }),
      (this._states = {
        current: {},
        tags: {
          initializing: ["busy"],
          animating: ["busy"],
          dragging: ["interacting"],
        },
      }),
      a.each(
        ["onResize", "onThrottledResize"],
        a.proxy(function (b, c) {
          this._handlers[c] = a.proxy(this[c], this);
        }, this)
      ),
      a.each(
        e.Plugins,
        a.proxy(function (a, b) {
          this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
        }, this)
      ),
      a.each(
        e.Workers,
        a.proxy(function (b, c) {
          this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
        }, this)
      ),
      this.setup(),
      this.initialize();
  }
  (e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    checkVisibility: !0,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    slideTransition: "",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab",
  }),
    (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
    (e.Type = { Event: "event", State: "state" }),
    (e.Plugins = {}),
    (e.Workers = [
      {
        filter: ["width", "settings"],
        run: function () {
          this._width = this.$element.width();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          a.current = this._items && this._items[this.relative(this._current)];
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          this.$stage.children(".cloned").remove();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this.settings.margin || "",
            c = !this.settings.autoWidth,
            d = this.settings.rtl,
            e = {
              width: "auto",
              "margin-left": d ? b : "",
              "margin-right": d ? "" : b,
            };
          !c && this.$stage.children().css(e), (a.css = e);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b =
              (this.width() / this.settings.items).toFixed(3) -
              this.settings.margin,
            c = null,
            d = this._items.length,
            e = !this.settings.autoWidth,
            f = [];
          for (a.items = { merge: !1, width: b }; d--; )
            (c = this._mergers[d]),
              (c =
                (this.settings.mergeFit && Math.min(c, this.settings.items)) ||
                c),
              (a.items.merge = c > 1 || a.items.merge),
              (f[d] = e ? b * c : this._items[d].width());
          this._widths = f;
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          var b = [],
            c = this._items,
            d = this.settings,
            e = Math.max(2 * d.items, 4),
            f = 2 * Math.ceil(c.length / 2),
            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
            h = "",
            i = "";
          for (g /= 2; g > 0; )
            b.push(this.normalize(b.length / 2, !0)),
              (h += c[b[b.length - 1]][0].outerHTML),
              b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
              (i = c[b[b.length - 1]][0].outerHTML + i),
              (g -= 1);
          (this._clones = b),
            a(h).addClass("cloned").appendTo(this.$stage),
            a(i).addClass("cloned").prependTo(this.$stage);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          for (
            var a = this.settings.rtl ? 1 : -1,
              b = this._clones.length + this._items.length,
              c = -1,
              d = 0,
              e = 0,
              f = [];
            ++c < b;

          )
            (d = f[c - 1] || 0),
              (e = this._widths[this.relative(c)] + this.settings.margin),
              f.push(d + e * a);
          this._coordinates = f;
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          var a = this.settings.stagePadding,
            b = this._coordinates,
            c = {
              width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
              "padding-left": a || "",
              "padding-right": a || "",
            };
          this.$stage.css(c);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this._coordinates.length,
            c = !this.settings.autoWidth,
            d = this.$stage.children();
          if (c && a.items.merge)
            for (; b--; )
              (a.css.width = this._widths[this.relative(b)]),
                d.eq(b).css(a.css);
          else c && ((a.css.width = a.items.width), d.css(a.css));
        },
      },
      {
        filter: ["items"],
        run: function () {
          this._coordinates.length < 1 && this.$stage.removeAttr("style");
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          (a.current = a.current ? this.$stage.children().index(a.current) : 0),
            (a.current = Math.max(
              this.minimum(),
              Math.min(this.maximum(), a.current)
            )),
            this.reset(a.current);
        },
      },
      {
        filter: ["position"],
        run: function () {
          this.animate(this.coordinates(this._current));
        },
      },
      {
        filter: ["width", "position", "items", "settings"],
        run: function () {
          var a,
            b,
            c,
            d,
            e = this.settings.rtl ? 1 : -1,
            f = 2 * this.settings.stagePadding,
            g = this.coordinates(this.current()) + f,
            h = g + this.width() * e,
            i = [];
          for (c = 0, d = this._coordinates.length; c < d; c++)
            (a = this._coordinates[c - 1] || 0),
              (b = Math.abs(this._coordinates[c]) + f * e),
              ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                (this.op(b, "<", g) && this.op(b, ">", h))) &&
                i.push(c);
          this.$stage.children(".active").removeClass("active"),
            this.$stage
              .children(":eq(" + i.join("), :eq(") + ")")
              .addClass("active"),
            this.$stage.children(".center").removeClass("center"),
            this.settings.center &&
              this.$stage.children().eq(this.current()).addClass("center");
        },
      },
    ]),
    (e.prototype.initializeStage = function () {
      (this.$stage = this.$element.find("." + this.settings.stageClass)),
        this.$stage.length ||
          (this.$element.addClass(this.options.loadingClass),
          (this.$stage = a("<" + this.settings.stageElement + ">", {
            class: this.settings.stageClass,
          }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
          this.$element.append(this.$stage.parent()));
    }),
    (e.prototype.initializeItems = function () {
      var b = this.$element.find(".owl-item");
      if (b.length)
        return (
          (this._items = b.get().map(function (b) {
            return a(b);
          })),
          (this._mergers = this._items.map(function () {
            return 1;
          })),
          void this.refresh()
        );
      this.replace(this.$element.children().not(this.$stage.parent())),
        this.isVisible() ? this.refresh() : this.invalidate("width"),
        this.$element
          .removeClass(this.options.loadingClass)
          .addClass(this.options.loadedClass);
    }),
    (e.prototype.initialize = function () {
      if (
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading"))
      ) {
        var a, b, c;
        (a = this.$element.find("img")),
          (b = this.settings.nestedItemSelector
            ? "." + this.settings.nestedItemSelector
            : d),
          (c = this.$element.children(b).width()),
          a.length && c <= 0 && this.preloadAutoWidthImages(a);
      }
      this.initializeStage(),
        this.initializeItems(),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized");
    }),
    (e.prototype.isVisible = function () {
      return !this.settings.checkVisibility || this.$element.is(":visible");
    }),
    (e.prototype.setup = function () {
      var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null;
      c
        ? (a.each(c, function (a) {
            a <= b && a > d && (d = Number(a));
          }),
          (e = a.extend({}, this.options, c[d])),
          "function" == typeof e.stagePadding &&
            (e.stagePadding = e.stagePadding()),
          delete e.responsive,
          e.responsiveClass &&
            this.$element.attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(
                    "(" + this.options.responsiveClass + "-)\\S+\\s",
                    "g"
                  ),
                  "$1" + d
                )
            ))
        : (e = a.extend({}, this.options)),
        this.trigger("change", { property: { name: "settings", value: e } }),
        (this._breakpoint = d),
        (this.settings = e),
        this.invalidate("settings"),
        this.trigger("changed", {
          property: { name: "settings", value: this.settings },
        });
    }),
    (e.prototype.optionsLogic = function () {
      this.settings.autoWidth &&
        ((this.settings.stagePadding = !1), (this.settings.merge = !1));
    }),
    (e.prototype.prepare = function (b) {
      var c = this.trigger("prepare", { content: b });
      return (
        c.data ||
          (c.data = a("<" + this.settings.itemElement + "/>")
            .addClass(this.options.itemClass)
            .append(b)),
        this.trigger("prepared", { content: c.data }),
        c.data
      );
    }),
    (e.prototype.update = function () {
      for (
        var b = 0,
          c = this._pipe.length,
          d = a.proxy(function (a) {
            return this[a];
          }, this._invalidated),
          e = {};
        b < c;

      )
        (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) &&
          this._pipe[b].run(e),
          b++;
      (this._invalidated = {}), !this.is("valid") && this.enter("valid");
    }),
    (e.prototype.width = function (a) {
      switch ((a = a || e.Width.Default)) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width;
        default:
          return (
            this._width - 2 * this.settings.stagePadding + this.settings.margin
          );
      }
    }),
    (e.prototype.refresh = function () {
      this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed");
    }),
    (e.prototype.onThrottledResize = function () {
      b.clearTimeout(this.resizeTimer),
        (this.resizeTimer = b.setTimeout(
          this._handlers.onResize,
          this.settings.responsiveRefreshRate
        ));
    }),
    (e.prototype.onResize = function () {
      return (
        !!this._items.length &&
        this._width !== this.$element.width() &&
        !!this.isVisible() &&
        (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented()
          ? (this.leave("resizing"), !1)
          : (this.invalidate("width"),
            this.refresh(),
            this.leave("resizing"),
            void this.trigger("resized")))
      );
    }),
    (e.prototype.registerEventHandlers = function () {
      a.support.transition &&
        this.$stage.on(
          a.support.transition.end + ".owl.core",
          a.proxy(this.onTransitionEnd, this)
        ),
        !1 !== this.settings.responsive &&
          this.on(b, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag &&
          (this.$element.addClass(this.options.dragClass),
          this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on(
            "dragstart.owl.core selectstart.owl.core",
            function () {
              return !1;
            }
          )),
        this.settings.touchDrag &&
          (this.$stage.on(
            "touchstart.owl.core",
            a.proxy(this.onDragStart, this)
          ),
          this.$stage.on(
            "touchcancel.owl.core",
            a.proxy(this.onDragEnd, this)
          ));
    }),
    (e.prototype.onDragStart = function (b) {
      var d = null;
      3 !== b.which &&
        (a.support.transform
          ? ((d = this.$stage
              .css("transform")
              .replace(/.*\(|\)| /g, "")
              .split(",")),
            (d = {
              x: d[16 === d.length ? 12 : 4],
              y: d[16 === d.length ? 13 : 5],
            }))
          : ((d = this.$stage.position()),
            (d = {
              x: this.settings.rtl
                ? d.left +
                  this.$stage.width() -
                  this.width() +
                  this.settings.margin
                : d.left,
              y: d.top,
            })),
        this.is("animating") &&
          (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
          this.invalidate("position")),
        this.$element.toggleClass(
          this.options.grabClass,
          "mousedown" === b.type
        ),
        this.speed(0),
        (this._drag.time = new Date().getTime()),
        (this._drag.target = a(b.target)),
        (this._drag.stage.start = d),
        (this._drag.stage.current = d),
        (this._drag.pointer = this.pointer(b)),
        a(c).on(
          "mouseup.owl.core touchend.owl.core",
          a.proxy(this.onDragEnd, this)
        ),
        a(c).one(
          "mousemove.owl.core touchmove.owl.core",
          a.proxy(function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b));
            a(c).on(
              "mousemove.owl.core touchmove.owl.core",
              a.proxy(this.onDragMove, this)
            ),
              (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                (b.preventDefault(),
                this.enter("dragging"),
                this.trigger("drag"));
          }, this)
        ));
    }),
    (e.prototype.onDragMove = function (a) {
      var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e);
      this.is("dragging") &&
        (a.preventDefault(),
        this.settings.loop
          ? ((b = this.coordinates(this.minimum())),
            (c = this.coordinates(this.maximum() + 1) - b),
            (f.x = ((((f.x - b) % c) + c) % c) + b))
          : ((b = this.settings.rtl
              ? this.coordinates(this.maximum())
              : this.coordinates(this.minimum())),
            (c = this.settings.rtl
              ? this.coordinates(this.minimum())
              : this.coordinates(this.maximum())),
            (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
            (f.x = Math.max(Math.min(f.x, b + d), c + d))),
        (this._drag.stage.current = f),
        this.animate(f.x));
    }),
    (e.prototype.onDragEnd = function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
      a(c).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
          (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
          this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
          this.invalidate("position"),
          this.update(),
          (this._drag.direction = f),
          (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
            this._drag.target.one("click.owl.core", function () {
              return !1;
            })),
        this.is("dragging") &&
          (this.leave("dragging"), this.trigger("dragged"));
    }),
    (e.prototype.closest = function (b, c) {
      var e = -1,
        f = 30,
        g = this.width(),
        h = this.coordinates();
      return (
        this.settings.freeDrag ||
          a.each(
            h,
            a.proxy(function (a, i) {
              return (
                "left" === c && b > i - f && b < i + f
                  ? (e = a)
                  : "right" === c && b > i - g - f && b < i - g + f
                  ? (e = a + 1)
                  : this.op(b, "<", i) &&
                    this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) &&
                    (e = "left" === c ? a + 1 : a),
                -1 === e
              );
            }, this)
          ),
        this.settings.loop ||
          (this.op(b, ">", h[this.minimum()])
            ? (e = b = this.minimum())
            : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
        e
      );
    }),
    (e.prototype.animate = function (b) {
      var c = this.speed() > 0;
      this.is("animating") && this.onTransitionEnd(),
        c && (this.enter("animating"), this.trigger("translate")),
        a.support.transform3d && a.support.transition
          ? this.$stage.css({
              transform: "translate3d(" + b + "px,0px,0px)",
              transition:
                this.speed() / 1e3 +
                "s" +
                (this.settings.slideTransition
                  ? " " + this.settings.slideTransition
                  : ""),
            })
          : c
          ? this.$stage.animate(
              { left: b + "px" },
              this.speed(),
              this.settings.fallbackEasing,
              a.proxy(this.onTransitionEnd, this)
            )
          : this.$stage.css({ left: b + "px" });
    }),
    (e.prototype.is = function (a) {
      return this._states.current[a] && this._states.current[a] > 0;
    }),
    (e.prototype.current = function (a) {
      if (a === d) return this._current;
      if (0 === this._items.length) return d;
      if (((a = this.normalize(a)), this._current !== a)) {
        var b = this.trigger("change", {
          property: { name: "position", value: a },
        });
        b.data !== d && (a = this.normalize(b.data)),
          (this._current = a),
          this.invalidate("position"),
          this.trigger("changed", {
            property: { name: "position", value: this._current },
          });
      }
      return this._current;
    }),
    (e.prototype.invalidate = function (b) {
      return (
        "string" === a.type(b) &&
          ((this._invalidated[b] = !0),
          this.is("valid") && this.leave("valid")),
        a.map(this._invalidated, function (a, b) {
          return b;
        })
      );
    }),
    (e.prototype.reset = function (a) {
      (a = this.normalize(a)) !== d &&
        ((this._speed = 0),
        (this._current = a),
        this.suppress(["translate", "translated"]),
        this.animate(this.coordinates(a)),
        this.release(["translate", "translated"]));
    }),
    (e.prototype.normalize = function (a, b) {
      var c = this._items.length,
        e = b ? 0 : this._clones.length;
      return (
        !this.isNumeric(a) || c < 1
          ? (a = d)
          : (a < 0 || a >= c + e) &&
            (a = ((((a - e / 2) % c) + c) % c) + e / 2),
        a
      );
    }),
    (e.prototype.relative = function (a) {
      return (a -= this._clones.length / 2), this.normalize(a, !0);
    }),
    (e.prototype.maximum = function (a) {
      var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length;
      if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
      else if (e.autoWidth || e.merge) {
        if ((b = this._items.length))
          for (
            c = this._items[--b].width(), d = this.$element.width();
            b-- && !((c += this._items[b].width() + this.settings.margin) > d);

          );
        f = b + 1;
      } else
        f = e.center ? this._items.length - 1 : this._items.length - e.items;
      return a && (f -= this._clones.length / 2), Math.max(f, 0);
    }),
    (e.prototype.minimum = function (a) {
      return a ? 0 : this._clones.length / 2;
    }),
    (e.prototype.items = function (a) {
      return a === d
        ? this._items.slice()
        : ((a = this.normalize(a, !0)), this._items[a]);
    }),
    (e.prototype.mergers = function (a) {
      return a === d
        ? this._mergers.slice()
        : ((a = this.normalize(a, !0)), this._mergers[a]);
    }),
    (e.prototype.clones = function (b) {
      var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function (a) {
          return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
        };
      return b === d
        ? a.map(this._clones, function (a, b) {
            return f(b);
          })
        : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null;
          });
    }),
    (e.prototype.speed = function (a) {
      return a !== d && (this._speed = a), this._speed;
    }),
    (e.prototype.coordinates = function (b) {
      var c,
        e = 1,
        f = b - 1;
      return b === d
        ? a.map(
            this._coordinates,
            a.proxy(function (a, b) {
              return this.coordinates(b);
            }, this)
          )
        : (this.settings.center
            ? (this.settings.rtl && ((e = -1), (f = b + 1)),
              (c = this._coordinates[b]),
              (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
            : (c = this._coordinates[f] || 0),
          (c = Math.ceil(c)));
    }),
    (e.prototype.duration = function (a, b, c) {
      return 0 === c
        ? 0
        : Math.min(Math.max(Math.abs(b - a), 1), 6) *
            Math.abs(c || this.settings.smartSpeed);
    }),
    (e.prototype.to = function (a, b) {
      var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (e < 0),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum();
      this.settings.loop
        ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
          (a = c + e),
          (d = ((((a - h) % g) + g) % g) + h) !== a &&
            d - e <= i &&
            d - e > 0 &&
            ((c = d - e), (a = d), this.reset(c)))
        : this.settings.rewind
        ? ((i += 1), (a = ((a % i) + i) % i))
        : (a = Math.max(h, Math.min(i, a))),
        this.speed(this.duration(c, a, b)),
        this.current(a),
        this.isVisible() && this.update();
    }),
    (e.prototype.next = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) + 1, a);
    }),
    (e.prototype.prev = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) - 1, a);
    }),
    (e.prototype.onTransitionEnd = function (a) {
      if (
        a !== d &&
        (a.stopPropagation(),
        (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
      )
        return !1;
      this.leave("animating"), this.trigger("translated");
    }),
    (e.prototype.viewport = function () {
      var d;
      return (
        this.options.responsiveBaseElement !== b
          ? (d = a(this.options.responsiveBaseElement).width())
          : b.innerWidth
          ? (d = b.innerWidth)
          : c.documentElement && c.documentElement.clientWidth
          ? (d = c.documentElement.clientWidth)
          : console.warn("Can not detect viewport width."),
        d
      );
    }),
    (e.prototype.replace = function (b) {
      this.$stage.empty(),
        (this._items = []),
        b && (b = b instanceof jQuery ? b : a(b)),
        this.settings.nestedItemSelector &&
          (b = b.find("." + this.settings.nestedItemSelector)),
        b
          .filter(function () {
            return 1 === this.nodeType;
          })
          .each(
            a.proxy(function (a, b) {
              (b = this.prepare(b)),
                this.$stage.append(b),
                this._items.push(b),
                this._mergers.push(
                  1 *
                    b
                      .find("[data-merge]")
                      .addBack("[data-merge]")
                      .attr("data-merge") || 1
                );
            }, this)
          ),
        this.reset(
          this.isNumeric(this.settings.startPosition)
            ? this.settings.startPosition
            : 0
        ),
        this.invalidate("items");
    }),
    (e.prototype.add = function (b, c) {
      var e = this.relative(this._current);
      (c = c === d ? this._items.length : this.normalize(c, !0)),
        (b = b instanceof jQuery ? b : a(b)),
        this.trigger("add", { content: b, position: c }),
        (b = this.prepare(b)),
        0 === this._items.length || c === this._items.length
          ? (0 === this._items.length && this.$stage.append(b),
            0 !== this._items.length && this._items[c - 1].after(b),
            this._items.push(b),
            this._mergers.push(
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            ))
          : (this._items[c].before(b),
            this._items.splice(c, 0, b),
            this._mergers.splice(
              c,
              0,
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            )),
        this._items[e] && this.reset(this._items[e].index()),
        this.invalidate("items"),
        this.trigger("added", { content: b, position: c });
    }),
    (e.prototype.remove = function (a) {
      (a = this.normalize(a, !0)) !== d &&
        (this.trigger("remove", { content: this._items[a], position: a }),
        this._items[a].remove(),
        this._items.splice(a, 1),
        this._mergers.splice(a, 1),
        this.invalidate("items"),
        this.trigger("removed", { content: null, position: a }));
    }),
    (e.prototype.preloadAutoWidthImages = function (b) {
      b.each(
        a.proxy(function (b, c) {
          this.enter("pre-loading"),
            (c = a(c)),
            a(new Image())
              .one(
                "load",
                a.proxy(function (a) {
                  c.attr("src", a.target.src),
                    c.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") &&
                      !this.is("initializing") &&
                      this.refresh();
                }, this)
              )
              .attr(
                "src",
                c.attr("src") || c.attr("data-src") || c.attr("data-src-retina")
              );
        }, this)
      );
    }),
    (e.prototype.destroy = function () {
      this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        a(c).off(".owl.core"),
        !1 !== this.settings.responsive &&
          (b.clearTimeout(this.resizeTimer),
          this.off(b, "resize", this._handlers.onThrottledResize));
      for (var d in this._plugins) this._plugins[d].destroy();
      this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$stage.remove(),
        this.$element
          .removeClass(this.options.refreshClass)
          .removeClass(this.options.loadingClass)
          .removeClass(this.options.loadedClass)
          .removeClass(this.options.rtlClass)
          .removeClass(this.options.dragClass)
          .removeClass(this.options.grabClass)
          .attr(
            "class",
            this.$element
              .attr("class")
              .replace(
                new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                ""
              )
          )
          .removeData("owl.carousel");
    }),
    (e.prototype.op = function (a, b, c) {
      var d = this.settings.rtl;
      switch (b) {
        case "<":
          return d ? a > c : a < c;
        case ">":
          return d ? a < c : a > c;
        case ">=":
          return d ? a <= c : a >= c;
        case "<=":
          return d ? a >= c : a <= c;
      }
    }),
    (e.prototype.on = function (a, b, c, d) {
      a.addEventListener
        ? a.addEventListener(b, c, d)
        : a.attachEvent && a.attachEvent("on" + b, c);
    }),
    (e.prototype.off = function (a, b, c, d) {
      a.removeEventListener
        ? a.removeEventListener(b, c, d)
        : a.detachEvent && a.detachEvent("on" + b, c);
    }),
    (e.prototype.trigger = function (b, c, d, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } },
        i = a.camelCase(
          a
            .grep(["on", b, d], function (a) {
              return a;
            })
            .join("-")
            .toLowerCase()
        ),
        j = a.Event(
          [b, "owl", d || "carousel"].join(".").toLowerCase(),
          a.extend({ relatedTarget: this }, h, c)
        );
      return (
        this._supress[b] ||
          (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(j);
          }),
          this.register({ type: e.Type.Event, name: b }),
          this.$element.trigger(j),
          this.settings &&
            "function" == typeof this.settings[i] &&
            this.settings[i].call(this, j)),
        j
      );
    }),
    (e.prototype.enter = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b] === d && (this._states.current[b] = 0),
            this._states.current[b]++;
        }, this)
      );
    }),
    (e.prototype.leave = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b]--;
        }, this)
      );
    }),
    (e.prototype.register = function (b) {
      if (b.type === e.Type.Event) {
        if (
          (a.event.special[b.name] || (a.event.special[b.name] = {}),
          !a.event.special[b.name].owl)
        ) {
          var c = a.event.special[b.name]._default;
          (a.event.special[b.name]._default = function (a) {
            return !c ||
              !c.apply ||
              (a.namespace && -1 !== a.namespace.indexOf("owl"))
              ? a.namespace && a.namespace.indexOf("owl") > -1
              : c.apply(this, arguments);
          }),
            (a.event.special[b.name].owl = !0);
        }
      } else
        b.type === e.Type.State &&
          (this._states.tags[b.name]
            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(
                b.tags
              ))
            : (this._states.tags[b.name] = b.tags),
          (this._states.tags[b.name] = a.grep(
            this._states.tags[b.name],
            a.proxy(function (c, d) {
              return a.inArray(c, this._states.tags[b.name]) === d;
            }, this)
          )));
    }),
    (e.prototype.suppress = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          this._supress[b] = !0;
        }, this)
      );
    }),
    (e.prototype.release = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          delete this._supress[b];
        }, this)
      );
    }),
    (e.prototype.pointer = function (a) {
      var c = { x: null, y: null };
      return (
        (a = a.originalEvent || a || b.event),
        (a =
          a.touches && a.touches.length
            ? a.touches[0]
            : a.changedTouches && a.changedTouches.length
            ? a.changedTouches[0]
            : a),
        a.pageX
          ? ((c.x = a.pageX), (c.y = a.pageY))
          : ((c.x = a.clientX), (c.y = a.clientY)),
        c
      );
    }),
    (e.prototype.isNumeric = function (a) {
      return !isNaN(parseFloat(a));
    }),
    (e.prototype.difference = function (a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
    }),
    (a.fn.owlCarousel = function (b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each(function () {
        var d = a(this),
          f = d.data("owl.carousel");
        f ||
          ((f = new e(this, "object" == typeof b && b)),
          d.data("owl.carousel", f),
          a.each(
            [
              "next",
              "prev",
              "to",
              "destroy",
              "refresh",
              "replace",
              "add",
              "remove",
            ],
            function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + ".owl.carousel.core",
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]),
                      f[c].apply(this, [].slice.call(arguments, 1)),
                      this.release([c]));
                  }, f)
                );
            }
          )),
          "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
      });
    }),
    (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (e.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.isVisible()),
          (this._interval = b.setInterval(
            a.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (e.prototype.refresh = function () {
        this._core.isVisible() !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible &&
            this._core.invalidate("width") &&
            this._core.refresh());
      }),
      (e.prototype.destroy = function () {
        var a, c;
        b.clearInterval(this._interval);
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
            a.proxy(function (b) {
              if (
                b.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((b.property && "position" == b.property.name) ||
                  "initialized" == b.type)
              ) {
                var c = this._core.settings,
                  e = (c.center && Math.ceil(c.items / 2)) || c.items,
                  f = (c.center && -1 * e) || 0,
                  g =
                    (b.property && b.property.value !== d
                      ? b.property.value
                      : this._core.current()) + f,
                  h = this._core.clones().length,
                  i = a.proxy(function (a, b) {
                    this.load(b);
                  }, this);
                for (
                  c.lazyLoadEager > 0 &&
                  ((e += c.lazyLoadEager),
                  c.loop && ((g -= c.lazyLoadEager), e++));
                  f++ < e;

                )
                  this.load(h / 2 + this._core.relative(g)),
                    h && a.each(this._core.clones(this._core.relative(g)), i),
                    g++;
              }
            }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
      (e.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
          e = d && d.find(".owl-lazy");
        !e ||
          a.inArray(d.get(0), this._loaded) > -1 ||
          (e.each(
            a.proxy(function (c, d) {
              var e,
                f = a(d),
                g =
                  (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                  f.attr("data-src") ||
                  f.attr("data-srcset");
              this._core.trigger("load", { element: f, url: g }, "lazy"),
                f.is("img")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          f.css("opacity", 1),
                            this._core.trigger(
                              "loaded",
                              { element: f, url: g },
                              "lazy"
                            );
                        }, this)
                      )
                      .attr("src", g)
                  : f.is("source")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          this._core.trigger(
                            "loaded",
                            { element: f, url: g },
                            "lazy"
                          );
                        }, this)
                      )
                      .attr("srcset", g)
                  : ((e = new Image()),
                    (e.onload = a.proxy(function () {
                      f.css({
                        "background-image": 'url("' + g + '")',
                        opacity: "1",
                      }),
                        this._core.trigger(
                          "loaded",
                          { element: f, url: g },
                          "lazy"
                        );
                    }, this)),
                    (e.src = g));
            }, this)
          ),
          this._loaded.push(d.get(0)));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (c) {
      (this._core = c),
        (this._previousHeight = null),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (
            a
          ) {
            a.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              "position" === a.property.name &&
              this.update();
          }, this),
          "loaded.owl.lazy": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              a.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        (this._intervalId = null);
      var d = this;
      a(b).on("load", function () {
        d._core.settings.autoHeight && d.update();
      }),
        a(b).resize(function () {
          d._core.settings.autoHeight &&
            (null != d._intervalId && clearTimeout(d._intervalId),
            (d._intervalId = setTimeout(function () {
              d.update();
            }, 250)));
        });
    };
    (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (e.prototype.update = function () {
        var b = this._core._current,
          c = b + this._core.settings.items,
          d = this._core.settings.lazyLoad,
          e = this._core.$stage.children().toArray().slice(b, c),
          f = [],
          g = 0;
        a.each(e, function (b, c) {
          f.push(a(c).height());
        }),
          (g = Math.max.apply(null, f)),
          g <= 1 && d && this._previousHeight && (g = this._previousHeight),
          (this._previousHeight = g),
          this._core.$stage
            .parent()
            .height(g)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.register({
                type: "state",
                name: "playing",
                tags: ["interacting"],
              });
          }, this),
          "resize.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              a.preventDefault();
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove();
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" === a.property.name &&
              this._playing &&
              this.stop();
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find(".owl-video");
              c.length &&
                (c.css("display", "none"), this.fetch(c, a(b.content)));
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          a.proxy(function (a) {
            this.play(a);
          }, this)
        );
    };
    (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (e.prototype.fetch = function (a, b) {
        var c = (function () {
            return a.attr("data-vimeo-id")
              ? "vimeo"
              : a.attr("data-vzaar-id")
              ? "vzaar"
              : "youtube";
          })(),
          d =
            a.attr("data-vimeo-id") ||
            a.attr("data-youtube-id") ||
            a.attr("data-vzaar-id"),
          e = a.attr("data-width") || this._core.settings.videoWidth,
          f = a.attr("data-height") || this._core.settings.videoHeight,
          g = a.attr("href");
        if (!g) throw new Error("Missing video URL.");
        if (
          ((d = g.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          )),
          d[3].indexOf("youtu") > -1)
        )
          c = "youtube";
        else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
        else {
          if (!(d[3].indexOf("vzaar") > -1))
            throw new Error("Video URL not supported.");
          c = "vzaar";
        }
        (d = d[6]),
          (this._videos[g] = { type: c, id: d, width: e, height: f }),
          b.attr("data-video", g),
          this.thumbnail(a, this._videos[g]);
      }),
      (e.prototype.thumbnail = function (b, c) {
        var d,
          e,
          f,
          g =
            c.width && c.height
              ? "width:" + c.width + "px;height:" + c.height + "px;"
              : "",
          h = b.find("img"),
          i = "src",
          j = "",
          k = this._core.settings,
          l = function (c) {
            (e = '<div class="owl-video-play-icon"></div>'),
              (d = k.lazyLoad
                ? a("<div/>", { class: "owl-video-tn " + j, srcType: c })
                : a("<div/>", {
                    class: "owl-video-tn",
                    style: "opacity:1;background-image:url(" + c + ")",
                  })),
              b.after(d),
              b.after(e);
          };
        if (
          (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })),
          this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
          h.length)
        )
          return l(h.attr(i)), h.remove(), !1;
        "youtube" === c.type
          ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
          : "vimeo" === c.type
          ? a.ajax({
              type: "GET",
              url: "//vimeo.com/api/v2/video/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a[0].thumbnail_large), l(f);
              },
            })
          : "vzaar" === c.type &&
            a.ajax({
              type: "GET",
              url: "//vzaar.com/api/videos/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a.framegrab_url), l(f);
              },
            });
      }),
      (e.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video");
      }),
      (e.prototype.play = function (b) {
        var c,
          d = a(b.target),
          e = d.closest("." + this._core.settings.itemClass),
          f = this._videos[e.attr("data-video")],
          g = f.width || "100%",
          h = f.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          (c = a(
            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
          )),
          c.attr("height", h),
          c.attr("width", g),
          "youtube" === f.type
            ? c.attr(
                "src",
                "//www.youtube.com/embed/" +
                  f.id +
                  "?autoplay=1&rel=0&v=" +
                  f.id
              )
            : "vimeo" === f.type
            ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
            : "vzaar" === f.type &&
              c.attr(
                "src",
                "//view.vzaar.com/" + f.id + "/player?autoplay=true"
              ),
          a(c)
            .wrap('<div class="owl-video-frame" />')
            .insertAfter(e.find(".owl-video")),
          (this._playing = e.addClass("owl-video-playing")));
      }),
      (e.prototype.isInFullScreen = function () {
        var b =
          c.fullscreenElement ||
          c.mozFullScreenElement ||
          c.webkitFullscreenElement;
        return b && a(b).parent().hasClass("owl-video-frame");
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this._core.$element.off("click.owl.video");
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Video = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this.core = b),
        (this.core.options = a.extend({}, e.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = d),
        (this.next = d),
        (this.handlers = {
          "change.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" == a.property.name &&
              ((this.previous = this.core.current()),
              (this.next = a.property.value));
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
            a.proxy(function (a) {
              a.namespace && (this.swapping = "translated" == a.type);
            }, this),
          "translate.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    };
    (e.Defaults = { animateOut: !1, animateIn: !1 }),
      (e.prototype.swap = function () {
        if (
          1 === this.core.settings.items &&
          a.support.animation &&
          a.support.transition
        ) {
          this.core.speed(0);
          var b,
            c = a.proxy(this.clear, this),
            d = this.core.$stage.children().eq(this.previous),
            e = this.core.$stage.children().eq(this.next),
            f = this.core.settings.animateIn,
            g = this.core.settings.animateOut;
          this.core.current() !== this.previous &&
            (g &&
              ((b =
                this.core.coordinates(this.previous) -
                this.core.coordinates(this.next)),
              d
                .one(a.support.animation.end, c)
                .css({ left: b + "px" })
                .addClass("animated owl-animated-out")
                .addClass(g)),
            f &&
              e
                .one(a.support.animation.end, c)
                .addClass("animated owl-animated-in")
                .addClass(f));
        }
      }),
      (e.prototype.clear = function (b) {
        a(b.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._call = null),
        (this._time = 0),
        (this._timeout = 0),
        (this._paused = !0),
        (this._handlers = {
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "settings" === a.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : a.namespace &&
                "position" === a.property.name &&
                this._paused &&
                (this._time = 0);
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoplay && this.play();
          }, this),
          "play.owl.autoplay": a.proxy(function (a, b, c) {
            a.namespace && this.play(b, c);
          }, this),
          "stop.owl.autoplay": a.proxy(function (a) {
            a.namespace && this.stop();
          }, this),
          "mouseover.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "mouseleave.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.play();
          }, this),
          "touchstart.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "touchend.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = a.extend({}, e.Defaults, this._core.options));
    };
    (e.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (e.prototype._next = function (d) {
        (this._call = b.setTimeout(
          a.proxy(this._next, this, d),
          this._timeout * (Math.round(this.read() / this._timeout) + 1) -
            this.read()
        )),
          this._core.is("interacting") ||
            c.hidden ||
            this._core.next(d || this._core.settings.autoplaySpeed);
      }),
      (e.prototype.read = function () {
        return new Date().getTime() - this._time;
      }),
      (e.prototype.play = function (c, d) {
        var e;
        this._core.is("rotating") || this._core.enter("rotating"),
          (c = c || this._core.settings.autoplayTimeout),
          (e = Math.min(this._time % (this._timeout || c), c)),
          this._paused
            ? ((this._time = this.read()), (this._paused = !1))
            : b.clearTimeout(this._call),
          (this._time += (this.read() % c) - e),
          (this._timeout = c),
          (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
      }),
      (e.prototype.stop = function () {
        this._core.is("rotating") &&
          ((this._time = 0),
          (this._paused = !0),
          b.clearTimeout(this._call),
          this._core.leave("rotating"));
      }),
      (e.prototype.pause = function () {
        this._core.is("rotating") &&
          !this._paused &&
          ((this._time = this.read()),
          (this._paused = !0),
          b.clearTimeout(this._call));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this.stop();
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (b) {
      (this._core = b),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          "prepared.owl.carousel": a.proxy(function (b) {
            b.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  a(b.content)
                    .find("[data-dot]")
                    .addBack("[data-dot]")
                    .attr("data-dot") +
                  "</div>"
              );
          }, this),
          "added.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 0, this._templates.pop());
          }, this),
          "remove.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 1);
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" == a.property.name && this.draw();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"));
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"));
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    };
    (e.Defaults = {
      nav: !1,
      navText: [
        '<span aria-label="Previous">&#x2039;</span>',
        '<span aria-label="Next">&#x203a;</span>',
      ],
      navSpeed: !1,
      navElement: 'button type="button" role="presentation"',
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (e.prototype.initialize = function () {
        var b,
          c = this._core.settings;
        (this._controls.$relative = (
          c.navContainer
            ? a(c.navContainer)
            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
          (this._controls.$previous = a("<" + c.navElement + ">")
            .addClass(c.navClass[0])
            .html(c.navText[0])
            .prependTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.prev(c.navSpeed);
              }, this)
            )),
          (this._controls.$next = a("<" + c.navElement + ">")
            .addClass(c.navClass[1])
            .html(c.navText[1])
            .appendTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.next(c.navSpeed);
              }, this)
            )),
          c.dotsData ||
            (this._templates = [
              a('<button role="button">')
                .addClass(c.dotClass)
                .append(a("<span>"))
                .prop("outerHTML"),
            ]),
          (this._controls.$absolute = (
            c.dotsContainer
              ? a(c.dotsContainer)
              : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
          ).addClass("disabled")),
          this._controls.$absolute.on(
            "click",
            "button",
            a.proxy(function (b) {
              var d = a(b.target).parent().is(this._controls.$absolute)
                ? a(b.target).index()
                : a(b.target).parent().index();
              b.preventDefault(), this.to(d, c.dotsSpeed);
            }, this)
          );
        for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
      }),
      (e.prototype.destroy = function () {
        var a, b, c, d, e;
        e = this._core.settings;
        for (a in this._handlers) this.$element.off(a, this._handlers[a]);
        for (b in this._controls)
          "$relative" === b && e.navContainer
            ? this._controls[b].html("")
            : this._controls[b].remove();
        for (d in this.overides) this._core[d] = this._overrides[d];
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (e.prototype.update = function () {
        var a,
          b,
          c,
          d = this._core.clones().length / 2,
          e = d + this._core.items().length,
          f = this._core.maximum(!0),
          g = this._core.settings,
          h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
        if (
          ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
          g.dots || "page" == g.slideBy)
        )
          for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
            if (b >= h || 0 === b) {
              if (
                (this._pages.push({
                  start: Math.min(f, a - d),
                  end: a - d + h - 1,
                }),
                Math.min(f, a - d) === f)
              )
                break;
              (b = 0), ++c;
            }
            b += this._core.mergers(this._core.relative(a));
          }
      }),
      (e.prototype.draw = function () {
        var b,
          c = this._core.settings,
          d = this._core.items().length <= c.items,
          e = this._core.relative(this._core.current()),
          f = c.loop || c.rewind;
        this._controls.$relative.toggleClass("disabled", !c.nav || d),
          c.nav &&
            (this._controls.$previous.toggleClass(
              "disabled",
              !f && e <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              "disabled",
              !f && e >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass("disabled", !c.dots || d),
          c.dots &&
            ((b =
              this._pages.length - this._controls.$absolute.children().length),
            c.dotsData && 0 !== b
              ? this._controls.$absolute.html(this._templates.join(""))
              : b > 0
              ? this._controls.$absolute.append(
                  new Array(b + 1).join(this._templates[0])
                )
              : b < 0 && this._controls.$absolute.children().slice(b).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(a.inArray(this.current(), this._pages))
              .addClass("active"));
      }),
      (e.prototype.onTrigger = function (b) {
        var c = this._core.settings;
        b.page = {
          index: a.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            c &&
            (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
        };
      }),
      (e.prototype.current = function () {
        var b = this._core.relative(this._core.current());
        return a
          .grep(
            this._pages,
            a.proxy(function (a, c) {
              return a.start <= b && a.end >= b;
            }, this)
          )
          .pop();
      }),
      (e.prototype.getPosition = function (b) {
        var c,
          d,
          e = this._core.settings;
        return (
          "page" == e.slideBy
            ? ((c = a.inArray(this.current(), this._pages)),
              (d = this._pages.length),
              b ? ++c : --c,
              (c = this._pages[((c % d) + d) % d].start))
            : ((c = this._core.relative(this._core.current())),
              (d = this._core.items().length),
              b ? (c += e.slideBy) : (c -= e.slideBy)),
          c
        );
      }),
      (e.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
      }),
      (e.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
      }),
      (e.prototype.to = function (b, c, d) {
        var e;
        !d && this._pages.length
          ? ((e = this._pages.length),
            a.proxy(this._overrides.to, this._core)(
              this._pages[((b % e) + e) % e].start,
              c
            ))
          : a.proxy(this._overrides.to, this._core)(b, c);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (c) {
      (this._core = c),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (c) {
            c.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              a(b).trigger("hashchange.owl.navigation");
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content)
                .find("[data-hash]")
                .addBack("[data-hash]")
                .attr("data-hash");
              if (!c) return;
              this._hashes[c] = b.content;
            }
          }, this),
          "changed.owl.carousel": a.proxy(function (c) {
            if (c.namespace && "position" === c.property.name) {
              var d = this._core.items(
                  this._core.relative(this._core.current())
                ),
                e = a
                  .map(this._hashes, function (a, b) {
                    return a === d ? b : null;
                  })
                  .join();
              if (!e || b.location.hash.slice(1) === e) return;
              b.location.hash = e;
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        a(b).on(
          "hashchange.owl.navigation",
          a.proxy(function (a) {
            var c = b.location.hash.substring(1),
              e = this._core.$stage.children(),
              f = this._hashes[c] && e.index(this._hashes[c]);
            f !== d &&
              f !== this._core.current() &&
              this._core.to(this._core.relative(f), !1, !0);
          }, this)
        );
    };
    (e.Defaults = { URLhashListener: !1 }),
      (e.prototype.destroy = function () {
        var c, d;
        a(b).off("hashchange.owl.navigation");
        for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
        for (d in Object.getOwnPropertyNames(this))
          "function" != typeof this[d] && (this[d] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    function e(b, c) {
      var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1);
      return (
        a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
          if (g[b] !== d) return (e = !c || b), !1;
        }),
        e
      );
    }
    function f(a) {
      return e(a, !0);
    }
    var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
          },
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend",
          },
        },
      },
      j = {
        csstransforms: function () {
          return !!e("transform");
        },
        csstransforms3d: function () {
          return !!e("perspective");
        },
        csstransitions: function () {
          return !!e("transition");
        },
        cssanimations: function () {
          return !!e("animation");
        },
      };
    j.csstransitions() &&
      ((a.support.transition = new String(f("transition"))),
      (a.support.transition.end = i.transition.end[a.support.transition])),
      j.cssanimations() &&
        ((a.support.animation = new String(f("animation"))),
        (a.support.animation.end = i.animation.end[a.support.animation])),
      j.csstransforms() &&
        ((a.support.transform = new String(f("transform"))),
        (a.support.transform3d = j.csstransforms3d()));
  })(window.Zepto || window.jQuery, window, document);

/**
 * Owl2row
 * @since 2.0.2
 */
(function ($, window, document, undefined) {
  Owl2row = function (scope) {
    this.owl = scope;
    this.owl.options = $.extend({}, Owl2row.Defaults, this.owl.options);
    //link callback events with owl carousel here

    this.handlers = {
      "initialize.owl.carousel": $.proxy(function (e) {
        if (this.owl.settings.owl2row) {
          this.build2row(this);
        }
      }, this),
    };

    this.owl.$element.on(this.handlers);
  };

  Owl2row.Defaults = {
    owl2row: false,
    owl2rowTarget: "item",
    owl2rowContainer: "owl2row-item",
    owl2rowDirection: "utd", // ltr
  };

  //mehtods:
  Owl2row.prototype.build2row = function (thisScope) {
    var carousel = $(thisScope.owl.$element);
    var carouselItems = carousel.find(
      "." + thisScope.owl.options.owl2rowTarget
    );

    var aEvenElements = [];
    var aOddElements = [];

    $.each(carouselItems, function (index, item) {
      if (index % 2 === 0) {
        aEvenElements.push(item);
      } else {
        aOddElements.push(item);
      }
    });

    carousel.empty();

    switch (thisScope.owl.options.owl2rowDirection) {
      case "ltr":
        thisScope.leftToright(thisScope, carousel, carouselItems);
        break;

      default:
        thisScope.upTodown(thisScope, aEvenElements, aOddElements, carousel);
    }
  };

  Owl2row.prototype.leftToright = function (
    thisScope,
    carousel,
    carouselItems
  ) {
    var o2wContainerClass = thisScope.owl.options.owl2rowContainer;
    var owlMargin = thisScope.owl.options.margin;

    var carouselItemsLength = carouselItems.length;

    var firsArr = [];
    var secondArr = [];

    //console.log(carouselItemsLength);

    if (carouselItemsLength % 2 === 1) {
      carouselItemsLength = (carouselItemsLength - 1) / 2 + 1;
    } else {
      carouselItemsLength = carouselItemsLength / 2;
    }

    //console.log(carouselItemsLength);

    $.each(carouselItems, function (index, item) {
      if (index < carouselItemsLength) {
        firsArr.push(item);
      } else {
        secondArr.push(item);
      }
    });

    $.each(firsArr, function (index, item) {
      var rowContainer = $('<div class="' + o2wContainerClass + '"/>');

      var firstRowElement = firsArr[index];
      firstRowElement.style.marginBottom = owlMargin + "px";

      rowContainer.append(firstRowElement).append(secondArr[index]);

      carousel.append(rowContainer);
    });
  };

  Owl2row.prototype.upTodown = function (
    thisScope,
    aEvenElements,
    aOddElements,
    carousel
  ) {
    var o2wContainerClass = thisScope.owl.options.owl2rowContainer;
    var owlMargin = thisScope.owl.options.margin;

    $.each(aEvenElements, function (index, item) {
      var rowContainer = $('<div class="' + o2wContainerClass + '"/>');
      var evenElement = aEvenElements[index];

      evenElement.style.marginBottom = owlMargin + "px";

      rowContainer.append(evenElement).append(aOddElements[index]);

      carousel.append(rowContainer);
    });
  };

  /**
   * Destroys the plugin.
   */
  Owl2row.prototype.destroy = function () {
    var handler, property;

    for (handler in this.handlers) {
      this.owl.dom.$el.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] !== "function" && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins["owl2row"] = Owl2row;
})(window.Zepto || window.jQuery, window, document);



$(".featured_collection_slider").owlCarousel({
  loop: true,
  margin: 40,
  nav: true,
  items: 4,
  autoplay:true,
  autoplayTimeout:7500,
  dots: false,
  responsive: {
    0: {
      items: 2,
      margin: 10,
    },
    768: {
      items: 3,
      margin: 20,
    },
    992: {
      items: 4,
      margin: 30,
      rows: true,
      rowsCount: 3,
    },
  },
});

$(".collect_list_rightpart_slider_new").owlCarousel({
  loop: true,
  margin: 40,
  nav: false,
  items: 2,
  autoplay:true,
  autoplayTimeout:3000,
  dots: false,
  responsive: {
    0: {
      items: 2,
      margin: 20,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
});

$(".customers_slider").owlCarousel({
  loop: true,
  margin: 20,
  nav: true,
  items: 3,
  autoplay:false,
  autoplayTimeout:3000,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 3,
    },
    992: {
      items: 3,
    },
  },
});

$(".story_slider").owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  items: 3,
  autoplay:false,
  autoplayTimeout:3000,
  dots: false,
  responsive: {
    0: {
      items: 1,
      autoWidth: true,
      loop: true,
    },
    768: {
      items: 3,
    },
    992: {
      items: 3,
    },
  },
});

$(".variant_slider").owlCarousel({
  loop: true,
  margin: 12,
  nav: false,
  items: 5,
  autoplay:true,
  autoplayTimeout:3000,
  dots: false,
  autoWidth: false,
  responsive: {
    0: {
      items: 7,
      autoWidth: true,
      nav: false,
    },
    769: {
      items: 4,
      nav: false,
    },
    400: {
      items: 3,
      nav: false,
    },
    992: {
      items: 5,
    },
  },
});

$(".gallery_slider").owlCarousel({
  loop: true,
  margin: 0,
  autoplay:true,
  autoplayTimeout:3000,
  nav: false,
  items: 1,
  dots: true,
});

$(".product_list_rightpart_slider_new").owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  items: 3,
  autoplay:true,
  autoplayTimeout:3000,
  dots: false,
  responsive: {
    0: {
      items: 2,
      margin: 8,
    },
    768: {
      items: 3,
    },
    992: {
      items: 3,
    },
  },
});

$(".collection_list_slider").owlCarousel({
  loop: true,
  margin: 0,
  nav: false,
  items: 1,
  autoplay:true,
  autoplayTimeout:3000,
  dots: true,
});

$(".collections_list_slider").owlCarousel({
  loop: false,
  margin: 80,
  nav: true,
  items: 3,
  autoplay:true,
  autoplayTimeout:3000,
  dots: false,
  responsive: {
    0: {
      items: 1,
      margin: 0,
    },
    768: {
      items: 2,
      margin: 30,
    },
    992: {
      items: 3,
      margin: 30,
    },
    1200: {
      items: 3,
      margin: 50,
    },
    1500: {
      items: 3,
      margin: 80,
    },
  },
});

$(".deals_and_offers_testimonials_slider").owlCarousel({
  loop: false,
  margin: 0,
  nav: false,
  autoplay:true,
  autoplayTimeout:3000,
  items: 1,
  dots: false,
});

$(".offer_list_rightpart_slider_new").owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  autoplay:true,
  autoplayTimeout:3000,
  items: 3,
  dots: false,
  responsive: {
    0: {
      items: 2,
      margin: 8,
    },
    768: {
      items: 2,
    },
    992: {
      items: 3,
    },
  },
});

$(".blog_product_list").owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  autoplay:true,
  autoplayTimeout:3000,
  items: 4,
  dots: false,
  responsive: {
    0: {
      items: 2,
      margin: 8,
    },
    768: {
      items: 3,
    },
    992: {
      items: 4,
    },
  },
});

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "undefined" != typeof exports
    ? (module.exports = a(require("jquery")))
    : a(jQuery);
})(function (a) {
  "use strict";
  var b = window.Slick || {};
  (b = (function () {
    function c(c, d) {
      var f,
        e = this;
      (e.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: a(c),
        appendDots: a(c),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (b, c) {
          return a(
            '<button type="button" data-role="none" role="button" tabindex="0" />'
          ).text(c + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (e.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        a.extend(e, e.initials),
        (e.activeBreakpoint = null),
        (e.animType = null),
        (e.animProp = null),
        (e.breakpoints = []),
        (e.breakpointSettings = []),
        (e.cssTransitions = !1),
        (e.focussed = !1),
        (e.interrupted = !1),
        (e.hidden = "hidden"),
        (e.paused = !0),
        (e.positionProp = null),
        (e.respondTo = null),
        (e.rowCount = 1),
        (e.shouldClick = !0),
        (e.$slider = a(c)),
        (e.$slidesCache = null),
        (e.transformType = null),
        (e.transitionType = null),
        (e.visibilityChange = "visibilitychange"),
        (e.windowWidth = 0),
        (e.windowTimer = null),
        (f = a(c).data("slick") || {}),
        (e.options = a.extend({}, e.defaults, d, f)),
        (e.currentSlide = e.options.initialSlide),
        (e.originalSettings = e.options),
        "undefined" != typeof document.mozHidden
          ? ((e.hidden = "mozHidden"),
            (e.visibilityChange = "mozvisibilitychange"))
          : "undefined" != typeof document.webkitHidden &&
            ((e.hidden = "webkitHidden"),
            (e.visibilityChange = "webkitvisibilitychange")),
        (e.autoPlay = a.proxy(e.autoPlay, e)),
        (e.autoPlayClear = a.proxy(e.autoPlayClear, e)),
        (e.autoPlayIterator = a.proxy(e.autoPlayIterator, e)),
        (e.changeSlide = a.proxy(e.changeSlide, e)),
        (e.clickHandler = a.proxy(e.clickHandler, e)),
        (e.selectHandler = a.proxy(e.selectHandler, e)),
        (e.setPosition = a.proxy(e.setPosition, e)),
        (e.swipeHandler = a.proxy(e.swipeHandler, e)),
        (e.dragHandler = a.proxy(e.dragHandler, e)),
        (e.keyHandler = a.proxy(e.keyHandler, e)),
        (e.instanceUid = b++),
        (e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        e.registerBreakpoints(),
        e.init(!0);
    }
    var b = 0;
    return c;
  })()),
    (b.prototype.activateADA = function () {
      var a = this;
      a.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
    (b.prototype.addSlide = b.prototype.slickAdd =
      function (b, c, d) {
        var e = this;
        if ("boolean" == typeof c) (d = c), (c = null);
        else if (0 > c || c >= e.slideCount) return !1;
        e.unload(),
          "number" == typeof c
            ? 0 === c && 0 === e.$slides.length
              ? a(b).appendTo(e.$slideTrack)
              : d
              ? a(b).insertBefore(e.$slides.eq(c))
              : a(b).insertAfter(e.$slides.eq(c))
            : d === !0
            ? a(b).prependTo(e.$slideTrack)
            : a(b).appendTo(e.$slideTrack),
          (e.$slides = e.$slideTrack.children(this.options.slide)),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slideTrack.append(e.$slides),
          e.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b);
          }),
          (e.$slidesCache = e.$slides),
          e.reinit();
      }),
    (b.prototype.animateHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.animate({ height: b }, a.options.speed);
      }
    }),
    (b.prototype.animateSlide = function (b, c) {
      var d = {},
        e = this;
      e.animateHeight(),
        e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
        e.transformsEnabled === !1
          ? e.options.vertical === !1
            ? e.$slideTrack.animate(
                { left: b },
                e.options.speed,
                e.options.easing,
                c
              )
            : e.$slideTrack.animate(
                { top: b },
                e.options.speed,
                e.options.easing,
                c
              )
          : e.cssTransitions === !1
          ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
            a({ animStart: e.currentLeft }).animate(
              { animStart: b },
              {
                duration: e.options.speed,
                easing: e.options.easing,
                step: function (a) {
                  (a = Math.ceil(a)),
                    e.options.vertical === !1
                      ? ((d[e.animType] = "translate(" + a + "px, 0px)"),
                        e.$slideTrack.css(d))
                      : ((d[e.animType] = "translate(0px," + a + "px)"),
                        e.$slideTrack.css(d));
                },
                complete: function () {
                  c && c.call();
                },
              }
            ))
          : (e.applyTransition(),
            (b = Math.ceil(b)),
            e.options.vertical === !1
              ? (d[e.animType] = "translate3d(" + b + "px, 0px, 0px)")
              : (d[e.animType] = "translate3d(0px," + b + "px, 0px)"),
            e.$slideTrack.css(d),
            c &&
              setTimeout(function () {
                e.disableTransition(), c.call();
              }, e.options.speed));
    }),
    (b.prototype.getNavTarget = function () {
      var b = this,
        c = b.options.asNavFor;
      return c && null !== c && (c = a(c).not(b.$slider)), c;
    }),
    (b.prototype.asNavFor = function (b) {
      var c = this,
        d = c.getNavTarget();
      null !== d &&
        "object" == typeof d &&
        d.each(function () {
          var c = a(this).slick("getSlick");
          c.unslicked || c.slideHandler(b, !0);
        });
    }),
    (b.prototype.applyTransition = function (a) {
      var b = this,
        c = {};
      b.options.fade === !1
        ? (c[b.transitionType] =
            b.transformType + " " + b.options.speed + "ms " + b.options.cssEase)
        : (c[b.transitionType] =
            "opacity " + b.options.speed + "ms " + b.options.cssEase),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.autoPlay = function () {
      var a = this;
      a.autoPlayClear(),
        a.slideCount > a.options.slidesToShow &&
          (a.autoPlayTimer = setInterval(
            a.autoPlayIterator,
            a.options.autoplaySpeed
          ));
    }),
    (b.prototype.autoPlayClear = function () {
      var a = this;
      a.autoPlayTimer && clearInterval(a.autoPlayTimer);
    }),
    (b.prototype.autoPlayIterator = function () {
      var a = this,
        b = a.currentSlide + a.options.slidesToScroll;
      a.paused ||
        a.interrupted ||
        a.focussed ||
        (a.options.infinite === !1 &&
          (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1
            ? (a.direction = 0)
            : 0 === a.direction &&
              ((b = a.currentSlide - a.options.slidesToScroll),
              a.currentSlide - 1 === 0 && (a.direction = 1))),
        a.slideHandler(b));
    }),
    (b.prototype.buildArrows = function () {
      var b = this;
      b.options.arrows === !0 &&
        ((b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow")),
        (b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow")),
        b.slideCount > b.options.slidesToShow
          ? (b.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.htmlExpr.test(b.options.prevArrow) &&
              b.$prevArrow.prependTo(b.options.appendArrows),
            b.htmlExpr.test(b.options.nextArrow) &&
              b.$nextArrow.appendTo(b.options.appendArrows),
            b.options.infinite !== !0 &&
              b.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : b.$prevArrow
              .add(b.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (b.prototype.buildDots = function () {
      var c,
        d,
        b = this;
      if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
        for (
          b.$slider.addClass("slick-dotted"),
            d = a("<ul />").addClass(b.options.dotsClass),
            c = 0;
          c <= b.getDotCount();
          c += 1
        )
          d.append(a("<li />").append(b.options.customPaging.call(this, b, c)));
        (b.$dots = d.appendTo(b.options.appendDots)),
          b.$dots
            .find("li")
            .first()
            .addClass("slick-active")
            .attr("aria-hidden", "false");
      }
    }),
    (b.prototype.buildOut = function () {
      var b = this;
      (b.$slides = b.$slider
        .children(b.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.$slides.each(function (b, c) {
          a(c)
            .attr("data-slick-index", b)
            .data("originalStyling", a(c).attr("style") || "");
        }),
        b.$slider.addClass("slick-slider"),
        (b.$slideTrack =
          0 === b.slideCount
            ? a('<div class="slick-track"/>').appendTo(b.$slider)
            : b.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (b.$list = b.$slideTrack
          .wrap('<div aria-live="polite" class="slick-list"/>')
          .parent()),
        b.$slideTrack.css("opacity", 0),
        (b.options.centerMode === !0 || b.options.swipeToSlide === !0) &&
          (b.options.slidesToScroll = 1),
        a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
        b.setupInfinite(),
        b.buildArrows(),
        b.buildDots(),
        b.updateDots(),
        b.setSlideClasses(
          "number" == typeof b.currentSlide ? b.currentSlide : 0
        ),
        b.options.draggable === !0 && b.$list.addClass("draggable");
    }),
    (b.prototype.buildRows = function () {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        a = this;
      if (
        ((e = document.createDocumentFragment()),
        (g = a.$slider.children()),
        a.options.rows > 1)
      ) {
        for (
          h = a.options.slidesPerRow * a.options.rows,
            f = Math.ceil(g.length / h),
            b = 0;
          f > b;
          b++
        ) {
          var i = document.createElement("div");
          for (c = 0; c < a.options.rows; c++) {
            var j = document.createElement("div");
            for (d = 0; d < a.options.slidesPerRow; d++) {
              var k = b * h + (c * a.options.slidesPerRow + d);
              g.get(k) && j.appendChild(g.get(k));
            }
            i.appendChild(j);
          }
          e.appendChild(i);
        }
        a.$slider.empty().append(e),
          a.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / a.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (b.prototype.checkResponsive = function (b, c) {
      var e,
        f,
        g,
        d = this,
        h = !1,
        i = d.$slider.width(),
        j = window.innerWidth || a(window).width();
      if (
        ("window" === d.respondTo
          ? (g = j)
          : "slider" === d.respondTo
          ? (g = i)
          : "min" === d.respondTo && (g = Math.min(j, i)),
        d.options.responsive &&
          d.options.responsive.length &&
          null !== d.options.responsive)
      ) {
        f = null;
        for (e in d.breakpoints)
          d.breakpoints.hasOwnProperty(e) &&
            (d.originalSettings.mobileFirst === !1
              ? g < d.breakpoints[e] && (f = d.breakpoints[e])
              : g > d.breakpoints[e] && (f = d.breakpoints[e]));
        null !== f
          ? null !== d.activeBreakpoint
            ? (f !== d.activeBreakpoint || c) &&
              ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
            : ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
          : null !== d.activeBreakpoint &&
            ((d.activeBreakpoint = null),
            (d.options = d.originalSettings),
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b),
            (h = f)),
          b || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
      }
    }),
    (b.prototype.changeSlide = function (b, c) {
      var f,
        g,
        h,
        d = this,
        e = a(b.currentTarget);
      switch (
        (e.is("a") && b.preventDefault(),
        e.is("li") || (e = e.closest("li")),
        (h = d.slideCount % d.options.slidesToScroll !== 0),
        (f = h
          ? 0
          : (d.slideCount - d.currentSlide) % d.options.slidesToScroll),
        b.data.message)
      ) {
        case "previous":
          (g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide - g, !1, c);
          break;
        case "next":
          (g = 0 === f ? d.options.slidesToScroll : f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide + g, !1, c);
          break;
        case "index":
          var i =
            0 === b.data.index
              ? 0
              : b.data.index || e.index() * d.options.slidesToScroll;
          d.slideHandler(d.checkNavigable(i), !1, c),
            e.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (b.prototype.checkNavigable = function (a) {
      var c,
        d,
        b = this;
      if (((c = b.getNavigableIndexes()), (d = 0), a > c[c.length - 1]))
        a = c[c.length - 1];
      else
        for (var e in c) {
          if (a < c[e]) {
            a = d;
            break;
          }
          d = c[e];
        }
      return a;
    }),
    (b.prototype.cleanUpEvents = function () {
      var b = this;
      b.options.dots &&
        null !== b.$dots &&
        a("li", b.$dots)
          .off("click.slick", b.changeSlide)
          .off("mouseenter.slick", a.proxy(b.interrupt, b, !0))
          .off("mouseleave.slick", a.proxy(b.interrupt, b, !1)),
        b.$slider.off("focus.slick blur.slick"),
        b.options.arrows === !0 &&
          b.slideCount > b.options.slidesToShow &&
          (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
          b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)),
        b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
        b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
        b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
        b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
        b.$list.off("click.slick", b.clickHandler),
        a(document).off(b.visibilityChange, b.visibility),
        b.cleanUpSlideEvents(),
        b.options.accessibility === !0 &&
          b.$list.off("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().off("click.slick", b.selectHandler),
        a(window).off(
          "orientationchange.slick.slick-" + b.instanceUid,
          b.orientationChange
        ),
        a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
        a("[draggable!=true]", b.$slideTrack).off(
          "dragstart",
          b.preventDefault
        ),
        a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.cleanUpSlideEvents = function () {
      var b = this;
      b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }),
    (b.prototype.cleanUpRows = function () {
      var b,
        a = this;
      a.options.rows > 1 &&
        ((b = a.$slides.children().children()),
        b.removeAttr("style"),
        a.$slider.empty().append(b));
    }),
    (b.prototype.clickHandler = function (a) {
      var b = this;
      b.shouldClick === !1 &&
        (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
    }),
    (b.prototype.destroy = function (b) {
      var c = this;
      c.autoPlayClear(),
        (c.touchObject = {}),
        c.cleanUpEvents(),
        a(".slick-cloned", c.$slider).detach(),
        c.$dots && c.$dots.remove(),
        c.$prevArrow &&
          c.$prevArrow.length &&
          (c.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
        c.$nextArrow &&
          c.$nextArrow.length &&
          (c.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
        c.$slides &&
          (c.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              a(this).attr("style", a(this).data("originalStyling"));
            }),
          c.$slideTrack.children(this.options.slide).detach(),
          c.$slideTrack.detach(),
          c.$list.detach(),
          c.$slider.append(c.$slides)),
        c.cleanUpRows(),
        c.$slider.removeClass("slick-slider"),
        c.$slider.removeClass("slick-initialized"),
        c.$slider.removeClass("slick-dotted"),
        (c.unslicked = !0),
        b || c.$slider.trigger("destroy", [c]);
    }),
    (b.prototype.disableTransition = function (a) {
      var b = this,
        c = {};
      (c[b.transitionType] = ""),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.fadeSlide = function (a, b) {
      var c = this;
      c.cssTransitions === !1
        ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }),
          c.$slides
            .eq(a)
            .animate({ opacity: 1 }, c.options.speed, c.options.easing, b))
        : (c.applyTransition(a),
          c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }),
          b &&
            setTimeout(function () {
              c.disableTransition(a), b.call();
            }, c.options.speed));
    }),
    (b.prototype.fadeSlideOut = function (a) {
      var b = this;
      b.cssTransitions === !1
        ? b.$slides
            .eq(a)
            .animate(
              { opacity: 0, zIndex: b.options.zIndex - 2 },
              b.options.speed,
              b.options.easing
            )
        : (b.applyTransition(a),
          b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
    }),
    (b.prototype.filterSlides = b.prototype.slickFilter =
      function (a) {
        var b = this;
        null !== a &&
          ((b.$slidesCache = b.$slides),
          b.unload(),
          b.$slideTrack.children(this.options.slide).detach(),
          b.$slidesCache.filter(a).appendTo(b.$slideTrack),
          b.reinit());
      }),
    (b.prototype.focusHandler = function () {
      var b = this;
      b.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (c) {
          c.stopImmediatePropagation();
          var d = a(this);
          setTimeout(function () {
            b.options.pauseOnFocus &&
              ((b.focussed = d.is(":focus")), b.autoPlay());
          }, 0);
        });
    }),
    (b.prototype.getCurrent = b.prototype.slickCurrentSlide =
      function () {
        var a = this;
        return a.currentSlide;
      }),
    (b.prototype.getDotCount = function () {
      var a = this,
        b = 0,
        c = 0,
        d = 0;
      if (a.options.infinite === !0)
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      else if (a.options.centerMode === !0) d = a.slideCount;
      else if (a.options.asNavFor)
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      else
        d =
          1 +
          Math.ceil(
            (a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll
          );
      return d - 1;
    }),
    (b.prototype.getLeft = function (a) {
      var c,
        d,
        f,
        b = this,
        e = 0;
      return (
        (b.slideOffset = 0),
        (d = b.$slides.first().outerHeight(!0)),
        b.options.infinite === !0
          ? (b.slideCount > b.options.slidesToShow &&
              ((b.slideOffset = b.slideWidth * b.options.slidesToShow * -1),
              (e = d * b.options.slidesToShow * -1)),
            b.slideCount % b.options.slidesToScroll !== 0 &&
              a + b.options.slidesToScroll > b.slideCount &&
              b.slideCount > b.options.slidesToShow &&
              (a > b.slideCount
                ? ((b.slideOffset =
                    (b.options.slidesToShow - (a - b.slideCount)) *
                    b.slideWidth *
                    -1),
                  (e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1))
                : ((b.slideOffset =
                    (b.slideCount % b.options.slidesToScroll) *
                    b.slideWidth *
                    -1),
                  (e = (b.slideCount % b.options.slidesToScroll) * d * -1))))
          : a + b.options.slidesToShow > b.slideCount &&
            ((b.slideOffset =
              (a + b.options.slidesToShow - b.slideCount) * b.slideWidth),
            (e = (a + b.options.slidesToShow - b.slideCount) * d)),
        b.slideCount <= b.options.slidesToShow &&
          ((b.slideOffset = 0), (e = 0)),
        b.options.centerMode === !0 && b.options.infinite === !0
          ? (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2) -
              b.slideWidth)
          : b.options.centerMode === !0 &&
            ((b.slideOffset = 0),
            (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2))),
        (c =
          b.options.vertical === !1
            ? a * b.slideWidth * -1 + b.slideOffset
            : a * d * -1 + e),
        b.options.variableWidth === !0 &&
          ((f =
            b.slideCount <= b.options.slidesToShow || b.options.infinite === !1
              ? b.$slideTrack.children(".slick-slide").eq(a)
              : b.$slideTrack
                  .children(".slick-slide")
                  .eq(a + b.options.slidesToShow)),
          (c =
            b.options.rtl === !0
              ? f[0]
                ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                : 0
              : f[0]
              ? -1 * f[0].offsetLeft
              : 0),
          b.options.centerMode === !0 &&
            ((f =
              b.slideCount <= b.options.slidesToShow ||
              b.options.infinite === !1
                ? b.$slideTrack.children(".slick-slide").eq(a)
                : b.$slideTrack
                    .children(".slick-slide")
                    .eq(a + b.options.slidesToShow + 1)),
            (c =
              b.options.rtl === !0
                ? f[0]
                  ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                  : 0
                : f[0]
                ? -1 * f[0].offsetLeft
                : 0),
            (c += (b.$list.width() - f.outerWidth()) / 2))),
        c
      );
    }),
    (b.prototype.getOption = b.prototype.slickGetOption =
      function (a) {
        var b = this;
        return b.options[a];
      }),
    (b.prototype.getNavigableIndexes = function () {
      var e,
        a = this,
        b = 0,
        c = 0,
        d = [];
      for (
        a.options.infinite === !1
          ? (e = a.slideCount)
          : ((b = -1 * a.options.slidesToScroll),
            (c = -1 * a.options.slidesToScroll),
            (e = 2 * a.slideCount));
        e > b;

      )
        d.push(b),
          (b = c + a.options.slidesToScroll),
          (c +=
            a.options.slidesToScroll <= a.options.slidesToShow
              ? a.options.slidesToScroll
              : a.options.slidesToShow);
      return d;
    }),
    (b.prototype.getSlick = function () {
      return this;
    }),
    (b.prototype.getSlideCount = function () {
      var c,
        d,
        e,
        b = this;
      return (
        (e =
          b.options.centerMode === !0
            ? b.slideWidth * Math.floor(b.options.slidesToShow / 2)
            : 0),
        b.options.swipeToSlide === !0
          ? (b.$slideTrack.find(".slick-slide").each(function (c, f) {
              return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft
                ? ((d = f), !1)
                : void 0;
            }),
            (c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1))
          : b.options.slidesToScroll
      );
    }),
    (b.prototype.goTo = b.prototype.slickGoTo =
      function (a, b) {
        var c = this;
        c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
      }),
    (b.prototype.init = function (b) {
      var c = this;
      a(c.$slider).hasClass("slick-initialized") ||
        (a(c.$slider).addClass("slick-initialized"),
        c.buildRows(),
        c.buildOut(),
        c.setProps(),
        c.startLoad(),
        c.loadSlider(),
        c.initializeEvents(),
        c.updateArrows(),
        c.updateDots(),
        c.checkResponsive(!0),
        c.focusHandler()),
        b && c.$slider.trigger("init", [c]),
        c.options.accessibility === !0 && c.initADA(),
        c.options.autoplay && ((c.paused = !1), c.autoPlay());
    }),
    (b.prototype.initADA = function () {
      var b = this;
      b.$slides
        .add(b.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        b.$slideTrack.attr("role", "listbox"),
        b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
          a(this).attr({
            role: "option",
            "aria-describedby": "slick-slide" + b.instanceUid + c,
          });
        }),
        null !== b.$dots &&
          b.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (c) {
              a(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + b.instanceUid + c,
                id: "slick-slide" + b.instanceUid + c,
              });
            })
            .first()
            .attr("aria-selected", "true")
            .end()
            .find("button")
            .attr("role", "button")
            .end()
            .closest("div")
            .attr("role", "toolbar"),
        b.activateADA();
    }),
    (b.prototype.initArrowEvents = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, a.changeSlide),
        a.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, a.changeSlide));
    }),
    (b.prototype.initDotEvents = function () {
      var b = this;
      b.options.dots === !0 &&
        b.slideCount > b.options.slidesToShow &&
        a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide),
        b.options.dots === !0 &&
          b.options.pauseOnDotsHover === !0 &&
          a("li", b.$dots)
            .on("mouseenter.slick", a.proxy(b.interrupt, b, !0))
            .on("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }),
    (b.prototype.initSlideEvents = function () {
      var b = this;
      b.options.pauseOnHover &&
        (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)));
    }),
    (b.prototype.initializeEvents = function () {
      var b = this;
      b.initArrowEvents(),
        b.initDotEvents(),
        b.initSlideEvents(),
        b.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on("click.slick", b.clickHandler),
        a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
        b.options.accessibility === !0 &&
          b.$list.on("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        a(window).on(
          "orientationchange.slick.slick-" + b.instanceUid,
          a.proxy(b.orientationChange, b)
        ),
        a(window).on(
          "resize.slick.slick-" + b.instanceUid,
          a.proxy(b.resize, b)
        ),
        a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
        a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.initUI = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.show(), a.$nextArrow.show()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.show();
    }),
    (b.prototype.keyHandler = function (a) {
      var b = this;
      a.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === a.keyCode && b.options.accessibility === !0
          ? b.changeSlide({
              data: { message: b.options.rtl === !0 ? "next" : "previous" },
            })
          : 39 === a.keyCode &&
            b.options.accessibility === !0 &&
            b.changeSlide({
              data: { message: b.options.rtl === !0 ? "previous" : "next" },
            }));
    }),
    (b.prototype.lazyLoad = function () {
      function g(c) {
        a("img[data-lazy]", c).each(function () {
          var c = a(this),
            d = a(this).attr("data-lazy"),
            e = document.createElement("img");
          (e.onload = function () {
            c.animate({ opacity: 0 }, 100, function () {
              c.attr("src", d).animate({ opacity: 1 }, 200, function () {
                c.removeAttr("data-lazy").removeClass("slick-loading");
              }),
                b.$slider.trigger("lazyLoaded", [b, c, d]);
            });
          }),
            (e.onerror = function () {
              c
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                b.$slider.trigger("lazyLoadError", [b, c, d]);
            }),
            (e.src = d);
        });
      }
      var c,
        d,
        e,
        f,
        b = this;
      b.options.centerMode === !0
        ? b.options.infinite === !0
          ? ((e = b.currentSlide + (b.options.slidesToShow / 2 + 1)),
            (f = e + b.options.slidesToShow + 2))
          : ((e = Math.max(
              0,
              b.currentSlide - (b.options.slidesToShow / 2 + 1)
            )),
            (f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide))
        : ((e = b.options.infinite
            ? b.options.slidesToShow + b.currentSlide
            : b.currentSlide),
          (f = Math.ceil(e + b.options.slidesToShow)),
          b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)),
        (c = b.$slider.find(".slick-slide").slice(e, f)),
        g(c),
        b.slideCount <= b.options.slidesToShow
          ? ((d = b.$slider.find(".slick-slide")), g(d))
          : b.currentSlide >= b.slideCount - b.options.slidesToShow
          ? ((d = b.$slider
              .find(".slick-cloned")
              .slice(0, b.options.slidesToShow)),
            g(d))
          : 0 === b.currentSlide &&
            ((d = b.$slider
              .find(".slick-cloned")
              .slice(-1 * b.options.slidesToShow)),
            g(d));
    }),
    (b.prototype.loadSlider = function () {
      var a = this;
      a.setPosition(),
        a.$slideTrack.css({ opacity: 1 }),
        a.$slider.removeClass("slick-loading"),
        a.initUI(),
        "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
    }),
    (b.prototype.next = b.prototype.slickNext =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "next" } });
      }),
    (b.prototype.orientationChange = function () {
      var a = this;
      a.checkResponsive(), a.setPosition();
    }),
    (b.prototype.pause = b.prototype.slickPause =
      function () {
        var a = this;
        a.autoPlayClear(), (a.paused = !0);
      }),
    (b.prototype.play = b.prototype.slickPlay =
      function () {
        var a = this;
        a.autoPlay(),
          (a.options.autoplay = !0),
          (a.paused = !1),
          (a.focussed = !1),
          (a.interrupted = !1);
      }),
    (b.prototype.postSlide = function (a) {
      var b = this;
      b.unslicked ||
        (b.$slider.trigger("afterChange", [b, a]),
        (b.animating = !1),
        b.setPosition(),
        (b.swipeLeft = null),
        b.options.autoplay && b.autoPlay(),
        b.options.accessibility === !0 && b.initADA());
    }),
    (b.prototype.prev = b.prototype.slickPrev =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "previous" } });
      }),
    (b.prototype.preventDefault = function (a) {
      a.preventDefault();
    }),
    (b.prototype.progressiveLazyLoad = function (b) {
      b = b || 1;
      var e,
        f,
        g,
        c = this,
        d = a("img[data-lazy]", c.$slider);
      d.length
        ? ((e = d.first()),
          (f = e.attr("data-lazy")),
          (g = document.createElement("img")),
          (g.onload = function () {
            e
              .attr("src", f)
              .removeAttr("data-lazy")
              .removeClass("slick-loading"),
              c.options.adaptiveHeight === !0 && c.setPosition(),
              c.$slider.trigger("lazyLoaded", [c, e, f]),
              c.progressiveLazyLoad();
          }),
          (g.onerror = function () {
            3 > b
              ? setTimeout(function () {
                  c.progressiveLazyLoad(b + 1);
                }, 500)
              : (e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                c.$slider.trigger("lazyLoadError", [c, e, f]),
                c.progressiveLazyLoad());
          }),
          (g.src = f))
        : c.$slider.trigger("allImagesLoaded", [c]);
    }),
    (b.prototype.refresh = function (b) {
      var d,
        e,
        c = this;
      (e = c.slideCount - c.options.slidesToShow),
        !c.options.infinite && c.currentSlide > e && (c.currentSlide = e),
        c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0),
        (d = c.currentSlide),
        c.destroy(!0),
        a.extend(c, c.initials, { currentSlide: d }),
        c.init(),
        b || c.changeSlide({ data: { message: "index", index: d } }, !1);
    }),
    (b.prototype.registerBreakpoints = function () {
      var c,
        d,
        e,
        b = this,
        f = b.options.responsive || null;
      if ("array" === a.type(f) && f.length) {
        b.respondTo = b.options.respondTo || "window";
        for (c in f)
          if (
            ((e = b.breakpoints.length - 1),
            (d = f[c].breakpoint),
            f.hasOwnProperty(c))
          ) {
            for (; e >= 0; )
              b.breakpoints[e] &&
                b.breakpoints[e] === d &&
                b.breakpoints.splice(e, 1),
                e--;
            b.breakpoints.push(d), (b.breakpointSettings[d] = f[c].settings);
          }
        b.breakpoints.sort(function (a, c) {
          return b.options.mobileFirst ? a - c : c - a;
        });
      }
    }),
    (b.prototype.reinit = function () {
      var b = this;
      (b.$slides = b.$slideTrack
        .children(b.options.slide)
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.currentSlide >= b.slideCount &&
          0 !== b.currentSlide &&
          (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
        b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
        b.registerBreakpoints(),
        b.setProps(),
        b.setupInfinite(),
        b.buildArrows(),
        b.updateArrows(),
        b.initArrowEvents(),
        b.buildDots(),
        b.updateDots(),
        b.initDotEvents(),
        b.cleanUpSlideEvents(),
        b.initSlideEvents(),
        b.checkResponsive(!1, !0),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        b.setSlideClasses(
          "number" == typeof b.currentSlide ? b.currentSlide : 0
        ),
        b.setPosition(),
        b.focusHandler(),
        (b.paused = !b.options.autoplay),
        b.autoPlay(),
        b.$slider.trigger("reInit", [b]);
    }),
    (b.prototype.resize = function () {
      var b = this;
      a(window).width() !== b.windowWidth &&
        (clearTimeout(b.windowDelay),
        (b.windowDelay = window.setTimeout(function () {
          (b.windowWidth = a(window).width()),
            b.checkResponsive(),
            b.unslicked || b.setPosition();
        }, 50)));
    }),
    (b.prototype.removeSlide = b.prototype.slickRemove =
      function (a, b, c) {
        var d = this;
        return (
          "boolean" == typeof a
            ? ((b = a), (a = b === !0 ? 0 : d.slideCount - 1))
            : (a = b === !0 ? --a : a),
          d.slideCount < 1 || 0 > a || a > d.slideCount - 1
            ? !1
            : (d.unload(),
              c === !0
                ? d.$slideTrack.children().remove()
                : d.$slideTrack.children(this.options.slide).eq(a).remove(),
              (d.$slides = d.$slideTrack.children(this.options.slide)),
              d.$slideTrack.children(this.options.slide).detach(),
              d.$slideTrack.append(d.$slides),
              (d.$slidesCache = d.$slides),
              void d.reinit())
        );
      }),
    (b.prototype.setCSS = function (a) {
      var d,
        e,
        b = this,
        c = {};
      b.options.rtl === !0 && (a = -a),
        (d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (c[b.positionProp] = a),
        b.transformsEnabled === !1
          ? b.$slideTrack.css(c)
          : ((c = {}),
            b.cssTransitions === !1
              ? ((c[b.animType] = "translate(" + d + ", " + e + ")"),
                b.$slideTrack.css(c))
              : ((c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)"),
                b.$slideTrack.css(c)));
    }),
    (b.prototype.setDimensions = function () {
      var a = this;
      a.options.vertical === !1
        ? a.options.centerMode === !0 &&
          a.$list.css({ padding: "0px " + a.options.centerPadding })
        : (a.$list.height(
            a.$slides.first().outerHeight(!0) * a.options.slidesToShow
          ),
          a.options.centerMode === !0 &&
            a.$list.css({ padding: a.options.centerPadding + " 0px" })),
        (a.listWidth = a.$list.width()),
        (a.listHeight = a.$list.height()),
        a.options.vertical === !1 && a.options.variableWidth === !1
          ? ((a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow)),
            a.$slideTrack.width(
              Math.ceil(
                a.slideWidth * a.$slideTrack.children(".slick-slide").length
              )
            ))
          : a.options.variableWidth === !0
          ? a.$slideTrack.width(5e3 * a.slideCount)
          : ((a.slideWidth = Math.ceil(a.listWidth)),
            a.$slideTrack.height(
              Math.ceil(
                a.$slides.first().outerHeight(!0) *
                  a.$slideTrack.children(".slick-slide").length
              )
            ));
      var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
      a.options.variableWidth === !1 &&
        a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
    }),
    (b.prototype.setFade = function () {
      var c,
        b = this;
      b.$slides.each(function (d, e) {
        (c = b.slideWidth * d * -1),
          b.options.rtl === !0
            ? a(e).css({
                position: "relative",
                right: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              })
            : a(e).css({
                position: "relative",
                left: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              });
      }),
        b.$slides
          .eq(b.currentSlide)
          .css({ zIndex: b.options.zIndex - 1, opacity: 1 });
    }),
    (b.prototype.setHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.css("height", b);
      }
    }),
    (b.prototype.setOption = b.prototype.slickSetOption =
      function () {
        var c,
          d,
          e,
          f,
          h,
          b = this,
          g = !1;
        if (
          ("object" === a.type(arguments[0])
            ? ((e = arguments[0]), (g = arguments[1]), (h = "multiple"))
            : "string" === a.type(arguments[0]) &&
              ((e = arguments[0]),
              (f = arguments[1]),
              (g = arguments[2]),
              "responsive" === arguments[0] && "array" === a.type(arguments[1])
                ? (h = "responsive")
                : "undefined" != typeof arguments[1] && (h = "single")),
          "single" === h)
        )
          b.options[e] = f;
        else if ("multiple" === h)
          a.each(e, function (a, c) {
            b.options[a] = c;
          });
        else if ("responsive" === h)
          for (d in f)
            if ("array" !== a.type(b.options.responsive))
              b.options.responsive = [f[d]];
            else {
              for (c = b.options.responsive.length - 1; c >= 0; )
                b.options.responsive[c].breakpoint === f[d].breakpoint &&
                  b.options.responsive.splice(c, 1),
                  c--;
              b.options.responsive.push(f[d]);
            }
        g && (b.unload(), b.reinit());
      }),
    (b.prototype.setPosition = function () {
      var a = this;
      a.setDimensions(),
        a.setHeight(),
        a.options.fade === !1
          ? a.setCSS(a.getLeft(a.currentSlide))
          : a.setFade(),
        a.$slider.trigger("setPosition", [a]);
    }),
    (b.prototype.setProps = function () {
      var a = this,
        b = document.body.style;
      (a.positionProp = a.options.vertical === !0 ? "top" : "left"),
        "top" === a.positionProp
          ? a.$slider.addClass("slick-vertical")
          : a.$slider.removeClass("slick-vertical"),
        (void 0 !== b.WebkitTransition ||
          void 0 !== b.MozTransition ||
          void 0 !== b.msTransition) &&
          a.options.useCSS === !0 &&
          (a.cssTransitions = !0),
        a.options.fade &&
          ("number" == typeof a.options.zIndex
            ? a.options.zIndex < 3 && (a.options.zIndex = 3)
            : (a.options.zIndex = a.defaults.zIndex)),
        void 0 !== b.OTransform &&
          ((a.animType = "OTransform"),
          (a.transformType = "-o-transform"),
          (a.transitionType = "OTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.MozTransform &&
          ((a.animType = "MozTransform"),
          (a.transformType = "-moz-transform"),
          (a.transitionType = "MozTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.MozPerspective &&
            (a.animType = !1)),
        void 0 !== b.webkitTransform &&
          ((a.animType = "webkitTransform"),
          (a.transformType = "-webkit-transform"),
          (a.transitionType = "webkitTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.msTransform &&
          ((a.animType = "msTransform"),
          (a.transformType = "-ms-transform"),
          (a.transitionType = "msTransition"),
          void 0 === b.msTransform && (a.animType = !1)),
        void 0 !== b.transform &&
          a.animType !== !1 &&
          ((a.animType = "transform"),
          (a.transformType = "transform"),
          (a.transitionType = "transition")),
        (a.transformsEnabled =
          a.options.useTransform && null !== a.animType && a.animType !== !1);
    }),
    (b.prototype.setSlideClasses = function (a) {
      var c,
        d,
        e,
        f,
        b = this;
      (d = b.$slider
        .find(".slick-slide")
        .removeClass("slick-active slick-center slick-current")
        .attr("aria-hidden", "true")),
        b.$slides.eq(a).addClass("slick-current"),
        b.options.centerMode === !0
          ? ((c = Math.floor(b.options.slidesToShow / 2)),
            b.options.infinite === !0 &&
              (a >= c && a <= b.slideCount - 1 - c
                ? b.$slides
                    .slice(a - c, a + c + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((e = b.options.slidesToShow + a),
                  d
                    .slice(e - c + 1, e + c + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === a
                ? d
                    .eq(d.length - 1 - b.options.slidesToShow)
                    .addClass("slick-center")
                : a === b.slideCount - 1 &&
                  d.eq(b.options.slidesToShow).addClass("slick-center")),
            b.$slides.eq(a).addClass("slick-center"))
          : a >= 0 && a <= b.slideCount - b.options.slidesToShow
          ? b.$slides
              .slice(a, a + b.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : d.length <= b.options.slidesToShow
          ? d.addClass("slick-active").attr("aria-hidden", "false")
          : ((f = b.slideCount % b.options.slidesToShow),
            (e = b.options.infinite === !0 ? b.options.slidesToShow + a : a),
            b.options.slidesToShow == b.options.slidesToScroll &&
            b.slideCount - a < b.options.slidesToShow
              ? d
                  .slice(e - (b.options.slidesToShow - f), e + f)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : d
                  .slice(e, e + b.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
        "ondemand" === b.options.lazyLoad && b.lazyLoad();
    }),
    (b.prototype.setupInfinite = function () {
      var c,
        d,
        e,
        b = this;
      if (
        (b.options.fade === !0 && (b.options.centerMode = !1),
        b.options.infinite === !0 &&
          b.options.fade === !1 &&
          ((d = null), b.slideCount > b.options.slidesToShow))
      ) {
        for (
          e =
            b.options.centerMode === !0
              ? b.options.slidesToShow + 1
              : b.options.slidesToShow,
            c = b.slideCount;
          c > b.slideCount - e;
          c -= 1
        )
          (d = c - 1),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d - b.slideCount)
              .prependTo(b.$slideTrack)
              .addClass("slick-cloned");
        for (c = 0; e > c; c += 1)
          (d = c),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d + b.slideCount)
              .appendTo(b.$slideTrack)
              .addClass("slick-cloned");
        b.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            a(this).attr("id", "");
          });
      }
    }),
    (b.prototype.interrupt = function (a) {
      var b = this;
      a || b.autoPlay(), (b.interrupted = a);
    }),
    (b.prototype.selectHandler = function (b) {
      var c = this,
        d = a(b.target).is(".slick-slide")
          ? a(b.target)
          : a(b.target).parents(".slick-slide"),
        e = parseInt(d.attr("data-slick-index"));
      return (
        e || (e = 0),
        c.slideCount <= c.options.slidesToShow
          ? (c.setSlideClasses(e), void c.asNavFor(e))
          : void c.slideHandler(e)
      );
    }),
    (b.prototype.slideHandler = function (a, b, c) {
      var d,
        e,
        f,
        g,
        j,
        h = null,
        i = this;
      return (
        (b = b || !1),
        (i.animating === !0 && i.options.waitForAnimate === !0) ||
        (i.options.fade === !0 && i.currentSlide === a) ||
        i.slideCount <= i.options.slidesToShow
          ? void 0
          : (b === !1 && i.asNavFor(a),
            (d = a),
            (h = i.getLeft(d)),
            (g = i.getLeft(i.currentSlide)),
            (i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft),
            i.options.infinite === !1 &&
            i.options.centerMode === !1 &&
            (0 > a || a > i.getDotCount() * i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : i.options.infinite === !1 &&
                i.options.centerMode === !0 &&
                (0 > a || a > i.slideCount - i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : (i.options.autoplay && clearInterval(i.autoPlayTimer),
                (e =
                  0 > d
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? i.slideCount - (i.slideCount % i.options.slidesToScroll)
                      : i.slideCount + d
                    : d >= i.slideCount
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? 0
                      : d - i.slideCount
                    : d),
                (i.animating = !0),
                i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
                (f = i.currentSlide),
                (i.currentSlide = e),
                i.setSlideClasses(i.currentSlide),
                i.options.asNavFor &&
                  ((j = i.getNavTarget()),
                  (j = j.slick("getSlick")),
                  j.slideCount <= j.options.slidesToShow &&
                    j.setSlideClasses(i.currentSlide)),
                i.updateDots(),
                i.updateArrows(),
                i.options.fade === !0
                  ? (c !== !0
                      ? (i.fadeSlideOut(f),
                        i.fadeSlide(e, function () {
                          i.postSlide(e);
                        }))
                      : i.postSlide(e),
                    void i.animateHeight())
                  : void (c !== !0
                      ? i.animateSlide(h, function () {
                          i.postSlide(e);
                        })
                      : i.postSlide(e))))
      );
    }),
    (b.prototype.startLoad = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.hide(), a.$nextArrow.hide()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.hide(),
        a.$slider.addClass("slick-loading");
    }),
    (b.prototype.swipeDirection = function () {
      var a,
        b,
        c,
        d,
        e = this;
      return (
        (a = e.touchObject.startX - e.touchObject.curX),
        (b = e.touchObject.startY - e.touchObject.curY),
        (c = Math.atan2(b, a)),
        (d = Math.round((180 * c) / Math.PI)),
        0 > d && (d = 360 - Math.abs(d)),
        45 >= d && d >= 0
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : 360 >= d && d >= 315
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : d >= 135 && 225 >= d
          ? e.options.rtl === !1
            ? "right"
            : "left"
          : e.options.verticalSwiping === !0
          ? d >= 35 && 135 >= d
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (b.prototype.swipeEnd = function (a) {
      var c,
        d,
        b = this;
      if (
        ((b.dragging = !1),
        (b.interrupted = !1),
        (b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0),
        void 0 === b.touchObject.curX)
      )
        return !1;
      if (
        (b.touchObject.edgeHit === !0 &&
          b.$slider.trigger("edge", [b, b.swipeDirection()]),
        b.touchObject.swipeLength >= b.touchObject.minSwipe)
      ) {
        switch ((d = b.swipeDirection())) {
          case "left":
          case "down":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide + b.getSlideCount())
              : b.currentSlide + b.getSlideCount()),
              (b.currentDirection = 0);
            break;
          case "right":
          case "up":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide - b.getSlideCount())
              : b.currentSlide - b.getSlideCount()),
              (b.currentDirection = 1);
        }
        "vertical" != d &&
          (b.slideHandler(c),
          (b.touchObject = {}),
          b.$slider.trigger("swipe", [b, d]));
      } else
        b.touchObject.startX !== b.touchObject.curX &&
          (b.slideHandler(b.currentSlide), (b.touchObject = {}));
    }),
    (b.prototype.swipeHandler = function (a) {
      var b = this;
      if (
        !(
          b.options.swipe === !1 ||
          ("ontouchend" in document && b.options.swipe === !1) ||
          (b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))
        )
      )
        switch (
          ((b.touchObject.fingerCount =
            a.originalEvent && void 0 !== a.originalEvent.touches
              ? a.originalEvent.touches.length
              : 1),
          (b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold),
          b.options.verticalSwiping === !0 &&
            (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
          a.data.action)
        ) {
          case "start":
            b.swipeStart(a);
            break;
          case "move":
            b.swipeMove(a);
            break;
          case "end":
            b.swipeEnd(a);
        }
    }),
    (b.prototype.swipeMove = function (a) {
      var d,
        e,
        f,
        g,
        h,
        b = this;
      return (
        (h = void 0 !== a.originalEvent ? a.originalEvent.touches : null),
        !b.dragging || (h && 1 !== h.length)
          ? !1
          : ((d = b.getLeft(b.currentSlide)),
            (b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX),
            (b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY),
            (b.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))
            )),
            b.options.verticalSwiping === !0 &&
              (b.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(b.touchObject.curY - b.touchObject.startY, 2)
                )
              )),
            (e = b.swipeDirection()),
            "vertical" !== e
              ? (void 0 !== a.originalEvent &&
                  b.touchObject.swipeLength > 4 &&
                  a.preventDefault(),
                (g =
                  (b.options.rtl === !1 ? 1 : -1) *
                  (b.touchObject.curX > b.touchObject.startX ? 1 : -1)),
                b.options.verticalSwiping === !0 &&
                  (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1),
                (f = b.touchObject.swipeLength),
                (b.touchObject.edgeHit = !1),
                b.options.infinite === !1 &&
                  ((0 === b.currentSlide && "right" === e) ||
                    (b.currentSlide >= b.getDotCount() && "left" === e)) &&
                  ((f = b.touchObject.swipeLength * b.options.edgeFriction),
                  (b.touchObject.edgeHit = !0)),
                b.options.vertical === !1
                  ? (b.swipeLeft = d + f * g)
                  : (b.swipeLeft =
                      d + f * (b.$list.height() / b.listWidth) * g),
                b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g),
                b.options.fade === !0 || b.options.touchMove === !1
                  ? !1
                  : b.animating === !0
                  ? ((b.swipeLeft = null), !1)
                  : void b.setCSS(b.swipeLeft))
              : void 0)
      );
    }),
    (b.prototype.swipeStart = function (a) {
      var c,
        b = this;
      return (
        (b.interrupted = !0),
        1 !== b.touchObject.fingerCount ||
        b.slideCount <= b.options.slidesToShow
          ? ((b.touchObject = {}), !1)
          : (void 0 !== a.originalEvent &&
              void 0 !== a.originalEvent.touches &&
              (c = a.originalEvent.touches[0]),
            (b.touchObject.startX = b.touchObject.curX =
              void 0 !== c ? c.pageX : a.clientX),
            (b.touchObject.startY = b.touchObject.curY =
              void 0 !== c ? c.pageY : a.clientY),
            void (b.dragging = !0))
      );
    }),
    (b.prototype.unfilterSlides = b.prototype.slickUnfilter =
      function () {
        var a = this;
        null !== a.$slidesCache &&
          (a.unload(),
          a.$slideTrack.children(this.options.slide).detach(),
          a.$slidesCache.appendTo(a.$slideTrack),
          a.reinit());
      }),
    (b.prototype.unload = function () {
      var b = this;
      a(".slick-cloned", b.$slider).remove(),
        b.$dots && b.$dots.remove(),
        b.$prevArrow &&
          b.htmlExpr.test(b.options.prevArrow) &&
          b.$prevArrow.remove(),
        b.$nextArrow &&
          b.htmlExpr.test(b.options.nextArrow) &&
          b.$nextArrow.remove(),
        b.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (b.prototype.unslick = function (a) {
      var b = this;
      b.$slider.trigger("unslick", [b, a]), b.destroy();
    }),
    (b.prototype.updateArrows = function () {
      var b,
        a = this;
      (b = Math.floor(a.options.slidesToShow / 2)),
        a.options.arrows === !0 &&
          a.slideCount > a.options.slidesToShow &&
          !a.options.infinite &&
          (a.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          a.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === a.currentSlide
            ? (a.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - a.options.slidesToShow &&
              a.options.centerMode === !1
            ? (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - 1 &&
              a.options.centerMode === !0 &&
              (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (b.prototype.updateDots = function () {
      var a = this;
      null !== a.$dots &&
        (a.$dots
          .find("li")
          .removeClass("slick-active")
          .attr("aria-hidden", "true"),
        a.$dots
          .find("li")
          .eq(Math.floor(a.currentSlide / a.options.slidesToScroll))
          .addClass("slick-active")
          .attr("aria-hidden", "false"));
    }),
    (b.prototype.visibility = function () {
      var a = this;
      a.options.autoplay &&
        (document[a.hidden] ? (a.interrupted = !0) : (a.interrupted = !1));
    }),
    (a.fn.slick = function () {
      var f,
        g,
        a = this,
        c = arguments[0],
        d = Array.prototype.slice.call(arguments, 1),
        e = a.length;
      for (f = 0; e > f; f++)
        if (
          ("object" == typeof c || "undefined" == typeof c
            ? (a[f].slick = new b(a[f], c))
            : (g = a[f].slick[c].apply(a[f].slick, d)),
          "undefined" != typeof g)
        )
          return g;
      return a;
    });
});

/*-Read more-*/
!(function (e) {
  "function" == typeof define && define.amd
    ? define(["jquery"], e)
    : "object" == typeof exports
    ? (module.exports = e(require("jquery")))
    : e(jQuery);
})(function (e) {
  "use strict";
  var t = "readmore",
    i = {
      speed: 100,
      collapsedHeight: 200,
      heightMargin: 16,
      moreLink: '<a href="#">Read More</a>',
      lessLink: '<a href="#">Close</a>',
      embedCSS: !0,
      blockCSS: "display: block; width: 100%;",
      startOpen: !1,
      blockProcessed: function () {},
      beforeToggle: function () {},
      afterToggle: function () {},
    },
    o = {},
    a = 0;
  function n(e) {
    var t = e
        .clone()
        .css({
          height: "auto",
          width: e.width(),
          maxHeight: "none",
          overflow: "hidden",
        })
        .insertAfter(e),
      i = t.outerHeight(),
      o = parseInt(
        t
          .css({ maxHeight: "" })
          .css("max-height")
          .replace(/[^-\d\.]/g, ""),
        10
      ),
      a = e.data("defaultHeight");
    t.remove();
    var n = o || e.data("collapsedHeight") || a;
    e.data({ expandedHeight: i, maxHeight: o, collapsedHeight: n }).css({
      maxHeight: "none",
    });
  }
  var s,
    r,
    d,
    h,
    l =
      ((s = function () {
        e("[data-readmore]").each(function () {
          var t = e(this),
            i = "true" === t.attr("aria-expanded");
          n(t),
            t.css({ height: t.data(i ? "expandedHeight" : "collapsedHeight") });
        });
      }),
      (r = 100),
      function () {
        var e = this,
          t = arguments,
          i = d && !h;
        clearTimeout(h),
          (h = setTimeout(function () {
            (h = null), d || s.apply(e, t);
          }, r)),
          i && s.apply(e, t);
      });
  function c(a, n) {
    (this.element = a),
      (this.options = e.extend({}, i, n)),
      (function (e) {
        if (!o[e.selector]) {
          var t = " ";
          e.embedCSS &&
            "" !== e.blockCSS &&
            (t +=
              e.selector +
              " + [data-readmore-toggle], " +
              e.selector +
              "[data-readmore]{" +
              e.blockCSS +
              "}"),
            (t +=
              e.selector +
              "[data-readmore]{transition: height " +
              e.speed +
              "ms;overflow: hidden;}"),
            (i = document),
            (a = t),
            ((n = i.createElement("style")).type = "text/css"),
            n.styleSheet
              ? (n.styleSheet.cssText = a)
              : n.appendChild(i.createTextNode(a)),
            i.getElementsByTagName("head")[0].appendChild(n),
            (o[e.selector] = !0);
        }
        var i, a, n;
      })(this.options),
      (this._defaults = i),
      (this._name = t),
      this.init(),
      window.addEventListener
        ? (window.addEventListener("load", l),
          window.addEventListener("resize", l))
        : (window.attachEvent("load", l), window.attachEvent("resize", l));
  }
  (c.prototype = {
    init: function () {
      var t = e(this.element);
      t.data({
        defaultHeight: this.options.collapsedHeight,
        heightMargin: this.options.heightMargin,
      }),
        n(t);
      var i = t.data("collapsedHeight"),
        o = t.data("heightMargin");
      if (t.outerHeight(!0) <= i + o)
        return (
          this.options.blockProcessed &&
            "function" == typeof this.options.blockProcessed &&
            this.options.blockProcessed(t, !1),
          !0
        );
      var s,
        r =
          t.attr("id") ||
          (function (e) {
            var t = ++a;
            return String(null == e ? "rmjs-" : e) + t;
          })(),
        d = this.options.startOpen
          ? this.options.lessLink
          : this.options.moreLink;
      t.attr({
        "data-readmore": "",
        "aria-expanded": this.options.startOpen,
        id: r,
      }),
        t.after(
          e(d)
            .on(
              "click",
              ((s = this),
              function (e) {
                s.toggle(this, t[0], e);
              })
            )
            .attr({ "data-readmore-toggle": r, "aria-controls": r })
        ),
        this.options.startOpen || t.css({ height: i }),
        this.options.blockProcessed &&
          "function" == typeof this.options.blockProcessed &&
          this.options.blockProcessed(t, !0);
    },
    toggle: function (t, i, o) {
      o && o.preventDefault(),
        t || (t = e('[aria-controls="' + this.element.id + '"]')[0]),
        i || (i = this.element);
      var a,
        n = e(i),
        s = "",
        r = "",
        d = !1,
        h = n.data("collapsedHeight");
      n.height() <= h
        ? ((s = n.data("expandedHeight") + "px"), (r = "lessLink"), (d = !0))
        : ((s = h), (r = "moreLink")),
        this.options.beforeToggle &&
          "function" == typeof this.options.beforeToggle &&
          this.options.beforeToggle(t, n, !d),
        n.css({ height: s }),
        n.on(
          "transitionend",
          ((a = this),
          function () {
            a.options.afterToggle &&
              "function" == typeof a.options.afterToggle &&
              a.options.afterToggle(t, n, d),
              e(this).attr({ "aria-expanded": d }).off("transitionend");
          })
        ),
        e(t).replaceWith(
          e(this.options[r])
            .on(
              "click",
              (function (e) {
                return function (t) {
                  e.toggle(this, i, t);
                };
              })(this)
            )
            .attr({
              "data-readmore-toggle": n.attr("id"),
              "aria-controls": n.attr("id"),
            })
        );
    },
    destroy: function () {
      e(this.element).each(function () {
        var t = e(this);
        t
          .attr({ "data-readmore": null, "aria-expanded": null })
          .css({ maxHeight: "", height: "" })
          .next("[data-readmore-toggle]")
          .remove(),
          t.removeData();
      });
    },
  }),
    (e.fn.readmore = function (i) {
      var o = arguments,
        a = this.selector;
      return "object" == typeof (i = i || {})
        ? this.each(function () {
            if (e.data(this, "plugin_" + t)) {
              var o = e.data(this, "plugin_" + t);
              o.destroy.apply(o);
            }
            (i.selector = a), e.data(this, "plugin_" + t, new c(this, i));
          })
        : "string" == typeof i && "_" !== i[0] && "init" !== i
        ? this.each(function () {
            var a = e.data(this, "plugin_" + t);
            a instanceof c &&
              "function" == typeof a[i] &&
              a[i].apply(a, Array.prototype.slice.call(o, 1));
          })
        : void 0;
    });
});

$(document).ready(function () {
  $(".product_meta_short_description_new").readmore({
    speed: 500,
    collapsedHeight: 70,
    heightMargin: 16,
    moreLink: '<a href="javascript:void(0)" class="more_new">+ More</a>',
    lessLink: '<a href="javascript:void(0)" class="more_new">- Less</a>',
  });
});

$('a[href="#specification"]').on("click", function () {
  var target = $(this.hash);
  target = target.length ? target : $("[name=" + this.hash.substr(1) + "]");
  if (target.length) {
    $("html,body").animate(
      {
        scrollTop: target.offset().top - 150,
      },
      1000
    );
    return false;
  }
});

$(".open_variant_new").click(function () {
  $(".product_meta_tag_collection_products_new").addClass("open");
  $("body").addClass("openVariant");
  setTimeout(function () {
    $(".product_meta_tag_collection_products_new").fadeIn();
  }, 500);
});

$(document).mouseup(function (e) {
  var container = $(
    ".product_meta_tag_collection_products_new, .product_left_icon_new"
  );

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".product_meta_tag_collection_products_new").fadeIn();
    setTimeout(function () {
      $(".product_meta_tag_collection_products_new").removeClass("open");
      $("body").removeClass("openVariant");
    }, 500);
  }
});

$(".view_more_info_new").click(function () {
  $(".view_more_details_new").slideToggle();
  $(".view_more_text_new").toggleClass("hidden");
  $(".view_less_text_new").toggleClass("hidden");
  $(".view_more_info_new").toggleClass("open");
});

$(".collection_info_links_new li").hover(function () {
  var ID = this.id;
  setTimeout(function () {
    $(".megamenu_right_collection_Info_new").css("display", "none");
    $("." + ID + "_display").css("display", "block");
  }, 200);
});

$(".custom_mega_menu_top_new").hover(
  function () {},
  function () {
    setTimeout(function () {
      $(".megamenu_right_collection_Info_new").css("display", "none");
      $(".first_element_in_loop_new").css("display", "block");
    }, 200);
  }
);

$(".collection_filter_new").click(function () {
  $(".c-filters").addClass("active");
});
$(".close_filter_new").click(function () {
  $(".c-filters").removeClass("active");
});

$(".c-filter-btn").click(function () {
  var width = $(window).width();
  if (width < 769) {
    $(this).next(".c-filter-list").slideToggle();
  }
});

$(".c-filter-item, .all_filter_new").click(function () {
  var width = $(window).width();
  if (width < 769) {
    $(".c-filters").removeClass("active");
  }
});

// collections script start

$(document).ready(function () {
  let collectionFilter = [];

  $("[data-c-filter-item]").click(function () {
    $("[data-selected-filter-clear]").css({ display: "inline-block" });
    const props = $(this).data("c-filter-item");
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      $(`[data-props="${props}"]`).remove();
      const index = collectionFilter.indexOf(props);
      if (index > -1) {
        collectionFilter.splice(index, 1);
      }
    } else {
      $(this).addClass("selected");
      $("[data-selected-filter-items]").prepend(`
          <span class="c-filter-selected-item btn" data-props="${props}" data-selected-filter-item>
			<span data-selected-filter-remove-btn>
              ${$(this).text()}
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.03177 6.50013L12.6823 1.84948C13.1059 1.42591 13.1059 0.741255 12.6823 0.317681C12.2588 -0.105894 11.5741 -0.105894 11.1506 0.317681L6.5 4.96833L1.84944 0.317681C1.42588 -0.105894 0.74124 -0.105894 0.317674 0.317681C-0.105891 0.741255 -0.105891 1.42591 0.317674 1.84948L4.96823 6.50013L0.317674 11.1508C-0.105891 11.5744 -0.105891 12.259 0.317674 12.6826C0.528915 12.8938 0.806237 13 1.08356 13C1.36088 13 1.6382 12.8938 1.84944 12.6826L6.5 8.03194L11.1506 12.6826C11.3618 12.8938 11.6391 13 11.9164 13C12.1938 13 12.4711 12.8938 12.6823 12.6826C13.1059 12.259 13.1059 11.5744 12.6823 11.1508L8.03177 6.50013Z" fill="black"/></svg>
			</span>
          </span>   
        `);
      collectionFilter.push(props);
    }

    $("[data-collection-row] .collection_list_grid").css({ display: "none" });

    $("[data-collection-row] .list_collections_template_sections_main_new").css(
      { display: "none" }
    );

    collectionFilter.forEach((item) => {
      $(`[data-collection-row] .${item}`).css({ display: "flex" });
    });

    console.log("22", { collectionFilter });

    if (!$("[data-selected-filter-item]").length) {
      $("[data-collection-row] .collection_list_grid").css({ display: "flex" });
    }

    removeSelectedFilterItem();
  });

  $("[data-selected-filter-clear]").click(function () {
    collectionFilter = [];
    $("[data-selected-filter-item]").remove();
    $(".selected[data-c-filter-item]").removeClass("selected");
    $("[data-collection-row] .collection_list_grid").css({ display: "flex" });
    $("[data-collection-row] .list_collections_template_sections_main_new").css(
      { display: "block" }
    );
    $(this).css({ display: "none" });
  });

  function removeSelectedFilterItem() {
    $("[data-selected-filter-remove-btn]").click(function () {
      $(`[data-c-filter-item="${$(this).parent().data("props")}"]`).removeClass(
        "selected"
      );
      $(this).parent().remove();

      const index = collectionFilter.indexOf($(this).parent().data("props"));
      if (index > -1) {
        collectionFilter.splice(index, 1);
      }

      $("[data-collection-row] .collection_list_grid").css({ display: "none" });
      $(
        "[data-collection-row] .list_collections_template_sections_main_new"
      ).css({ display: "none" });

      collectionFilter.forEach((item) => {
        $(`[data-collection-row] .${item}`).css({ display: "flex" });
        $(
          "[data-collection-row] .list_collections_template_sections_main_new"
        ).css({ display: "block" });
      });

      if (!$("[data-selected-filter-item]").length) {
        $("[data-collection-row] .collection_list_grid").css({
          display: "flex",
        });
        $(
          "[data-collection-row] .list_collections_template_sections_main_new"
        ).css({ display: "block" });
      }

      if (!collectionFilter.length) {
        $("[data-selected-filter-clear]").css({ display: "none" });
      }

      console.log("33", { collectionFilter });
    });
  }
});

// collections script end

/* jQuery elevateZoom 2.1.0 - Demo's and documentation: - www.elevateweb.co.uk/image-zoom - Copyright (c) 2012 Andrew Eades - www.elevateweb.co.uk - Dual licensed under the LGPL licenses. - http://en.wikipedia.org/wiki/MIT_License - http://en.wikipedia.org/wiki/GNU_General_Public_License */
"function" !== typeof Object.create &&
  (Object.create = function (b) {
    function e() {}
    e.prototype = b;
    return new e();
  });
(function (b) {
  var e = {
    init: function (a, d) {
      var c = this;
      c.elem = d;
      c.$elem = b(d);
      c.imageSrc = c.$elem.data("zoom-image")
        ? c.$elem.data("zoom-image")
        : c.$elem.attr("src");
      c.options = b.extend({}, b.fn.elevateZoom.options, a);
      c.options.tint &&
        ((c.options.lensColour = "none"), (c.options.lensOpacity = "1"));
      "inner" == c.options.zoomType && (c.options.showLens = !1);
      c.$elem.parent().removeAttr("title").removeAttr("alt");
      c.zoomImage = c.imageSrc;
      c.refresh(1);
      b("#" + c.options.gallery + " a").click(function (a) {
        a.preventDefault();
        c.zoomImagePre = b(this).data("zoom-image")
          ? b(this).data("zoom-image")
          : b(this).data("image");
        c.swaptheimage(b(this).data("image"), c.zoomImagePre);
        return !1;
      });
    },
    refresh: function (a) {
      var d = this;
      setTimeout(function () {
        d.fetch(d.imageSrc);
      }, a || d.options.refresh);
    },
    fetch: function (a) {
      var d = this,
        c = new Image();
      c.onload = function () {
        d.largeWidth = c.width;
        d.largeHeight = c.height;
        d.startZoom();
        d.currentImage = d.imageSrc;
      };
      c.src = a;
    },
    startZoom: function () {
      var a = this;
      a.nzWidth = a.$elem.width();
      a.nzHeight = a.$elem.height();
      a.nzOffset = a.$elem.offset();
      a.widthRatio = a.largeWidth / a.nzWidth;
      a.heightRatio = a.largeHeight / a.nzHeight;
      "window" == a.options.zoomType &&
        (a.zoomWindowStyle =
          "overflow: hidden;background-position: 0px 0px;background-color:white;text-align:center;width: " +
          String(a.options.zoomWindowWidth) +
          "px;height: " +
          String(a.options.zoomWindowHeight) +
          "px;float: left;display: none;z-index:100px;border: " +
          String(a.options.borderSize) +
          "px solid " +
          a.options.borderColour +
          ";background-repeat: no-repeat;position: absolute;");
      "inner" == a.options.zoomType &&
        (a.zoomWindowStyle =
          "overflow: hidden;background-position: 0px 0px;width: " +
          String(a.nzWidth) +
          "px;height: " +
          String(a.nzHeight) +
          "px;float: left;display: none;cursor:" +
          a.options.cursor +
          ";px solid " +
          a.options.borderColour +
          ";background-repeat: no-repeat;position: absolute;");
      "window" == a.options.zoomType &&
        ((lensHeight =
          a.nzHeight < a.options.zoomWindowWidth / a.widthRatio
            ? a.nzHeight
            : String(a.options.zoomWindowHeight / a.heightRatio)),
        (lensWidth =
          a.largeWidth < a.options.zoomWindowWidth
            ? a.nzHWidth
            : a.options.zoomWindowWidth / a.widthRatio),
        (a.lensStyle =
          "background-position: 0px 0px;width: " +
          String(a.options.zoomWindowWidth / a.widthRatio) +
          "px;height: " +
          String(a.options.zoomWindowHeight / a.heightRatio) +
          "px;float: right;display: none;overflow: hidden;z-index: 999;opacity:" +
          a.options.lensOpacity +
          ";filter: alpha(opacity = " +
          100 * a.options.lensOpacity +
          "); zoom:1;width:" +
          lensWidth +
          "px;height:" +
          lensHeight +
          "px;background-color:" +
          a.options.lensColour +
          ";cursor:" +
          a.options.cursor +
          ";border: " +
          a.options.lensBorder +
          "px solid black;background-repeat: no-repeat;position: absolute;"));
      a.tintStyle =
        "display: block;position: absolute;background-color: " +
        a.options.tintColour +
        ";opacity: 0;width: " +
        a.nzWidth +
        "px;height: " +
        a.nzHeight +
        "px;";
      a.lensRound = "";
      "lens" == a.options.zoomType &&
        (a.lensStyle =
          "background-position: 0px 0px;float: left;display: none;border: " +
          String(a.options.borderSize) +
          "px solid " +
          a.options.borderColour +
          ";width:" +
          String(a.options.lensSize) +
          "px;height:" +
          String(a.options.lensSize) +
          "px;background-repeat: no-repeat;position: absolute;");
      "round" == a.options.lensShape &&
        (a.lensRound =
          "border-top-left-radius: " +
          String(a.options.lensSize / 2 + a.options.borderSize) +
          "px;border-top-right-radius: " +
          String(a.options.lensSize / 2 + a.options.borderSize) +
          "px;border-bottom-left-radius: " +
          String(a.options.lensSize / 2 + a.options.borderSize) +
          "px;border-bottom-right-radius: " +
          String(a.options.lensSize / 2 + a.options.borderSize) +
          "px;");
      a.zoomContainer = b(
        '<div class="zoomContainer" style="position:absolute;left:' +
          a.nzOffset.left +
          "px;top:" +
          a.nzOffset.top +
          "px;height:" +
          a.nzHeight +
          "px;width:" +
          a.nzWidth +
          'px;"></div>'
      ).appendTo(a.$elem);
      a.$elem.after(a.zoomContainer);
      a.options.containLensZoom &&
        "lens" == a.options.zoomType &&
        a.zoomContainer.css("overflow", "hidden");
      "inner" != a.options.zoomType &&
        (a.zoomLens = b(
          "<div class='zoomLens' style='" +
            a.lensStyle +
            a.lensRound +
            "'>&nbsp;</div>"
        )
          .appendTo(a.zoomContainer)
          .click(function () {
            a.$elem.trigger("click");
          }));
      a.options.tint &&
        ((a.tintContainer = b("<div/>").addClass("tintContainer")),
        (a.zoomTint = b(
          "<div class='zoomTint' style='" + a.tintStyle + "'></div>"
        )),
        a.zoomLens.wrap(a.tintContainer),
        (a.zoomTintcss = a.zoomLens.after(a.zoomTint)),
        (a.zoomTintImage = b(
          '<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' +
            a.nzWidth +
            "px; height: " +
            a.nzHeight +
            'px;" src="' +
            a.imageSrc +
            '">'
        )
          .appendTo(a.zoomLens)
          .click(function () {
            a.$elem.trigger("click");
          })));
      a.zoomWindow = isNaN(a.options.zoomWindowPosition)
        ? b(
            "<div style='z-index:999;left:" +
              a.windowOffsetLeft +
              "px;top:" +
              a.windowOffsetTop +
              "px;" +
              a.zoomWindowStyle +
              "' class='zoomWindow'>&nbsp;</div>"
          )
            .appendTo("body")
            .click(function () {
              a.$elem.trigger("click");
            })
        : b(
            "<div style='z-index:999;left:" +
              a.windowOffsetLeft +
              "px;top:" +
              a.windowOffsetTop +
              "px;" +
              a.zoomWindowStyle +
              "' class='zoomWindow'>&nbsp;</div>"
          )
            .appendTo(a.zoomContainer)
            .click(function () {
              a.$elem.trigger("click");
            });
      a.zoomWindowContainer = b("<div/>")
        .addClass("zoomWindowContainer")
        .css("width", a.options.zoomWindowWidth);
      a.zoomWindow.wrap(a.zoomWindowContainer);
      "lens" == a.options.zoomType &&
        a.zoomLens.css({ backgroundImage: "url('" + a.imageSrc + "')" });
      "window" == a.options.zoomType &&
        a.zoomWindow.css({ backgroundImage: "url('" + a.imageSrc + "')" });
      "inner" == a.options.zoomType &&
        a.zoomWindow.css({ backgroundImage: "url('" + a.imageSrc + "')" });
      a.$elem.bind("mousemove", function (d) {
        a.setPosition(d);
      });
      a.zoomContainer.bind("mousemove", function (d) {
        a.setPosition(d);
      });
      "inner" != a.options.zoomType &&
        a.zoomLens.bind("mousemove", function (d) {
          a.setPosition(d);
        });
      a.options.tint &&
        a.zoomTint.bind("mousemove", function (d) {
          a.setPosition(d);
        });
      "inner" == a.options.zoomType &&
        a.zoomWindow.bind("mousemove", function (d) {
          a.setPosition(d);
        });
      a.zoomContainer
        .mouseenter(function () {
          "inner" == a.options.zoomType &&
            (a.options.zoomWindowFadeIn
              ? a.zoomWindow.stop(!0, !0).fadeIn(a.options.zoomWindowFadeIn)
              : a.zoomWindow.show());
          "window" == a.options.zoomType &&
            (a.options.zoomWindowFadeIn
              ? a.zoomWindow.stop(!0, !0).fadeIn(a.options.zoomWindowFadeIn)
              : a.zoomWindow.show());
          a.options.showLens &&
            (a.options.lensFadeIn
              ? a.zoomLens.stop(!0, !0).fadeIn(a.options.lensFadeIn)
              : a.zoomLens.show());
          a.options.tint &&
            (a.options.zoomTintFadeIn
              ? a.zoomTint.stop(!0, !0).fadeIn(a.options.zoomTintFadeIn)
              : a.zoomTint.show());
        })
        .mouseleave(function () {
          a.zoomWindow.hide();
          a.options.showLens && a.zoomLens.hide();
          a.options.tint && a.zoomTint.hide();
        });
      a.$elem
        .mouseenter(function () {
          "inner" == a.options.zoomType &&
            (a.options.zoomWindowFadeIn
              ? a.zoomWindow.stop(!0, !0).fadeIn(a.options.zoomWindowFadeIn)
              : a.zoomWindow.show());
          "window" == a.options.zoomType &&
            (a.options.zoomWindowFadeIn
              ? a.zoomWindow.stop(!0, !0).fadeIn(a.options.zoomWindowFadeIn)
              : a.zoomWindow.show());
          a.options.showLens &&
            (a.options.lensFadeIn
              ? a.zoomLens.stop(!0, !0).fadeIn(a.options.lensFadeIn)
              : a.zoomLens.show());
          a.options.tint &&
            (a.options.zoomTintFadeIn
              ? a.zoomTint.stop(!0, !0).fadeIn(a.options.zoomTintFadeIn)
              : a.zoomTint.show());
        })
        .mouseleave(function () {
          a.zoomWindow.hide();
          a.options.showLens && a.zoomLens.hide();
          a.options.tint && a.zoomTint.hide();
        });
      "inner" != a.options.zoomType &&
        a.zoomLens
          .mouseenter(function () {
            "inner" == a.options.zoomType &&
              (a.options.zoomWindowFadeIn
                ? a.zoomWindow.stop(!0, !0).fadeIn(a.options.zoomWindowFadeIn)
                : a.zoomWindow.show());
            "window" == a.options.zoomType && a.zoomWindow.show();
            a.options.showLens && a.zoomLens.show();
            a.options.tint && a.zoomTint.show();
          })
          .mouseleave(function () {
            a.options.zoomWindowFadeOut
              ? a.zoomWindow.stop(!0, !0).fadeOut(a.options.zoomWindowFadeOut)
              : a.zoomWindow.hide();
            "inner" != a.options.zoomType && a.zoomLens.hide();
            a.options.tint && a.zoomTint.hide();
          });
      a.options.tint &&
        a.zoomTint
          .mouseenter(function () {
            "inner" == a.options.zoomType && a.zoomWindow.show();
            "window" == a.options.zoomType && a.zoomWindow.show();
            a.options.showLens && a.zoomLens.show();
            a.zoomTint.show();
          })
          .mouseleave(function () {
            a.zoomWindow.hide();
            "inner" != a.options.zoomType && a.zoomLens.hide();
            a.zoomTint.hide();
          });
      "inner" == a.options.zoomType &&
        a.zoomWindow
          .mouseenter(function () {
            "inner" == a.options.zoomType && a.zoomWindow.show();
            "window" == a.options.zoomType && a.zoomWindow.show();
            a.options.showLens && a.zoomLens.show();
          })
          .mouseleave(function () {
            a.options.zoomWindowFadeOut
              ? a.zoomWindow.stop(!0, !0).fadeOut(a.options.zoomWindowFadeOut)
              : a.zoomWindow.hide();
            "inner" != a.options.zoomType && a.zoomLens.hide();
          });
    },
    setPosition: function (a) {
      this.nzHeight = this.$elem.height();
      this.nzWidth = this.$elem.width();
      this.nzOffset = this.$elem.offset();
      this.options.tint &&
        (this.zoomTint.css({ top: 0 }), this.zoomTint.css({ left: 0 }));
      this.zoomContainer.css({ top: this.nzOffset.top });
      this.zoomContainer.css({ left: this.nzOffset.left });
      this.mouseLeft = parseInt(a.pageX - this.nzOffset.left);
      this.mouseTop = parseInt(a.pageY - this.nzOffset.top);
      "window" == this.options.zoomType &&
        ((this.Etoppos = this.mouseTop < this.zoomLens.height() / 2),
        (this.Eboppos =
          this.mouseTop >
          this.nzHeight -
            this.zoomLens.height() / 2 -
            2 * this.options.lensBorder),
        (this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2),
        (this.Eroppos =
          this.mouseLeft >
          this.nzWidth -
            this.zoomLens.width() / 2 -
            2 * this.options.lensBorder));
      "inner" == this.options.zoomType &&
        ((this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio),
        (this.Eboppos =
          this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio),
        (this.Eloppos =
          this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio),
        (this.Eroppos =
          this.mouseLeft >
          this.nzWidth -
            this.nzWidth / 2 / this.widthRatio -
            2 * this.options.lensBorder));
      0 > this.mouseLeft ||
      0 >= this.mouseTop ||
      this.mouseLeft > this.nzWidth ||
      this.mouseTop > this.nzHeight
        ? (this.zoomWindow.hide(),
          this.options.showLens && this.zoomLens.hide(),
          this.options.tint && this.zoomTint.hide())
        : ("window" == this.options.zoomType && this.zoomWindow.show(),
          this.options.tint && this.zoomTint.show(),
          this.options.showLens &&
            (this.zoomLens.show(),
            (this.lensLeftPos = String(
              this.mouseLeft - this.zoomLens.width() / 2
            )),
            (this.lensTopPos = String(
              this.mouseTop - this.zoomLens.height() / 2
            ))),
          this.Etoppos && (this.lensTopPos = 0),
          this.Eloppos &&
            (this.tintpos = this.lensLeftPos = this.windowLeftPos = 0),
          "window" == this.options.zoomType &&
            (this.Eboppos &&
              (this.lensTopPos = Math.max(
                this.nzHeight -
                  this.zoomLens.height() -
                  2 * this.options.lensBorder,
                0
              )),
            this.Eroppos &&
              (this.lensLeftPos =
                this.nzWidth -
                this.zoomLens.width() -
                2 * this.options.lensBorder)),
          "inner" == this.options.zoomType &&
            (this.Eboppos &&
              (this.lensTopPos = Math.max(
                this.nzHeight - 2 * this.options.lensBorder,
                0
              )),
            this.Eroppos &&
              (this.lensLeftPos =
                this.nzWidth - this.nzWidth - 2 * this.options.lensBorder)),
          "lens" == this.options.zoomType &&
            ((this.windowLeftPos = String(
              -1 *
                ((a.pageX - this.nzOffset.left) * this.widthRatio -
                  this.zoomLens.width() / 2)
            )),
            (this.windowTopPos = String(
              -1 *
                ((a.pageY - this.nzOffset.top) * this.heightRatio -
                  this.zoomLens.height() / 2)
            )),
            this.zoomLens.css({
              backgroundPosition:
                this.windowLeftPos + "px " + this.windowTopPos + "px",
            }),
            this.setWindowPostition(a)),
          this.options.tint && this.setTintPosition(a),
          "window" == this.options.zoomType && this.setWindowPostition(a),
          "inner" == this.options.zoomType && this.setWindowPostition(a),
          this.options.showLens &&
            this.zoomLens.css({
              left: this.lensLeftPos + "px",
              top: this.lensTopPos + "px",
            }));
    },
    setLensPostition: function () {},
    setWindowPostition: function (a) {
      if (isNaN(this.options.zoomWindowPosition))
        (this.externalContainer = b("#" + this.options.zoomWindowPosition)),
          (this.externalContainerWidth = this.externalContainer.width()),
          (this.externalContainerHeight = this.externalContainer.height()),
          (this.externalContainerOffset = this.externalContainer.offset()),
          (this.windowOffsetTop = this.externalContainerOffset.top),
          (this.windowOffsetLeft = this.externalContainerOffset.left);
      else
        switch (this.options.zoomWindowPosition) {
          case 1:
            this.windowOffsetTop = this.options.zoomWindowOffety;
            this.windowOffsetLeft = +this.nzWidth;
            break;
          case 2:
            this.options.zoomWindowHeight > this.nzHeight &&
              ((this.windowOffsetTop =
                -1 * (this.options.zoomWindowHeight / 2 - this.nzHeight / 2)),
              (this.windowOffsetLeft = this.nzWidth));
            break;
          case 3:
            this.windowOffsetTop =
              this.nzHeight -
              this.zoomWindow.height() -
              2 * this.options.borderSize;
            this.windowOffsetLeft = this.nzWidth;
            break;
          case 4:
            this.windowOffsetTop = this.nzHeight;
            this.windowOffsetLeft = this.nzWidth;
            break;
          case 5:
            this.windowOffsetTop = this.nzHeight;
            this.windowOffsetLeft =
              this.nzWidth -
              this.zoomWindow.width() -
              2 * this.options.borderSize;
            break;
          case 6:
            this.options.zoomWindowHeight > this.nzHeight &&
              ((this.windowOffsetTop = this.nzHeight),
              (this.windowOffsetLeft =
                -1 *
                (this.options.zoomWindowWidth / 2 -
                  this.nzWidth / 2 +
                  2 * this.options.borderSize)));
            break;
          case 7:
            this.windowOffsetTop = this.nzHeight;
            this.windowOffsetLeft = 0;
            break;
          case 8:
            this.windowOffsetTop = this.nzHeight;
            this.windowOffsetLeft =
              -1 * (this.zoomWindow.width() + 2 * this.options.borderSize);
            break;
          case 9:
            this.windowOffsetTop =
              this.nzHeight -
              this.zoomWindow.height() -
              2 * this.options.borderSize;
            this.windowOffsetLeft =
              -1 * (this.zoomWindow.width() + 2 * this.options.borderSize);
            break;
          case 10:
            this.options.zoomWindowHeight > this.nzHeight &&
              ((this.windowOffsetTop =
                -1 * (this.options.zoomWindowHeight / 2 - this.nzHeight / 2)),
              (this.windowOffsetLeft =
                -1 * (this.zoomWindow.width() + 2 * this.options.borderSize)));
            break;
          case 11:
            this.windowOffsetTop = this.options.zoomWindowOffety;
            this.windowOffsetLeft =
              -1 * (this.zoomWindow.width() + 2 * this.options.borderSize);
            break;
          case 12:
            this.windowOffsetTop =
              -1 * (this.zoomWindow.height() + 2 * this.options.borderSize);
            this.windowOffsetLeft =
              -1 * (this.zoomWindow.width() + 2 * this.options.borderSize);
            break;
          case 13:
            this.windowOffsetTop =
              -1 * (this.zoomWindow.height() + 2 * this.options.borderSize);
            this.windowOffsetLeft = 0;
            break;
          case 14:
            this.options.zoomWindowHeight > this.nzHeight &&
              ((this.windowOffsetTop =
                -1 * (this.zoomWindow.height() + 2 * this.options.borderSize)),
              (this.windowOffsetLeft =
                -1 *
                (this.options.zoomWindowWidth / 2 -
                  this.nzWidth / 2 +
                  2 * this.options.borderSize)));
            break;
          case 15:
            this.windowOffsetTop =
              -1 * (this.zoomWindow.height() + 2 * this.options.borderSize);
            this.windowOffsetLeft =
              this.nzWidth -
              this.zoomWindow.width() -
              2 * this.options.borderSize;
            break;
          case 16:
            this.windowOffsetTop =
              -1 * (this.zoomWindow.height() + 2 * this.options.borderSize);
            this.windowOffsetLeft = this.nzWidth;
            break;
          default:
            (this.windowOffsetTop = this.options.zoomWindowOffety),
              (this.windowOffsetLeft = this.nzWidth);
        }
      this.windowOffsetTop += this.options.zoomWindowOffety;
      this.windowOffsetLeft += this.options.zoomWindowOffetx;
      this.zoomWindow.css({ top: this.windowOffsetTop });
      this.zoomWindow.css({ left: this.windowOffsetLeft });
      "inner" == this.options.zoomType &&
        (this.zoomWindow.css({ top: 0 }), this.zoomWindow.css({ left: 0 }));
      this.windowLeftPos = String(
        -1 *
          ((a.pageX - this.nzOffset.left) * this.widthRatio -
            this.zoomWindow.width() / 2)
      );
      this.windowTopPos = String(
        -1 *
          ((a.pageY - this.nzOffset.top) * this.heightRatio -
            this.zoomWindow.height() / 2)
      );
      this.Etoppos && (this.windowTopPos = 0);
      this.Eloppos && (this.windowLeftPos = 0);
      this.Eboppos &&
        (this.windowTopPos =
          -1 * (this.largeHeight - this.zoomWindow.height()));
      this.Eroppos &&
        (this.windowLeftPos = -1 * (this.largeWidth - this.zoomWindow.width()));
      "window" == this.options.zoomType &&
        (1 >= this.widthRatio && (this.windowLeftPos = 0),
        1 >= this.heightRatio && (this.windowTopPos = 0),
        this.largeHeight < this.options.zoomWindowHeight &&
          (this.windowTopPos = 0),
        this.largeWidth < this.options.zoomWindowWidth &&
          (this.windowLeftPos = 0),
        this.options.easing
          ? ((b.easing.zoomsmoothmove = function (a, c, b, e, f) {
              return c == f ? b + e : e * (-Math.pow(2, (-10 * c) / f) + 1) + b;
            }),
            this.zoomWindow.animate(
              {
                "background-position-x": this.windowLeftPos,
                "background-position-y": this.windowTopPos,
              },
              {
                queue: !1,
                duration: this.options.easingDuration,
                easing: "zoomsmoothmove",
              }
            ))
          : this.zoomWindow.css({
              backgroundPosition:
                this.windowLeftPos + "px " + this.windowTopPos + "px",
            }));
      "inner" == this.options.zoomType &&
        this.zoomWindow.css({
          backgroundPosition:
            this.windowLeftPos + "px " + this.windowTopPos + "px",
        });
    },
    setTintPosition: function (a) {
      this.nzOffset = this.$elem.offset();
      this.tintpos = String(
        -1 * (a.pageX - this.nzOffset.left - this.zoomLens.width() / 2)
      );
      this.tintposy = String(
        -1 * (a.pageY - this.nzOffset.top - this.zoomLens.height() / 2)
      );
      this.Etoppos && (this.tintposy = 0);
      this.Eloppos && (this.tintpos = 0);
      this.Eboppos &&
        (this.tintposy =
          -1 *
          (this.nzHeight -
            this.zoomLens.height() -
            2 * this.options.lensBorder));
      this.Eroppos &&
        (this.tintpos =
          -1 *
          (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorder));
      this.options.tint &&
        (this.zoomTint
          .css({ opacity: this.options.tintOpacity })
          .animate()
          .fadeIn("slow"),
        this.zoomTintImage.css({
          left: this.tintpos - this.options.lensBorder + "px",
        }),
        this.zoomTintImage.css({
          top: this.tintposy - this.options.lensBorder + "px",
        }));
    },
    swaptheimage: function (a, d) {
      var c = this,
        b = new Image();
      b.onload = function () {
        c.largeWidth = b.width;
        c.largeHeight = b.height;
        c.zoomImage = d;
        c.swapAction(a, d);
      };
      b.src = d;
    },
    swapAction: function (a, b) {
      var c = this,
        e = new Image();
      e.onload = function () {
        c.nzHeight = e.height;
        c.nzWidth = e.width;
        c.doneCallback();
      };
      e.src = a;
      c.zoomWindow.css({ backgroundImage: "url('" + b + "')" });
      c.currentImage = b;
      c.$elem.attr("src", a);
    },
    doneCallback: function () {
      this.options.tint &&
        (this.zoomTintImage.attr("src", largeimage),
        this.zoomTintImage.attr("height", this.$elem.height()),
        this.zoomTintImage.css({ height: this.$elem.height() }),
        this.zoomTint.css({ height: this.$elem.height() }));
      this.nzOffset = this.$elem.offset();
      this.nzWidth = this.$elem.width();
      this.nzHeight = this.$elem.height();
      this.widthRatio = this.largeWidth / this.nzWidth;
      this.heightRatio = this.largeHeight / this.nzHeight;
      lensHeight =
        this.nzHeight < this.options.zoomWindowWidth / this.widthRatio
          ? this.nzHeight
          : String(this.options.zoomWindowHeight / this.heightRatio);
      lensWidth =
        this.largeWidth < this.options.zoomWindowWidth
          ? this.nzHWidth
          : this.options.zoomWindowWidth / this.widthRatio;
      this.zoomLens.css("width", lensWidth);
      this.zoomLens.css("height", lensHeight);
    },
    getCurrentImage: function () {
      return this.zoomImage;
    },
    getGalleryList: function () {
      var a = this;
      a.gallerylist = [];
      a.options.gallery
        ? b("#" + a.options.gallery + " a").each(function () {
            var d = "";
            b(this).data("zoom-image")
              ? (d = b(this).data("zoom-image"))
              : b(this).data("image") && (d = b(this).data("image"));
            d == a.zoomImage
              ? a.gallerylist.unshift({
                  href: "" + d + "",
                  title: b(this).find("img").attr("title"),
                })
              : a.gallerylist.push({
                  href: "" + d + "",
                  title: b(this).find("img").attr("title"),
                });
          })
        : a.gallerylist.push({
            href: "" + a.zoomImage + "",
            title: b(this).find("img").attr("title"),
          });
      return a.gallerylist;
    },
  };
  b.fn.elevateZoom = function (a) {
    return this.each(function () {
      var d = Object.create(e);
      d.init(a, this);
      b.data(this, "elevateZoom", d);
    });
  };
  b.fn.elevateZoom.options = {
    easing: !1,
    easingType: "zoomdefault",
    easingDuration: 2e3,
    lensSize: 200,
    zoomWindowWidth: 400,
    zoomWindowHeight: 400,
    zoomWindowOffetx: 0,
    zoomWindowOffety: 0,
    zoomWindowPosition: 1,
    lensFadeIn: !1,
    lensFadeOut: !1,
    debug: !1,
    zoomWindowFadeIn: !1,
    zoomWindowFadeOut: !1,
    zoomWindowAlwaysShow: !1,
    zoomTintFadeIn: !1,
    zoomTintFadeOut: !1,
    borderSize: 4,
    showLens: !0,
    borderColour: "#888",
    lensBorder: 1,
    lensShape: "square",
    zoomType: "window",
    containLensZoom: !1,
    lensColour: "white",
    lensOpacity: 0.4,
    lenszoom: !1,
    tint: !1,
    tintColour: "#333",
    tintOpacity: 0.4,
    gallery: !1,
    cursor: "default",
    onComplete: b.noop,
  };
})(jQuery, window, document);

$(".zoom-in").elevateZoom({
  zoomType: "inner",
  cursor: "crosshair",
  zoomWindowFadeIn: 500,
  zoomWindowFadeOut: 750,
});

/* nanogallery2 - v3.0.2 - 2020-07-21 */
!(function (e) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], e)
    : "object" == typeof exports && "function" == typeof require
    ? e(require("jquery"))
    : e(jQuery);
})(function (e) {
  "use strict";
  function t(e) {
    var t = document.getElementById("ngyColorHelperToRGB");
    return (
      null === t &&
        (((t = document.createElement("div")).id = "ngyColorHelperToRGB"),
        (t.style.cssText = "display: none; color:" + e + ";"),
        document.body.appendChild(t)),
      getComputedStyle(t).color
    );
  }
  function n(e, t, n) {
    var i = "";
    if (
      ("RGBA(" == t.toUpperCase().substring(0, 5) &&
        ((i = "a"), (t = "rgb(" + t.substring(5))),
      "number" != typeof e ||
        e < -1 ||
        e > 1 ||
        "string" != typeof t ||
        ("r" != t[0] && "#" != t[0]) ||
        ("string" != typeof n && void 0 !== n))
    )
      return null;
    function a(e) {
      var t = e.length,
        n = new Object();
      if (t > 9) {
        if ((e = e.split(",")).length < 3 || e.length > 4) return null;
        (n[0] = o(e[0].slice(4))),
          (n[1] = o(e[1])),
          (n[2] = o(e[2])),
          (n[3] = e[3] ? parseFloat(e[3]) : -1);
      } else {
        if (8 == t || 6 == t || t < 4) return null;
        t < 6 &&
          (e =
            "#" +
            e[1] +
            e[1] +
            e[2] +
            e[2] +
            e[3] +
            e[3] +
            (t > 4 ? e[4] + "" + e[4] : "")),
          (e = o(e.slice(1), 16)),
          (n[0] = (e >> 16) & 255),
          (n[1] = (e >> 8) & 255),
          (n[2] = 255 & e),
          (n[3] =
            9 == t || 5 == t ? r((((e >> 24) & 255) / 255) * 1e4) / 1e4 : -1);
      }
      return n;
    }
    var o = parseInt,
      r = Math.round,
      l = t.length > 9,
      s =
        ((l = "string" == typeof n ? n.length > 9 || ("c" == n && !l) : l),
        e < 0),
      u =
        ((e = s ? -1 * e : e),
        (n = n && "c" != n ? n : s ? "#000000" : "#FFFFFF"),
        a(t)),
      c = a(n);
    return u && c
      ? l
        ? "rgb" +
          i +
          "(" +
          r((c[0] - u[0]) * e + u[0]) +
          "," +
          r((c[1] - u[1]) * e + u[1]) +
          "," +
          r((c[2] - u[2]) * e + u[2]) +
          (u[3] < 0 && c[3] < 0
            ? ")"
            : "," +
              (u[3] > -1 && c[3] > -1
                ? r(1e4 * ((c[3] - u[3]) * e + u[3])) / 1e4
                : c[3] < 0
                ? u[3]
                : c[3]) +
              ")")
        : "#" +
          (
            4294967296 +
            16777216 *
              (u[3] > -1 && c[3] > -1
                ? r(255 * ((c[3] - u[3]) * e + u[3]))
                : c[3] > -1
                ? r(255 * c[3])
                : u[3] > -1
                ? r(255 * u[3])
                : 255) +
            65536 * r((c[0] - u[0]) * e + u[0]) +
            256 * r((c[1] - u[1]) * e + u[1]) +
            r((c[2] - u[2]) * e + u[2])
          )
            .toString(16)
            .slice(u[3] > -1 || c[3] > -1 ? 1 : 3)
      : null;
  }
  function i(e) {
    if (null === e || "object" != typeof e) return e;
    var t = e.constructor();
    for (var n in e) t[n] = i(e[n]);
    return t;
  }
  function a() {
    var e = jQuery(window);
    return { l: e.scrollLeft(), t: e.scrollTop(), w: e.width(), h: e.height() };
  }
  function o(e, t) {
    var n = 0;
    "" == e && (e = "*"),
      jQuery(e).each(function () {
        var e = parseInt(jQuery(this).css("z-index"));
        n = e > n ? e : n;
      }),
      n++,
      jQuery(t).css("z-index", n);
  }
  var r = function (e) {
    return {}.toString
      .call(e)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  };
  function l() {
    (this.LightboxReOpen = function () {
      m();
    }),
      (this.ReloadAlbum = function () {
        if ("" === u.O.kind)
          throw "Not supported for this content source:" + u.O.kind;
        var e = u.GOM.albumIdx;
        if (-1 == e) throw "Current album not found.";
        for (var t = u.I[e].GetID(), n = u.I.length, i = 0; i < n; i++) {
          var a = u.I[i];
          a.albumID == t && (a.selected = !1);
        }
        (u.I[e].contentIsLoaded = !1), g("-1", t);
      }),
      (this.ItemsSetSelectedValue = function (e, t) {
        for (var n = e.length, i = 0; i < n; i++) pe(e[i], t);
      }),
      (this.ItemsSelectedGet = function () {
        for (var e = [], t = u.I.length, n = 0; n < t; n++)
          1 == u.I[n].selected && e.push(u.I[n]);
        return e;
      }),
      (this.Get = function (e) {
        return u.O[e];
      }),
      (this.Set = function (e, t) {
        switch (((u.O[e] = t), e)) {
          case "thumbnailSelectable":
            de(), w(u.GOM.albumIdx);
        }
      }),
      (this.Refresh = function () {
        w(u.GOM.albumIdx);
      }),
      (this.Resize = function () {
        x();
      }),
      (this.DisplayItem = function (e) {
        var t = p(e);
        "0" != t.imageID ? Q(t.imageID, t.albumID) : g("-1", t.albumID);
      }),
      (this.ThumbnailToolbarOneCartUpdate = function (e) {
        R(e);
      });
    var l = function (e) {
      if (null == u.I[e]) return 0;
      for (var t = u.I[e].GetID(), n = u.I.length, i = 0, a = 0; a < n; a++) {
        u.I[a].isToDisplay(t) && i++;
      }
      return i;
    };
    (this.Search = function (e) {
      u.GOM.albumSearch = e.toUpperCase();
      var t = u.GOM.albumIdx;
      return w(u.GOM.albumIdx), l(t);
    }),
      (this.Search2 = function (e, t) {
        return (
          (u.GOM.albumSearch =
            null != e && null != e ? e.toUpperCase().trim() : ""),
          (u.GOM.albumSearchTags =
            null != t && null != t ? t.toUpperCase().trim() : ""),
          l(u.GOM.albumIdx)
        );
      }),
      (this.Search2Execute = function () {
        var e = u.GOM.albumIdx;
        return w(u.GOM.albumIdx), l(e);
      }),
      (this.Destroy = function () {
        null != u.GOM.hammertime &&
          (u.GOM.hammertime.destroy(), (u.GOM.hammertime = null)),
          null != u.VOM.hammertime &&
            (u.VOM.hammertime.destroy(), (u.VOM.hammertime = null)),
          e("#ngycs_" + u.baseEltID).remove(),
          (u.GOM.items = []),
          NGY2Item.New(
            u,
            u.i18nTranslations.breadcrumbHome,
            "",
            "0",
            "-1",
            "album"
          ),
          (u.GOM.navigationBar.$newContent = null),
          u.$E.base.empty(),
          u.$E.base.removeData(),
          u.O.locationHash &&
            jQuery(window).off("hashchange.nanogallery2." + u.baseEltID),
          jQuery(window).off("resize.nanogallery2." + u.baseEltID),
          jQuery(window).off("orientationChange.nanogallery2." + u.baseEltID),
          jQuery(window).off("scroll.nanogallery2." + u.baseEltID),
          null !== u.$E.scrollableParent &&
            u.$E.scrollableParent.off("scroll.nanogallery2." + u.baseEltID),
          (u.GOM.firstDisplay = !0);
      }),
      (this.CloseViewer = function () {
        return tt(null), !1;
      }),
      (this.MinimizeToolbar = function () {
        return We(), !1;
      }),
      (this.MaximizeToolbar = function () {
        return Ue(), !1;
      }),
      (this.PaginationPreviousPage = function () {
        return G(), !1;
      }),
      (this.PaginationNextPage = function () {
        return y(), !1;
      }),
      (this.PaginationGotoPage = function (e) {
        return (
          e > 1 && e--,
          (u.GOM.pagination.currentPage = e),
          u.GOM.ScrollToTop(),
          L(),
          E(!0),
          !1
        );
      }),
      (this.PaginationCountPages = function () {
        return 0 == u.GOM.items.length
          ? 0
          : Math.ceil(
              (u.GOM.items[u.GOM.items.length - 1].row + 1) /
                u.galleryMaxRows.Get()
            );
      });
    var s = function (e, t, n) {
      var i;
      return function () {
        var a = this,
          o = arguments;
        function r() {
          n || e.apply(a, o), (i = null);
        }
        i ? clearTimeout(i) : n && e.apply(a, o), (i = setTimeout(r, t || 100));
      };
    };
    (window.ng_draf = function (e) {
      return requestAnimationFrame(function () {
        window.requestAnimationFrame(e);
      });
    }),
      (window.requestTimeout = function (e, t) {
        if (
          !(
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            (window.mozRequestAnimationFrame &&
              window.mozCancelRequestAnimationFrame) ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame
          )
        )
          return window.setTimeout(e, t);
        var n = new Date().getTime(),
          i = new Object();
        return (
          (i.value = requestAnimFrame(function a() {
            new Date().getTime() - n >= t
              ? e.call()
              : (i.value = requestAnimFrame(a));
          })),
          i
        );
      }),
      (window.requestAnimFrame =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (e, t) {
          window.setTimeout(e, 1e3 / 60);
        }),
      (window.clearRequestTimeout = function (e) {
        window.cancelAnimationFrame
          ? window.cancelAnimationFrame(e.value)
          : window.webkitCancelAnimationFrame
          ? window.webkitCancelAnimationFrame(e.value)
          : window.webkitCancelRequestAnimationFrame
          ? window.webkitCancelRequestAnimationFrame(e.value)
          : window.mozCancelRequestAnimationFrame
          ? window.mozCancelRequestAnimationFrame(e.value)
          : window.oCancelRequestAnimationFrame
          ? window.oCancelRequestAnimationFrame(e.value)
          : window.msCancelRequestAnimationFrame
          ? window.msCancelRequestAnimationFrame(e.value)
          : clearTimeout(e);
      });
    var u = this;
    function c(e) {
      (this.$e = null),
        (this.ngy2ItemIdx = e),
        (this.mediaNumber = u.VOM.items.length + 1),
        (this.posX = 0),
        (this.posY = 0);
    }
    (u.I = []),
      (u.Id = []),
      (u.O = null),
      (u.baseEltID = null),
      (u.$E = {
        base: null,
        conTnParent: null,
        conLoadingB: null,
        conConsole: null,
        conNavigationBar: null,
        conTnBottom: null,
        scrollableParent: null,
      }),
      (u.shoppingCart = []),
      (u.layout = {
        internal: !0,
        engine: "",
        support: { rows: !1 },
        prerequisite: { imageSize: !1 },
        SetEngine: function () {
          if (u.layout.internal) {
            if (
              "auto" ==
                u.tn.settings.width[u.GOM.curNavLevel][u.GOM.curWidth] ||
              "" == u.tn.settings.width[u.GOM.curNavLevel][u.GOM.curWidth]
            )
              return (
                (u.layout.engine = "JUSTIFIED"),
                (u.layout.support.rows = !0),
                void (u.layout.prerequisite.imageSize = !0)
              );
            if (
              "auto" ==
                u.tn.settings.height[u.GOM.curNavLevel][u.GOM.curWidth] ||
              "" == u.tn.settings.height[u.GOM.curNavLevel][u.GOM.curWidth]
            )
              return (
                (u.layout.engine = "CASCADING"),
                (u.layout.support.rows = !1),
                void (u.layout.prerequisite.imageSize = !0)
              );
            if (null != u.tn.settings.getMosaic())
              return (
                (u.layout.engine = "MOSAIC"),
                (u.layout.support.rows = !0),
                void (u.layout.prerequisite.imageSize = !1)
              );
            (u.layout.engine = "GRID"),
              (u.layout.support.rows = !0),
              (u.layout.prerequisite.imageSize = !1);
          }
        },
      }),
      (u.galleryResizeEventEnabled = !1),
      (u.galleryMaxRows = {
        l1: 0,
        lN: 0,
        Get: function () {
          return u.galleryMaxRows[u.GOM.curNavLevel];
        },
      }),
      (u.galleryMaxItems = {
        l1: 0,
        lN: 0,
        Get: function () {
          return u.galleryMaxItems[u.GOM.curNavLevel];
        },
      }),
      (u.galleryFilterTags = {
        l1: 0,
        lN: 0,
        Get: function () {
          return u.galleryFilterTags[u.GOM.curNavLevel];
        },
      }),
      (u.galleryFilterTagsMode = {
        l1: 0,
        lN: 0,
        Get: function () {
          return u.galleryFilterTagsMode[u.GOM.curNavLevel];
        },
      }),
      (u.galleryDisplayMode = {
        l1: "FULLCONTENT",
        lN: "FULLCONTENT",
        Get: function () {
          return u.galleryDisplayMode[u.GOM.curNavLevel];
        },
      }),
      (u.galleryLastRowFull = {
        l1: !1,
        lN: !1,
        Get: function () {
          return u.galleryLastRowFull[u.GOM.curNavLevel];
        },
      }),
      (u.gallerySorting = {
        l1: "",
        lN: "",
        Get: function () {
          return u.gallerySorting[u.GOM.curNavLevel];
        },
      }),
      (u.galleryDisplayTransition = {
        l1: "none",
        lN: "none",
        Get: function () {
          return u.galleryDisplayTransition[u.GOM.curNavLevel];
        },
      }),
      (u.galleryDisplayTransitionDuration = {
        l1: 500,
        lN: 500,
        Get: function () {
          return u.galleryDisplayTransitionDuration[u.GOM.curNavLevel];
        },
      }),
      (u.$currentTouchedThumbnail = null),
      (u.tn = {
        opt: {
          l1: {
            crop: !0,
            stacks: 0,
            stacksTranslateX: 0,
            stacksTranslateY: 0,
            stacksTranslateZ: 0,
            stacksRotateX: 0,
            stacksRotateY: 0,
            stacksRotateZ: 0,
            stacksScale: 0,
            borderHorizontal: 0,
            borderVertical: 0,
            baseGridHeight: 0,
            displayTransition: "FADEIN",
            displayTransitionStartVal: 0,
            displayTransitionEasing: "easeOutQuart",
            displayTransitionDuration: 240,
            displayInterval: 15,
          },
          lN: {
            crop: !0,
            stacks: 0,
            stacksTranslateX: 0,
            stacksTranslateY: 0,
            stacksTranslateZ: 0,
            stacksRotateX: 0,
            stacksRotateY: 0,
            stacksRotateZ: 0,
            stacksScale: 0,
            borderHorizontal: 0,
            borderVertical: 0,
            baseGridHeight: 0,
            displayTransition: "FADEIN",
            displayTransitionStartVal: 0,
            displayTransitionEasing: "easeOutQuart",
            displayTransitionDuration: 240,
            displayInterval: 15,
          },
          Get: function (e) {
            return u.tn.opt[u.GOM.curNavLevel][e];
          },
        },
        scale: 1,
        labelHeight: {
          l1: 0,
          lN: 0,
          get: function () {
            return u.tn.labelHeight[u.GOM.curNavLevel];
          },
        },
        defaultSize: {
          width: {
            l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
            lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
          },
          height: {
            l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
            lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
          },
          getWidth: function () {
            return u.tn.defaultSize.width[u.GOM.curNavLevel][u.GOM.curWidth];
          },
          getOuterWidth: function () {
            (u.tn.borderWidth = u.tn.opt.Get("borderHorizontal")),
              (u.tn.borderHeight = u.tn.opt.Get("borderVertical"));
            var e =
              u.tn.defaultSize.width[u.GOM.curNavLevel][u.GOM.curWidth] +
              2 * u.tn.opt.Get("borderHorizontal");
            return (
              ("right" != u.O.thumbnailLabel.get("position") &&
                "left" != u.O.thumbnailLabel.get("position")) ||
                (e +=
                  u.tn.defaultSize.width[u.GOM.curNavLevel][u.GOM.curWidth]),
              e
            );
          },
          getHeight: function () {
            return u.tn.defaultSize.height[u.GOM.curNavLevel][u.GOM.curWidth];
          },
          getOuterHeight: function () {
            return (
              u.tn.defaultSize.height[u.GOM.curNavLevel][u.GOM.curWidth] +
              2 * u.tn.opt.Get("borderVertical")
            );
          },
        },
        settings: {
          width: {
            l1: {
              xs: 0,
              sm: 0,
              me: 0,
              la: 0,
              xl: 0,
              xsc: "u",
              smc: "u",
              mec: "u",
              lac: "u",
              xlc: "u",
            },
            lN: {
              xs: 0,
              sm: 0,
              me: 0,
              la: 0,
              xl: 0,
              xsc: "u",
              smc: "u",
              mec: "u",
              lac: "u",
              xlc: "u",
            },
          },
          height: {
            l1: {
              xs: 0,
              sm: 0,
              me: 0,
              la: 0,
              xl: 0,
              xsc: "u",
              smc: "u",
              mec: "u",
              lac: "u",
              xlc: "u",
            },
            lN: {
              xs: 0,
              sm: 0,
              me: 0,
              la: 0,
              xl: 0,
              xsc: "u",
              smc: "u",
              mec: "u",
              lac: "u",
              xlc: "u",
            },
          },
          getH: function (e, t) {
            var n = null == e ? u.GOM.curNavLevel : e,
              i = null == t ? u.GOM.curWidth : t;
            return "MOSAIC" == u.layout.engine
              ? this.height[n][i] * this.mosaic[n + "Factor"].h[i]
              : this.height[n][i];
          },
          getW: function (e, t) {
            var n = null == e ? u.GOM.curNavLevel : e,
              i = null == t ? u.GOM.curWidth : t;
            return "MOSAIC" == u.layout.engine
              ? this.width[n][i] * this.mosaic[n + "Factor"].w[i]
              : this.width[n][i];
          },
          mosaic: {
            l1: { xs: null, sm: null, me: null, la: null, xl: null },
            lN: { xs: null, sm: null, me: null, la: null, xl: null },
            l1Factor: {
              h: { xs: 1, sm: 1, me: 1, la: 1, xl: 1 },
              w: { xs: 1, sm: 1, me: 1, la: 1, xl: 1 },
            },
            lNFactor: {
              h: { xs: 1, sm: 1, me: 1, la: 1, xl: 1 },
              w: { xs: 1, sm: 1, me: 1, la: 1, xl: 1 },
            },
          },
          getMosaic: function () {
            return this.mosaic[u.GOM.curNavLevel][u.GOM.curWidth];
          },
          mosaicCalcFactor: function (e, t) {
            for (
              var n = 1, i = 1, a = 0;
              a < u.tn.settings.mosaic[e][t].length;
              a++
            )
              (n = Math.max(n, this.mosaic[e][t][a].w)),
                (i = Math.max(i, this.mosaic[e][t][a].h));
            (this.mosaic[e + "Factor"].h[t] = i),
              (this.mosaic[e + "Factor"].w[t] = n);
          },
          gutterHeight: {
            l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
            lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
          },
          gutterWidth: {
            l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
            lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
          },
          GetResponsive: function (e) {
            return this[e][u.GOM.curNavLevel][u.GOM.curWidth];
          },
        },
        hoverEffects: {
          std: [],
          level1: [],
          get: function () {
            return "l1" == u.GOM.curNavLevel && 0 !== this.level1.length
              ? this.level1
              : this.std;
          },
        },
        buildInit: {
          std: [],
          level1: [],
          get: function () {
            return "l1" == u.GOM.curNavLevel && 0 !== this.level1.length
              ? this.level1
              : this.std;
          },
        },
        toolbar: {
          album: { topLeft: "", topRight: "", bottomLeft: "", bottomRight: "" },
          image: { topLeft: "", topRight: "", bottomLeft: "", bottomRight: "" },
          albumUp: {
            topLeft: "",
            topRight: "",
            bottomLeft: "",
            bottomRight: "",
          },
          get: function (e) {
            return this[e.kind];
          },
        },
        style: {
          l1: { label: "", title: "", desc: "" },
          lN: { label: "", title: "", desc: "" },
          getTitle: function () {
            return 'style="' + this[u.GOM.curNavLevel].title + '"';
          },
          getDesc: function () {
            return 'style="' + this[u.GOM.curNavLevel].desc + '"';
          },
          getLabel: function () {
            var e = 'style="' + this[u.GOM.curNavLevel].label;
            return (e += u.O.RTL ? '"direction:RTL;"' : ""), (e += '"');
          },
        },
      }),
      (u.scrollTimeOut = 0),
      (u.i18nTranslations = {
        paginationPrevious: "Previous",
        paginationNext: "Next",
        breadcrumbHome: "List of Albums",
        thumbnailImageTitle: "",
        thumbnailAlbumTitle: "",
        thumbnailImageDescription: "",
        thumbnailAlbumDescription: "",
      }),
      (u.emptyGif =
        "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw=="),
      (u.CSStransformName = dt([
        "transform",
        "msTransform",
        "MozTransform",
        "WebkitTransform",
        "OTransform",
      ])),
      (u.CSStransformStyle = dt([
        "transformStyle",
        "msTransformStyle",
        "MozTransformStyle",
        "WebkitTransformStyle",
        "OTransformStyle",
      ])),
      (u.CSSperspective = dt([
        "perspective",
        "msPerspective",
        "MozPerspective",
        "WebkitPerspective",
        "OPerspective",
      ])),
      (u.CSSbackfaceVisibilityName = dt([
        "backfaceVisibility",
        "msBackfaceVisibility",
        "MozBackfaceVisibility",
        "WebkitBackfaceVisibility",
        "OBackfaceVisibility",
      ])),
      (u.CSStransitionName = dt([
        "transition",
        "msTransition",
        "MozTransition",
        "WebkitTransition",
        "OTransition",
      ])),
      (u.CSSanimationName = dt([
        "animation",
        "msAnimation",
        "MozAnimation",
        "WebkitAnimation",
        "OAnimation",
      ])),
      (u.GalleryResizeThrottled = (function (e, t, n) {
        var i,
          a,
          o,
          r = null,
          l = 0;
        n || (n = {});
        var s = function () {
          (l = !1 === n.leading ? 0 : new Date().getTime()),
            (r = null),
            (o = e.apply(i, a)),
            r || (i = a = null);
        };
        return function () {
          var u = new Date().getTime();
          l || !1 !== n.leading || (l = u);
          var c = t - (u - l);
          return (
            (i = this),
            (a = arguments),
            c <= 0 || c > t
              ? (r && (clearTimeout(r), (r = null)),
                (l = u),
                (o = e.apply(i, a)),
                r || (i = a = null))
              : r || !1 === n.trailing || (r = setTimeout(s, c)),
            o
          );
        };
      })(x, 15, { leading: !1 })),
      (u.blockList = null),
      (u.allowList = null),
      (u.albumList = []),
      (u.locationHashLastUsed = ""),
      (u.custGlobals = {}),
      (u.touchAutoOpenDelayTimerID = 0),
      (u.i18nLang = ""),
      (u.timeLastTouchStart = 0),
      (u.custGlobals = {}),
      (u.markupOrApiProcessed = !1),
      (u.GOM = {
        albumIdx: -1,
        clipArea: { top: 0, height: 0 },
        displayArea: { width: 0, height: 0 },
        displayAreaLast: { width: 0, height: 0 },
        displayedMoreSteps: 0,
        items: [],
        $imgPreloader: [],
        thumbnails2Display: [],
        itemsDisplayed: 0,
        firstDisplay: !0,
        firstDisplayTime: 0,
        navigationBar: { displayed: !1, $newContent: "" },
        cache: { viewport: null, containerOffset: null, areaWidth: 100 },
        nbSelected: 0,
        pagination: { currentPage: 0 },
        panThreshold: 60,
        panYOnly: !1,
        lastFullRow: -1,
        lastDisplayedIdx: -1,
        displayInterval: { from: 0, len: 0 },
        hammertime: null,
        curNavLevel: "l1",
        curWidth: "me",
        albumSearch: "",
        albumSearchTags: "",
        lastZIndex: 0,
        lastRandomValue: 0,
        slider: {
          hostIdx: -1,
          hostItem: null,
          currentIdx: 0,
          nextIdx: 0,
          timerID: 0,
          tween: null,
        },
        NGY2Item: function (e) {
          if (null == u.GOM.items[e] || null == u.GOM.items[e]) return null;
          var t = u.GOM.items[e].thumbnailIdx;
          return u.I[t];
        },
        GTn: function (e, t, n) {
          (this.thumbnailIdx = e),
            (this.width = 0),
            (this.height = 0),
            (this.top = 0),
            (this.left = 0),
            (this.row = 0),
            (this.imageWidth = t),
            (this.imageHeight = n),
            (this.resizedContentWidth = 0),
            (this.resizedContentHeight = 0),
            (this.displayed = !1),
            (this.neverDisplayed = !0),
            (this.inDisplayArea = !1);
        },
        ScrollToTop: function () {
          var e, t, n, i;
          if (
            !u.GOM.firstDisplay &&
            (null !== u.$E.scrollableParent ||
              ((e = u.$E.base),
              (t = 20),
              (n = a()),
              (i = e.offset()).top >= n.t && i.top <= n.t + n.h - t) ||
              u.$E.base.get(0).scrollIntoView(),
            null !== u.$E.scrollableParent)
          ) {
            var o = u.$E.scrollableParent.scrollTop(),
              r = Math.abs(
                u.$E.scrollableParent.offset().top - u.$E.base.offset().top - o
              );
            o > r &&
              window.ng_draf(function () {
                u.$E.scrollableParent.scrollTop(r);
              });
          }
        },
      }),
      (u.VOM = {
        viewerDisplayed: !1,
        viewerIsFullscreen: !1,
        infoDisplayed: !1,
        toolbarsDisplayed: !0,
        toolsHide: null,
        zoom: { posX: 0, posY: 0, userFactor: 1, isZooming: !1 },
        padding: { H: 0, V: 0 },
        window: { lastWidth: 0, lastHeight: 0 },
        $viewer: null,
        $toolbar: null,
        $toolbarTL: null,
        $toolbarTR: null,
        toolbarMode: "std",
        playSlideshow: !1,
        playSlideshowTimerID: 0,
        slideshowDelay: 3e3,
        albumID: -1,
        viewerMediaIsChanged: !1,
        items: [],
        panMode: "off",
        $baseCont: null,
        $content: null,
        content: {
          previous: {
            vIdx: -1,
            $media: null,
            NGY2Item: function () {
              return u.I[u.VOM.items[u.VOM.content.previous.vIdx].ngy2ItemIdx];
            },
          },
          current: {
            vIdx: -1,
            $media: null,
            NGY2Item: function () {
              return u.I[u.VOM.items[u.VOM.content.current.vIdx].ngy2ItemIdx];
            },
          },
          next: {
            vIdx: -1,
            $media: null,
            NGY2Item: function () {
              return u.I[u.VOM.items[u.VOM.content.next.vIdx].ngy2ItemIdx];
            },
          },
        },
        IdxNext: function () {
          var e = 0;
          return (
            u.VOM.content.current.vIdx < u.VOM.items.length - 1 &&
              (e = u.VOM.content.current.vIdx + 1),
            e
          );
        },
        IdxPrevious: function () {
          var e = u.VOM.content.current.vIdx - 1;
          return (
            0 == u.VOM.content.current.vIdx && (e = u.VOM.items.length - 1), e
          );
        },
        gallery: {
          $elt: null,
          $tmbCont: null,
          gwidth: 0,
          vwidth: 0,
          oneTmbWidth: 0,
          firstDisplay: !0,
          posX: 0,
          SetThumbnailActive() {
            "none" != u.O.viewerGallery &&
              (this.$tmbCont.children().removeClass("activeVThumbnail"),
              this.$tmbCont
                .children()
                .eq(u.VOM.content.current.vIdx)
                .addClass("activeVThumbnail"),
              (this.firstDisplay = !1));
          },
          Resize: function () {
            if ("none" != u.O.viewerGallery)
              if (this.firstDisplay)
                new NGTweenable().tween({
                  from: { opacity: 0 },
                  to: { opacity: 1 },
                  easing: "easeInOutSine",
                  duration: 1e3,
                  step: function (e) {},
                  finish: function (e) {},
                });
              else {
                var e = u.VOM.$viewer.width(),
                  t = Math.trunc(e / this.oneTmbWidth);
                if (
                  ((this.vwidth = t * this.oneTmbWidth),
                  this.$elt.css({
                    width: this.vwidth,
                    left: (e - this.vwidth) / 2,
                  }),
                  u.VOM.items.length >= t)
                ) {
                  var n = this.oneTmbWidth * u.VOM.content.current.vIdx;
                  n + this.posX < this.vwidth
                    ? n + this.posX < 0 && (this.posX = -n)
                    : n + this.posX >= this.vwidth &&
                      (this.posX = this.vwidth - (n + this.oneTmbWidth));
                }
                this.PanGallery(0);
              }
          },
          PanGallery: function (e) {
            this.gwidth < u.VOM.$viewer.width() &&
              ((this.posX = (u.VOM.$viewer.width() - this.gwidth) / 2),
              (e = 0)),
              this.posX > this.vwidth - this.oneTmbWidth &&
                (this.posX = this.vwidth - this.oneTmbWidth),
              this.posX + this.gwidth < this.oneTmbWidth &&
                (this.posX = -this.gwidth + this.oneTmbWidth),
              this.$tmbCont.css(
                u.CSStransformName,
                "translateX(" + (this.posX + e) + "px)"
              );
          },
          PanGalleryEnd: function (e) {
            var t = 100 * e;
            new NGTweenable().tween({
              from: { pan: u.VOM.gallery.posX },
              to: { pan: u.VOM.gallery.posX + t },
              easing: "easeOutQuad",
              duration: 500,
              step: function (e) {
                (u.VOM.gallery.posX = e.pan), u.VOM.gallery.PanGallery(0);
              },
            });
          },
        },
        hammertime: null,
        swipePosX: 0,
        panPosX: 0,
        panPosY: 0,
        panThreshold: 60,
        panXOnly: !1,
        singletapTime: 0,
        viewerTheme: "",
        timeImgChanged: 0,
        ImageLoader: {
          maxChecks: 1e3,
          list: [],
          intervalHandle: null,
          loadImage: function (e, t) {
            if ("img" == t.mediaKind) {
              var n = new Image();
              if (((n.src = t.responsiveURL()), n.width && n.height))
                e(n.width, n.height, t, 0);
              else {
                var i,
                  a = {
                    image: n,
                    url: t.responsiveURL(),
                    ngitem: t,
                    callback: e,
                    checks: 1,
                  };
                for (i = 0; i < this.list.length && null != this.list[i]; i++);
                (this.list[i] = a),
                  this.intervalHandle ||
                    (this.intervalHandle = setInterval(this.interval, 50));
              }
            }
          },
          interval: function () {
            for (
              var e, t = 0, n = u.VOM.ImageLoader.list, i = 0;
              i < n.length;
              i++
            )
              null != (e = n[i]) &&
                (e.image.width && e.image.height
                  ? ((u.VOM.ImageLoader.list[i] = null),
                    e.callback(
                      e.image.width,
                      e.image.height,
                      e.ngitem,
                      e.checks
                    ))
                  : e.checks > u.VOM.ImageLoader.maxChecks
                  ? ((u.VOM.ImageLoader.list[i] = null),
                    e.callback(0, 0, e.ngitem, e.checks))
                  : (t++, e.checks++));
            0 == t &&
              ((u.VOM.ImageLoader.list = []),
              clearInterval(u.VOM.ImageLoader.intervalHandle),
              delete u.VOM.ImageLoader.intervalHandle);
          },
        },
      }),
      (u.popup = {
        isDisplayed: !1,
        $elt: null,
        close: function () {
          null != this.$elt &&
            new NGTweenable().tween({
              from: { opacity: 1 },
              to: { opacity: 0 },
              attachment: { t: this },
              easing: "easeInOutSine",
              duration: 100,
              step: function (e, t) {
                null != t.t.$elt && t.t.$elt.css("opacity", e.opacity);
              },
              finish: function (e, t) {
                null != t.t.$elt && (t.t.$elt.remove(), (t.t.$elt = null)),
                  (t.t.isDisplayed = !1);
              },
            });
        },
      }),
      (u.galleryTheme_dark = {
        navigationBar: {
          background: "none",
          borderTop: "",
          borderBottom: "",
          borderRight: "",
          borderLeft: "",
        },
        navigationBreadcrumb: {
          background: "#111",
          color: "#fff",
          colorHover: "#ccc",
          borderRadius: "4px",
        },
        navigationFilter: {
          color: "#ddd",
          background: "#111",
          colorSelected: "#fff",
          backgroundSelected: "#111",
          borderRadius: "4px",
        },
        navigationPagination: {
          background: "#111",
          color: "#fff",
          colorHover: "#ccc",
          borderRadius: "4px",
        },
        thumbnail: {
          background: "#444",
          backgroundImage: "linear-gradient(315deg, #111 0%, #445 90%)",
          borderColor: "#000",
          borderRadius: "0px",
          labelOpacity: 1,
          labelBackground: "rgba(34, 34, 34, 0)",
          titleColor: "#fff",
          titleBgColor: "transparent",
          titleShadow: "",
          descriptionColor: "#ccc",
          descriptionBgColor: "transparent",
          descriptionShadow: "",
          stackBackground: "#aaa",
        },
        thumbnailIcon: { padding: "5px", color: "#fff", shadow: "" },
        pagination: {
          background: "#181818",
          backgroundSelected: "#666",
          color: "#fff",
          borderRadius: "2px",
          shapeBorder: "3px solid #666",
          shapeColor: "#444",
          shapeSelectedColor: "#aaa",
        },
      }),
      (u.galleryTheme_light = {
        navigationBar: {
          background: "none",
          borderTop: "",
          borderBottom: "",
          borderRight: "",
          borderLeft: "",
        },
        navigationBreadcrumb: {
          background: "#eee",
          color: "#000",
          colorHover: "#333",
          borderRadius: "4px",
        },
        navigationFilter: {
          background: "#eee",
          color: "#222",
          colorSelected: "#000",
          backgroundSelected: "#eee",
          borderRadius: "4px",
        },
        navigationPagination: {
          background: "#eee",
          color: "#000",
          colorHover: "#333",
          borderRadius: "4px",
        },
        thumbnail: {
          background: "#444",
          backgroundImage: "linear-gradient(315deg, #111 0%, #445 90%)",
          borderColor: "#000",
          labelOpacity: 1,
          labelBackground: "rgba(34, 34, 34, 0)",
          titleColor: "#fff",
          titleBgColor: "transparent",
          titleShadow: "",
          descriptionColor: "#ccc",
          descriptionBgColor: "transparent",
          descriptionShadow: "",
          stackBackground: "#888",
        },
        thumbnailIcon: { padding: "5px", color: "#fff" },
        pagination: {
          background: "#eee",
          backgroundSelected: "#aaa",
          color: "#000",
          borderRadius: "2px",
          shapeBorder: "3px solid #666",
          shapeColor: "#444",
          shapeSelectedColor: "#aaa",
        },
      }),
      (u.viewerTheme_dark = {
        background: "#000",
        barBackground: "rgba(4, 4, 4, 0.2)",
        barBorder: "0px solid #111",
        barColor: "#fff",
        barDescriptionColor: "#ccc",
      }),
      (u.viewerTheme_light = {
        background: "#f8f8f8",
        barBackground: "rgba(4, 4, 4, 0.7)",
        barBorder: "0px solid #111",
        barColor: "#fff",
        barDescriptionColor: "#ccc",
      });
    var h = NGY2Tools.NanoAlert,
      d = NGY2Tools.NanoConsoleLog;
    function m() {
      (u.VOM.items = []), (u.VOM.albumID = "0"), (u.GOM.curNavLevel = "l1");
      for (
        var e = 0, t = u.$E.base[0].src, n = void 0, i = 0;
        i < u.I.length;
        i++
      )
        if ("image" == u.I[i].kind) {
          var a = new c(i);
          u.VOM.items.push(a), u.I[i].thumbImg().src == t && (n = e), e++;
        }
      u.VOM.items.length > 0
        ? De(n)
        : d(u, "No content for Lightbox standalone.");
    }
    function p(e) {
      var t = { albumID: "0", imageID: "0" },
        n = e.split("/");
      return (
        n.length > 0 &&
          ((t.albumID = n[0]), n.length > 1 && (t.imageID = n[1])),
        t
      );
    }
    function g(e, t) {
      u.VOM.viewerDisplayed && tt(null);
      var n = NGY2Item.GetIdx(u, t);
      (u.GOM.curNavLevel = "lN"),
        0 == n && (u.GOM.curNavLevel = "l1"),
        u.layout.SetEngine(),
        (u.galleryResizeEventEnabled = !1),
        -1 == n &&
          (NGY2Item.New(u, "", "", t, "0", "album"), (n = u.I.length - 1)),
        u.I[n].contentIsLoaded
          ? (de(), (u.GOM.pagination.currentPage = 0), rt(t, ""), w(n))
          : q(t, g, e, t);
    }
    function f() {
      switch (u.galleryDisplayMode.Get()) {
        case "PAGINATION":
          u.layout.support.rows &&
            u.galleryMaxRows.Get() > 0 &&
            (function () {
              if (
                (u.$E.conTnBottom.css("opacity", 0),
                u.$E.conTnBottom.children().remove(),
                0 == u.GOM.items.length)
              )
                return;
              var e = Math.ceil(
                (u.GOM.items[u.GOM.items.length - 1].row + 1) /
                  u.galleryMaxRows.Get()
              );
              if (1 == e) return;
              u.GOM.pagination.currentPage > e - 1 &&
                (u.GOM.pagination.currentPage = e - 1);
              if ((M(), 0 == u.GOM.displayInterval.len)) return;
              if (
                "NUMBERS" == u.O.galleryPaginationMode &&
                u.GOM.pagination.currentPage > 0
              ) {
                jQuery(
                  '<div class="nGY2PaginationPrev">' +
                    u.O.icons.paginationPrevious +
                    "</div>"
                )
                  .appendTo(u.$E.conTnBottom)
                  .click(function (e) {
                    G();
                  });
              }
              var t = 0,
                n = e;
              if ("NUMBERS" != u.O.galleryPaginationMode) t = 0;
              else {
                var i = u.O.paginationVisiblePages;
                if (i >= e) t = 0;
                else {
                  var a = 0;
                  (a = i % 2 == 1 ? (i + 1) / 2 : i / 2),
                    u.GOM.pagination.currentPage < a
                      ? ((t = 0), (n = i - 1) > e && (n = e - 1))
                      : ((t = u.GOM.pagination.currentPage - a),
                        (n = t + i) > e && (n = e - 1)),
                    n - t < i && (t = n - i) < 0 && (t = 0);
                }
              }
              for (var o = t; o < n; o++) {
                var r = "",
                  l = "";
                switch (u.O.galleryPaginationMode) {
                  case "NUMBERS":
                    (r = "nGY2paginationItem"), (l = o + 1);
                    break;
                  case "DOTS":
                    r = "nGY2paginationDot";
                    break;
                  case "RECTANGLES":
                    r = "nGY2paginationRectangle";
                }
                o == u.GOM.pagination.currentPage && (r += "CurrentPage");
                var s = jQuery(
                  '<div class="' + r + '">' + l + "</div>"
                ).appendTo(u.$E.conTnBottom);
                s.data("pageNumber", o),
                  s.click(function (e) {
                    (u.GOM.pagination.currentPage =
                      jQuery(this).data("pageNumber")),
                      at("pageChanged"),
                      u.GOM.ScrollToTop(),
                      L(),
                      E(!0);
                  });
              }
              if (
                "NUMBERS" == u.O.galleryPaginationMode &&
                u.GOM.pagination.currentPage + 1 < e
              ) {
                jQuery(
                  '<div class="nGY2PaginationNext">' +
                    u.O.icons.paginationNext +
                    "</div>"
                )
                  .appendTo(u.$E.conTnBottom)
                  .click(function (e) {
                    y();
                  });
              }
              u.$E.conTnBottom.css("opacity", 1);
            })();
          break;
        case "MOREBUTTON":
          u.$E.conTnBottom.off("click");
          var e = u.GOM.items.length - u.GOM.itemsDisplayed;
          0 == e
            ? u.$E.conTnBottom.empty()
            : (u.$E.conTnBottom.html(
                '<div class="nGY2GalleryMoreButton"><div class="nGY2GalleryMoreButtonAnnotation">+' +
                  e +
                  " " +
                  u.O.icons.galleryMoreButton +
                  "</div></div>"
              ),
              u.$E.conTnBottom.on("click", function (e) {
                u.GOM.displayedMoreSteps++, x();
              }));
      }
    }
    function b(e) {
      var t = "";
      u.O.breadcrumbHideIcons ||
        ((t = u.O.icons.breadcrumbAlbum),
        0 == e && (t = u.O.icons.breadcrumbHome));
      var n = jQuery(
        '<div class="oneItem">' + t + u.I[e].title + "</div>"
      ).appendTo(u.GOM.navigationBar.$newContent.find(".nGY2Breadcrumb"));
      u.O.breadcrumbOnlyCurrentLevel
        ? 0 == e
          ? jQuery(n).data("albumID", "0")
          : jQuery(n).data("albumID", u.I[e].albumID)
        : jQuery(n).data("albumID", u.I[e].GetID()),
        n.click(function () {
          g("-1", jQuery(this).data("albumID"));
        });
    }
    function v(e) {
      var t = jQuery(
        '<div class="oneItem">' +
          (u.O.RTL
            ? u.O.icons.breadcrumbSeparatorRtl
            : u.O.icons.breadcrumbSeparator) +
          "</div>"
      ).appendTo(u.GOM.navigationBar.$newContent.find(".nGY2Breadcrumb"));
      jQuery(t).data("albumIdx", e),
        t.click(function () {
          var e = jQuery(this).data("albumIdx");
          g("-1", u.I[e].GetID());
        });
    }
    function O(e) {
      if (
        ((u.GOM.navigationBar.$newContent = jQuery(
          '<div class="nGY2Navigationbar"></div>'
        )),
        1 == u.O.displayBreadcrumb && !u.O.thumbnailAlbumDisplayImage)
      ) {
        var t = 0,
          n = [];
        if (0 != e) {
          var i = u.I.length;
          n.push(e);
          var a = e;
          for (t++; 0 != u.I[a].albumID && -1 != u.I[a].albumID; )
            for (var o = 1; o < i; o++)
              if (u.I[o].GetID() == u.I[a].albumID) {
                (a = o), n.push(a), t++;
                break;
              }
        }
        (u.O.breadcrumbAutoHideTopLevel && 0 == t) ||
          (function (e) {
            if (
              (jQuery(
                '<div class="nGY2NavigationbarItem nGY2Breadcrumb"></div>'
              ).appendTo(u.GOM.navigationBar.$newContent),
              u.O.breadcrumbOnlyCurrentLevel)
            )
              0 == e.length ? b(0) : (1 == e.length ? v(0) : v(e[0]), b(e[0]));
            else if ((b(0), e.length > 0)) {
              v(0);
              for (var t = e.length - 1; t >= 0; t--)
                b(e[t]), t > 0 && v(e[t - 1]);
            }
          })(n);
      }
      if (0 != u.galleryFilterTags.Get()) {
        var r = u.I[e].albumTagList.length;
        if (r > 0) {
          for (o = 0; o < r; o++) {
            var l = u.I[e].albumTagList[o],
              s = u.O.icons.navigationFilterUnselected,
              c = "Unselected";
            jQuery.inArray(l, u.I[e].albumTagListSel) >= 0 &&
              ((c = "Selected"), (s = u.O.icons.navigationFilterSelected)),
              jQuery(
                '<div class="nGY2NavigationbarItem nGY2NavFilter' +
                  c +
                  '">' +
                  s +
                  " " +
                  l +
                  "</div>"
              )
                .appendTo(u.GOM.navigationBar.$newContent)
                .click(function () {
                  var t = jQuery(this),
                    n = t.text().replace(/^\s*|\s*$/, "");
                  if ("single" == u.galleryFilterTagsMode.Get())
                    (u.I[e].albumTagListSel = []),
                      u.I[e].albumTagListSel.push(n);
                  else {
                    if (t.hasClass("nGY2NavFilterUnselected"))
                      u.I[e].albumTagListSel.push(n);
                    else {
                      var i = jQuery.inArray(n, u.I[e].albumTagListSel);
                      -1 != i && u.I[e].albumTagListSel.splice(i, 1);
                    }
                    t.toggleClass(
                      "nGY2NavFilters-oneTagUnselected nGY2NavFilters-oneTagSelected"
                    );
                  }
                  g("-1", u.I[e].GetID());
                });
          }
          jQuery(
            '<div class="nGY2NavigationbarItem nGY2NavFilterSelectAll">' +
              u.O.icons.navigationFilterSelectedAll +
              "</div>"
          )
            .appendTo(u.GOM.navigationBar.$newContent)
            .click(function () {
              (u.I[e].albumTagListSel = []), g("-1", u.I[e].GetID());
            });
        }
      }
      "PAGINATION" == u.galleryDisplayMode.Get() &&
        u.O.galleryPaginationTopButtons &&
        u.layout.support.rows &&
        u.galleryMaxRows.Get() > 0 &&
        (jQuery(
          '<div class="nGY2NavigationbarItem nGY2NavPagination">' +
            u.O.icons.navigationPaginationPrevious +
            "</div>"
        )
          .appendTo(u.GOM.navigationBar.$newContent)
          .click(function () {
            G();
          }),
        jQuery(
          '<div class="nGY2NavigationbarItem nGY2NavPagination">' +
            u.O.icons.navigationPaginationNext +
            "</div>"
        )
          .appendTo(u.GOM.navigationBar.$newContent)
          .click(function () {
            y();
          }));
    }
    function y() {
      var e = 0;
      j(),
        u.galleryMaxRows.Get() > 0 &&
          (e =
            (u.GOM.items[u.GOM.items.length - 1].row + 1) /
            u.galleryMaxRows.Get());
      var t = Math.ceil(e),
        n = u.GOM.pagination.currentPage;
      n < t - 1 ? n++ : (n = 0),
        (u.GOM.pagination.currentPage = n),
        at("pageChanged"),
        u.GOM.ScrollToTop(),
        L(),
        E(!0);
    }
    function G() {
      var e = 0;
      j(),
        u.galleryMaxRows.Get() > 0 &&
          (e =
            (u.GOM.items[u.GOM.items.length - 1].row + 1) /
            u.galleryMaxRows.Get());
      var t = Math.ceil(e),
        n = u.GOM.pagination.currentPage;
      n > 0 ? n-- : (n = t - 1),
        (u.GOM.pagination.currentPage = n),
        at("pageChanged"),
        u.GOM.ScrollToTop(),
        L(),
        E(!0);
    }
    function M() {
      switch (
        ((u.GOM.displayInterval.from = 0),
        (u.GOM.displayInterval.len = u.I.length),
        u.galleryDisplayMode.Get())
      ) {
        case "PAGINATION":
          if (u.layout.support.rows) {
            let a = u.GOM.items.length;
            var e = u.GOM.pagination.currentPage * u.galleryMaxRows.Get(),
              t = e + u.galleryMaxRows.Get(),
              n = -1;
            u.GOM.displayInterval.len = 0;
            for (var i = 0; i < a; i++) {
              let a = u.GOM.items[i];
              a.row >= e &&
                a.row < t &&
                (-1 == n && ((u.GOM.displayInterval.from = i), (n = i)),
                u.GOM.displayInterval.len++);
            }
          }
          break;
        case "MOREBUTTON":
          if (u.layout.support.rows) {
            let e = u.GOM.items.length,
              t = u.O.galleryDisplayMoreStep * (u.GOM.displayedMoreSteps + 1);
            u.GOM.displayInterval.len = 0;
            for (i = 0; i < e; i++) {
              u.GOM.items[i].row < t && u.GOM.displayInterval.len++;
            }
          }
          break;
        case "ROWS":
          if (u.layout.support.rows) {
            let e = u.GOM.items.length,
              t = u.galleryMaxRows.Get();
            u.galleryLastRowFull.Get() &&
              -1 != u.GOM.lastFullRow &&
              t > u.GOM.lastFullRow + 1 &&
              (t = u.GOM.lastFullRow + 1),
              (u.GOM.displayInterval.len = 0);
            for (i = 0; i < e; i++) {
              u.GOM.items[i].row < t && u.GOM.displayInterval.len++;
            }
          }
          break;
        default:
        case "FULLCONTENT":
          if (
            u.layout.support.rows &&
            u.galleryLastRowFull.Get() &&
            -1 != u.GOM.lastFullRow
          ) {
            let e = u.GOM.items.length,
              t = u.GOM.lastFullRow + 1;
            u.GOM.displayInterval.len = 0;
            for (i = 0; i < e; i++) {
              u.GOM.items[i].row < t && u.GOM.displayInterval.len++;
            }
          }
      }
    }
    function w(e) {
      at("galleryRenderStart"),
        clearTimeout(u.GOM.slider.timerID),
        (u.GOM.slider.hostIdx = -1);
      var t = u.O.fnGalleryRenderStart;
      if (
        (null !== t &&
          ("function" == typeof t
            ? t(u.I[u.GOM.albumIdx])
            : window[t](u.I[u.GOM.albumIdx])),
        u.layout.SetEngine(),
        (u.galleryResizeEventEnabled = !1),
        (u.GOM.albumIdx = -1),
        (u.GOM.lastDisplayedIdx = -1),
        void 0 !== u.$E.conTnBottom && u.$E.conTnBottom.empty(),
        O(e),
        u.GOM.firstDisplay)
      ) {
        u.GOM.firstDisplay = !1;
        var n = Date.now() - u.GOM.firstDisplayTime;
        n < u.O.galleryRenderDelay
          ? requestTimeout(function () {
              I(e);
            }, u.O.galleryRenderDelay - n)
          : I(e),
          (u.O.galleryRenderDelay = 0);
      } else {
        var i = !1;
        0 == u.GOM.navigationBar.$newContent.children().length && (i = !0),
          new NGTweenable().tween({
            from: { opacity: 1 },
            to: { opacity: 0 },
            duration: 300,
            easing: "easeInQuart",
            attachment: { h: i },
            step: function (e, t) {
              u.$E.conTnParent.css({ opacity: e.opacity }),
                t.h && u.$E.conNavigationBar.css({ opacity: e.opacity });
            },
            finish: function (t, n) {
              n.h && u.$E.conNavigationBar.css({ opacity: 0, display: "none" }),
                u.GOM.ScrollToTop(),
                I(e);
            },
          });
      }
    }
    function I(e) {
      var t = u.$E.conNavigationBar.children().length;
      (u.$E.conNavigationBar.empty(),
      u.GOM.navigationBar.$newContent
        .children()
        .clone(!0, !0)
        .appendTo(u.$E.conNavigationBar),
      u.$E.conNavigationBar.children().length > 0 && 0 == t)
        ? (u.$E.conNavigationBar.css({ opacity: 0, display: "block" }),
          new NGTweenable().tween({
            from: { opacity: 0 },
            to: { opacity: 1 },
            duration: 200,
            easing: "easeInQuart",
            step: function (e) {
              u.$E.conNavigationBar.css(e);
            },
            finish: function (t) {
              u.$E.conNavigationBar.css({ opacity: 1 }),
                requestTimeout(function () {
                  T(e);
                }, 20);
            },
          }))
        : requestTimeout(function () {
            T(e);
          }, 20);
    }
    function T(e) {
      (u.GOM.lastZIndex = parseInt(u.$E.base.css("z-index"))),
        isNaN(u.GOM.lastZIndex) && (u.GOM.lastZIndex = 0),
        u.$E.conTnParent.css({ opacity: 0 }),
        u.$E.conTn.off().empty();
      for (var t = u.I.length, n = 0; n < t; n++) {
        var i = u.I[n];
        (i.hovered = !1),
          (i.$elt = null),
          (i.$Elts = []),
          (i.eltTransform = []),
          (i.eltFilter = []),
          (i.width = 0),
          (i.height = 0),
          (i.left = 0),
          (i.top = 0),
          (i.resizedContentWidth = 0),
          (i.resizedContentHeight = 0),
          (i.thumbnailImgRevealed = !1);
      }
      null == u.CSStransformName
        ? u.$E.conTn.css("left", "0px")
        : u.$E.conTn.css(u.CSStransformName, "none"),
        requestTimeout(function () {
          !(function (e) {
            var t = new Date();
            u.$E.conTnParent.css("opacity", 1),
              (u.GOM.items = []),
              (u.GOM.displayedMoreSteps = 0),
              "onBottom" == u.O.thumbnailLabel.get("position")
                ? (u.tn.labelHeight[u.GOM.curNavLevel] = (function () {
                    var e = [],
                      t = 0;
                    if (0 == u.O.thumbnailLabel.get("display")) return 0;
                    (e[t++] =
                      '<div class="nGY2GThumbnail ' +
                      u.O.theme +
                      '" style="display:block;visibility:hidden;position:absolute;top:-9999px;left:-9999px;" ><div class="nGY2GThumbnailSub">'),
                      1 == u.O.thumbnailLabel.get("display") &&
                        ((e[t++] =
                          '  <div class="nGY2GThumbnailLabel" ' +
                          u.tn.style.getLabel() +
                          ">"),
                        (e[t++] =
                          '    <div class="nGY2GThumbnailAlbumTitle" ' +
                          u.tn.style.getTitle() +
                          ">aAzZjJ</div>"),
                        1 == u.O.thumbnailLabel.get("displayDescription") &&
                          (e[t++] =
                            '    <div class="nGY2GThumbnailDescription" ' +
                            u.tn.style.getDesc() +
                            ">aAzZjJ</div>"),
                        (e[t++] = "  </div>"));
                    e[t++] = "</div></div>";
                    var n = jQuery(e.join("")).appendTo(u.$E.conTn),
                      i = n.find(".nGY2GThumbnailLabel").outerHeight(!0);
                    return n.remove(), i;
                  })())
                : (u.tn.labelHeight[u.GOM.curNavLevel] = 0);
            (u.GOM.albumIdx = e), at("galleryRenderEnd");
            var n = u.O.fnGalleryRenderEnd;
            null !== n &&
              ("function" == typeof n
                ? n(u.I[u.GOM.albumIdx])
                : window[n](u.I[u.GOM.albumIdx]));
            !(function () {
              for (
                var e = "",
                  t = u.I[u.GOM.albumIdx].GetID(),
                  n = u.I.length,
                  i = 0,
                  a = 0;
                a < n;
                a++
              ) {
                var o = u.I[a];
                if (o.isToDisplay(t)) {
                  var r = o.thumbImg().width,
                    l = o.thumbImg().height;
                  !u.layout.prerequisite.imageSize ||
                    (0 != r && 0 != l) ||
                    (e +=
                      '<img src="' +
                      o.thumbImg().src +
                      '" data-idx="' +
                      i +
                      '" data-albumidx="' +
                      u.GOM.albumIdx +
                      '">'),
                    0 == l && (l = u.tn.defaultSize.getHeight()),
                    0 == r && (r = u.tn.defaultSize.getWidth());
                  var s = new u.GOM.GTn(a, r, l);
                  u.GOM.items.push(s), i++;
                }
              }
              at("galleryObjectModelBuilt");
              var c = u.O.fnGalleryObjectModelBuilt;
              null !== c && ("function" == typeof c ? c() : window[c]());
              if ("" != e) {
                var h = jQuery(e),
                  d = ngimagesLoaded(h);
                return (
                  (h = null),
                  d.on("progress", function (e, t) {
                    if (t.isLoaded) {
                      var n = t.img.getAttribute("data-idx");
                      if (
                        t.img.getAttribute("data-albumidx") == u.GOM.albumIdx
                      ) {
                        var i = u.GOM.items[n];
                        (i.imageWidth = t.img.naturalWidth),
                          (i.imageHeight = t.img.naturalHeight);
                        var a = u.I[i.thumbnailIdx];
                        (a.thumbs.width[u.GOM.curNavLevel][u.GOM.curWidth] =
                          i.imageWidth),
                          (a.thumbs.height[u.GOM.curNavLevel][u.GOM.curWidth] =
                            i.imageHeight),
                          u.GalleryResizeThrottled();
                        var o = a.thumbs.width.l1;
                        for (let e in o)
                          o.hasOwnProperty(e) &&
                            e != u.GOM.curWidth &&
                            u.tn.settings.width.l1[e] == u.tn.settings.getW() &&
                            u.tn.settings.height.l1[e] ==
                              u.tn.settings.getH() &&
                            ((a.thumbs.width.l1[e] = i.imageWidth),
                            (a.thumbs.height.l1[e] = i.imageHeight));
                        o = a.thumbs.width.lN;
                        for (let e in o)
                          o.hasOwnProperty(e) &&
                            e != u.GOM.curWidth &&
                            u.tn.settings.width.lN[e] == u.tn.settings.getW() &&
                            u.tn.settings.height.lN[e] ==
                              u.tn.settings.getH() &&
                            ((a.thumbs.width.lN[e] = i.imageWidth),
                            (a.thumbs.height.lN[e] = i.imageHeight));
                      }
                    }
                  }),
                  (u.galleryResizeEventEnabled = !0),
                  !1
                );
              }
              return !0;
            })()
              ? (u.galleryResizeEventEnabled = !0)
              : (S(),
                (function () {
                  var e = u.galleryDisplayTransitionDuration.Get();
                  switch (u.galleryDisplayTransition.Get()) {
                    case "ROTATEX":
                      u.$E.base.css({
                        perspective: "1000px",
                        "perspective-origin": "50% 0%",
                      }),
                        new NGTweenable().tween({
                          from: { r: 50 },
                          to: { r: 0 },
                          attachment: { orgIdx: u.GOM.albumIdx },
                          duration: e,
                          easing: "easeOutCirc",
                          step: function (e, t) {
                            t.orgIdx == u.GOM.albumIdx &&
                              u.$E.conTnParent.css(
                                u.CSStransformName,
                                "rotateX(" + e.r + "deg)"
                              );
                          },
                        });
                      break;
                    case "SLIDEUP":
                      u.$E.conTnParent.css({ opacity: 0 }),
                        new NGTweenable().tween({
                          from: { y: 200, o: 0 },
                          to: { y: 0, o: 1 },
                          attachment: { orgIdx: u.GOM.albumIdx },
                          duration: e,
                          easing: "easeOutCirc",
                          step: function (e, t) {
                            t.orgIdx == u.GOM.albumIdx &&
                              u.$E.conTnParent
                                .css(
                                  u.CSStransformName,
                                  "translate( 0px, " + e.y + "px)"
                                )
                                .css("opacity", e.o);
                          },
                        });
                  }
                })(),
                L(),
                requestTimeout(function () {
                  E(!1);
                }, 20));
            u.O.debugMode &&
              console.log("GalleryRenderPart3: " + (new Date() - t));
          })(e);
        }, 20);
    }
    function x() {
      var e = new Date();
      if (((u.galleryResizeEventEnabled = !1), 0 == S()))
        return (
          (u.galleryResizeEventEnabled = !0),
          void (
            u.O.debugMode && console.log("GalleryResize1: " + (new Date() - e))
          )
        );
      u.O.debugMode &&
        console.log("GalleryResizeSetLayout: " + (new Date() - e)),
        L(),
        E(!1),
        u.O.debugMode && console.log("GalleryResizeFull: " + (new Date() - e));
    }
    function S() {
      var e = !0;
      switch (
        ((u.GOM.cache.areaWidth = u.$E.conTnParent.width()),
        (u.GOM.displayArea = { width: 0, height: 0 }),
        u.layout.engine)
      ) {
        case "JUSTIFIED":
          e = (function () {
            for (
              var e = 0,
                t = u.GOM.cache.areaWidth,
                n = 0,
                i = 0,
                a = [],
                o = 0,
                r = [],
                l = !1,
                s = u.tn.settings.GetResponsive("gutterWidth"),
                c = u.tn.settings.GetResponsive("gutterHeight"),
                h = 0,
                d = 0,
                m = !1,
                p = !1,
                g = u.tn.defaultSize.getOuterHeight(),
                f = 2 * u.tn.opt.Get("borderHorizontal"),
                b = 2 * u.tn.opt.Get("borderVertical"),
                v = 1,
                O = u.GOM.items.length,
                y = 0;
              y < O;
              y++
            ) {
              let n = u.GOM.items[y];
              if (1 == n.deleted) break;
              if (n.imageWidth > 0) {
                let i = n.imageWidth / n.imageHeight,
                  u = Math.floor(g * i);
                if (
                  (l && ((l = !1), o++, (e = 0), (m = !1), (p = !1), (v = 1)),
                  n.imageHeight > n.imageWidth ? (m = !0) : (p = !0),
                  e + s + u < t - v * f)
                ) {
                  (e += u + s), (r[o] = g);
                  var G = Math.max(m ? h : 0, p ? d : 0);
                  G > 0 && (r[o] = Math.min(r[o], G)), (a[o] = y);
                } else {
                  let n = (t - v * f) / (e += s + u),
                    i = Math.floor(g * n);
                  (r[o] = i),
                    m && (h = Math.max(h, i)),
                    p && (d = Math.max(d, i)),
                    (a[o] = y),
                    (l = !0);
                }
                v++;
              }
            }
            (o = 0), (i = 0), (n = 0), 0, (u.GOM.lastFullRow = 0);
            for (y = 0; y < O; y++) {
              let e = u.GOM.items[y];
              if (!(e.imageWidth > 0)) return !1;
              {
                let l = e.imageWidth / e.imageHeight,
                  h = Math.floor(l * r[o]);
                y == a[o] &&
                  (a.length != o + 1 || n + s + h + f > t) &&
                  (h = t - n - f);
                let d = parseInt(r[o]);
                (h = parseInt(h)),
                  (e.resizedContentWidth = h),
                  (e.resizedContentHeight = d),
                  (e.width = h + f),
                  (e.height = d + u.tn.labelHeight.get() + b),
                  (e.row = o),
                  (e.top = i);
                let m = n;
                u.O.RTL && (m = t - n - e.width),
                  (e.left = m),
                  (n += e.width + s),
                  y == a[o] &&
                    ((i += e.height + c),
                    (u.GOM.lastFullRow = o - 1),
                    o++,
                    (n = 0));
              }
            }
            return (u.GOM.displayArea.width = t), !0;
          })();
          break;
        case "CASCADING":
          e = (function () {
            var e = 0,
              t = u.GOM.cache.areaWidth,
              n = 0,
              i = [],
              a = z(t),
              o = 0,
              r = u.tn.settings.GetResponsive("gutterHeight"),
              l = 1,
              s = u.tn.defaultSize.getOuterWidth(),
              c = u.GOM.items.length,
              h = 0;
            "justified" == u.O.thumbnailAlignment
              ? ((a = Math.min(a, c)), (o = 1 == a ? 0 : (t - a * s) / (a - 1)))
              : (o = u.tn.settings.GetResponsive("gutterWidth"));
            var d = 2 * u.tn.opt.Get("borderHorizontal"),
              m = 2 * u.tn.opt.Get("borderVertical");
            if (
              ((u.GOM.lastFullRow = -1), "fillWidth" == u.O.thumbnailAlignment)
            ) {
              var p = (a - 1) * o;
              (l = (t - p) / (a * s)) > 1 && a++,
                (p = (a - 1) * o),
                (l = Math.min((t - p) / (a * s), 1));
            }
            for (
              var g = (s = Math.round(s * l)) - d,
                f = Math.round(u.tn.opt.Get("baseGridHeight") * l),
                b = 0;
              b < c;
              b++
            ) {
              var v = u.GOM.items[b];
              if (1 == v.deleted) break;
              if (v.imageHeight > 0 && v.imageWidth > 0) {
                var O = 0,
                  y = ((h = 0), v.imageHeight / v.imageWidth);
                if (
                  ((v.resizedContentWidth = g),
                  (v.resizedContentHeight = v.resizedContentWidth * y),
                  f > 0)
                ) {
                  var G = Math.max(Math.trunc(v.resizedContentHeight / f), 1);
                  v.resizedContentHeight = f * G + (G - 1) * (m + r);
                }
                if (
                  ((v.height =
                    v.resizedContentHeight + m + u.tn.labelHeight.get()),
                  (v.width = s),
                  (v.row = 0),
                  0 == n)
                )
                  (O = e * (s + o)),
                    (i[e] = v.height + r),
                    ++e >= a && ((e = 0), n++);
                else {
                  for (var M = 0, w = i[0], I = 1; I < a; I++)
                    i[I] + 5 < w && ((w = i[I]), (M = I));
                  (h = i[M]), (O = M * (s + o)), (i[M] = h + v.height + r);
                }
                var T = O;
                u.O.RTL && (T = 0 - O - s), (v.left = T), (v.top = h);
              }
            }
            return (u.GOM.displayArea.width = a * (s + o) - o), !0;
          })();
          break;
        case "MOSAIC":
          e = (function () {
            var e = u.GOM.cache.areaWidth,
              t = u.tn.settings.GetResponsive("gutterHeight"),
              n = u.tn.settings.GetResponsive("gutterWidth"),
              i = 2 * u.tn.opt.Get("borderHorizontal"),
              a = 2 * u.tn.opt.Get("borderVertical"),
              o = u.GOM.items.length,
              r = 0,
              l = 0,
              s = 0,
              c = 0,
              h = 0;
            let d = u.tn.settings.getMosaic();
            for (var m = 0; m < o; m++) {
              let e = d[s];
              var p =
                  (e.c - 1) * u.tn.defaultSize.getOuterWidth() + (e.c - 1) * n,
                g = e.w * u.tn.defaultSize.getOuterWidth() + (e.w - 1) * n;
              if (
                ((h = Math.max(h, p + g)),
                (c = Math.max(c, e.c - 1 + e.w)),
                ++s >= d.length)
              )
                break;
            }
            var f = (c - 1) * n,
              b = Math.min((e - f) / (h - f), 1);
            (r = 0), (s = 0);
            for (m = 0; m < o; m++) {
              let e = u.GOM.items[m],
                o = d[s];
              (e.top =
                Math.round((o.r - 1) * u.tn.defaultSize.getOuterHeight() * b) +
                (o.r - 1) * t +
                r * l +
                u.tn.labelHeight.get() * (o.r - 1)),
                r > 0 && (e.top += t),
                (e.left =
                  (o.c - 1) * Math.round(u.tn.defaultSize.getOuterWidth() * b) +
                  (o.c - 1) * n),
                (e.height =
                  Math.round(o.h * u.tn.defaultSize.getOuterHeight() * b) +
                  (o.h - 1) * t +
                  u.tn.labelHeight.get() * o.h),
                (e.resizedContentHeight =
                  e.height - u.tn.labelHeight.get() - a),
                (e.width =
                  Math.round(o.w * u.tn.defaultSize.getOuterWidth() * b) +
                  (o.w - 1) * n),
                (e.resizedContentWidth = e.width - i),
                (e.row = r),
                0 == r && (l = Math.max(l, e.top + e.height)),
                ++s >= d.length && ((s = 0), r++);
            }
            return (u.GOM.displayArea.width = (h - f) * b + f), !0;
          })();
          break;
        case "GRID":
        default:
          e = (function () {
            var e = 0,
              t = 0,
              n = u.GOM.cache.areaWidth,
              i = 0,
              a = u.tn.settings.GetResponsive("gutterHeight"),
              o = z(n),
              r = 0,
              l = [],
              s = 0,
              c = n,
              h = u.tn.defaultSize.getOuterWidth(),
              d = 1,
              m = u.GOM.items.length,
              p = 2 * u.tn.opt.Get("borderHorizontal"),
              g = 2 * u.tn.opt.Get("borderVertical");
            "justified" == u.O.thumbnailAlignment
              ? ((o = Math.min(o, m)), (i = 1 == o ? 0 : (n - o * h) / (o - 1)))
              : (i = u.tn.settings.GetResponsive("gutterWidth"));
            if (u.O.RTL || "fillWidth" == u.O.thumbnailAlignment) {
              var f = (o - 1) * i;
              (d = (n - f) / (o * h)) > 1 && o++,
                (f = (o - 1) * i),
                (d = Math.min((n - f) / (o * h), 1)),
                (c = o * h + f);
            }
            u.GOM.lastFullRow = 0;
            for (
              var b = 0,
                v = (h = Math.round(h * d)) - p,
                O =
                  Math.round(u.tn.defaultSize.getOuterHeight() * d) +
                  u.tn.labelHeight.get(),
                y = Math.round(u.tn.defaultSize.getOuterHeight() * d) - g,
                G = 0;
              G < m;
              G++
            ) {
              0 == t
                ? ((e = s * (h + i)), (l[s] = e), (r = e + h))
                : (e = l[s]);
              var M = e;
              u.O.RTL && (M = parseInt(c) - e - h);
              var w = u.GOM.items[G];
              (w.top = t),
                (w.left = M),
                (w.height = O),
                (w.width = h),
                "fillWidth" == u.O.thumbnailAlignment &&
                  ((w.resizedContentWidth = v), (w.resizedContentHeight = y)),
                (w.row = b),
                ++s >= o &&
                  ((s = 0), (t += O + a), (u.GOM.lastFullRow = b), b++);
            }
            return (u.GOM.displayArea.width = r), !0;
          })();
      }
      at("galleryLayoutApplied");
      var t = u.O.fnGalleryLayoutApplied;
      return null !== t && ("function" == typeof t ? t() : window[t]()), e;
    }
    function L() {
      null == u.CSStransformName
        ? u.$E.conTn.css("left", "0px")
        : u.$E.conTn.css(u.CSStransformName, "none");
    }
    function C() {
      (u.GOM.cache.viewport = a()),
        (u.GOM.cache.areaWidth = u.$E.base.width()),
        u.O.lightboxStandalone ||
          (u.GOM.cache.containerOffset = u.$E.conLoadingB.offset());
    }
    function E(e) {
      C();
      var t = u.GOM.items.length;
      u.GOM.itemsDisplayed = 0;
      var n = 0;
      M();
      for (var i = 0; i < t; i++) {
        let t = u.GOM.items[i];
        i >= u.GOM.displayInterval.from && n < u.GOM.displayInterval.len
          ? ((t.inDisplayArea = !0),
            e && (t.neverDisplayed = !0),
            u.GOM.itemsDisplayed++,
            n++)
          : (t.inDisplayArea = !1);
      }
      f();
      var a = [],
        o = [];
      C(), (u.GOM.clipArea.top = -1), (n = 0);
      var r = -1;
      u.GOM.clipArea.height = 0;
      for (i = 0; i < t; i++) {
        let e = u.GOM.items[i];
        if (e.inDisplayArea) {
          if (
            (-1 == u.GOM.clipArea.top && (u.GOM.clipArea.top = e.top),
            e.top - u.GOM.clipArea.top <= -1 && (u.GOM.clipArea.top = e.top),
            (u.GOM.clipArea.height = Math.max(
              u.GOM.clipArea.height,
              e.top - u.GOM.clipArea.top + e.height
            )),
            e.neverDisplayed)
          ) {
            var l =
              u.GOM.cache.containerOffset.top + (e.top - u.GOM.clipArea.top);
            if (
              l + e.height >= u.GOM.cache.viewport.t - 50 &&
              l <= u.GOM.cache.viewport.t + u.GOM.cache.viewport.h + 50
            ) {
              let t = u.I[e.thumbnailIdx];
              null == t.$elt && A(t, e.thumbnailIdx, i),
                a.push({ idx: i, delay: n, top: e.top, left: e.left }),
                n++;
            }
          } else o.push({ idx: i, delay: 0, top: e.top, left: e.left });
          r = i;
        } else {
          e.displayed = !1;
          let t = u.I[e.thumbnailIdx];
          null != t.$elt && t.$elt.css({ opacity: 0, display: "none" });
        }
      }
      var s = u.$E.conTnParent.width();
      if (
        ((u.GOM.displayArea.width == u.GOM.displayAreaLast.width &&
          u.GOM.clipArea.height == u.GOM.displayAreaLast.height) ||
          (u.$E.conTn
            .width(u.GOM.displayArea.width)
            .height(u.GOM.clipArea.height),
          (u.GOM.displayAreaLast.width = u.GOM.displayArea.width),
          (u.GOM.displayAreaLast.height = u.GOM.clipArea.height)),
        s != u.$E.conTnParent.width())
      )
        return (
          (u.GOM.cache.areaWidth = u.$E.conTnParent.width()),
          S(),
          L(),
          void E(e)
        );
      if (
        u.layout.support.rows &&
        ("ROWS" == u.galleryDisplayMode.Get() ||
          ("FULLCONTENT" == u.galleryDisplayMode.Get() &&
            u.galleryLastRowFull.Get() &&
            -1 != u.GOM.lastFullRow)) &&
        ((u.GOM.lastDisplayedIdxNew = r < t - 1 ? r : -1),
        -1 != u.GOM.lastDisplayedIdx)
      ) {
        u.I[u.GOM.items[u.GOM.lastDisplayedIdx].thumbnailIdx]
          .$getElt(".nGY2GThumbnailIconsFullThumbnail")
          .html("");
      }
      u.GOM.thumbnails2Display = [];
      var c = k(a);
      k(o),
        u.GOM.thumbnails2Display.forEach(function (e) {
          !(function (e, t) {
            function n(e, t) {
              return Math.floor(Math.random() * (t - e + 1) + e);
            }
            var i = {},
              a = {};
            switch (u.tn.opt.Get("displayTransition")) {
              case "RANDOMSCALE": {
                for (var o = n(0, 3); o == u.GOM.lastRandomValue; ) o = n(0, 3);
                u.GOM.lastRandomValue = o;
                let t = [0.95, 1, 1.05, 1.1][o];
                e.$elt.css({
                  "z-index": u.GOM.lastZIndex + [1, 2, 3, 4][o],
                  "box-shadow": "0px 0px 5px 3px rgba(0,0,0,0.74)",
                }),
                  (i = { scale: 0.5, opacity: 0 }),
                  (a = { scale: t, opacity: 1 });
                break;
              }
              case "SCALEUP": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 0.6),
                  (i = { scale: e, opacity: 0 }),
                  (a = { scale: 1, opacity: 1 });
                break;
              }
              case "SCALEDOWN": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 1.3),
                  (i = { scale: e, opacity: 0 }),
                  (a = { scale: 1, opacity: 1 });
                break;
              }
              case "SLIDEUP": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 50),
                  (i = { opacity: 0, translateY: e }),
                  (a = { opacity: 1, translateY: 0 });
                break;
              }
              case "SLIDEDOWN": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = -50),
                  (i = { opacity: 0, translateY: e }),
                  (a = { opacity: 1, translateY: 0 });
                break;
              }
              case "FLIPUP": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 100),
                  (i = { opacity: 0, translateY: e, rotateX: 45 }),
                  (a = { opacity: 1, translateY: 0, rotateX: 0 });
                break;
              }
              case "FLIPDOWN": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = -100),
                  (i = { opacity: 0, translateY: e, rotateX: -45 }),
                  (a = { opacity: 1, translateY: 0, rotateX: 0 });
                break;
              }
              case "SLIDEUP2": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 100),
                  (i = { opacity: 0, translateY: e, rotateY: 40 }),
                  (a = { opacity: 1, translateY: 0, rotateY: 0 });
                break;
              }
              case "IMAGESLIDEUP":
                (i = { opacity: 0, top: "100%" }),
                  (a = { opacity: 1, top: "0%" });
                break;
              case "SLIDEDOWN2": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = -100),
                  (i = { opacity: 0, translateY: e, rotateY: 40 }),
                  (a = { opacity: 1, translateY: 0, rotateY: 0 });
                break;
              }
              case "SLIDERIGHT": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = -150),
                  (i = { opacity: 0, translateX: e }),
                  (a = { opacity: 1, translateX: 0 });
                break;
              }
              case "SLIDELEFT": {
                let e = u.tn.opt.Get("displayTransitionStartVal");
                0 == e && (e = 150),
                  (i = { opacity: 0, translateX: e }),
                  (a = { opacity: 1, translateX: 0 });
                break;
              }
              case "FADEIN":
                (i = { opacity: 0 }), (a = { opacity: 1 });
            }
            var r = new NGTweenable();
            r.tween({
              from: i,
              to: a,
              attachment: { $e: e.$elt, item: e, tw: r },
              delay: t,
              duration: u.tn.opt.Get("displayTransitionDuration"),
              easing: u.tn.opt.Get("displayTransitionEasing"),
              step: function (e, t) {
                window.requestAnimationFrame(function () {
                  if (null !== t.item.$elt)
                    switch (u.tn.opt.Get("displayTransition")) {
                      case "RANDOMSCALE":
                      case "SCALEUP":
                        t.$e
                          .css(u.CSStransformName, "scale(" + e.scale + ")")
                          .css("opacity", e.opacity);
                        break;
                      case "SCALEDOWN":
                        t.item.$elt.last().css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "scale",
                            e.scale
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "SLIDEUP":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            "0px, " + e.translateY + "px"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "SLIDEDOWN":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            "0px," + e.translateY + "px"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "FLIPUP":
                        t.item.CSSTransformSet(
                          ".nGY2GThumbnail",
                          "translate",
                          "0px," + e.translateY + "px"
                        ),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "rotateX",
                            e.rotateX + "deg"
                          ),
                          t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "FLIPDOWN":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            "0px," + e.translateY + "px"
                          ),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "rotateX",
                            e.rotateX + "deg"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "SLIDEUP2":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            "0px," + e.translateY + "px"
                          ),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "rotateY",
                            e.rotateY + "deg"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "IMAGESLIDEUP":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.$Elts[".nGY2GThumbnailImage"].css(
                            "top",
                            e.top
                          );
                        break;
                      case "SLIDEDOWN2":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            "0px, " + e.translateY + "px"
                          ),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "rotateY",
                            e.rotateY + "deg"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "SLIDERIGHT":
                        t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "translate",
                            e.translateX + "px, 0px"
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "SLIDELEFT":
                        t.item.CSSTransformSet(
                          ".nGY2GThumbnail",
                          "translate",
                          e.translateX + "px, 0px"
                        ),
                          t.item.$elt.css("opacity", e.opacity),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "FADEIN":
                        t.$e.css(e);
                    }
                  else t.tw.stop(!1);
                });
              },
              finish: function (e, t) {
                window.requestAnimationFrame(function () {
                  if (null !== t.item.$elt) {
                    switch (u.tn.opt.Get("displayTransition")) {
                      case "RANDOMSCALE":
                        t.$e
                          .css(u.CSStransformName, "scale(" + e.scale + ")")
                          .css("opacity", "");
                        break;
                      case "SCALEUP":
                        t.$e.css(u.CSStransformName, "").css("opacity", "");
                        break;
                      case "SCALEDOWN":
                        t.item.$elt.last().css("opacity", ""),
                          t.item.CSSTransformSet(
                            ".nGY2GThumbnail",
                            "scale",
                            e.scale
                          ),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      case "IMAGESLIDEUP":
                        t.item.$elt.css("opacity", ""),
                          t.item.$Elts[".nGY2GThumbnailImage"].css("top", 0);
                        break;
                      case "SLIDEDOWN2":
                        t.item.$elt.css("opacity", ""),
                          t.item.CSSTransformApply(".nGY2GThumbnail");
                        break;
                      default:
                        t.item.$elt.css("opacity", "");
                    }
                    B(t.item);
                  }
                });
              },
            });
          })(e.itm, e.d);
        }),
        (u.GOM.thumbnails2Display = []),
        "NONE" == u.tn.opt.Get("displayTransition")
          ? ((u.galleryResizeEventEnabled = !0), at("galleryDisplayed"))
          : requestTimeout(function () {
              (u.galleryResizeEventEnabled = !0), at("galleryDisplayed");
            }, c * u.tn.opt.Get("displayInterval"));
    }
    function k(e) {
      var t = e.length;
      if (0 == t) return 0;
      var n = u.tn.opt.Get("displayOrder");
      if (
        ("random" == n
          ? NGY2Tools.AreaShuffle(e)
          : ("rowByRow" == n &&
              "JUSTIFIED" != u.layout.engine &&
              "GRID" != u.layout.engine &&
              (n = ""),
            ("colFromRight" != n && "colFromLeft" != n) ||
              "CASCADING" == u.layout.engine ||
              "GRID" == u.layout.engine ||
              (n = "")),
        "colFromRight" == n || "colFromLeft" == n)
      ) {
        for (var i = [], a = [], o = 0; o < t; o++)
          null == i[e[o].left] && ((i[e[o].left] = []), a.push(e[o].left)),
            i[e[o].left].push(e[o].idx);
        "colFromRight" == n && (a = a.reverse());
        for (o = 0; o < a.length; o++)
          for (var r = a[o], l = 0; l < i[r].length; l++) D(i[r][l], o);
        return o;
      }
      var s = 0,
        c = e[0].top;
      for (o = 0; o < t; o++)
        "rowByRow" == n ? e[o].top > c && (s++, (c = e[o].top)) : s++,
          D(e[o].idx, s);
      return s;
    }
    function D(e, t) {
      var n = 0,
        i = u.GOM.items[e],
        a = u.GOM.items[e].thumbnailIdx,
        o = u.I[a];
      if (i.neverDisplayed) {
        var r = i.top - u.GOM.clipArea.top;
        if (
          (u.tn.opt.Get("stacks") > 0
            ? (o.$elt.last().css({ display: "block" }),
              o.$elt.css({ top: r, left: i.left }))
            : o.$elt.css({ display: "block", top: r, left: i.left }),
          (n = r),
          !0 === u.O.thumbnailWaitImageLoaded)
        )
          ngimagesLoaded(o.$getElt(".nGY2TnImg2")).on(
            "progress",
            function (e, t) {
              if (
                t.isLoaded &&
                t.img.getAttribute("data-albumidx") == u.GOM.albumIdx
              ) {
                var n = t.img.getAttribute("data-idx");
                u.I[n].ThumbnailImageReveal();
              }
            }
          );
        !(function (e, t) {
          var n = u.GOM.items[e],
            i = u.I[n.thumbnailIdx];
          if ("NONE" == u.tn.opt.Get("displayTransition"))
            i.$elt.css({ opacity: 1 }), B(i);
          else {
            if (null == i.$elt) return;
            var a =
                u.GOM.cache.containerOffset.top + (n.top - u.GOM.clipArea.top),
              o = u.GOM.cache.viewport;
            if (
              a + (n.top - u.GOM.clipArea.top) >= o.t - 50 &&
              a <= o.t + o.h + 50
            ) {
              var r = t * u.tn.opt.Get("displayInterval");
              return void ("CUSTOM" == u.tn.opt.Get("displayTransition")
                ? "lN" == u.GOM.curNavLevel
                  ? u.O.fnThumbnailDisplayEffect(i.$elt, i, e, r)
                  : u.O.fnThumbnailL1DisplayEffect(i.$elt, i, e, r)
                : u.GOM.thumbnails2Display.push({ itm: i, d: r }));
            }
            i.$elt.css({ opacity: 1 }), B(i);
          }
        })(e, t),
          (i.displayed = !0),
          (i.neverDisplayed = !1);
      } else {
        var l = u.GOM.cache.containerOffset.top + o.top;
        r = u.GOM.cache.containerOffset.top + (i.top - u.GOM.clipArea.top);
        n = i.top - u.GOM.clipArea.top;
        var s = u.GOM.cache.viewport;
        if (
          u.O.thumbnailDisplayOutsideScreen ||
          (l + i.height >= s.t - s.h && l <= s.t + 4 * s.h) ||
          (r + i.height >= s.t - s.h && r <= s.t + 4 * s.h)
        )
          if (i.displayed) {
            if (o.top != i.top || o.left != i.left)
              if (1 == u.O.galleryResizeAnimation)
                new NGTweenable().tween({
                  from: {
                    top: o.top,
                    left: o.left,
                    height: o.height,
                    width: o.width,
                  },
                  to: {
                    top: n,
                    left: i.left,
                    height: i.height,
                    width: i.width,
                  },
                  attachment: { $e: o.$elt },
                  duration: 100,
                  delay: (t * u.tn.opt.Get("displayInterval")) / 5,
                  easing: "easeOutQuart",
                  step: function (e, t) {
                    t.$e.css(e);
                  },
                  finish: function (e, t) {
                    this.dispose();
                  },
                });
              else o.$elt.css({ top: n, left: i.left });
          } else
            (i.displayed = !0),
              o.$elt.css({
                display: "block",
                top: n,
                left: i.left,
                opacity: 1,
              }),
              B(o);
        else (i.displayed = !1), o.$elt.css({ display: "none" });
      }
      if (
        ((o.left = i.left),
        (o.top = n),
        (o.width == i.width && o.height == i.height) ||
          (o.$elt.css({ width: i.width, height: i.height }),
          (o.width = i.width),
          (o.height = i.height),
          (o.resizedContentWidth == i.resizedContentWidth &&
            o.resizedContentHeight == i.resizedContentHeight) ||
            ("albumUp" == o.kind ||
              (o
                .$getElt(".nGY2GThumbnailImage")
                .css({
                  height: i.resizedContentHeight,
                  width: i.resizedContentWidth,
                }),
              "JUSTIFIED" == u.layout.engine &&
                o
                  .$getElt(".nGY2GThumbnailImg")
                  .css({
                    height: i.resizedContentHeight,
                    width: i.resizedContentWidth,
                  })),
            (o.resizedContentWidth = i.resizedContentWidth),
            (o.resizedContentHeight = i.resizedContentHeight))),
        u.GOM.lastDisplayedIdxNew == e &&
          u.layout.support.rows &&
          (("ROWS" == u.galleryDisplayMode.Get() &&
            u.galleryMaxRows.Get() > 0) ||
            ("FULLCONTENT" == u.galleryDisplayMode.Get() &&
              u.galleryLastRowFull.Get() &&
              -1 != u.GOM.lastFullRow)))
      ) {
        var c = u.GOM.items.length - e - 1;
        "0" != o.albumID && u.O.thumbnailLevelUp && c--,
          c > 0
            ? ((u.O.thumbnailOpenInLightox || u.O.thumbnailSliderDelay > 0) &&
                o.$getElt(".nGY2GThumbnailIconsFullThumbnail").html("+" + c),
              "right" != u.O.thumbnailLabel.get("position") &&
                "left" != u.O.thumbnailLabel.get("position") &&
                u.GOM.slider.hostItem != u.GOM.NGY2Item(e) &&
                (V(u.GOM.slider.hostItem),
                (u.GOM.slider.hostIdx = e),
                (u.GOM.slider.hostItem = u.GOM.NGY2Item(e)),
                (u.GOM.slider.nextIdx = e),
                (u.GOM.slider.currentIdx = e),
                (function () {
                  if (
                    0 == u.O.thumbnailSliderDelay ||
                    -1 == u.GOM.slider.hostIdx
                  )
                    return;
                  clearTimeout(u.GOM.slider.timerID);
                  var e = u.GOM.slider.hostItem;
                  0 == e.$getElt(".nGY2TnImgNext").length &&
                    (e
                      .$getElt(".nGY2TnImg")
                      .clone()
                      .removeClass("nGY2TnImg")
                      .addClass("nGY2TnImgNext")
                      .insertAfter(e.$getElt(".nGY2TnImg")),
                    e
                      .$getElt(".nGY2TnImgBack")
                      .clone()
                      .removeClass("nGY2TnImgBack")
                      .addClass("nGY2TnImgBackNext")
                      .insertAfter(e.$getElt(".nGY2TnImg", !0)),
                    e.$getElt(".nGY2GThumbnailImage", !0),
                    e.$getElt(".nGY2GThumbnailImg", !0));
                  e.CSSTransformSet(".nGY2TnImgNext", "translateX", "100%", !0),
                    e.CSSTransformApply(".nGY2TnImgNext"),
                    e.CSSTransformSet(
                      ".nGY2TnImgBackNext",
                      "translateX",
                      "100%",
                      !0
                    ),
                    e.CSSTransformApply(".nGY2TnImgBackNext"),
                    N(),
                    (u.GOM.slider.timerID = requestTimeout(function () {
                      !(function e() {
                        if (null != u.GOM.slider.hostItem.$getElt()) {
                          var t = new NGTweenable();
                          (u.GOM.slider.tween = t),
                            t.tween({
                              from: { left: 100 },
                              to: { left: 0 },
                              duration: 800,
                              delay: 0,
                              easing: "easeOutQuart",
                              step: function (e) {
                                null != u.GOM.slider.hostItem.$getElt()
                                  ? (u.GOM.slider.hostItem.CSSTransformSet(
                                      ".nGY2TnImgBack",
                                      "translateX",
                                      -(100 - e.left) + "%"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformApply(
                                      ".nGY2TnImgBack"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformSet(
                                      ".nGY2TnImg",
                                      "translateX",
                                      -(100 - e.left) + "%"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformApply(
                                      ".nGY2TnImg"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformSet(
                                      ".nGY2TnImgBackNext",
                                      "translateX",
                                      e.left + "%"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformApply(
                                      ".nGY2TnImgBackNext"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformSet(
                                      ".nGY2TnImgNext",
                                      "translateX",
                                      e.left + "%"
                                    ),
                                    u.GOM.slider.hostItem.CSSTransformApply(
                                      ".nGY2TnImgNext"
                                    ))
                                  : u.GOM.slider.tween.stop(!1);
                              },
                              finish: function (t) {
                                null != u.GOM.slider.hostItem.$getElt() &&
                                  null !=
                                    u.GOM.NGY2Item(u.GOM.slider.nextIdx) &&
                                  (V(u.GOM.NGY2Item(u.GOM.slider.nextIdx)),
                                  (u.GOM.slider.currentIdx =
                                    u.GOM.slider.nextIdx),
                                  N(),
                                  clearTimeout(u.GOM.slider.timerID),
                                  (u.GOM.slider.timerID = requestTimeout(
                                    function () {
                                      e();
                                    },
                                    u.O.thumbnailSliderDelay
                                  )));
                              },
                            });
                        }
                      })();
                    }, u.O.thumbnailSliderDelay));
                })()))
            : (V(u.GOM.slider.hostItem), (u.GOM.slider.hostIdx = -1)),
          (u.GOM.lastDisplayedIdx = e);
      }
    }
    function N() {
      u.GOM.slider.nextIdx++,
        u.GOM.slider.nextIdx >= u.GOM.items.length &&
          (u.GOM.slider.nextIdx = u.GOM.slider.hostIdx);
      var e = u.GOM.NGY2Item(u.GOM.slider.nextIdx),
        t = "url('" + u.emptyGif + "')";
      null != e.imageDominantColors &&
        (t = "url('" + e.imageDominantColors + "')"),
        u.GOM.slider.hostItem
          .$getElt(".nGY2TnImgBackNext", !0)
          .css({ "background-image": t, opacity: 1 }),
        u.GOM.slider.hostItem
          .$getElt(".nGY2TnImgNext", !0)
          .css({
            "background-image": "url('" + e.thumbImg().src + "')",
            opacity: 1,
          }),
        u.GOM.slider.hostItem
          .$getElt(".nGY2TnImgNext .nGY2GThumbnailImg", !0)
          .attr("src", e.thumbImg().src);
    }
    function V(e) {
      if (-1 != u.GOM.slider.hostIdx) {
        null != u.GOM.slider.tween &&
          1 == u.GOM.slider.tween._isTweening &&
          u.GOM.slider.tween.stop(!1);
        var t = "url('" + u.emptyGif + "')";
        if (
          (null != e.imageDominantColors &&
            (t = "url('" + e.imageDominantColors + "')"),
          u.GOM.slider.hostItem
            .$getElt(".nGY2TnImgBack")
            .css("background-image", t),
          u.GOM.slider.hostItem
            .$getElt(".nGY2TnImg")
            .css("background-image", "url('" + e.thumbImg().src + "')"),
          u.GOM.slider.hostItem
            .$getElt(".nGY2TnImg .nGY2GThumbnailImg")
            .attr("src", e.thumbImg().src),
          u.GOM.slider.hostItem.CSSTransformSet(
            ".nGY2TnImgBack",
            "translateX",
            "0"
          ),
          u.GOM.slider.hostItem.CSSTransformApply(".nGY2TnImgBack"),
          u.GOM.slider.hostItem.CSSTransformSet(
            ".nGY2TnImg",
            "translateX",
            "0"
          ),
          u.GOM.slider.hostItem.CSSTransformApply(".nGY2TnImg"),
          u.GOM.slider.hostItem.CSSTransformSet(
            ".nGY2TnImgBackNext",
            "translateX",
            "100%",
            !0
          ),
          u.GOM.slider.hostItem.CSSTransformApply(".nGY2TnImgBackNext"),
          u.GOM.slider.hostItem.CSSTransformSet(
            ".nGY2TnImgNext",
            "translateX",
            "100%",
            !0
          ),
          u.GOM.slider.hostItem.CSSTransformApply(".nGY2TnImgNext"),
          1 == u.O.thumbnailLabel.get("display"))
        ) {
          var n = u.O.icons.thumbnailAlbum;
          "album" != e.kind && (n = u.O.icons.thumbnailImage),
            u.GOM.slider.hostItem
              .$getElt(".nGY2GThumbnailTitle")
              .html(n + $(e)),
            u.GOM.slider.hostItem
              .$getElt(".nGY2GThumbnailDescription")
              .html(n + F(e));
        }
      }
    }
    function Y(e) {
      var t = u.tn.opt.Get("stacks");
      if (0 == t) return "";
      for (var n = "", i = 0; i < t; i++)
        n =
          '<div class="nGY2GThumbnailStack " style="display:none;' +
          e +
          '"></div>' +
          n;
      return n;
    }
    function A(e, t, n) {
      if (
        ((e.eltTransform = []),
        (e.eltFilter = []),
        (e.hoverInitDone = !1),
        (e.$Elts = []),
        "albumUp" != e.kind)
      ) {
        var i = [],
          a = 0,
          o = "";
        !1 === u.O.thumbnailOpenInLightox && (o = "cursor:default;");
        var r = e.thumbImg().src.replace(/'/g, "%27"),
          l = $(e),
          s = "",
          c = "background-image: url('" + u.emptyGif + "');";
        null != e.imageDominantColors
          ? (c = "background-image: url('" + e.imageDominantColors + "');")
          : null != e.imageDominantColor
          ? (s = "background-color:" + e.imageDominantColor + ";")
          : (c = "");
        var h = "opacity:1;";
        1 == u.O.thumbnailWaitImageLoaded && (h = "opacity:0;"),
          (i[a++] =
            Y(s) +
            '<div class="nGY2GThumbnail nGY2GThumbnail_' +
            u.GOM.curNavLevel +
            '" style="display:none;opacity:0;' +
            o +
            '"><div class="nGY2GThumbnailSub ' +
            (u.O.thumbnailSelectable && e.selected
              ? "nGY2GThumbnailSubSelected"
              : "") +
            '">');
        var d = u.tn.settings.getW(),
          m = u.tn.settings.getH();
        null !== u.tn.settings.getMosaic() &&
          ((d = u.GOM.items[n].width), (m = u.GOM.items[n].height));
        var p = "contain";
        u.tn.opt.Get("crop") && (p = "cover");
        var g =
          "position: absolute; top: 0px; left: 0px; width:" +
          d +
          "px; height:" +
          m +
          "px;" +
          s +
          c +
          " background-position: center center;  background-repeat: no-repeat; background-size:" +
          p +
          "; overflow: hidden;";
        i[a++] =
          '<div class="nGY2GThumbnailImage nGY2TnImgBack" style="' +
          g +
          '"></div>';
        var f =
          h +
          "position: absolute; top: 0px; left: 0px; width:" +
          d +
          "px; height:" +
          m +
          "px; background-image: url('" +
          r +
          "'); background-position: center center; background-repeat: no-repeat; background-size:" +
          p +
          "; overflow: hidden;";
        (i[a++] =
          '<div class="nGY2GThumbnailImage nGY2TnImg" style="' + f + '">'),
          (i[a++] =
            '  <img class="nGY2GThumbnailImg nGY2TnImg2" src="' +
            r +
            '" alt="' +
            l +
            '" style="opacity:0;" data-idx="' +
            t +
            '" data-albumidx="' +
            u.GOM.albumIdx +
            '" >'),
          (i[a++] = "</div>"),
          (i[a++] = '<div class="nGY2GThumbnailCustomLayer"></div>'),
          1 == u.O.thumbnailLabel.get("display") &&
            ((i[a++] =
              '  <div class="nGY2GThumbnailLabel" ' +
              u.tn.style.getLabel(e) +
              ">"),
            "album" == e.kind
              ? (i[a++] =
                  '    <div class="nGY2GThumbnailTitle nGY2GThumbnailAlbumTitle" ' +
                  u.tn.style.getTitle() +
                  ">" +
                  u.O.icons.thumbnailAlbum +
                  l +
                  "</div>")
              : (i[a++] =
                  '    <div class="nGY2GThumbnailTitle nGY2GThumbnailImageTitle" ' +
                  u.tn.style.getTitle() +
                  ">" +
                  u.O.icons.thumbnailImage +
                  l +
                  "</div>"),
            (i[a++] =
              '    <div class="nGY2GThumbnailDescription" ' +
              u.tn.style.getDesc() +
              ">" +
              F(e) +
              "</div>"),
            (i[a++] = "  </div>")),
          (i[a++] = (function (e) {
            var t =
              _(e, "topLeft") +
              _(e, "topRight") +
              _(e, "bottomLeft") +
              _(e, "bottomRight");
            return (t +=
              '<div class="nGY2GThumbnailIconsFullThumbnail"></div>');
          })(e)),
          (i[a++] = "</div></div>");
        var b = jQuery(i.join("")).appendTo(u.$E.conTn);
        (e.$elt = b),
          b.data("index", n),
          e.$getElt(".nGY2GThumbnailImg").data("index", n);
        var v = u.O.fnThumbnailInit;
        null !== v &&
          ("function" == typeof v ? v(b, e, n) : window[v](b, e, n)),
          "image gallery by nanogallery2 [build]" != e.title && H(n);
      } else
        !(function (e, t) {
          var n = [],
            i = 0,
            a = "";
          !1 === u.O.thumbnailOpenInLightox && (a = "cursor:default;"),
            (n[i++] =
              Y("") +
              '<div class="nGY2GThumbnail" style="display:none;opacity:0;' +
              a +
              '" >'),
            (n[i++] = '  <div class="nGY2GThumbnailSub">');
          var o = u.tn.defaultSize.getHeight(),
            r = u.tn.defaultSize.getWidth();
          (n[i++] =
            '    <div class="nGY2GThumbnailImage" style="width:' +
            r +
            "px;height:" +
            o +
            'px;"><img class="nGY2GThumbnailImg" src="' +
            u.emptyGif +
            '" alt="" style="max-width:' +
            r +
            "px;max-height:" +
            o +
            'px;" ></div>'),
            (n[i++] =
              '    <div class="nGY2GThumbnailAlbumUp" >' +
              u.O.icons.thumbnailAlbumUp +
              "</div>"),
            (n[i++] = "  </div>"),
            (n[i++] = "</div>");
          var l = jQuery(n.join("")).appendTo(u.$E.conTn);
          (e.$elt = l),
            l.data("index", t),
            e.$getElt(".nGY2GThumbnailImg").data("index", t);
        })(e, n);
    }
    function _(e, t) {
      var n = "",
        i = u.tn.toolbar.get(e),
        a = { xs: 0, sm: 1, me: 2, la: 3, xl: 4 },
        o = 0;
      if ("" != i[t]) {
        var r = "top: 0; right: 0; text-align: right;";
        switch (t) {
          case "topLeft":
            r = "top: 0; left: 0; text-align: left;";
            break;
          case "bottomRight":
            r = "bottom: 0; right: 0; text-align: right;";
            break;
          case "bottomLeft":
            r = "bottom: 0; left: 0; text-align: left;";
        }
        n += '  <ul class="nGY2GThumbnailIcons" style="' + r + '">';
        for (var l = i[t].split(","), s = l.length, c = 0; c < s; c++) {
          var h = l[c].replace(/^\s*|\s*$/, ""),
            d = h.substring(0, 2).toLowerCase(),
            m = h,
            p = !0;
          if (
            (/xs|sm|me|la|xl/i.test(d) &&
              (a[d] > a[u.GOM.curWidth] && (p = !1), (m = h.substring(2))),
            p)
          ) {
            var g = c + 1 < s ? "&nbsp;" : "";
            switch (m) {
              case "COUNTER":
                "album" == e.kind &&
                  ((n +=
                    '    <li class="nGY2GThumbnailIcon" data-ngy2action="">'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconImageCounter"></div>'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconText">' +
                    u.O.icons.thumbnailCounter +
                    Math.max(e.getContentLength(!1), e.numberItems) +
                    g +
                    "</div>"),
                  (n += "    </li>"),
                  o++);
                break;
              case "COUNTER2":
                "album" == e.kind &&
                  ((n +=
                    '    <li class="nGY2GThumbnailIcon" data-ngy2action="">'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconTextBadge">' +
                    u.O.icons.thumbnailCounter +
                    Math.max(e.getContentLength(!1), e.numberItems) +
                    g +
                    "</div>"),
                  (n += "    </li>"),
                  o++);
                break;
              case "SHARE":
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="' +
                  m +
                  '">'),
                  (n += "      <div>" + u.O.icons.thumbnailShare + "</div>"),
                  (n += "    </li>"),
                  o++;
                break;
              case "DOWNLOAD":
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="' +
                  m +
                  '">'),
                  (n += "      <div>" + u.O.icons.thumbnailDownload + "</div>"),
                  (n += "    </li>"),
                  o++;
                break;
              case "INFO":
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="' +
                  m +
                  '">'),
                  (n += "      <div>" + u.O.icons.thumbnailInfo + "</div>"),
                  (n += "    </li>"),
                  o++;
                break;
              case "SHOPPINGCART":
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="' +
                  m +
                  '">'),
                  (n += P(e)),
                  (n += "    </li>"),
                  o++;
                break;
              case "DISPLAY":
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="DISPLAY">'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconImageShare">' +
                    u.O.icons.thumbnailDisplay +
                    "</div>"),
                  (n += "    </li>"),
                  o++;
                break;
              case "CUSTOM1":
              case "CUSTOM2":
              case "CUSTOM3":
              case "CUSTOM4":
              case "CUSTOM5":
              case "CUSTOM6":
              case "CUSTOM7":
              case "CUSTOM8":
              case "CUSTOM9":
              case "CUSTOM10":
                var f = m.replace("CUSTOM", "");
                (n +=
                  '    <li class="nGY2GThumbnailIcon" data-ngy2action="' +
                  m.toLowerCase() +
                  '">'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconImageShare">' +
                    u.O.icons["thumbnailCustomTool" + f] +
                    "</div>"),
                  (n += "    </li>"),
                  o++;
                break;
              case "FEATURED":
                !0 === e.featured &&
                  ((n +=
                    '    <li class="nGY2GThumbnailIcon" data-ngy2action="">'),
                  (n +=
                    '      <div class="nGY2GThumbnailIconImageFeatured">' +
                    u.O.icons.thumbnailFeatured +
                    "</div>"),
                  (n += "    </li>"),
                  o++);
                break;
              case "SELECT":
                1 == u.O.thumbnailSelectable &&
                  ((n +=
                    '    <li class="nGY2GThumbnailIcon" data-ngy2action="TOGGLESELECT">'),
                  !0 === e.selected
                    ? (n +=
                        '      <div class="nGY2GThumbnailIconImageSelect nGY2ThumbnailSelected">' +
                        u.O.icons.thumbnailSelected +
                        "</div>")
                    : (n +=
                        '      <div class="nGY2GThumbnailIconImageSelect nGY2ThumbnailUnselected">' +
                        u.O.icons.thumbnailUnselected +
                        "</div>"),
                  (n += "    </li>"),
                  o++);
            }
          }
        }
        n += "  </ul>";
      }
      return o > 0 ? n : "";
    }
    function P(e) {
      for (var t = 0, n = e.GetID(), i = 0; i < u.shoppingCart.length; i++)
        u.I[u.shoppingCart[i].idx].GetID() == n && (t = u.shoppingCart[i].qty);
      return (
        0 == t && (t = ""),
        "      <div>" + u.O.icons.thumbnailShoppingcart + t + "</div>"
      );
    }
    function R(e) {
      var t = e.$elt;
      if (null != t) {
        var n = t.find('*[data-ngy2action="SHOPPINGCART"]');
        void 0 !== n && n.html(P(e));
      }
    }
    function $(e) {
      var t = e.title;
      if (1 == u.O.thumbnailLabel.get("display")) {
        (void 0 !== t && 0 != t.length) || (t = "&nbsp;"),
          "" != u.i18nTranslations.thumbnailImageTitle &&
            (t = u.i18nTranslations.thumbnailImageTitle);
        var n = u.O.thumbnailLabel.get("titleMaxLength");
        n > 3 && t.length > n && (t = t.substring(0, n) + "...");
      }
      return t;
    }
    function F(e) {
      var t = "";
      if (1 == u.O.thumbnailLabel.get("displayDescription")) {
        t =
          "album" == e.kind
            ? "" != u.i18nTranslations.thumbnailImageDescription
              ? u.i18nTranslations.thumbnailAlbumDescription
              : e.description
            : "" != u.i18nTranslations.thumbnailImageDescription
            ? u.i18nTranslations.thumbnailImageDescription
            : e.description;
        var n = u.O.thumbnailLabel.get("descriptionMaxLength");
        n > 3 && t.length > n && (t = t.substring(0, n) + "..."),
          0 == t.length && (t = "&nbsp;");
      }
      return t;
    }
    function z(e) {
      var t = u.tn.defaultSize.getOuterWidth(),
        n = 0;
      return (
        (n =
          "justified" == u.O.thumbnailAlignment
            ? Math.floor(e / t)
            : Math.floor(
                (e + u.tn.settings.GetResponsive("gutterWidth")) /
                  (t + u.tn.settings.GetResponsive("gutterWidth"))
              )),
        u.O.maxItemsPerLine > 0 &&
          n > u.O.maxItemsPerLine &&
          (n = u.O.maxItemsPerLine),
        n < 1 && (n = 1),
        n
      );
    }
    function B(e) {
      var t = u.tn.opt.Get("stacks");
      if (t > 0) {
        e.$elt.css({ display: "block" });
        for (var n = 0.9, i = t - 1; i >= 0; i--)
          e.$elt.eq(i).css("opacity", n), (n -= 0.2);
      }
    }
    function H(e) {
      var t = u.GOM.items[e],
        n = u.I[t.thumbnailIdx];
      if (null != n.$elt) {
        var i = u.O.fnThumbnailHoverInit;
        null !== i &&
          ("function" == typeof i ? i($e, n, e) : window[i]($e, n, e));
        for (var a = u.tn.buildInit.get(), o = 0; o < a.length; o++)
          switch (a[o].property) {
            case "scale":
            case "rotateX":
            case "rotateY":
            case "rotateZ":
            case "translateX":
            case "translateY":
            case "translateZ":
              n.CSSTransformSet(a[o].element, a[o].property, a[o].value),
                n.CSSTransformApply(a[o].element);
              break;
            case "blur":
            case "brightness":
            case "grayscale":
            case "sepia":
            case "contrast":
            case "opacity":
            case "saturate":
              n.CSSFilterSet(a[o].element, a[o].property, a[o].value),
                n.CSSFilterApply(a[o].element);
              break;
            default:
              n.$getElt(a[o].element).css(a[o].property, a[o].value);
          }
        var r = u.tn.hoverEffects.get();
        for (o = 0; o < r.length; o++)
          if (!0 === r[o].firstKeyframe)
            switch (r[o].type) {
              case "scale":
              case "rotateX":
              case "rotateY":
              case "rotateZ":
              case "translateX":
              case "translateY":
              case "translateZ":
                n.CSSTransformSet(r[o].element, r[o].type, r[o].from),
                  n.CSSTransformApply(r[o].element);
                break;
              case "blur":
              case "brightness":
              case "grayscale":
              case "sepia":
              case "contrast":
              case "opacity":
              case "saturate":
                n.CSSFilterSet(r[o].element, r[o].type, r[o].from),
                  n.CSSFilterApply(r[o].element);
                break;
              default:
                n.$getElt(r[o].element).css(r[o].type, r[o].from);
            }
        n.hoverInitDone = !0;
      }
    }
    function U() {
      if (-1 != u.GOM.albumIdx)
        for (var e = u.GOM.items.length, t = 0; t < e; t++)
          H(t), (u.I[u.GOM.items[t].thumbnailIdx].hovered = !1);
    }
    function W(e) {
      if (
        -1 != u.GOM.albumIdx &&
        u.galleryResizeEventEnabled &&
        u.GOM.slider.hostIdx != e
      ) {
        var t = u.GOM.items[e],
          n = u.I[t.thumbnailIdx];
        if ("albumUp" != n.kind && null != n.$elt) {
          n.hovered = !0;
          var i = u.O.fnThumbnailHover;
          null !== i &&
            ("function" == typeof i
              ? i(n.$elt, n, e)
              : window[i](n.$elt, n, e));
          var a = u.tn.hoverEffects.get();
          try {
            for (var o = 0; o < a.length; o++)
              !0 === a[o].hoverin && n.animate(a[o], 0, !0);
          } catch (e) {
            h(u, "error on hover: " + e.message);
          }
        }
      }
    }
    function j() {
      if (-1 != u.GOM.albumIdx)
        for (var e = u.GOM.items.length, t = 0; t < e; t++)
          u.GOM.items[t].inDisplayArea
            ? X(t)
            : (u.I[u.GOM.items[t].thumbnailIdx].hovered = !1);
    }
    function X(e) {
      if (
        -1 != u.GOM.albumIdx &&
        u.galleryResizeEventEnabled &&
        u.GOM.slider.hostIdx != e
      ) {
        var t = u.GOM.items[e],
          n = u.I[t.thumbnailIdx];
        if (
          "albumUp" != n.kind &&
          n.hovered &&
          ((n.hovered = !1), null != n.$elt)
        ) {
          var i = u.O.fnThumbnailHoverOut;
          null !== i &&
            ("function" == typeof i
              ? i(n.$elt, n, e)
              : window[i](n.$elt, n, e));
          var a = u.tn.hoverEffects.get();
          try {
            for (var o = 0; o < a.length; o++)
              !0 === a[o].hoverout && n.animate(a[o], 0, !1);
          } catch (e) {
            h(u, "error on hoverOut: " + e.message);
          }
        }
      }
    }
    function Q(e, t) {
      u.O.debugMode && console.log("#DisplayPhoto : " + t + "-" + e);
      var n = NGY2Item.GetIdx(u, t);
      (u.GOM.curNavLevel = 0 == n ? "l1" : "lN"),
        -1 == n && "" != u.O.kind && NGY2Item.New(u, "", "", t, "0", "album");
      var i = NGY2Item.GetIdx(u, e);
      -1 != i
        ? (u.O.debugMode && console.log("#DisplayPhoto : " + i), we(i))
        : q(t, Q, e, t);
    }
    function q(e, t, n, i) {
      switch (u.O.kind) {
        case "":
          !(function (e, t, n) {
            if (!0 === u.markupOrApiProcessed) return void g("-1", 0);
            if (void 0 !== u.O.items && null !== u.O.items) K();
            else {
              if (!(u.O.$markup.length > 0))
                return void d(u, "error: no media to process.");
              te(u.O.$markup), (u.O.$markup = []);
            }
            (u.markupOrApiProcessed = !0), null != e && e(t, n, null);
          })(t, n, i);
          break;
        default:
          jQuery.nanogallery2["data_" + u.O.kind](
            u,
            "AlbumGetContent",
            e,
            t,
            n,
            i
          );
      }
    }
    this.initiateGallery2 = function (e, t) {
      if (
        ((u.O = t),
        (u.$E.base = jQuery(e)),
        (u.baseEltID = u.$E.base.attr("id")),
        null == u.baseEltID)
      ) {
        for (var n = "", i = !0; i; )
          document.getElementById("my_nanogallery" + n)
            ? "" == n
              ? (n = 1)
              : n++
            : ((i = !1), (u.baseEltID = "my_nanogallery" + n));
        u.$E.base.attr("id", u.baseEltID);
      }
      if (
        ((u.O.$markup = []),
        (function () {
          ("PICASA" != u.O.kind.toUpperCase() &&
            "GOOGLE" != u.O.kind.toUpperCase()) ||
            (u.O.kind = "google2");
          (u.GOM.cache.viewport = a()),
            (u.GOM.curWidth = ht()),
            jQuery.extend(!0, u.tn.toolbar.image, u.O.thumbnailToolbarImage),
            jQuery.extend(!0, u.tn.toolbar.album, u.O.thumbnailToolbarAlbum);
          for (
            var e = ["image", "album"],
              t = ["topLeft", "topRight", "bottomLeft", "bottomRight"],
              n = 0;
            n < e.length;
            n++
          )
            for (var i = 0; i < t.length; i++)
              u.tn.toolbar[e[n]][t[i]] = u.tn.toolbar[e[n]][t[i]].toUpperCase();
          "overImageOnBottom" == u.O.thumbnailLabel.position &&
            ((u.O.thumbnailLabel.valign = "bottom"),
            (u.O.thumbnailLabel.position = "overImage"));
          "overImageOnMiddle" == u.O.thumbnailLabel.position &&
            ((u.O.thumbnailLabel.valign = "middle"),
            (u.O.thumbnailLabel.position = "overImage"));
          "overImageOnTop" == u.O.thumbnailLabel.position &&
            ((u.O.thumbnailLabel.valign = "top"),
            (u.O.thumbnailLabel.position = "overImage"));
          void 0 !== u.O.thumbnailL1Label &&
            void 0 !== u.O.thumbnailL1Label.position &&
            ("overImageOnBottom" == u.O.thumbnailL1Label.position &&
              ((u.O.thumbnailL1Label.valign = "bottom"),
              (u.O.thumbnailL1Label.position = "overImage")),
            "overImageOnMiddle" == u.O.thumbnailL1Label.position &&
              ((u.O.thumbnailL1Label.valign = "middle"),
              (u.O.thumbnailL1Label.position = "overImage")),
            "overImageOnTop" == u.O.thumbnailL1Label.position &&
              ((u.O.thumbnailL1Label.valign = "top"),
              (u.O.thumbnailL1Label.position = "overImage")));
          (u.O.thumbnailLabel.get = function (e) {
            return "l1" == u.GOM.curNavLevel &&
              void 0 !== u.O.thumbnailL1Label &&
              void 0 !== u.O.thumbnailL1Label[e]
              ? u.O.thumbnailL1Label[e]
              : u.O.thumbnailLabel[e];
          }),
            (u.O.thumbnailLabel.set = function (e, t) {
              "l1" == u.GOM.curNavLevel &&
              void 0 !== u.O.thumbnailL1Label &&
              void 0 !== u.O.thumbnailL1Label[e]
                ? (u.O.thumbnailL1Label[e] = t)
                : (u.O.thumbnailLabel[e] = t);
            }),
            "" != u.O.blockList &&
              (u.blockList = u.O.blockList.toUpperCase().split("|"));
          "" != u.O.allowList &&
            (u.allowList = u.O.allowList.toUpperCase().split("|"));
          if (
            void 0 !== u.O.albumList2 &&
            null !== u.O.albumList2 &&
            u.O.albumList2.constructor === Array
          ) {
            var o = u.O.albumList2.length;
            for (n = 0; n < o; n++) u.albumList.push(u.O.albumList2[n]);
          }
          void 0 !== u.O.albumList2 &&
            "string" == typeof u.O.albumList2 &&
            u.albumList.push(u.O.albumList2);
          function l(e, t, n) {
            (u.tn.opt.lN[n] = u.O[e]),
              (u.tn.opt.l1[n] = u.O[e]),
              "number" == r(u.O[t]) && (u.tn.opt.l1[n] = u.O[t]);
          }
          function s(e, t, n) {
            (u.tn.settings[e][t].xs = n),
              (u.tn.settings[e][t].sm = n),
              (u.tn.settings[e][t].me = n),
              (u.tn.settings[e][t].la = n),
              (u.tn.settings[e][t].xl = n);
          }
          function c(e, t, n) {
            var i = u.O[e];
            if (null != i)
              if ("number" == r(i) || -1 == i.indexOf(" ")) {
                var a = "auto";
                "auto" != i && (a = parseInt(i)), s(t, n, a);
              } else {
                var o = i.split(" ");
                if (o.length > 0 && +o[0] == +o[0]) {
                  a = "auto";
                  "auto" != o[0] && (a = parseInt(o[0])), s(t, n, a);
                }
                for (var l = 1; l < o.length; l++)
                  if (/^xs|sm|me|la|xl/i.test(o[l])) {
                    var c = o[l].substring(0, 2).toLowerCase(),
                      h = o[l].substring(2);
                    a = "auto";
                    "auto" != h && (a = parseInt(h)),
                      (u.tn.settings[t][n][c] = a);
                  }
              }
          }
          (u.tn.opt.lN.crop = u.O.thumbnailCrop),
            (u.tn.opt.l1.crop =
              null != u.O.thumbnailL1Crop
                ? u.O.thumbnailL1Crop
                : u.O.thumbnailCrop),
            l("thumbnailStacks", "thumbnailL1Stacks", "stacks"),
            l(
              "thumbnailStacksTranslateX",
              "thumbnailL1StacksTranslateX",
              "stacksTranslateX"
            ),
            l(
              "thumbnailStacksTranslateY",
              "thumbnailL1StacksTranslateY",
              "stacksTranslateY"
            ),
            l(
              "thumbnailStacksTranslateZ",
              "thumbnailL1StacksTranslateZ",
              "stacksTranslateZ"
            ),
            l(
              "thumbnailStacksRotateX",
              "thumbnailL1StacksRotateX",
              "stacksRotateX"
            ),
            l(
              "thumbnailStacksRotateY",
              "thumbnailL1StacksRotateY",
              "stacksRotateY"
            ),
            l(
              "thumbnailStacksRotateZ",
              "thumbnailL1StacksRotateZ",
              "stacksRotateZ"
            ),
            l("thumbnailStacksScale", "thumbnailL1StacksScale", "stacksScale"),
            l(
              "thumbnailBorderHorizontal",
              "thumbnailL1BorderHorizontal",
              "borderHorizontal"
            ),
            l(
              "thumbnailBorderVertical",
              "thumbnailL1BorderVertical",
              "borderVertical"
            ),
            l(
              "thumbnailBaseGridHeight",
              "thumbnailL1BaseGridHeight",
              "baseGridHeight"
            ),
            c("thumbnailGutterWidth", "gutterWidth", "lN"),
            c("thumbnailGutterWidth", "gutterWidth", "l1"),
            c("thumbnailL1GutterWidth", "gutterWidth", "l1"),
            c("thumbnailGutterHeight", "gutterHeight", "lN"),
            c("thumbnailGutterHeight", "gutterHeight", "l1"),
            c("thumbnailL1GutterHeight", "gutterHeight", "l1"),
            (u.galleryDisplayMode.lN = u.O.galleryDisplayMode.toUpperCase()),
            (u.galleryDisplayMode.l1 =
              null != u.O.galleryL1DisplayMode
                ? u.O.galleryL1DisplayMode.toUpperCase()
                : u.O.galleryDisplayMode.toUpperCase()),
            (u.galleryMaxRows.lN = u.O.galleryMaxRows),
            (u.galleryMaxRows.l1 =
              "number" == r(u.O.galleryL1MaxRows)
                ? u.O.galleryL1MaxRows
                : u.O.galleryMaxRows),
            (u.galleryLastRowFull.lN = u.O.galleryLastRowFull),
            (u.galleryLastRowFull.l1 =
              null != u.O.galleryL1LastRowFull
                ? u.O.galleryL1LastRowFull
                : u.O.galleryLastRowFull),
            (u.gallerySorting.lN = u.O.gallerySorting.toUpperCase()),
            (u.gallerySorting.l1 =
              null != u.O.galleryL1Sorting
                ? u.O.galleryL1Sorting.toUpperCase()
                : u.gallerySorting.lN),
            (u.galleryDisplayTransition.lN =
              u.O.galleryDisplayTransition.toUpperCase()),
            (u.galleryDisplayTransition.l1 =
              null != u.O.galleryL1DisplayTransition
                ? u.O.galleryL1DisplayTransition.toUpperCase()
                : u.galleryDisplayTransition.lN),
            (u.galleryDisplayTransitionDuration.lN =
              u.O.galleryDisplayTransitionDuration),
            (u.galleryDisplayTransitionDuration.l1 =
              null != u.O.galleryL1DisplayTransitionDuration
                ? u.O.galleryL1DisplayTransitionDuration
                : u.galleryDisplayTransitionDuration.lN),
            (u.galleryMaxItems.lN = u.O.galleryMaxItems),
            (u.galleryMaxItems.l1 =
              "number" == r(u.O.galleryL1MaxItems)
                ? u.O.galleryL1MaxItems
                : u.O.galleryMaxItems),
            (u.galleryFilterTags.lN = u.O.galleryFilterTags),
            (u.galleryFilterTags.l1 =
              null != u.O.galleryL1FilterTags
                ? u.O.galleryL1FilterTags
                : u.O.galleryFilterTags),
            (u.galleryFilterTagsMode.lN = u.O.galleryFilterTagsMode),
            (u.galleryFilterTagsMode.l1 =
              null != u.O.galleryL1FilterTagsMode
                ? u.O.galleryL1FilterTagsMode
                : u.O.galleryFilterTagsMode),
            (u.O.galleryPaginationMode =
              u.O.galleryPaginationMode.toUpperCase()),
            "number" == r(u.O.slideshowDelay) && u.O.slideshowDelay >= 2e3
              ? (u.VOM.slideshowDelay = u.O.slideshowDelay)
              : d(
                  u,
                  'Parameter "slideshowDelay" must be an integer >= 2000 ms.'
                );
          "boolean" == typeof u.O.thumbnailDisplayTransition &&
            (!0 === u.O.thumbnailDisplayTransition
              ? ((u.tn.opt.lN.displayTransition = "FADEIN"),
                (u.tn.opt.l1.displayTransition = "FADEIN"))
              : ((u.tn.opt.lN.displayTransition = "NONE"),
                (u.tn.opt.l1.displayTransition = "NONE")));
          "" !== u.O.fnThumbnailDisplayEffect &&
            ((u.tn.opt.lN.displayTransition = "CUSTOM"),
            (u.tn.opt.l1.displayTransition = "CUSTOM"));
          "" !== u.O.fnThumbnailL1DisplayEffect &&
            (u.tn.opt.l1.displayTransition = "CUSTOM");
          function m(e, t) {
            if ("string" == typeof e) {
              var n = e.split("_");
              1 == n.length &&
                (u.tn.opt[t].displayTransition = e.toUpperCase()),
                2 == n.length &&
                  ((u.tn.opt[t].displayTransition = n[0].toUpperCase()),
                  (u.tn.opt[t].displayTransitionStartVal = Number(n[1]))),
                3 == n.length &&
                  ((u.tn.opt[t].displayTransition = n[0].toUpperCase()),
                  (u.tn.opt[t].displayTransitionStartVal = Number(n[1])),
                  (u.tn.opt[t].displayTransitionEasing = n[2]));
            }
          }
          l(
            "thumbnailDisplayTransitionEasing",
            "thumbnailL1DisplayTransitionEasing",
            "displayTransitionEasing"
          ),
            m(u.O.thumbnailDisplayTransition, "lN"),
            m(u.O.thumbnailDisplayTransition, "l1"),
            m(u.O.thumbnailL1DisplayTransition, "l1"),
            l(
              "thumbnailDisplayTransitionDuration",
              "thumbnailL1DisplayTransitionDuration",
              "displayTransitionDuration"
            ),
            l(
              "thumbnailDisplayInterval",
              "thumbnailL1DisplayInterval",
              "displayInterval"
            ),
            l(
              "thumbnailDisplayOrder",
              "thumbnailL1DisplayOrder",
              "displayOrder"
            ),
            void 0 !== u.O.thumbnailSizeSM &&
              (u.O.breakpointSizeSM = u.O.thumbnailSizeSM);
          void 0 !== u.O.thumbnailSizeME &&
            (u.O.breakpointSizeME = u.O.thumbnailSizeME);
          void 0 !== u.O.thumbnailSizeLA &&
            (u.O.breakpointSizeLA = u.O.thumbnailSizeLA);
          void 0 !== u.O.thumbnailSizeXL &&
            (u.O.breakpointSizeXL = u.O.thumbnailSizeXL);
          if (void 0 !== u.O.thumbnailL1BuildInit2) {
            var p = u.O.thumbnailL1BuildInit2.split("|");
            for (n = 0; n < p.length; n++) {
              if (3 == (g = p[n].trim().split("_")).length)
                ((f = re()).element = ie(g[0], "")),
                  (f.property = g[1]),
                  (f.value = g[2]),
                  u.tn.buildInit.level1.push(f);
            }
          }
          if (void 0 !== u.O.thumbnailBuildInit2)
            for (
              p = u.O.thumbnailBuildInit2.split("|"), n = 0;
              n < p.length;
              n++
            ) {
              var g, f;
              if (3 == (g = p[n].trim().split("_")).length)
                ((f = re()).element = ie(g[0], "")),
                  (f.property = g[1]),
                  (f.value = g[2]),
                  u.tn.buildInit.std.push(f);
            }
          var b = u.O.thumbnailL1HoverEffect2;
          if (void 0 !== b)
            switch (r(b)) {
              case "string": {
                let e = b.split("|");
                for (n = 0; n < e.length; n++) {
                  let t = oe();
                  (t = ne(e[n].trim(), t)),
                    null != t && u.tn.hoverEffects.level1.push(t);
                }
                break;
              }
              case "object": {
                let e = oe();
                (e = jQuery.extend(e, b)),
                  (e = ne(e.name, e)),
                  null != e && u.tn.hoverEffects.level1.push(e);
                break;
              }
              case "array":
                for (n = 0; n < b.length; n++) {
                  let e = oe();
                  (e = jQuery.extend(e, b[n])),
                    (e = ne(e.name, e)),
                    null != e && u.tn.hoverEffects.level1.push(e);
                }
                break;
              case "null":
                break;
              default:
                h(u, 'incorrect parameter for "thumbnailL1HoverEffect2".');
            }
          u.tn.hoverEffects.level1 = ae(u.tn.hoverEffects.level1);
          var v = u.O.thumbnailHoverEffect2;
          switch (r(v)) {
            case "string": {
              let e = v.split("|");
              for (n = 0; n < e.length; n++) {
                let t = oe();
                (t = ne(e[n].trim(), t)),
                  null != t && u.tn.hoverEffects.std.push(t);
              }
              break;
            }
            case "object": {
              let e = oe();
              (e = jQuery.extend(e, v)),
                (e = ne(e.name, e)),
                null != e && u.tn.hoverEffects.std.push(e);
              break;
            }
            case "array":
              for (n = 0; n < v.length; n++) {
                let e = oe();
                (e = jQuery.extend(e, v[n])),
                  (e = ne(e.name, e)),
                  null != e && u.tn.hoverEffects.std.push(e);
              }
              break;
            case "null":
              break;
            default:
              h(u, 'incorrect parameter for "thumbnailHoverEffect2".');
          }
          (u.tn.hoverEffects.std = ae(u.tn.hoverEffects.std)),
            null == u.O.touchAnimationL1 &&
              (u.O.touchAnimationL1 = u.O.touchAnimation);
          0 == u.tn.hoverEffects.std.length &&
            (0 == u.tn.hoverEffects.level1.length &&
              (u.O.touchAnimationL1 = !1),
            (u.O.touchAnimation = !1));
          (0 != u.O.thumbnailHeight && "" != u.O.thumbnailHeight) ||
            (u.O.thumbnailHeight = "auto");
          (0 != u.O.thumbnailWidth && "" != u.O.thumbnailWidth) ||
            (u.O.thumbnailWidth = "auto");
          (0 != u.O.thumbnailL1Height && "" != u.O.thumbnailL1Height) ||
            (u.O.thumbnailL1Height = "auto");
          (0 != u.O.thumbnailL1Width && "" != u.O.thumbnailL1Width) ||
            (u.O.thumbnailL1Width = "auto");
          c("thumbnailWidth", "width", "lN"),
            c("thumbnailWidth", "width", "l1"),
            c("thumbnailL1Width", "width", "l1"),
            c("thumbnailHeight", "height", "lN"),
            c("thumbnailHeight", "height", "l1"),
            c("thumbnailL1Height", "height", "l1"),
            (u.O.thumbnailLabelHeight = parseInt(u.O.thumbnailLabelHeight)),
            null != u.O.galleryMosaic &&
              ((u.tn.settings.mosaic.l1.xs = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.l1.sm = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.l1.me = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.l1.la = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.l1.xl = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.lN.xs = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.lN.sm = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.lN.me = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.lN.la = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              (u.tn.settings.mosaic.lN.xl = JSON.parse(
                JSON.stringify(u.O.galleryMosaic)
              )),
              u.tn.settings.mosaicCalcFactor("l1", "xs"),
              u.tn.settings.mosaicCalcFactor("l1", "sm"),
              u.tn.settings.mosaicCalcFactor("l1", "me"),
              u.tn.settings.mosaicCalcFactor("l1", "la"),
              u.tn.settings.mosaicCalcFactor("l1", "xl"),
              u.tn.settings.mosaicCalcFactor("lN", "xs"),
              u.tn.settings.mosaicCalcFactor("lN", "sm"),
              u.tn.settings.mosaicCalcFactor("lN", "me"),
              u.tn.settings.mosaicCalcFactor("lN", "la"),
              u.tn.settings.mosaicCalcFactor("lN", "xl"));
          null != u.O.galleryL1Mosaic &&
            ((u.tn.settings.mosaic.l1.xs = JSON.parse(
              JSON.stringify(u.O.galleryL1Mosaic)
            )),
            (u.tn.settings.mosaic.l1.sm = JSON.parse(
              JSON.stringify(u.O.galleryL1Mosaic)
            )),
            (u.tn.settings.mosaic.l1.me = JSON.parse(
              JSON.stringify(u.O.galleryL1Mosaic)
            )),
            (u.tn.settings.mosaic.l1.la = JSON.parse(
              JSON.stringify(u.O.galleryL1Mosaic)
            )),
            (u.tn.settings.mosaic.l1.xl = JSON.parse(
              JSON.stringify(u.O.galleryL1Mosaic)
            )),
            u.tn.settings.mosaicCalcFactor("l1", "xs"),
            u.tn.settings.mosaicCalcFactor("l1", "sm"),
            u.tn.settings.mosaicCalcFactor("l1", "me"),
            u.tn.settings.mosaicCalcFactor("l1", "la"),
            u.tn.settings.mosaicCalcFactor("l1", "xl"));
          for (var O = ["xs", "sm", "me", "la", "xl"], y = 0; y < O.length; y++)
            null != u.O["galleryMosaic" + O[y].toUpperCase()] &&
              ((u.tn.settings.mosaic.lN[O[y]] = JSON.parse(
                JSON.stringify(u.O["galleryMosaic" + O[y].toUpperCase()])
              )),
              (u.tn.settings.mosaic.l1[O[y]] = JSON.parse(
                JSON.stringify(u.O["galleryMosaic" + O[y].toUpperCase()])
              )),
              u.tn.settings.mosaicCalcFactor("lN", O[y]),
              u.tn.settings.mosaicCalcFactor("l1", O[y]));
          for (y = 0; y < O.length; y++)
            null != u.O["galleryL1Mosaic" + O[y].toUpperCase()] &&
              ((u.tn.settings.mosaic.l1[O[y]] = JSON.parse(
                JSON.stringify(u.O["galleryL1Mosaic" + O[y].toUpperCase()])
              )),
              u.tn.settings.mosaicCalcFactor("l1", O[y]));
          switch (
            ((u.O.imageTransition = u.O.imageTransition.toUpperCase()),
            u.layout.SetEngine(),
            u.O.kind)
          ) {
            case "":
              break;
            default:
              jQuery.nanogallery2["data_" + u.O.kind](u, "Init");
          }
        })(),
        (function () {
          Function.prototype.bind ||
            (Function.prototype.bind = function (e) {
              if ("function" != typeof this)
                throw new TypeError(
                  "Function.prototype.bind - what is trying to be bound is not callable"
                );
              var t = Array.prototype.slice.call(arguments, 1),
                n = this,
                i = function () {},
                a = function () {
                  return n.apply(
                    this instanceof i && e ? this : e,
                    t.concat(Array.prototype.slice.call(arguments))
                  );
                };
              return (i.prototype = this.prototype), (a.prototype = new i()), a;
            });
          // thanks to @lichtamberg - https://github.com/lichtamberg
          (function () {
            for (
              var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0;
              n < t.length && !window.requestAnimationFrame;
              ++n
            )
              (window.requestAnimationFrame =
                window[t[n] + "RequestAnimationFrame"]),
                (window.cancelAnimationFrame =
                  window[t[n] + "CancelAnimationFrame"] ||
                  window[t[n] + "CancelRequestAnimationFrame"]);
            window.requestAnimationFrame ||
              (window.requestAnimationFrame = function (t, n) {
                var i = new Date().getTime(),
                  a = Math.max(0, 16 - (i - e)),
                  o = window.setTimeout(function () {
                    t(i + a);
                  }, a);
                return (e = i + a), o;
              }),
              window.cancelAnimationFrame ||
                (window.cancelAnimationFrame = function (e) {
                  clearTimeout(e);
                });
          })(),
            (Array.prototype.removeIf = function (e) {
              for (var t = this.length; t--; )
                e(this[t], t) && this.splice(t, 1);
            }),
            String.prototype.startsWith ||
              (String.prototype.startsWith = function (e, t) {
                return (t = t || 0), this.indexOf(e, t) === t;
              });
        })(),
        (function () {
          var e = u.$E.base.children();
          e.length > 0 && (u.O.$markup = e);
          if (!u.O.lightboxStandalone) {
            u.$E.base.text(""),
              u.$E.base.addClass("ngy2_container"),
              u.$E.base.addClass(u.O.theme),
              (function () {
                void 0 !== u.O.colorScheme &&
                  (u.O.galleryTheme = u.O.colorScheme);
                var e = null,
                  t = "";
                switch (r(u.O.galleryTheme)) {
                  case "object":
                    (e = u.galleryTheme_dark),
                      jQuery.extend(!0, e, u.O.galleryTheme),
                      (t = "nanogallery_gallerytheme_custom_" + u.baseEltID);
                    break;
                  case "string":
                    switch (u.O.galleryTheme) {
                      case "light":
                        (e = u.galleryTheme_light),
                          (t = "nanogallery_gallerytheme_light_" + u.baseEltID);
                        break;
                      case "default":
                      case "dark":
                      case "none":
                      default:
                        (e = u.galleryTheme_dark),
                          (t = "nanogallery_gallerytheme_dark_" + u.baseEltID);
                    }
                    break;
                  default:
                    return void h(u, "Error in galleryTheme parameter.");
                }
                var n = "." + t + " ",
                  i = e.navigationBar,
                  a =
                    n +
                    ".nGY2Navigationbar { background:" +
                    i.background +
                    "; }\n";
                void 0 !== i.border &&
                  "" !== i.border &&
                  (a +=
                    n + ".nGY2Navigationbar { border:" + i.border + "; }\n");
                void 0 !== i.borderTop &&
                  "" !== i.borderTop &&
                  (a +=
                    n +
                    ".nGY2Navigationbar { border-top:" +
                    i.borderTop +
                    "; }\n");
                void 0 !== i.borderBottom &&
                  "" !== i.borderBottom &&
                  (a +=
                    n +
                    ".nGY2Navigationbar { border-bottom:" +
                    i.borderBottom +
                    "; }\n");
                void 0 !== i.borderRight &&
                  "" !== i.borderRight &&
                  (a +=
                    n +
                    ".nGY2Navigationbar { border-right:" +
                    i.borderRight +
                    "; }\n");
                void 0 !== i.borderLeft &&
                  "" !== i.borderLeft &&
                  (a +=
                    n +
                    ".nGY2Navigationbar { border-left:" +
                    i.borderLeft +
                    "; }\n");
                i = e.navigationBreadcrumb;
                (a +=
                  n +
                  ".nGY2Breadcrumb { background:" +
                  i.background +
                  "; border-radius:" +
                  i.borderRadius +
                  "; }\n"),
                  (a +=
                    n +
                    ".nGY2Breadcrumb .oneItem  { color:" +
                    i.color +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2Breadcrumb .oneItem:hover { color:" +
                    i.colorHover +
                    "; }\n");
                i = e.navigationFilter;
                (a +=
                  n +
                  ".nGY2NavFilterUnselected { color:" +
                  i.color +
                  "; background:" +
                  i.background +
                  "; border-radius:" +
                  i.borderRadius +
                  "; }\n"),
                  (a +=
                    n +
                    ".nGY2NavFilterSelected { color:" +
                    i.colorSelected +
                    "; background:" +
                    i.backgroundSelected +
                    "; border-radius:" +
                    i.borderRadius +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2NavFilterSelectAll { color:" +
                    i.colorSelected +
                    "; background:" +
                    i.background +
                    "; border-radius:" +
                    i.borderRadius +
                    "; }\n");
                i = e.navigationPagination;
                (a +=
                  n +
                  ".nGY2NavPagination { color:" +
                  i.color +
                  "; background:" +
                  i.background +
                  "; border-radius:" +
                  i.borderRadius +
                  "; }\n"),
                  (a +=
                    n +
                    ".nGY2NavPagination:hover { color:" +
                    i.colorHover +
                    "; }\n");
                i = e.thumbnail;
                (a +=
                  n +
                  ".nGY2GThumbnail { border-radius: " +
                  i.borderRadius +
                  "; background:" +
                  i.background +
                  "; border-color:" +
                  i.borderColor +
                  "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnail_l1 { border-top-width:" +
                    u.tn.opt.l1.borderVertical +
                    "px; border-right-width:" +
                    u.tn.opt.l1.borderHorizontal +
                    "px; border-bottom-width:" +
                    u.tn.opt.l1.borderVertical +
                    "px; border-left-width:" +
                    u.tn.opt.l1.borderHorizontal +
                    "px;}\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnail_lN { border-top-width:" +
                    u.tn.opt.lN.borderVertical +
                    "px; border-right-width:" +
                    u.tn.opt.lN.borderHorizontal +
                    "px; border-bottom-width:" +
                    u.tn.opt.lN.borderVertical +
                    "px; border-left-width:" +
                    u.tn.opt.lN.borderHorizontal +
                    "px;}\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailStack { background:" +
                    i.stackBackground +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2TnImgBack { background:" +
                    i.background +
                    "; background-image:" +
                    i.backgroundImage +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailAlbumUp { background:" +
                    i.background +
                    "; background-image:" +
                    i.backgroundImage +
                    "; color:" +
                    e.thumbnail.titleColor +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailIconsFullThumbnail { color:" +
                    i.titleColor +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailLabel { background:" +
                    i.labelBackground +
                    "; opacity:" +
                    i.labelOpacity +
                    "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailImageTitle  { color:" +
                    i.titleColor +
                    "; background-color:" +
                    i.titleBgColor +
                    "; " +
                    ("" == i.titleShadow
                      ? ""
                      : "Text-Shadow:" + i.titleShadow + ";") +
                    " }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailAlbumTitle { color:" +
                    i.titleColor +
                    "; background-color:" +
                    i.titleBgColor +
                    "; " +
                    ("" == i.titleShadow
                      ? ""
                      : "Text-Shadow:" + i.titleShadow + ";") +
                    " }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailDescription { color:" +
                    i.descriptionColor +
                    "; background-color:" +
                    i.descriptionBgColor +
                    "; " +
                    ("" == i.descriptionShadow
                      ? ""
                      : "Text-Shadow:" + i.descriptionShadow + ";") +
                    " }\n");
                i = e.thumbnailIcon;
                (a +=
                  n + ".nGY2GThumbnailIcons { padding:" + i.padding + "; }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailIcon { color:" +
                    i.color +
                    "; " +
                    ("" == i.shadow ? "" : "Text-Shadow:" + i.shadow + ";") +
                    " }\n"),
                  (a +=
                    n +
                    ".nGY2GThumbnailIconTextBadge { background-color:" +
                    i.color +
                    "; }\n");
                i = e.pagination;
                "NUMBERS" != u.O.galleryPaginationMode
                  ? ((a +=
                      n +
                      ".nGY2paginationDot { border:" +
                      i.shapeBorder +
                      "; background:" +
                      i.shapeColor +
                      ";}\n"),
                    (a +=
                      n +
                      ".nGY2paginationDotCurrentPage { border:" +
                      i.shapeBorder +
                      "; background:" +
                      i.shapeSelectedColor +
                      ";}\n"),
                    (a +=
                      n +
                      ".nGY2paginationRectangle { border:" +
                      i.shapeBorder +
                      "; background:" +
                      i.shapeColor +
                      ";}\n"),
                    (a +=
                      n +
                      ".nGY2paginationRectangleCurrentPage { border:" +
                      i.shapeBorder +
                      "; background:" +
                      i.shapeSelectedColor +
                      ";}\n"))
                  : ((a +=
                      n +
                      ".nGY2paginationItem { background:" +
                      i.background +
                      "; color:" +
                      i.color +
                      "; border-radius:" +
                      i.borderRadius +
                      "; }\n"),
                    (a +=
                      n +
                      ".nGY2paginationItemCurrentPage { background:" +
                      i.background +
                      "; color:" +
                      i.color +
                      "; border-radius:" +
                      i.borderRadius +
                      "; }\n"),
                    (a +=
                      n +
                      ".nGY2PaginationPrev { background:" +
                      i.background +
                      "; color:" +
                      i.color +
                      "; border-radius:" +
                      i.borderRadius +
                      "; }\n"),
                    (a +=
                      n +
                      ".nGY2PaginationNext { background:" +
                      i.background +
                      "; color:" +
                      i.color +
                      "; border-radius:" +
                      i.borderRadius +
                      "; }\n"),
                    (a +=
                      n +
                      ".nGY2paginationItemCurrentPage { background:" +
                      i.backgroundSelected +
                      "; }\n"));
                i = e.thumbnail;
                (a +=
                  n +
                  ".nGY2GalleryMoreButtonAnnotation { background:" +
                  i.background +
                  "; border-color:" +
                  i.borderColor +
                  "; border-top-width: 1px; border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px;}\n"),
                  (a +=
                    n +
                    ".nGY2GalleryMoreButtonAnnotation  { color:" +
                    i.titleColor +
                    "; " +
                    ("" == i.titleShadow
                      ? ""
                      : "Text-Shadow:" + i.titleShadow) +
                    "; }\n"),
                  jQuery("head").append(
                    '<style id="ngycs_' + u.baseEltID + '">' + a + "</style>"
                  ),
                  u.$E.base.addClass(t);
              })(),
              u.O.thumbnailLabel.get("hideIcons") &&
                ((u.O.icons.thumbnailAlbum = ""),
                (u.O.icons.thumbnailImage = ""));
            var t = "";
            switch (
              (null != u.O.navigationFontSize &&
                "" != u.O.navigationFontSize &&
                (t = ' style="font-size:' + u.O.navigationFontSize + ';"'),
              (u.$E.conNavigationBar = jQuery(
                '<div class="nGY2Navigationbar" ' + t + "></div>"
              ).appendTo(u.$E.base)),
              (u.$E.conLoadingB = jQuery(
                '<div class="nanoGalleryLBarOff"><div></div><div></div><div></div><div></div><div></div></div>'
              ).appendTo(u.$E.base)),
              (u.$E.conTnParent = jQuery(
                '<div class="nGY2Gallery"></div>'
              ).appendTo(u.$E.base)),
              (u.$E.conTn = jQuery(
                '<div class="nGY2GallerySub"></div>'
              ).appendTo(u.$E.conTnParent)),
              u.O.thumbnailAlignment)
            ) {
              case "left":
                u.$E.conTnParent.css({ "text-align": "left" });
                break;
              case "right":
                u.$E.conTnParent.css({ "text-align": "right" });
            }
            if (void 0 !== u.O.galleryBuildInit2)
              for (
                var n = u.O.galleryBuildInit2.split("|"), i = 0;
                i < n.length;
                i++
              ) {
                var a = n[i].split("_");
                2 == a.length && u.$E.conTn.css(a[0], a[1]);
              }
            for (
              var o = u.tn.hoverEffects.std.concat(u.tn.hoverEffects.level1),
                l = 0;
              l < o.length;
              l++
            )
              switch (o[l].type) {
                case "scale":
                case "rotateZ":
                case "rotateX":
                case "rotateY":
                case "translateX":
                case "translateY":
                  ".nGY2GThumbnail" == o[l].element &&
                    (u.$E.base.css("overflow", "visible"),
                    u.$E.base
                      .find(".nGY2GallerySub")
                      .css("overflow", "visible"),
                    u.$E.conTnParent.css("overflow", "visible"));
              }
            if (
              ((u.$E.conTnBottom = jQuery(
                '<div class="nGY2GalleryBottom" ' + t + "></div>"
              ).appendTo(u.$E.conTnParent)),
              u.O.portable)
            ) {
              var s =
                "font-weight:bold !important;color: #FF0075 !important;font-size: 14px !important;text-transform: lowercase !important;cursor:pointer !important;text-align: center !important;Text-Shadow: #000000 1px 0px 0px, #000000 1px 1px 0px, #000000 1px -1px 0px, #000000 -1px 1px 0px, #000000 -1px 0px 0px, #000000 -1px -1px 0px, #000000 0px 1px 0px, #000000 0px -1px 0px !important;";
              (u.$E.ngy2i = jQuery(
                '<div class="nGY2PortInfo"><a href="http://nano.gallery" target="_blank" title="nanogallery2 | easy photo gallery for your website" style="' +
                  s +
                  '"><img src="data:image/png;base64,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" style="height:32px !important;width:initial !important;box-shadow: none !important;vertical-align: middle !important;"/> &nbsp; nanogallery2</a></div>'
              ).appendTo(u.$E.base)),
                u.$E.ngy2i.find("a").on({
                  mouseenter: function () {
                    jQuery(this).attr("style", s);
                  },
                  mouseleave: function () {
                    jQuery(this).attr("style", s);
                  },
                });
            }
          }
          if (
            ((u.$E.conConsole = jQuery(
              '<div class="nGY2ConsoleParent"></div>'
            ).appendTo(u.$E.base)),
            (function () {
              (u.i18nLang = (
                navigator.language || navigator.userLanguage
              ).toUpperCase()),
                "UNDEFINED" === u.i18nLang && (u.i18nLang = "");
              var e = -("_" + u.i18nLang).length;
              if ("object" == r(u.O.i18n))
                for (var t in u.O.i18n) {
                  var n = t.substr(e);
                  n == "_" + u.i18nLang
                    ? (u.i18nTranslations[t.substr(0, t.length - n.length)] =
                        u.O.i18n[t])
                    : (u.i18nTranslations[t] = u.O.i18n[t]);
                }
            })(),
            !u.O.lightboxStandalone)
          )
            switch (
              ((function () {
                le(u.O.thumbnailLabel, "lN"),
                  void 0 !== u.O.thumbnailL1Label
                    ? le(u.O.thumbnailL1Label, "l1")
                    : le(u.O.thumbnailLabel, "l1");
                u.O.thumbnailL1Label &&
                  u.O.thumbnailL1Label.display &&
                  le(u.O.thumbnailL1Label, "l1");
                for (
                  var e = ["xs", "sm", "me", "la", "xl"], t = 0;
                  t < e.length;
                  t++
                ) {
                  if ("auto" != (i = u.tn.settings.width.lN[e[t]]))
                    (u.tn.defaultSize.width.lN[e[t]] = i),
                      (u.tn.defaultSize.width.l1[e[t]] = i);
                  else {
                    var n = u.tn.settings.height.lN[e[t]];
                    (u.tn.defaultSize.width.lN[e[t]] = n),
                      (u.tn.defaultSize.width.l1[e[t]] = n);
                  }
                }
                for (t = 0; t < e.length; t++) {
                  if ("auto" != (n = u.tn.settings.height.lN[e[t]]))
                    (u.tn.defaultSize.height.lN[e[t]] = n),
                      (u.tn.defaultSize.height.l1[e[t]] = n);
                  else {
                    var i = u.tn.settings.width.lN[e[t]];
                    (u.tn.defaultSize.height.lN[e[t]] = i),
                      (u.tn.defaultSize.height.l1[e[t]] = i);
                  }
                }
                for (t = 0; t < e.length; t++) {
                  if ("auto" != (i = u.tn.settings.width.l1[e[t]]))
                    u.tn.defaultSize.width.l1[e[t]] = i;
                  else {
                    n = u.tn.settings.height.l1[e[t]];
                    u.tn.defaultSize.width.l1[e[t]] = n;
                  }
                }
                for (t = 0; t < e.length; t++) {
                  if ("auto" != (n = u.tn.settings.height.l1[e[t]]))
                    u.tn.defaultSize.height.l1[e[t]] = n;
                  else {
                    i = u.tn.settings.width.l1[e[t]];
                    u.tn.defaultSize.height.l1[e[t]] = i;
                  }
                }
              })(),
              u.tn.opt.Get("displayTransition"))
            ) {
              case "SCALEDOWN":
              case "RANDOMSCALE":
              default:
                u.$E.base.css("overflow", "visible"),
                  u.$E.conTnParent.css("overflow", "visible"),
                  u.$E.conTn.css("overflow", "visible");
            }
        })(),
        (u.GOM.firstDisplayTime = Date.now()),
        (function () {
          u.O.lightboxStandalone ||
            (u.$E.conTnParent.on(
              { mouseenter: be, mouseleave: ve },
              ".nGY2GThumbnail"
            ),
            (u.GOM.hammertime = new NGHammer(u.$E.conTn[0])),
            u.GOM.hammertime.on("pan", function (e) {
              u.VOM.viewerDisplayed ||
                (u.O.paginationSwipe &&
                  u.layout.support.rows &&
                  "PAGINATION" == u.galleryDisplayMode.Get() &&
                  (Math.abs(e.deltaY) > u.GOM.panThreshold &&
                    (u.GOM.panYOnly = !0),
                  u.GOM.panYOnly ||
                    u.$E.conTn.css(
                      u.CSStransformName,
                      "translate(" + e.deltaX + "px,0px)"
                    )));
            }),
            u.GOM.hammertime.on("panend", function (e) {
              if (
                !u.VOM.viewerDisplayed &&
                u.O.paginationSwipe &&
                u.layout.support.rows &&
                "PAGINATION" == u.galleryDisplayMode.Get()
              ) {
                if (!u.GOM.panYOnly) {
                  if (e.deltaX > 50) return void G();
                  if (e.deltaX < -50) return void y();
                }
                (u.GOM.panYOnly = !1),
                  u.$E.conTn.css(u.CSStransformName, "translate(0px,0px)");
              }
            }),
            u.GOM.hammertime.on("tap", function (e) {
              if (!u.VOM.viewerDisplayed)
                if (
                  (e.srcEvent.stopPropagation(),
                  e.srcEvent.preventDefault(),
                  "mouse" == e.pointerType)
                ) {
                  if ("exit" == ue(e.srcEvent)) return;
                } else {
                  var t = Oe(e.srcEvent, !1);
                  if (-1 == t.GOMidx) return;
                  if ("NONE" != t.action && "OPEN" != t.action)
                    return void ue(e.srcEvent);
                  if (u.GOM.slider.hostIdx == t.GOMidx)
                    return (
                      j(),
                      void ye(
                        u.GOM.items[u.GOM.slider.currentIdx].thumbnailIdx,
                        !0
                      )
                    );
                  if (
                    ("l1" == u.GOM.curNavLevel && 0 == u.O.touchAnimationL1) ||
                    ("lN" == u.GOM.curNavLevel && 0 == u.O.touchAnimation)
                  )
                    return void ye(u.GOM.items[t.GOMidx].thumbnailIdx, !0);
                  u.O.touchAutoOpenDelay > 0
                    ? (j(),
                      W(t.GOMidx),
                      window.clearInterval(u.touchAutoOpenDelayTimerID),
                      (u.touchAutoOpenDelayTimerID = window.setInterval(
                        function () {
                          window.clearInterval(u.touchAutoOpenDelayTimerID),
                            ye(u.GOM.items[t.GOMidx].thumbnailIdx, !0);
                        },
                        u.O.touchAutoOpenDelay
                      )))
                    : u.I[u.GOM.items[t.GOMidx].thumbnailIdx].hovered
                    ? ye(u.GOM.items[t.GOMidx].thumbnailIdx, !0)
                    : (j(), W(t.GOMidx));
                }
            }),
            u.O.locationHash &&
              jQuery(window).on(
                "hashchange.nanogallery2." + u.baseEltID,
                function () {
                  ot();
                }
              ));
          if (
            (jQuery(window).on(
              "resize.nanogallery2." +
                u.baseEltID +
                " orientationChange.nanogallery2." +
                u.baseEltID,
              s(lt, u.O.eventsDebounceDelay, !1)
            ),
            jQuery(window).on(
              "scroll.nanogallery2." + u.baseEltID,
              s(st, u.O.eventsDebounceDelay, !1)
            ),
            !u.O.lightboxStandalone)
          ) {
            u.$E.scrollableParent = it(u.$E.base[0]);
            var e = it(u.$E.base[0]);
            null !== e &&
              ((u.$E.scrollableParent = jQuery(e)),
              u.$E.scrollableParent.on(
                "scroll.nanogallery2." + u.baseEltID,
                s(st, u.O.eventsDebounceDelay, !1)
              ));
          }
          (u.VOM.toolsHide = s(Ye, u.O.viewerHideToolsDelay, !1)),
            jQuery(document).keyup(function (e) {
              if (u.popup.isDisplayed)
                switch (e.keyCode) {
                  case 27:
                    u.popup.close();
                }
              else if (u.VOM.viewerDisplayed)
                switch ((Ae(), e.keyCode)) {
                  case 27:
                  case 40:
                  case 38:
                    tt();
                    break;
                  case 32:
                  case 13:
                    He();
                    break;
                  case 39:
                  case 33:
                    Qe();
                    break;
                  case 37:
                  case 34:
                    qe();
                }
            }),
            jQuery(window).bind("mousewheel wheel", function (e) {
              if (
                u.VOM.viewerDisplayed &&
                "img" == u.VOM.content.current.NGY2Item().mediaKind
              ) {
                var t = 0;
                e.preventDefault(),
                  Ie() &&
                    (e.originalEvent.deltaY
                      ? (t = e.originalEvent.deltaY)
                      : e.originalEvent.wheelDelta &&
                        (t = -e.originalEvent.wheelDelta),
                    Te(t <= 0));
              }
            }),
            jQuery(window).bind("mousemove", function (e) {
              u.VOM.viewerDisplayed &&
                0 == u.VOM.toolbarsDisplayed &&
                ((u.VOM.singletapTime = new Date().getTime()),
                s(Ae, 100, !1)());
            }),
            ngscreenfull.enabled &&
              ngscreenfull.onchange(function () {
                u.VOM.viewerDisplayed &&
                  (ngscreenfull.isFullscreen
                    ? ((u.VOM.viewerIsFullscreen = !0),
                      u.VOM.$viewer
                        .find(".fullscreenButton")
                        .html(u.O.icons.viewerFullscreenOff))
                    : ((u.VOM.viewerIsFullscreen = !1),
                      u.VOM.$viewer
                        .find(".fullscreenButton")
                        .html(u.O.icons.viewerFullscreenOn)));
              });
        })(),
        !u.O.lightboxStandalone)
      ) {
        var o = u.O.album;
        if (
          ("" == o &&
            "" != u.O.photoset &&
            ((o = u.O.photoset), (u.O.album = u.O.photoset)),
          "" != o && ((u.O.displayBreadcrumb = !1), "NONE" != o.toUpperCase()))
        )
          return (
            "nano_photos_provider2" == u.O.kind &&
              o == decodeURIComponent(o) &&
              ((o = encodeURIComponent(o)), (u.O.album = o)),
            NGY2Item.New(u, "", "", o, "-1", "album"),
            void (ot() || g("-1", o))
          );
      }
      NGY2Item.New(
        u,
        u.i18nTranslations.breadcrumbHome,
        "",
        "0",
        "-1",
        "album"
      ),
        ot() ||
          (function () {
            if (u.O.lightboxStandalone)
              !(function () {
                if (((u.GOM.curNavLevel = "l1"), null == u.O.items)) {
                  var e = jQuery("[data-nanogallery2-Lightbox"),
                    t = u.$E.base[0].dataset.nanogallery2Lgroup;
                  te(e, t);
                } else K();
                m();
              })();
            else if ("" != u.O.openOnStart) {
              var e = p(u.O.openOnStart);
              "0" != e.imageID ? Q(e.imageID, e.albumID) : g("-1", e.albumID);
            } else g("-1", 0);
          })();
    };
    
    var Z = {
      youtube: {
        getID: function (e) {
          console.log("111");
          console.log(e);
          var t = e.match(
            /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
          );
          console.log("Image TEST");
          return null != t ? t[1] : null;
        },
        thumbUrl: function (e) {
          return "https://img.youtube.com/vi/" + e + "/hqdefault.jpg";
        },
        url: function (e) {
          return "https://www.youtube.com/embed/" + e;
        },
        markup: function (e) {
          return (
            '<iframe class="nGY2ViewerMedia" src="https://www.youtube.com/embed/' +
            e +
            '?rel=0" frameborder="0" allow="autoplay" allowfullscreen></iframe>'
          );
        },
        kind: "iframe",
      },
      vimeo: {
        getID: function (e) {
          var t = e.match(
            /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/
          );
          return null != t ? t[4] : null;
        },
        url: function (e) {
          return "https://player.vimeo.com/video/" + e;
        },
        markup: function (e) {
          return (
            '<iframe class="nGY2ViewerMedia" src="https://player.vimeo.com/video/' +
            e +
            '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
          );
        },
        kind: "iframe",
      },
      dailymotion: {
        getID: function (e) {
          var t = e.match(
            /^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/
          );
          return null !== t ? (void 0 !== t[4] ? t[4] : t[2]) : null;
        },
        thumbUrl: function (e) {
          return "https://www.dailymotion.com/thumbnail/video/" + e;
        },
        url: function (e) {
          return "https://www.dailymotion.com/embed/video/" + e;
        },
        markup: function (e) {
          return (
            '<iframe class="nGY2ViewerMedia" src="https://www.dailymotion.com/embed/video/' +
            e +
            '?rel=0" frameborder="0" allow="autoplay" allowfullscreen></iframe>'
          );
        },
        kind: "iframe",
      },
      selfhosted: {
        getID: function (e) {
          var t = e.split(".").pop();
          return "mp4" === t || "webm" === t || "ogv" === t || "3gp" === t
            ? t
            : null;
        },
        markup: function (e) {
          var t = e.split(".").pop();
          return (
            '<video controls class="nGY2ViewerMedia"><source src="' +
            e +
            '" type="video/' +
            t +
            '" preload="auto">Your browser does not support the video tag (HTML 5).</video>'
          );
        },
        kind: "video",
        selfhosted: !0,
      },
    };
    function J(e) {
      if (null == e) return !1;
      return !!/^((http|https|ftp|ftps|file):\/\/)/.test(e);
    }
    function K() {
      var e = 0,
        t = NGY2Tools.AlbumPostProcess.bind(u);
      (u.I[0].contentIsLoaded = !0),
        jQuery.each(u.O.items, function (n, a) {
          var o = "";
          void 0 === (o = ct(a, "title")) && (o = "");
          var r = "";
          J(
            (r =
              void 0 !== a["src" + ht().toUpperCase()]
                ? a["src" + ht().toUpperCase()]
                : a.src)
          ) || (r = u.O.itemsBaseURL + r);
          var l = "";
          void 0 !== a.srct && a.srct.length > 0
            ? J((l = a.srct)) || (l = u.O.itemsBaseURL + l)
            : (l = r),
            "" != u.O.thumbnailLabel.get("title") && (o = GetImageTitle(r));
          var s = "";
          void 0 === (s = ct(a, "description")) && (s = "");
          var c = ct(a, "tags");
          void 0 === c && (c = "");
          var h = 0;
          void 0 !== a.albumID && ((h = a.albumID), !0);
          var d = null;
          void 0 !== a.ID && (d = a.ID);
          var m = "image";
          void 0 !== a.kind && a.kind.length > 0 && (m = a.kind);
          var p = NGY2Item.New(u, o, s, d, h, m, c);
          "" != o && e++,
            p.setMediaURL(r, "img"),
            jQuery.each(Z, function (e, t) {
              var n = t.getID(r);
              if (null != n)
                return (
                  "function" == typeof t.url && (r = t.url(n)),
                  "function" == typeof t.thumbUrl && (l = t.thumbUrl(n)),
                  (p.mediaKind = t.kind),
                  (p.mediaMarkup = t.selfhosted ? t.markup(r) : t.markup(n)),
                  !1
                );
            }),
            void 0 !== a.imageWidth && (p.imageWidth = a.width),
            void 0 !== a.imageHeight && (p.imageHeight = a.height);
          var g = void 0 !== a.imgtWidth ? a.imgtWidth : 0,
            f = void 0 !== a.imgtHeight ? a.imgtHeight : 0;
          if (
            ((p.thumbs = {
              url: {
                l1: { xs: l, sm: l, me: l, la: l, xl: l },
                lN: { xs: l, sm: l, me: l, la: l, xl: l },
              },
              width: {
                l1: { xs: g, sm: g, me: g, la: g, xl: g },
                lN: { xs: g, sm: g, me: g, la: g, xl: g },
              },
              height: {
                l1: { xs: f, sm: f, me: f, la: f, xl: f },
                lN: { xs: f, sm: f, me: f, la: f, xl: f },
              },
            }),
            "img" == p.mediaKind)
          ) {
            var b = ["xs", "sm", "me", "la", "xl"];
            for (n = 0; n < b.length; n++) {
              var v = a["srct" + b[n].toUpperCase()];
              void 0 !== v &&
                (J(v) || (v = u.O.itemsBaseURL + v),
                (p.url.l1[b[n]] = v),
                (p.url.lN[b[n]] = v)),
                null != (g = a["imgt" + b[n].toUpperCase() + "Width"]) &&
                  ((p.width.l1[b[n]] = parseInt(g)),
                  (p.width.lN[b[n]] = parseInt(g))),
                null != (f = a["imgt" + b[n].toUpperCase() + "Height"]) &&
                  ((p.height.l1[b[n]] = parseInt(f)),
                  (p.height.lN[b[n]] = parseInt(f)));
            }
          }
          void 0 !== a.imageDominantColors &&
            (p.imageDominantColors = a.imageDominantColors),
            void 0 !== a.imageDominantColor &&
              (p.imageDominantColor = a.imageDominantColor),
            void 0 !== a.destURL &&
              a.destURL.length > 0 &&
              (p.destinationURL = a.destURL),
            void 0 !== a.downloadURL &&
              a.downloadURL.length > 0 &&
              (p.downloadURL = a.downloadURL),
            void 0 !== a.exifModel && (p.exif.model = a.exifModel),
            void 0 !== a.exifFlash && (p.exif.flash = a.exifFlash),
            void 0 !== a.exifFocalLength &&
              (p.exif.focallength = a.exifFocalLength),
            void 0 !== a.exifFStop && (p.exif.fstop = a.exifFStop),
            void 0 !== a.exifExposure && (p.exif.exposure = a.exifExposure),
            void 0 !== a.exifIso && (p.exif.iso = a.exifIso),
            void 0 !== a.exifTime && (p.exif.time = a.exifTime),
            void 0 !== a.exifLocation && (p.exif.location = a.exifLocation),
            null !== a.customData && (p.customData = i(a.customData)),
            (p.contentIsLoaded = !0);
          var O = u.O.fnProcessData;
          null !== O &&
            ("function" == typeof O ? O(p, "api", a) : window[O](p, "api", a)),
            t(h);
        }),
        0 == e && (u.O.thumbnailLabel.display = !1);
    }
    function ee(e) {
      var t = "";
      return (
        void 0 !== e.childNodes[0] &&
          null !== e.childNodes[0].nodeValue &&
          void 0 !== e.childNodes[0].nodeValue &&
          (t = e.childNodes[0].nodeValue.trim()),
        t
      );
    }
    function te(t, n) {
      var a = 0,
        o = NGY2Tools.AlbumPostProcess.bind(u),
        r = NGY2Tools.GetImageTitleFromURL.bind(u);
      (u.I[0].contentIsLoaded = !0),
        jQuery.each(t, function (t, l) {
          if (l.dataset.nanogallery2Lgroup == n && "SCRIPT" != l.nodeName) {
            var s = {
              "data-ngdesc": "",
              "data-ngid": null,
              "data-ngkind": "image",
              "data-ngtags": null,
              "data-ngdest": "",
              "data-ngthumbimgwidth": 0,
              "data-ngthumbimgheight": 0,
              "data-ngimagewidth": 0,
              "data-ngimageheight": 0,
              "data-ngimagedominantcolors": null,
              "data-ngimagedominantcolor": null,
              "data-ngexifmodel": "",
              "data-ngexifflash": "",
              "data-ngexiffocallength": "",
              "data-ngexiffstop": "",
              "data-ngexifexposure": "",
              "data-ngexifiso": "",
              "data-ngexiftime": "",
              "data-ngexiflocation": "",
              "data-ngsrc": "",
              alt: "",
            };
            [].forEach.call(l.attributes, function (e) {
              s[e.name.toLowerCase()] = e.value.trim();
            });
            var c = ee(l);
            "" == c && "" != s.alt && (c = s.alt),
              jQuery.each(e(l).children(), function (e, t) {
                "" == c && (c = ee(t)),
                  [].forEach.call(t.attributes, function (e) {
                    s[e.name.toLowerCase()] = e.value.trim();
                  }),
                  "" == c && "" != s.alt && (c = s.alt);
              });
            var h = "",
              d = ht().toUpperCase();
            s.hasOwnProperty("data-ngsrc" + d) && (h = s["data-ngsrc" + d]),
              void 0 === (h = h || s["data-ngsrc"] || s.href) ||
                J(h) ||
                (h = u.O.itemsBaseURL + h);
            var m = "";
            if (
              (s.hasOwnProperty("src") && (m = s.src),
              "" == m &&
                s.hasOwnProperty("data-ngthumb") &&
                (m = s["data-ngthumb"]),
              "" == m && (m = h),
              void 0 === m || J(m) || (m = u.O.itemsBaseURL + m),
              void 0 !== h || void 0 !== m)
            ) {
              var p = s["data-ngdesc"],
                g = s.id || s["data-ngid"],
                f = s["data-ngkind"],
                b = s["data-ngtags"],
                v = "0";
              s.hasOwnProperty("data-ngalbumid") &&
                ((v = s["data-ngalbumid"]), !0);
              var O = r(h);
              "" != O && (c = O);
              var y = NGY2Item.New(u, c, p, g, v, f, b);
              "" != c && a++,
                y.setMediaURL(h, "img"),
                jQuery.each(Z, function (e, t) {
                  var n = t.getID(h);
                  if (null != n)
                    return (
                      "function" == typeof t.url && (h = t.url(n)),
                      "function" == typeof t.thumbUrl && (m = t.thumbUrl(n)),
                      (y.mediaKind = t.kind),
                      (y.mediaMarkup = t.selfhosted
                        ? t.markup(h)
                        : t.markup(n)),
                      !1
                    );
                }),
                (y.imageWidth = parseInt(s["data-ngimagewidth"])),
                (y.imageHeight = parseInt(s["data-ngimageheight"]));
              var G = parseInt(s["data-ngthumbimgwidth"]),
                M = parseInt(s["data-ngthumbimgheight"]);
              if (
                ((y.thumbs = {
                  url: {
                    l1: { xs: m, sm: m, me: m, la: m, xl: m },
                    lN: { xs: m, sm: m, me: m, la: m, xl: m },
                  },
                  width: {
                    l1: { xs: G, sm: G, me: G, la: G, xl: G },
                    lN: { xs: G, sm: G, me: G, la: G, xl: G },
                  },
                  height: {
                    l1: { xs: M, sm: M, me: M, la: M, xl: M },
                    lN: { xs: M, sm: M, me: M, la: M, xl: M },
                  },
                }),
                "img" == y.mediaKind)
              ) {
                var w = ["xs", "sm", "me", "la", "xl"];
                for (t = 0; t < w.length; t++) {
                  if (s.hasOwnProperty("data-ngthumb" + w[t])) {
                    var I = s["data-ngthumb" + w[t]];
                    J(I) || (I = u.O.itemsBaseURL + I),
                      (y.url.l1[w[t]] = I),
                      (y.url.lN[w[t]] = I);
                  }
                  if (s.hasOwnProperty("data-ngthumb" + w[t] + "width")) {
                    G = parseInt(s["data-ngthumb" + w[t] + "width"]);
                    (y.width.l1[w[t]] = G), (y.width.lN[w[t]] = G);
                  }
                  if (s.hasOwnProperty("data-ngthumb" + w[t] + "height")) {
                    M = parseInt("data-ngthumb" + w[t] + "height");
                    (y.height.l1[w[t]] = M), (y.height.lN[w[t]] = M);
                  }
                }
              }
              (y.imageDominantColors = s["data-ngimagedominantcolors"]),
                (y.imageDominantColor = s["data-ngimagedominantcolors"]),
                (y.destinationURL = s["data-ngdest"]),
                (y.downloadURL = s["data-ngdownloadurl"]),
                (y.exif.model = s["data-ngexifmodel"]),
                (y.exif.flash = s["data-ngexifflash"]),
                (y.exif.focallength = s["data-ngexiffocallength"]),
                (y.exif.fstop = s["data-ngexiffstop"]),
                (y.exif.exposure = s["data-ngexifexposure"]),
                (y.exif.iso = s["data-ngexifiso"]),
                (y.exif.time = s["data-ngexiftime"]),
                (y.exif.location = s["data-ngexiflocation"]),
                (y.contentIsLoaded = !0),
                void 0 !== jQuery(l).data("customdata") &&
                  (y.customData = i(jQuery(l).data("customdata"))),
                void 0 !== jQuery(l).data("ngcustomdata") &&
                  (y.customData = i(jQuery(l).data("ngcustomdata")));
              var T = u.O.fnProcessData;
              null !== T &&
                ("function" == typeof T
                  ? T(y, "markup", l)
                  : window[T](y, "markup", l)),
                o(v);
            }
          }
        }),
        0 == a && (u.O.thumbnailLabel.display = !1);
    }
    function ne(e, t) {
      var n = [
          "easeInQuad",
          "easeOutQuad",
          "easeInOutQuad",
          "easeInCubic",
          "easeOutCubic",
          "easeInOutCubic",
          "easeInQuart",
          "easeOutQuart",
          "easeInOutQuart",
          "easeInQuint",
          "easeOutQuint",
          "easeInOutQuint",
          "easeInSine",
          "easeOutSine",
          "easeInOutSine",
          "easeInExpo",
          "easeOutExpo",
          "easeInOutExpo",
          "easeInCirc",
          "easeOutCirc",
          "easeInOutCirc",
          "easeOutBounce",
          "easeInBack",
          "easeOutBack",
          "easeInOutBack",
          "elastic",
          "bounce",
        ],
        i = e.split("_");
      if (i.length >= 4) {
        if (
          ((t.name = ""),
          (t.type = i[1]),
          (t.from = i[2]),
          (t.to = i[3]),
          i.length >= 5)
        )
          for (var a = 4; a < i.length; a++) {
            for (var o = i[a], r = !1, l = 0; l < n.length; l++)
              if (o == n[l]) {
                (r = !0), (t.easing = o);
                break;
              }
            if (!0 !== r)
              if ("HOVERIN" != (o = o.toUpperCase()))
                if ("HOVEROUT" != o)
                  if ("KEYFRAME" != o) {
                    var s = parseInt(o.replace(/[^0-9\.]/g, ""), 10);
                    if (s > 0) {
                      if (o.indexOf("DURATION") >= 0) {
                        t.duration = s;
                        continue;
                      }
                      if (o.indexOf("DURATIONBACK") >= 0) {
                        t.durationBack = s;
                        continue;
                      }
                      if (o.indexOf("DELAY") >= 0) {
                        t.delay = s;
                        continue;
                      }
                      if (o.indexOf("DELAYBACK") >= 0) {
                        t.delayBack = s;
                        continue;
                      }
                      t.duration = s;
                    }
                  } else t.firstKeyframe = !1;
                else t.hoverin = !1;
              else t.hoverout = !1;
          }
        t.element = ie(i[0], t.type);
      } else t.name = e;
      return t;
    }
    function ie(e, t) {
      var n = {
        image: ".nGY2GThumbnailImage",
        thumbnail: ".nGY2GThumbnail",
        label: ".nGY2GThumbnailLabel",
        title: ".nGY2GThumbnailTitle",
        description: ".nGY2GThumbnailDescription",
        tools: ".nGY2GThumbnailIcons",
        customlayer: ".nGY2GThumbnailCustomLayer",
        default: "nGY2GThumbnailImage",
      };
      return n[e] || n.default;
    }
    function ae(e) {
      for (var a = [], o = 0; o < e.length; o++)
        switch (e[o].name.toUpperCase()) {
          case "BORDERLIGHTER": {
            let i = t(se().thumbnail.borderColor),
              r = "thumbnail_borderColor_" + i + "_" + n(0.5, i);
            a.push(ne(r, e[o]));
            break;
          }
          case "BORDERDARKER": {
            let i = t(se().thumbnail.borderColor),
              r = "thumbnail_borderColor_" + i + "_" + n(-0.5, i);
            a.push(ne(r, e[o]));
            break;
          }
          case "SCALE120":
            a.push(ne("thumbnail_scale_1.00_1.20", e[o]));
            break;
          case "LABELAPPEAR":
          case "LABELAPPEAR75":
            a.push(ne("label_opacity_0.00_1.00", e[o]));
            break;
          case "TOOLSAPPEAR":
            a.push(ne("tools_opacity_0_1", e[o]));
            break;
          case "TOOLSSLIDEDOWN":
            a.push(ne("tools_translateY_-100%_0%", e[o]));
            break;
          case "TOOLSSLIDEUP":
            a.push(ne("tools_translateY_100%_0%", e[o]));
            break;
          case "LABELOPACITY50":
            a.push(ne("label_opacity_1.00_0.50", e[o]));
            break;
          case "LABELSLIDEUPTOP":
          case "LABELSLIDEUP":
            a.push(ne("label_translateY_100%_0%", e[o])),
              a.push(ne("label_translateY_100%_0%", e[o]));
            break;
          case "LABELSLIDEDOWN":
            a.push(ne("label_translateY_-100%_0%", e[o]));
            break;
          case "SCALELABELOVERIMAGE":
            a.push(ne("label_scale_0.00_1.00", e[o]));
            var r = i(e[o]);
            a.push(ne("image_scale_1.00_0.00", r));
            break;
          case "OVERSCALE":
          case "OVERSCALEOUTSIDE":
            a.push(ne("label_scale_2.00_1.00", e[o]));
            r = i(e[o]);
            a.push(ne("label_opacity_0.00_1.00", r)),
              (r = i(e[o])),
              a.push(ne("image_scale_1.00_0.00", r)),
              (r = i(e[o])),
              a.push(ne("image_opacity_1.00_0.00", r));
            break;
          case "DESCRIPTIONAPPEAR":
            a.push(ne("description_opacity_0_1", e[o]));
            break;
          case "SLIDERIGHT":
            a.push(ne("image_translateX_0%_100%", e[o])),
              a.push(ne("label_translateX_-100%_0%", i(e[o])));
            break;
          case "SLIDELEFT":
            a.push(ne("image_translateX_0%_-100%", e[o])),
              a.push(ne("label_translateX_100%_0%", i(e[o])));
            break;
          case "SLIDEUP":
            a.push(ne("image_translateY_0%_-100%", e[o])),
              a.push(ne("label_translateY_100%_0%", i(e[o])));
            break;
          case "SLIDEDOWN":
            a.push(ne("image_translateY_0%_100%", e[o])),
              a.push(ne("label_translateY_-100%_0%", i(e[o])));
            break;
          case "IMAGESCALE150":
          case "IMAGESCALE150OUTSIDE":
            a.push(ne("image_scale_1.00_1.50", e[o]));
            break;
          case "IMAGESCALEIN80":
            a.push(ne("image_scale_1.20_1.00", e[o]));
            break;
          case "IMAGESLIDERIGHT":
            a.push(ne("image_translateX_0%_100%", e[o]));
            break;
          case "IMAGESLIDELEFT":
            a.push(ne("image_translateX_0%_-100%", e[o]));
            break;
          case "IMAGESLIDEUP":
            a.push(ne("image_translateY_0%_-100%", e[o]));
            break;
          case "IMAGESLIDEDOWN":
            a.push(ne("image_translateY_0%_100%", e[o]));
            break;
          case "LABELSLIDEUPDOWN":
            a.push(ne("label_translateY_0%_100%", e[o]));
            break;
          case "DESCRIPTIONSLIDEUP":
            a.push(ne("description_translateY_110%_0%", e[o]));
            break;
          case "IMAGEBLURON":
            a.push(ne("image_blur_2.00px_0.00px", e[o]));
            break;
          case "IMAGEBLUROFF":
            a.push(ne("image_blur_0.00px_2.00px", e[o]));
            break;
          case "IMAGEGRAYON":
            a.push(ne("image_grayscale_0%_100%", e[o]));
            break;
          case "IMAGEGRAYOFF":
            a.push(ne("image_grayscale_100%_0%", e[o]));
            break;
          case "IMAGESEPIAON":
            a.push(ne("image_sepia_100%_1%", e[o]));
            break;
          case "IMAGESEPIAOFF":
            a.push(ne("image_sepia_1%_100%", e[o]));
            break;
          default:
            a.push(e[o]);
        }
      return a;
    }
    function oe() {
      return {
        name: "",
        element: "",
        type: "",
        from: "",
        to: "",
        hoverin: !0,
        hoverout: !0,
        firstKeyframe: !0,
        delay: 0,
        delayBack: 0,
        duration: 400,
        durationBack: 300,
        easing: "easeOutQuart",
        easingBack: "easeOutQuart",
        animParam: null,
      };
    }
    function re() {
      return { element: "", property: "", value: "" };
    }
    function le(e, t) {
      switch (e.position) {
        case "onBottom":
          u.tn.style[t].label = "bottom:0; ";
          break;
        case "right":
          switch (e.valign) {
            case "top":
              u.tn.style[t].label = "top:0; position:absolute; left: 50%;";
              break;
            case "middle":
              (u.tn.style[t].label = "top:0; bottom:0; left: 50%;"),
                (u.tn.style[t].title = "position:absolute; bottom:50%;"),
                (u.tn.style[t].desc = "position:absolute; top:50%;");
              break;
            case "bottom":
            default:
              (u.tn.style[t].label = "bottom:0; position:absolute; left: 50%;"),
                (u.tn.style[t].title = "position:absolute;bottom:0;");
          }
          break;
        case "custom":
          break;
        default:
        case "overImage":
          switch (e.valign) {
            case "top":
              u.tn.style[t].label = "top:0; position:absolute;";
              break;
            case "middle":
              (u.tn.style[t].label = "top:0; bottom:0;"),
                (u.tn.style[t].title = "position:absolute; bottom:50%;"),
                (u.tn.style[t].desc = "position:absolute; top:50%;");
              break;
            case "bottom":
            default:
              u.tn.style[t].label = "bottom:0; position:absolute;";
          }
      }
      switch (
        ("onBottom" != e.position &&
          (e.titleMultiLine && (u.tn.style[t].title += "white-space:normal;"),
          e.descriptionMultiLine &&
            (u.tn.style[t].desc += "white-space:normal;")),
        e.align)
      ) {
        case "right":
          u.tn.style[t].label += "text-align:right;";
          break;
        case "left":
          u.tn.style[t].label += "text-align:left;";
          break;
        default:
          u.tn.style[t].label += "text-align:center;";
      }
      null != e.titleFontSize &&
        "" != e.titleFontSize &&
        (u.tn.style[t].title += "font-size:" + e.titleFontSize + ";"),
        null != e.descriptionFontSize &&
          "" != e.descriptionFontSize &&
          (u.tn.style[t].desc += "font-size:" + e.descriptionFontSize + ";"),
        0 == e.displayDescription && (u.tn.style[t].desc += "display:none;");
    }
    function se() {
      var e = null;
      switch (r(u.O.galleryTheme)) {
        case "object":
          (e = u.galleryTheme_dark), jQuery.extend(!0, e, u.O.galleryTheme);
          break;
        case "string":
          switch (u.O.galleryTheme) {
            case "light":
              e = u.galleryTheme_light;
              break;
            case "default":
            case "dark":
            case "none":
            default:
              e = u.galleryTheme_dark;
          }
          break;
        default:
          e = u.galleryTheme_dark;
      }
      return e;
    }
    function ue(e) {
      var t = Oe(e, !1);
      if (-1 == t.GOMidx) return "exit";
      var n = u.GOM.items[t.GOMidx].thumbnailIdx;
      switch (
        (u.GOM.slider.hostIdx == t.GOMidx &&
          (n = u.GOM.items[u.GOM.slider.currentIdx].thumbnailIdx),
        t.action)
      ) {
        case "OPEN":
          return ye(n, !1), "exit";
        case "DISPLAY":
          return ye(n, !0), "exit";
        case "TOGGLESELECT":
          return me(n), "exit";
        case "SHARE":
          return ge(n), "exit";
        case "DOWNLOAD":
          return ce(n), "exit";
        case "INFO":
          return ze(u.I[n]), "exit";
        case "SHOPPINGCART":
          return he(n, "gallery"), "exit";
        default:
          var i = u.O.fnThumbnailToolCustAction;
          null !== i &&
            ("function" == typeof i
              ? i(t.action, u.I[n])
              : window[i](t.action, u.I[n]));
      }
    }
    function ce(e) {
      if ("img" == u.I[e].mediaKind) {
        var t = u.I[e].src;
        null != u.I[e].downloadURL &&
          "" != u.I[e].downloadURL &&
          (t = u.I[e].downloadURL);
        var n = document.createElement("a");
        (n.href = t),
          (n.download = t.split("/").pop()),
          (n.target = "_blank"),
          (n.style.display = "none"),
          document.body.appendChild(n),
          n.click(),
          document.body.removeChild(n);
      }
    }
    function he(e, t) {
      for (var n = 0; n < u.shoppingCart.length; n++) {
        var i;
        if (u.shoppingCart[n].idx == e)
          return (
            u.shoppingCart[n].qty++,
            R(u.I[e]),
            null !== (i = u.O.fnShoppingCartUpdated) &&
              ("function" == typeof i
                ? i(u.shoppingCart, u.I[e], t)
                : window[i](u.shoppingCart, u.I[e], t)),
            void at("shoppingCartUpdated")
          );
      }
      u.shoppingCart.push({ idx: e, ID: u.I[e].GetID(), qty: 1 }),
        R(u.I[e]),
        null !== (i = u.O.fnShoppingCartUpdated) &&
          ("function" == typeof i
            ? i(u.shoppingCart, u.I[e], t)
            : window[i](u.shoppingCart, u.I[e], t)),
        at("shoppingCartUpdated");
    }
    function de() {
      u.GOM.nbSelected = 0;
      for (var e = 0, t = u.GOM.items.length; e < t; e++) {
        var n = u.I[u.GOM.items[e].thumbnailIdx];
        if (n.selected) {
          n.selected = !1;
          var i = u.O.fnThumbnailSelection;
          null !== i &&
            ("function" == typeof i
              ? i(n.$elt, n, u.I)
              : window[i](n.$elt, n, u.I));
        }
        n.selected = !1;
      }
    }
    function me(e) {
      var t = u.I[e];
      !0 === t.selected
        ? (pe(t, !1), u.GOM.nbSelected--, at("itemUnSelected"))
        : (pe(t, !0), u.GOM.nbSelected++, at("itemSelected"));
    }
    function pe(e, t) {
      (e.selected = t),
        (function (e) {
          if (null == e.$elt) return;
          var t = e.$getElt(".nGY2GThumbnail"),
            n = e.$getElt(".nGY2GThumbnailIconImageSelect");
          !0 === e.selected
            ? (t.addClass("nGY2GThumbnailSubSelected"),
              n.addClass("nGY2ThumbnailSelected"),
              n.removeClass("nGY2ThumbnailUnselected"),
              n.html(u.O.icons.thumbnailSelected))
            : (t.removeClass("nGY2GThumbnailSubSelected"),
              n.removeClass("nGY2ThumbnailSelected"),
              n.addClass("nGY2ThumbnailUnselected"),
              n.html(u.O.icons.thumbnailUnselected));
        })(e);
      var n = u.O.fnThumbnailSelection;
      null !== n &&
        ("function" == typeof n
          ? n(e.$elt, e, u.I)
          : window[n](e.$elt, e, u.I));
    }
    function ge(e) {
      var t = u.I[e],
        n =
          document.location.protocol +
          "//" +
          document.location.hostname +
          document.location.pathname,
        i = "#nanogallery/" + u.baseEltID + "/";
      "image" == t.kind ? (i += t.albumID + "/" + t.GetID()) : (i += t.GetID());
      var a = "<br><br>";
      (a +=
        '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="facebook">' +
        u.O.icons.shareFacebook +
        "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="pinterest">' +
          u.O.icons.sharePinterest +
          "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="tumblr">' +
          u.O.icons.shareTumblr +
          "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="twitter">' +
          u.O.icons.shareTwitter +
          "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="vk">' +
          u.O.icons.shareVK +
          "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;" data-share="mail">' +
          u.O.icons.shareMail +
          "</div>"),
        (a +=
          '<div class="nGY2PopupOneItem" style="text-align:center;"></div>'),
        (a +=
          '<input class="nGY2PopupOneItemText" readonly type="text" value="' +
          n +
          i +
          '" style="width:100%;text-align:center;">'),
        (a += "<br>"),
        (n = encodeURIComponent(
          document.location.protocol +
            "//" +
            document.location.hostname +
            document.location.pathname +
            i
        ));
      var o = t.title,
        r = t.thumbImg().src;
      fe("nanogallery2 - share to:", a, "Center"),
        u.popup.$elt.find(".nGY2PopupOneItem").on("click", function (e) {
          e.stopPropagation();
          var t = "",
            i = !0;
          switch (jQuery(this).attr("data-share").toUpperCase()) {
            case "FACEBOOK":
              t = "https://www.facebook.com/sharer.php?u=" + n;
              break;
            case "VK":
              t = "http://vk.com/share.php?url=" + n;
              break;
            case "GOOGLEPLUS":
              t = "https://plus.google.com/share?url=" + n;
              break;
            case "TWITTER":
              t = "https://twitter.com/intent/tweet?text=" + o + "url=" + n;
              break;
            case "PINTEREST":
              t =
                "https://pinterest.com/pin/create/button/?media=" +
                r +
                "&url=" +
                n +
                "&description=" +
                o;
              break;
            case "TUMBLR":
              t = "http://www.tumblr.com/share/link?url=" + n + "&name=" + o;
              break;
            case "MAIL":
              t = "mailto:?subject=" + o + "&body=" + n;
              break;
            default:
              i = !1;
          }
          i &&
            (window.open(
              t,
              "",
              "height=550,width=500,left=100,top=100,menubar=0"
            ),
            u.popup.close());
        });
    }
    function fe(e, t, n) {
      var i =
        '<div class="nGY2Popup" style="opacity:0;"><div class="nGY2PopupContent' +
        n +
        '">';
      (i +=
        '<div class="nGY2PopupCloseButton" style="font-size:0.9em;">' +
        u.O.icons.buttonClose +
        "</div>"),
        (i += '<div class="nGY2PopupTitle">' + e + "</div>"),
        (i += t),
        (i += "</div></div>"),
        (u.popup.$elt = jQuery(i).appendTo("body")),
        o(u.VOM.$viewer, u.popup.$elt),
        (u.popup.isDisplayed = !0),
        new NGTweenable().tween({
          from: { o: 0, y: 100 },
          to: { o: 1, y: 0 },
          easing: "easeInOutSine",
          duration: 250,
          step: function (e, t) {
            (u.popup.$elt[0].style.opacity = e.o),
              (u.popup.$elt[0].style[u.CSStransformName] =
                "translateY(" + e.y + "px)");
          },
        }),
        u.popup.$elt.find(".nGY2PopupCloseButton").on("click", function (e) {
          e.stopPropagation(), u.popup.close();
        });
    }
    function be(e) {
      if (!u.VOM.viewerDisplayed && -1 != u.GOM.albumIdx) {
        var t = Oe(e, !0);
        -1 != t.GOMidx && W(t.GOMidx);
      }
    }
    function ve(e) {
      if (!u.VOM.viewerDisplayed && -1 != u.GOM.albumIdx) {
        var t = Oe(e, !0);
        -1 != t.GOMidx && X(t.GOMidx);
      }
    }
    function Oe(e, t) {
      var n = { action: "NONE", GOMidx: -1 };
      if (null == e) return n;
      for (var i = e.target || e.srcElement; i != u.$E.conTnParent[0]; ) {
        if (jQuery(i).hasClass("nGY2GThumbnail"))
          return (
            "NONE" == n.action && (n.action = "OPEN"),
            (n.GOMidx = jQuery(i).data("index")),
            n
          );
        if (!t) {
          var a = jQuery(i).data("ngy2action");
          "" != a && null != a && (n.action = a);
        }
        if (null == i.parentNode) return n;
        i = i.parentNode;
      }
      return n;
    }
    function ye(e, t) {
      var n = u.I[e];
      u.GOM.albumIdxLoading = e;
      var i = u.O.fnThumbnailClicked;
      if (
        (null !== i &&
          ("function" == typeof i ? i(n.$elt, n) : window[i](n.$elt, n)),
        void 0 !== n.destinationURL && n.destinationURL.length > 0)
      )
        window.location = n.destinationURL;
      else
        switch (n.kind) {
          case "image":
            !1 === t && u.GOM.nbSelected > 0 ? me(e) : we(e);
            break;
          case "album":
            if (!1 === t && u.GOM.nbSelected > 0) me(e);
            else {
              if (u.O.thumbnailAlbumDisplayImage && 0 != e) return void Ge(e);
              g("-1", n.GetID());
            }
            break;
          case "albumUp":
            g("-1", NGY2Item.Get(u, n.albumID).albumID);
        }
    }
    function Ge(e) {
      u.O.debugMode && console.log("#DisplayFirstPhotoInAlbum : " + e);
      for (var t = u.I[e], n = u.I.length, i = 0; i < n; i++)
        if (u.I[i].albumID == t.GetID()) return void we(i);
      q(t.GetID(), Ge, e, null);
    }
    function Me(e) {
      switch (u.O.kind) {
        case "flickr":
          var t =
            "https://www.flickr.com/photos/" + u.O.userID + "/" + e.GetID();
          "0" != e.albumID && (t += "/in/album-" + e.albumID + "/"),
            window.open(t, "_blank");
          break;
        case "picasa":
        case "google":
        case "google2":
        default:
          t = e.responsiveURL();
          window.open(t, "_blank");
      }
    }
    function we(e) {
      if (u.O.thumbnailOpenInLightox)
        if (u.O.thumbnailOpenOriginal) Me(u.I[e]);
        else {
          var t = [];
          (u.VOM.content.current.vIdx = 0),
            (u.VOM.items = []),
            (u.VOM.albumID = u.I[e].albumID);
          var n = new c(e);
          u.VOM.items.push(n), t.push(u.I[e]);
          var i = u.I.length;
          for (let n = e + 1; n < i; n++) {
            let e = u.I[n];
            if (
              "image" == e.kind &&
              e.isToDisplay(u.VOM.albumID) &&
              "" == e.destinationURL
            ) {
              let i = new c(n);
              u.VOM.items.push(i), t.push(e);
            }
          }
          var a = u.VOM.items.length,
            o = 1;
          for (let n = 0; n < e; n++) {
            let e = u.I[n];
            if (
              "image" == e.kind &&
              e.isToDisplay(u.VOM.albumID) &&
              "" == e.destinationURL
            ) {
              let i = new c(n);
              (i.mediaNumber = o), u.VOM.items.push(i), t.push(e), o++;
            }
          }
          for (let e = 0; e < a; e++) (u.VOM.items[e].mediaNumber = o), o++;
          var r = u.O.fnThumbnailOpen;
          if (null === r)
            if (u.VOM.viewerDisplayed) {
              u.VOM.content.current.$media.empty();
              let e = u.VOM.content.current.NGY2Item();
              var l = '<div class="nGY2ViewerMediaLoaderDisplayed"></div>';
              "img" == e.mediaKind &&
                0 != e.imageWidth &&
                0 != e.imageHeight &&
                (l = '<div class="nGY2ViewerMediaLoaderHidden"></div>'),
                u.VOM.content.current.$media.append(l + e.mediaMarkup),
                et(u.VOM.content.next, 0),
                et(u.VOM.content.previous, 0),
                "img" == e.mediaKind && u.VOM.ImageLoader.loadImage(Ke, e),
                Ze("");
            } else De();
          else "function" == typeof r ? r(t) : window[r](t);
        }
    }
    function Ie() {
      if (u.O.viewerZoom && !u.VOM.viewerMediaIsChanged) {
        var e = u.VOM.content.current.NGY2Item();
        if ("img" == e.mediaKind && e.imageHeight > 0 && e.imageWidth > 0)
          return (
            !1 === u.VOM.zoom.isZooming &&
              ((u.VOM.zoom.userFactor = 1), (u.VOM.zoom.isZooming = !0)),
            !0
          );
      }
      return !1;
    }
    function Te(e) {
      e
        ? ((u.VOM.zoom.userFactor += 0.1), xe())
        : ((u.VOM.zoom.userFactor -= 0.1), Se()),
        Le();
    }
    function xe() {
      u.VOM.zoom.userFactor > 3 && (u.VOM.zoom.userFactor = 3);
    }
    function Se() {
      u.VOM.zoom.userFactor < 0.2 && (u.VOM.zoom.userFactor = 0.2);
    }
    function Le() {
      u.VOM.zoom.isZooming || (u.VOM.zoom.userFactor = 1),
        Ee(u.VOM.content.current, !0),
        Ee(u.VOM.content.previous, !1),
        Ee(u.VOM.content.next, !1);
    }
    function Ce(e) {
      var t = e.children().eq(1),
        n = 90;
      "none" != u.O.viewerGallery && (n -= 10),
        "none" != u.O.viewerToolbar.display && (n -= 10),
        t.css({ height: n + "%" }),
        t.css({ width: "90%" }),
        (t[0].style[u.CSStransformName] = 'translate(0px, "50%") ');
    }
    function Ee(e, t) {
      var n = e.NGY2Item(),
        i = e.$media;
      if ("img" == n.mediaKind)
        if (0 != n.imageHeight && 0 != n.imageWidth) {
          var a = 1 == t ? u.VOM.zoom.userFactor : 1,
            o = 1;
          "bestImageQuality" == u.O.viewerImageDisplay &&
            (o = window.devicePixelRatio);
          var r =
              (u.VOM.window.lastWidth - u.VOM.padding.V) / (n.imageWidth / o),
            l =
              (u.VOM.window.lastHeight - u.VOM.padding.H) / (n.imageHeight / o),
            s = Math.min(r, l);
          s > 1 && "upscale" != u.O.viewerImageDisplay && (s = 1);
          var c = (n.imageHeight / o) * a * s,
            h = (n.imageWidth / o) * a * s;
          i.children().eq(1).css({ height: c }),
            i.children().eq(1).css({ width: h });
          var d = 0;
          h > u.VOM.window.lastWidth && (d = -(h - u.VOM.window.lastWidth) / 2);
          t
            ? (u.VOM.zoom.isZooming ||
                ((u.VOM.panPosX = 0), (u.VOM.panPosY = 0)),
              (u.VOM.zoom.posX = d),
              (u.VOM.zoom.posY = 0),
              ke(u.VOM.panPosX, u.VOM.panPosY, i, !1))
            : (Xe(u.VOM.swipePosX),
              (i.children().eq(1)[0].style[u.CSStransformName] =
                "translate(0px, 0px) rotate(" + n.rotationAngle + "deg)"));
        } else et(e, 0);
      else Ce(i);
    }
    function ke(e, t, n, i) {
      i && ((u.VOM.panPosX = e), (u.VOM.panPosY = t)),
        (e += u.VOM.zoom.posX),
        (t += u.VOM.zoom.posY),
        (n.children().eq(1)[0].style[u.CSStransformName] =
          "translate(" +
          e +
          "px, " +
          t +
          "px) rotate(" +
          u.VOM.content.current.NGY2Item().rotationAngle +
          "deg)");
    }
    function De(e) {
      (u.GOM.firstDisplay = !1),
        jQuery("head").append(
          '<style id="nGY2_body_scrollbar_style" type="text/css">.nGY2_body_scrollbar{margin-right: ' +
            (window.innerWidth - document.documentElement.clientWidth) +
            "px;}</style>"
        ),
        jQuery("body").addClass("nGY2_body_scrollbar"),
        (u.VOM.$baseCont = jQuery(
          '<div  class="nGY2 nGY2ViewerContainer" style="opacity:1"></div>'
        ).appendTo("body")),
        (function () {
          if ("" == u.VOM.viewerTheme) {
            void 0 !== u.O.colorSchemeViewer &&
              (u.O.viewerTheme = u.O.colorSchemeViewer);
            var e = null;
            switch (r(u.O.viewerTheme)) {
              case "object":
                (e = u.viewerTheme_dark),
                  jQuery.extend(!0, e, u.O.viewerTheme),
                  (u.VOM.viewerTheme =
                    "nanogallery_viewertheme_custom_" + u.baseEltID);
                break;
              case "string":
                switch (u.O.viewerTheme) {
                  case "none":
                    return;
                  case "light":
                    (e = u.viewerTheme_light),
                      (u.VOM.viewerTheme =
                        "nanogallery_viewertheme_light_" + u.baseEltID);
                    break;
                  case "dark":
                  case "default":
                    (e = u.viewerTheme_dark),
                      (u.VOM.viewerTheme =
                        "nanogallery_viewertheme_dark_" + u.baseEltID);
                }
                break;
              default:
                return void h(u, "Error in viewerTheme parameter.");
            }
            var t = "." + u.VOM.viewerTheme + " ",
              n = t + ".nGY2Viewer { background:" + e.background + "; }\n";
            (n +=
              t +
              ".nGY2Viewer .toolbarBackground { background:" +
              e.barBackground +
              "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar { border:" +
                e.barBorder +
                "; color:" +
                e.barColor +
                "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar .previousButton:after { color:" +
                e.barColor +
                "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar .nextButton:after { color:" +
                e.barColor +
                "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar .closeButton:after { color:" +
                e.barColor +
                "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar .label .title { color:" +
                e.barColor +
                "; }\n"),
              (n +=
                t +
                ".nGY2Viewer .toolbar .label .description { color:" +
                e.barDescriptionColor +
                "; }\n"),
              jQuery("head").append("<style>" + n + "</style>"),
              u.VOM.$baseCont.addClass(u.VOM.viewerTheme);
          } else u.VOM.$baseCont.addClass(u.VOM.viewerTheme);
        })(),
        (u.VOM.$viewer = jQuery(
          '<div class="nGY2Viewer" style="opacity:0" itemscope itemtype="http://schema.org/ImageObject"></div>'
        ).appendTo(u.VOM.$baseCont)),
        u.VOM.$viewer.css({ msTouchAction: "none", touchAction: "none" }),
        (u.VOM.content.current.vIdx = null == e ? 0 : e),
        (u.VOM.content.previous.vIdx = u.VOM.IdxNext()),
        (u.VOM.content.next.vIdx = u.VOM.IdxPrevious());
      var t =
        '<div class="nGY2ViewerMediaPan"><div class="nGY2ViewerMediaLoaderDisplayed"></div>' +
        u.VOM.content.previous.NGY2Item().mediaMarkup +
        "</div>";
      (t +=
        '<div class="nGY2ViewerMediaPan"><div class="nGY2ViewerMediaLoaderDisplayed"></div>' +
        u.VOM.content.current.NGY2Item().mediaMarkup +
        "</div>"),
        (t +=
          '<div class="nGY2ViewerMediaPan"><div class="nGY2ViewerMediaLoaderDisplayed"></div>' +
          u.VOM.content.next.NGY2Item().mediaMarkup +
          "</div>");
      var n = "",
        i = u.O.icons.viewerImgPrevious;
      null != i &&
        "" != i &&
        (n +=
          '<div class="nGY2ViewerAreaPrevious ngy2viewerToolAction" data-ngy2action="previous">' +
          i +
          "</div>");
      var a = u.O.icons.viewerImgNext;
      null != a &&
        "" != a &&
        (n +=
          '<div class="nGY2ViewerAreaNext ngy2viewerToolAction" data-ngy2action="next">' +
          a +
          "</div>"),
        (u.VOM.$content = jQuery(
          '<div class="nGY2ViewerContent">' + t + n + "</div>"
        ).appendTo(u.VOM.$viewer)),
        (u.VOM.$buttonLeft = u.VOM.$content.find(".nGY2ViewerAreaPrevious")),
        (u.VOM.$buttonRight = u.VOM.$content.find(".nGY2ViewerAreaNext"));
      var l = u.VOM.$content.find(".nGY2ViewerMediaPan");
      (u.VOM.content.previous.$media = l.eq(0)),
        (u.VOM.content.current.$media = l.eq(1)),
        (u.VOM.content.next.$media = l.eq(2));
      var c = u.GOM.cache.viewport;
      (u.VOM.content.previous.$media[0].style[u.CSStransformName] =
        "translate(-" + c.w + "px, 0px)"),
        (u.VOM.content.next.$media[0].style[u.CSStransformName] =
          "translate(" + c.w + "px, 0px)"),
        u.VOM.ImageLoader.loadImage(Ke, u.VOM.content.current.NGY2Item()),
        u.VOM.ImageLoader.loadImage(Ke, u.VOM.content.previous.NGY2Item()),
        u.VOM.ImageLoader.loadImage(Ke, u.VOM.content.next.NGY2Item()),
        (u.VOM.padding.H =
          parseInt(u.VOM.$content.css("padding-left")) +
          parseInt(u.VOM.$content.css("padding-right"))),
        (u.VOM.padding.V =
          parseInt(u.VOM.$content.css("padding-top")) +
          parseInt(u.VOM.$content.css("padding-bottom")));
      var d = "",
        m = " toolbarBackground";
      u.O.viewerToolbar.fullWidth && ((d = " toolbarBackground"), (m = ""));
      var p = "text-align:center;";
      switch (u.O.viewerToolbar.align) {
        case "left":
          p = "text-align:left;";
          break;
        case "right":
          p = "text-align:right;";
      }
      var g =
        '<div class="toolbarContainer nGEvent' +
        d +
        '" style="visibility:' +
        (u.O.viewerToolbar.display ? "visible" : "hidden") +
        ";" +
        p +
        '"><div class="toolbar nGEvent' +
        m +
        '"></div></div>';
      (u.VOM.$toolbar = jQuery(g).appendTo(u.VOM.$viewer)),
        "min" == u.VOM.toolbarMode ||
        (u.O.viewerToolbar.autoMinimize > 0 &&
          u.O.viewerToolbar.autoMinimize >= u.GOM.cache.viewport.w)
          ? We()
          : Ue();
      for (
        var f =
            '<div class="nGY2ViewerToolsTopLeft nGEvent"><div class="toolbar nGEvent">',
          b = u.O.viewerTools.topLeft.split(","),
          v = 0,
          O = b.length;
        v < O;
        v++
      )
        f += Be(b[v]);
      (f += "</div></div>"),
        (u.VOM.$toolbarTL = jQuery(f).appendTo(u.VOM.$viewer));
      for (
        var y =
            '<div class="nGY2ViewerToolsTopRight nGEvent"><div class="toolbar nGEvent">',
          G = u.O.viewerTools.topRight.split(","),
          M = ((v = 0), G.length);
        v < M;
        v++
      )
        y += Be(G[v]);
      (y += "</div></div>"),
        (u.VOM.$toolbarTR = jQuery(y).appendTo(u.VOM.$viewer)),
        Pe(),
        ngscreenfull.enabled &&
          u.O.viewerFullscreen &&
          (ngscreenfull.request(), (u.VOM.viewerIsFullscreen = !0)),
        (function () {
          if (
            ((u.VOM.gallery.firstDisplay = !0), "none" != u.O.viewerGallery)
          ) {
            for (
              var e = u.O.viewerGalleryTWidth,
                t = u.O.viewerGalleryTHeight,
                n = "",
                i = 0;
              i < u.VOM.items.length;
              i++
            ) {
              var a = u.VOM.items[i].ngy2ItemIdx,
                o = u.I[a].thumbImg().src.replace(/'/g, "%27");
              n +=
                '<div class="nGY2VThumbnail" style="width:' +
                e +
                "px;height:" +
                t +
                "px;left:" +
                i * (e + 4) +
                "px;background-image: url(&apos;" +
                o +
                '&apos;);" data-ngy2_lightbox_thumbnail="true" data-ngy2_idx="' +
                a +
                '" data-ngy2_vidx="' +
                i +
                '" ></div>';
            }
            (u.VOM.gallery.gwidth = (e + 4) * u.VOM.items.length),
              (u.VOM.gallery.oneTmbWidth = e + 4);
            var r =
              "<div class='nGY2VThumbnailContainer' style='height:" +
              (t + 4) +
              "px;left:0;width:" +
              u.VOM.gallery.gwidth +
              "px;' data-ngy2_lightbox_gallery='true'>" +
              n +
              "</div>";
            (u.VOM.gallery.$elt = jQuery(
              '<div class="nGY2viewerGallery" style="display: inline-block;height:' +
                (t + 4) +
                'px;left:0;right:0;">' +
                r +
                "</div>"
            ).appendTo(u.VOM.$viewer)),
              (u.VOM.gallery.$tmbCont = u.VOM.gallery.$elt.find(
                ".nGY2VThumbnailContainer"
              )),
              u.VOM.gallery.Resize(),
              u.VOM.gallery.SetThumbnailActive();
          }
        })(),
        o("", u.VOM.$viewer),
        nt(!0),
        u.VOM.gallery.Resize(),
        (u.VOM.timeImgChanged = new Date().getTime()),
        u.VOM.$toolbarTL.css("opacity", 0),
        u.VOM.$toolbarTR.css("opacity", 0),
        u.VOM.$buttonLeft.css("opacity", 0),
        u.VOM.$buttonRight.css("opacity", 0),
        "none" != u.O.viewerGallery && u.VOM.gallery.$elt.css("opacity", 0),
        u.VOM.$content.css("opacity", 0),
        (u.VOM.$toolbarTR[0].style[u.CSStransformName] = "translateY(-40px) "),
        (u.VOM.$toolbarTL[0].style[u.CSStransformName] = "translateY(-40px) "),
        (u.VOM.$buttonLeft[0].style[u.CSStransformName] = "translateX(-40px) "),
        (u.VOM.$buttonRight[0].style[u.CSStransformName] = "translateX(40px) "),
        new NGTweenable().tween({
          from: { opacity: 0, posY: 0.5 * u.VOM.window.lastHeight },
          to: { opacity: 1, posY: 0 },
          delay: 10,
          duration: 450,
          easing: "easeInOutQuint",
          step: function (e) {
            u.VOM.$viewer.css("opacity", e.opacity),
              (u.VOM.$viewer[0].style[u.CSStransformName] =
                "translateY(" + e.posY + "px) "),
              u.VOM.$content.css("opacity", e.opacity);
          },
        }),
        new NGTweenable().tween({
          from: { posY: -40, opacity: 0, scale: 3 },
          to: { posY: 0, opacity: 1, scale: 1 },
          delay: 300,
          duration: 400,
          easing: "easeInOutQuint",
          step: function (e) {
            (u.VOM.$toolbarTR[0].style[u.CSStransformName] =
              "translateY(" + e.posY + "px) "),
              (u.VOM.$toolbarTL[0].style[u.CSStransformName] =
                "translateY(" + e.posY + "px) "),
              (u.VOM.$buttonLeft[0].style[u.CSStransformName] =
                "translateX(" + e.posY + "px) "),
              (u.VOM.$buttonRight[0].style[u.CSStransformName] =
                "translateX(" + -e.posY + "px) "),
              "none" != u.O.viewerGallery &&
                (u.VOM.gallery.$elt.css({ opacity: e.opacity }),
                (u.VOM.gallery.$elt[0].style[u.CSStransformName] =
                  "scale(" + e.scale + ")"));
          },
          finish: function () {
            (u.VOM.viewerDisplayed = !0),
              Xe(0),
              null == u.VOM.hammertime &&
                ((u.VOM.hammertime = new NGHammer.Manager(u.VOM.$baseCont[0], {
                  recognizers: [
                    [NGHammer.Pinch, { enable: !0 }],
                    [NGHammer.Pan, { direction: NGHammer.DIRECTION_ALL }],
                  ],
                })),
                u.VOM.hammertime.on("pan", function (e) {
                  if (Ne())
                    switch (
                      ("off" == u.VOM.panMode &&
                        (null != e.target.dataset.ngy2_lightbox_thumbnail ||
                        null != e.target.dataset.ngy2_lightbox_gallery
                          ? (u.VOM.panMode = "gallery")
                          : u.VOM.zoom.isZooming
                          ? (u.VOM.panMode = "zoom")
                          : (u.VOM.panMode = "media")),
                      u.VOM.panMode)
                    ) {
                      case "zoom":
                        ke(
                          u.VOM.panPosX + e.deltaX,
                          u.VOM.panPosY + e.deltaY,
                          u.VOM.content.current.$media,
                          !1
                        ),
                          u.VOM.toolsHide();
                        break;
                      case "media":
                        if (
                          Math.abs(e.deltaY) > u.VOM.panThreshold &&
                          Math.abs(e.deltaX) < u.VOM.panThreshold &&
                          !u.VOM.panXOnly
                        ) {
                          Xe(0);
                          var t = 0;
                          (t =
                            e.deltaY < 0
                              ? Math.max(e.deltaY, -200)
                              : Math.min(e.deltaY, 200)),
                            (u.VOM.$viewer[0].style[u.CSStransformName] =
                              "translateY(" + t + "px) "),
                            u.VOM.$viewer.css(
                              "opacity",
                              1 - Math.abs(t) / 200 / 2
                            );
                        } else
                          Math.abs(e.deltaX) > u.VOM.panThreshold &&
                            (u.VOM.panXOnly = !0),
                            Xe(e.deltaX),
                            (u.VOM.$viewer[0].style[u.CSStransformName] =
                              "translateY(0px)"),
                            u.VOM.$viewer.css("opacity", 1);
                        break;
                      case "gallery":
                        u.VOM.gallery.PanGallery(e.deltaX);
                    }
                }),
                u.VOM.hammertime.on("panend", function (e) {
                  if (Ne()) {
                    switch (u.VOM.panMode) {
                      case "zoom":
                        (u.VOM.timeImgChanged = new Date().getTime()),
                          ke(
                            u.VOM.panPosX + e.deltaX,
                            u.VOM.panPosY + e.deltaY,
                            u.VOM.content.current.$media,
                            !0
                          );
                        break;
                      case "media":
                        var t = !1;
                        u.VOM.panXOnly ||
                          (Math.abs(e.deltaY) > 50 &&
                            Math.abs(e.deltaX) < 50 &&
                            (tt(), (t = !0))),
                          t ||
                            (Math.abs(e.deltaX) < 50
                              ? Xe(0)
                              : e.deltaX > 50
                              ? qe(Math.abs(e.velocityX))
                              : Qe(Math.abs(e.velocityX))),
                          (u.VOM.panXOnly = !1);
                        break;
                      case "gallery":
                        (u.VOM.gallery.posX += e.deltaX),
                          u.VOM.gallery.PanGallery(0),
                          u.VOM.gallery.PanGalleryEnd(e.velocityX);
                    }
                    u.VOM.panMode = "off";
                  }
                }),
                u.O.viewerZoom
                  ? (u.VOM.hammertime.add(
                      new NGHammer.Tap({
                        event: "doubletap",
                        taps: 2,
                        interval: 250,
                      })
                    ),
                    u.VOM.hammertime.add(
                      new NGHammer.Tap({ event: "singletap" })
                    ),
                    u.VOM.hammertime
                      .get("doubletap")
                      .recognizeWith("singletap"),
                    u.VOM.hammertime
                      .get("singletap")
                      .requireFailure("doubletap"),
                    u.VOM.hammertime.on("singletap", function (e) {
                      if (Ne()) {
                        if (null != e.target.dataset.ngy2_lightbox_thumbnail) {
                          var t = parseInt(e.target.dataset.ngy2_idx),
                            n = parseInt(e.target.dataset.ngy2_vidx);
                          if (!isNaN(t) && n != u.VOM.content.current.vIdx) {
                            if (n > u.VOM.content.current.vIdx) {
                              at("lightboxNextImage"),
                                u.VOM.content.next.$media.empty();
                              var i = u.I[t];
                              u.VOM.content.next.vIdx = n;
                              let e =
                                '<div class="nGY2ViewerMediaLoaderDisplayed"></div>';
                              "img" == i.mediaKind &&
                                0 != i.imageWidth &&
                                0 != i.imageHeight &&
                                (e =
                                  '<div class="nGY2ViewerMediaLoaderHidden"></div>'),
                                u.VOM.content.next.$media.append(
                                  e + i.mediaMarkup
                                ),
                                "img" == i.mediaKind
                                  ? u.VOM.ImageLoader.loadImage(Ke, i)
                                  : Ce(u.VOM.content.next.$media),
                                Ze("nextImage");
                            } else {
                              at("lightboxPreviousImage"),
                                u.VOM.content.previous.$media.empty();
                              var a = u.I[t];
                              u.VOM.content.previous.vIdx = n;
                              let e =
                                '<div class="nGY2ViewerMediaLoaderDisplayed"></div>';
                              "img" == a.mediaKind &&
                                0 != a.imageWidth &&
                                0 != a.imageHeight &&
                                (e =
                                  '<div class="nGY2ViewerMediaLoaderHidden"></div>'),
                                u.VOM.content.previous.$media.append(
                                  e + a.mediaMarkup
                                ),
                                "img" == a.mediaKind
                                  ? u.VOM.ImageLoader.loadImage(Ke, a)
                                  : Ce(u.VOM.content.previous.$media),
                                Ze("previousImage");
                            }
                            return;
                          }
                        }
                        if ((Ve(e.srcEvent), 0 == u.VOM.toolbarsDisplayed))
                          s(Ae, 100, !1)(),
                            (u.VOM.singletapTime = new Date().getTime());
                        else {
                          if (new Date().getTime() - u.VOM.singletapTime < 400)
                            return;
                          "img" == u.VOM.content.current.NGY2Item().mediaKind &&
                            -1 !==
                              e.target.className.indexOf("nGY2ViewerMedia") &&
                            ((e.srcEvent instanceof MouseEvent
                              ? e.srcEvent.pageX
                              : e.srcEvent.changedTouches[0].pageX) <
                            u.GOM.cache.viewport.w / 2
                              ? qe()
                              : Qe());
                        }
                      }
                    }),
                    u.VOM.hammertime.on("doubletap", function (e) {
                      Ne() &&
                        (Ve(e.srcEvent),
                        -1 !== e.target.className.indexOf("nGY2ViewerMedia") &&
                          (u.VOM.zoom.isZooming
                            ? ((u.VOM.zoom.isZooming = !1), nt(!0))
                            : Ie() && ((u.VOM.zoom.userFactor = 1.5), Le())));
                    }),
                    u.VOM.hammertime.on("pinchend", function (e) {
                      e.srcEvent.stopPropagation(),
                        e.srcEvent.preventDefault(),
                        (u.VOM.timeImgChanged = new Date().getTime());
                    }),
                    u.VOM.hammertime.on("pinch", function (e) {
                      e.srcEvent.stopPropagation(),
                        e.srcEvent.preventDefault(),
                        Ie() &&
                          ((u.VOM.zoom.userFactor = e.scale), xe(), Se(), Le());
                    }))
                  : (u.VOM.hammertime.add(
                      new NGHammer.Tap({ event: "singletap" })
                    ),
                    u.VOM.hammertime.on("singletap", function (e) {
                      if (Ne())
                        if ((Ve(e.srcEvent), 0 == u.VOM.toolbarsDisplayed))
                          s(Ae, 100, !1)(),
                            (u.VOM.singletapTime = new Date().getTime());
                        else {
                          if (new Date().getTime() - u.VOM.singletapTime < 400)
                            return;
                          -1 !==
                            e.target.className.indexOf("nGY2ViewerMedia") &&
                            ((e.srcEvent instanceof MouseEvent
                              ? e.srcEvent.pageX
                              : e.srcEvent.changedTouches[0].pageX) <
                            u.GOM.cache.viewport.w / 2
                              ? qe()
                              : Qe());
                        }
                    }))),
              Ze(""),
              u.O.slideshowAutoStart && ((u.VOM.playSlideshow = !1), He()),
              Ae(),
              Je("");
          },
        });
    }
    function Ne() {
      return !(!u.VOM.viewerDisplayed || u.VOM.viewerMediaIsChanged);
    }
    function Ve(e) {
      e.stopPropagation(), e.preventDefault();
    }
    function Ye() {
      u.VOM.viewerDisplayed && ((u.VOM.toolbarsDisplayed = !1), _e(0));
    }
    function Ae() {
      u.VOM.viewerDisplayed &&
        ((u.VOM.toolbarsDisplayed = !0), _e(1), u.VOM.toolsHide());
    }
    function _e(e) {
      null != u.VOM.$toolbar && u.VOM.$toolbar.css("opacity", e),
        null != u.VOM.$toolbarTL && u.VOM.$toolbarTL.css("opacity", e),
        null != u.VOM.$toolbarTR && u.VOM.$toolbarTR.css("opacity", e),
        u.VOM.$content.find(".nGY2ViewerAreaNext").css("opacity", e),
        u.VOM.$content.find(".nGY2ViewerAreaPrevious").css("opacity", e);
    }
    function Pe() {
      u.VOM.$viewer.off("touchstart click", ".ngy2viewerToolAction", Re),
        u.VOM.$viewer.on("touchstart click", ".ngy2viewerToolAction", Re);
    }
    function Re(t) {
      if (!(new Date().getTime() - u.timeLastTouchStart < 300)) {
        u.timeLastTouchStart = new Date().getTime();
        var n = e(this),
          i = n.data("ngy2action");
        if (null != i) {
          switch (i) {
            case "next":
              Ve(t), Qe();
              break;
            case "previous":
              Ve(t), qe();
              break;
            case "playPause":
              t.stopPropagation(), He();
              break;
            case "zoomIn":
              Ve(t), Ie() && Te(!0);
              break;
            case "zoomOut":
              Ve(t), Ie() && Te(!1);
              break;
            case "minimize":
              Ve(t), "std" == u.VOM.toolbarMode ? We() : Ue();
              break;
            case "fullScreen":
              t.stopPropagation(),
                ngscreenfull.enabled && ngscreenfull.toggle();
              break;
            case "info":
              t.stopPropagation(), ze(u.VOM.content.current.NGY2Item());
              break;
            case "close":
              if ((Ve(t), new Date().getTime() - u.VOM.timeImgChanged < 400))
                return;
              tt();
              break;
            case "download":
              Ve(t), ce(u.VOM.items[u.VOM.content.current.vIdx].ngy2ItemIdx);
              break;
            case "share":
              Ve(t), ge(u.VOM.items[u.VOM.content.current.vIdx].ngy2ItemIdx);
              break;
            case "linkOriginal":
              Ve(t), Me(u.VOM.content.current.NGY2Item());
              break;
            case "rotateLeft":
              Ve(t), Fe(-90);
              break;
            case "rotateRight":
              Ve(t), Fe(90);
              break;
            case "shoppingcart":
              Ve(t),
                he(
                  u.VOM.items[u.VOM.content.current.vIdx].ngy2ItemIdx,
                  "lightbox"
                );
          }
          var a = u.O.fnImgToolbarCustClick;
          0 == i.indexOf("custom") &&
            null !== a &&
            ("function" == typeof a
              ? a(i, n, u.VOM.content.current.NGY2Item())
              : window[a](i, n, u.VOM.content.current.NGY2Item()));
        }
      }
    }
    function Fe(e) {
      var t = u.VOM.content.current.NGY2Item();
      "img" == t.mediaKind &&
        ((t.rotationAngle += e),
        (t.rotationAngle = t.rotationAngle % 360),
        t.rotationAngle < 0 && (t.rotationAngle += 360),
        Xe(0),
        Ee(u.VOM.content.current, !0));
    }
    function ze(e) {
      var t = '<div class="nGY2PopupOneItem">' + e.title + "</div>";
      (t += '<div class="nGY2PopupOneItemText">' + e.description + "</div>"),
        "" != e.author &&
          (t +=
            '<div class="nGY2PopupOneItemText">' +
            u.O.icons.user +
            " " +
            e.author +
            "</div>"),
        "" != e.exif.model &&
          (t +=
            '<div class="nGY2PopupOneItemText">' +
            u.O.icons.config +
            " " +
            e.exif.model +
            "</div>");
      var n = u.O.icons.picture + ":";
      "" != e.exif.flash ||
      "" != e.exif.focallength ||
      "" != e.exif.fstop ||
      "" != e.exif.exposure ||
      "" != e.exif.iso ||
      "" != e.exif.time
        ? ((n += "<br>"),
          (n += "" == e.exif.flash ? "" : " &nbsp; " + e.exif.flash),
          (n +=
            "" == e.exif.focallength
              ? ""
              : " &nbsp; " + e.exif.focallength + "mm"),
          (n += "" == e.exif.fstop ? "" : " &nbsp; f" + e.exif.fstop),
          (n +=
            "" == e.exif.exposure ? "" : " &nbsp; " + e.exif.exposure + "s"),
          (n += "" == e.exif.iso ? "" : " &nbsp; " + e.exif.iso + " ISO"),
          "" != e.exif.time && (n += " &nbsp; " + e.exif.time))
        : (n += " n/a"),
        (t += '<div class="nGY2PopupOneItemText">' + n + "</div>"),
        "" != e.exif.location
          ? ((t +=
              '<div class="nGY2PopupOneItemText">' +
              u.O.icons.location +
              ' <a href="http://maps.google.com/maps?z=12&t=m&q=' +
              encodeURIComponent(e.exif.location) +
              '" target="_blank">' +
              e.exif.location +
              "</a></div>"),
            (t +=
              '<iframe width="300" height="150" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?&amp;t=m&amp;q=' +
              encodeURIComponent(e.exif.location) +
              '&amp;output=embed"></iframe>'))
          : (t +=
              '<div class="nGY2PopupOneItemText">' +
              u.O.icons.location +
              ": n/a</div>");
      var i = { title: u.O.icons.viewerInfo, content: t },
        a = u.O.fnPopupMediaInfo;
      null !== a &&
        (i =
          "function" == typeof a
            ? a(e, i.title, i.content)
            : window[a](e, i.title, i.content)),
        fe(i.title, i.content, "Left");
    }
    function Be(e) {
      var t = '<div class="ngbt ngy2viewerToolAction ',
        n = e.replace(/^\s+|\s+$/g, "");
      switch (n) {
        case "minimizeButton":
        case "minimize":
          var i = u.O.icons.viewerToolbarMin;
          "min" == u.VOM.toolbarMode && (i = u.O.icons.viewerToolbarStd),
            (t +=
              'minimizeButton nGEvent" data-ngy2action="minimize">' +
              i +
              "</div>");
          break;
        case "previousButton":
        case "previous":
          t +=
            'previousButton nGEvent" data-ngy2action="previous">' +
            u.O.icons.viewerPrevious +
            "</div>";
          break;
        case "pageCounter":
          t += 'pageCounter nGEvent"></div>';
          break;
        case "nextButton":
        case "next":
          t +=
            'nextButton nGEvent" data-ngy2action="next">' +
            u.O.icons.viewerNext +
            "</div>";
          break;
        case "playPauseButton":
        case "playPause":
          t +=
            'playButton playPauseButton nGEvent" data-ngy2action="playPause">' +
            u.O.icons.viewerPlay +
            "</div>";
          break;
        case "rotateLeft":
          t +=
            'rotateLeftButton nGEvent" data-ngy2action="rotateLeft">' +
            u.O.icons.viewerRotateLeft +
            "</div>";
          break;
        case "rotateRight":
          t +=
            'rotateRightButton nGEvent" data-ngy2action="rotateRight">' +
            u.O.icons.viewerRotateRight +
            "</div>";
          break;
        case "downloadButton":
        case "download":
          t +=
            'downloadButton nGEvent" data-ngy2action="download">' +
            u.O.icons.viewerDownload +
            "</div>";
          break;
        case "zoomButton":
        case "zoom":
          t +=
            'nGEvent" data-ngy2action="zoomIn">' +
            u.O.icons.viewerZoomIn +
            '</div><div class="ngbt ngy2viewerToolAction nGEvent" data-ngy2action="zoomOut">' +
            u.O.icons.viewerZoomOut +
            "</div>";
          break;
        case "fullscreenButton":
        case "fullscreen":
          var a = u.O.icons.viewerFullscreenOn;
          ngscreenfull.enabled &&
            u.VOM.viewerIsFullscreen &&
            (a = u.O.icons.viewerFullscreenOff),
            (t +=
              'setFullscreenButton fullscreenButton nGEvent" data-ngy2action="fullScreen">' +
              a +
              "</div>");
          break;
        case "infoButton":
        case "info":
          t +=
            'infoButton nGEvent" data-ngy2action="info">' +
            u.O.icons.viewerInfo +
            "</div>";
          break;
        case "linkOriginalButton":
        case "linkOriginal":
          t +=
            'linkOriginalButton nGEvent" data-ngy2action="linkOriginal">' +
            u.O.icons.viewerLinkOriginal +
            "</div>";
          break;
        case "closeButton":
        case "close":
          t +=
            'closeButton nGEvent" data-ngy2action="close">' +
            u.O.icons.buttonClose +
            "</div>";
          break;
        case "shareButton":
        case "share":
          t +=
            'nGEvent" data-ngy2action="share">' +
            u.O.icons.viewerShare +
            "</div>";
          break;
        case "label":
          t +=
            '"><div class="label"><div class="title nGEvent" itemprop="name"></div><div class="description nGEvent" itemprop="description"></div></div></div>';
          break;
        case "shoppingcart":
          t +=
            'closeButton nGEvent" data-ngy2action="shoppingcart">' +
            u.O.icons.viewerShoppingcart +
            "</div>";
          break;
        default:
          if (0 == n.indexOf("custom")) {
            var o = "",
              r = u.O.fnImgToolbarCustInit;
            if (
              (null !== r && ("function" == typeof r ? r(n) : window[r](n)),
              null == o || "" == o)
            ) {
              var l = n.substring(6);
              o = u.O.icons["viewerCustomTool" + l];
            }
            t +=
              "ngy2CustomBtn " +
              n +
              ' nGEvent" data-ngy2action="' +
              n +
              '">' +
              o +
              "</div>";
          } else t = "";
      }
      return t;
    }
    function He() {
      u.VOM.playSlideshow
        ? (window.clearTimeout(u.VOM.playSlideshowTimerID),
          (u.VOM.playSlideshow = !1),
          u.VOM.$viewer.find(".playPauseButton").html(u.O.icons.viewerPlay))
        : ((u.VOM.playSlideshow = !0),
          Qe(),
          u.VOM.$viewer.find(".playPauseButton").html(u.O.icons.viewerPause));
    }
    function Ue() {
      u.VOM.toolbarMode = "std";
      for (
        var e = "",
          t = u.O.viewerToolbar.standard.split(","),
          n = 0,
          i = t.length;
        n < i;
        n++
      )
        e += Be(t[n]);
      u.VOM.$toolbar.find(".toolbar").html(e), je();
    }
    function We() {
      if (
        null == u.O.viewerToolbar.minimized ||
        "" == u.O.viewerToolbar.minimized
      )
        Ue();
      else {
        u.VOM.toolbarMode = "min";
        for (
          var e = "",
            t = u.O.viewerToolbar.minimized.split(","),
            n = 0,
            i = t.length;
          n < i;
          n++
        )
          e += Be(t[n]);
        u.VOM.$toolbar.find(".toolbar").html(e), je();
      }
    }
    function je() {
      var e = u.VOM.content.current.vIdx;
      if (null != e) {
        var t = u.VOM.content.current.NGY2Item(),
          n = !1;
        void 0 !== t.title && "" != t.title
          ? (u.VOM.$viewer
              .find(".ngy2viewerToolAction")
              .find(".title")
              .html(t.title),
            (n = !0))
          : u.VOM.$viewer.find(".ngy2viewerToolAction").find(".title").html(""),
          void 0 !== t.description && "" != t.description
            ? (u.VOM.$viewer
                .find(".ngy2viewerToolAction")
                .find(".description")
                .html(t.description),
              (n = !0))
            : u.VOM.$viewer
                .find(".ngy2viewerToolAction")
                .find(".description")
                .html(""),
          n
            ? u.VOM.$viewer.find(".ngy2viewerToolAction").find(".label").show()
            : u.VOM.$viewer.find(".ngy2viewerToolAction").find(".label").hide();
        var i = u.VOM.items.length;
        i > 0 &&
          u.VOM.$viewer
            .find(".pageCounter")
            .html(u.VOM.items[e].mediaNumber + "/" + i);
        var a = u.VOM.$viewer.find(".ngy2CustomBtn"),
          o = u.O.fnImgToolbarCustDisplay;
        a.length > 0 &&
          null !== o &&
          ("function" == typeof o ? o(a, t) : window[o](a, t)),
          Pe();
      }
    }
    function Xe(e) {
      if (((u.VOM.swipePosX = e), null == u.CSStransformName));
      else {
        u.VOM.content.current.$media[0].style[u.CSStransformName] =
          "translate(" + e + "px, 0px)";
        var t = u.VOM.content.previous.NGY2Item(),
          n = u.VOM.content.next.NGY2Item();
        if (u.O.imageTransition.startsWith("SWIPE")) {
          t.mediaTransition() && et(u.VOM.content.previous, 1),
            n.mediaTransition() && et(u.VOM.content.next, 1);
          var i = Math.min(
            Math.max(Math.abs(e) / u.VOM.window.lastWidth, 0.8),
            1
          );
          if (("SWIPE" == u.O.imageTransition && (i = 1), e > 0)) {
            let a = u.VOM.window.lastWidth;
            t.mediaTransition() &&
              (u.VOM.content.previous.$media[0].style[u.CSStransformName] =
                "translate(" + (-a + e) + "px, 0px) scale(" + i + ")"),
              n.mediaTransition() &&
                (u.VOM.content.next.$media[0].style[u.CSStransformName] =
                  "translate(" + a + "px, 0px) scale(" + i + ")");
          } else {
            let a = -u.VOM.window.lastWidth;
            n.mediaTransition() &&
              (u.VOM.content.next.$media[0].style[u.CSStransformName] =
                "translate(" + (-a + e) + "px, 0px) scale(" + i + ")"),
              t.mediaTransition() &&
                (u.VOM.content.previous.$media[0].style[u.CSStransformName] =
                  "translate(" + a + "px, 0px) scale(" + i + ")");
          }
        }
        if ("SLIDEAPPEAR" == u.O.imageTransition)
          if (
            ((u.VOM.content.previous.$media[0].style[u.CSStransformName] = ""),
            (u.VOM.content.next.$media[0].style[u.CSStransformName] = ""),
            e < 0)
          ) {
            let i = -e / u.VOM.window.lastWidth;
            n.mediaTransition() && et(u.VOM.content.next, i),
              t.mediaTransition() && et(u.VOM.content.previous, 0);
          } else {
            let i = e / u.VOM.window.lastWidth;
            t.mediaTransition() && et(u.VOM.content.previous, i),
              n.mediaTransition() && et(u.VOM.content.next, 0);
          }
      }
    }
    function Qe(e) {
      (e = e || 0),
        u.VOM.viewerMediaIsChanged ||
          new Date().getTime() - u.VOM.timeImgChanged < 300 ||
          (at("lightboxNextImage"), Ze("nextImage", e));
    }
    function qe(e) {
      (e = e || 0),
        u.VOM.viewerMediaIsChanged ||
          new Date().getTime() - u.VOM.timeImgChanged < 300 ||
          (u.VOM.playSlideshow && He(),
          at("lightboxPreviousImage"),
          Ze("previousImage", e));
    }
    function Ze(e, t) {
      (t = t || 0),
        u.O.debugMode &&
          console.timeline &&
          console.timeline("nanogallery2_viewer"),
        u.VOM.playSlideshow && window.clearTimeout(u.VOM.playSlideshowTimerID);
      var n = null,
        i = null;
      switch (
        ((u.VOM.timeImgChanged = new Date().getTime()),
        (u.VOM.viewerMediaIsChanged = !0),
        (u.VOM.zoom.isZooming = !1),
        nt(!0),
        e)
      ) {
        case "":
          (n = u.VOM.content.current), (i = u.VOM.content.current);
          break;
        case "previousImage":
          (n = u.VOM.content.current), (i = u.VOM.content.previous);
          break;
        default:
          (n = u.VOM.content.current), (i = u.VOM.content.next);
      }
      if ((rt(i.NGY2Item().albumID, i.NGY2Item().GetID()), "" != e)) {
        var a = u.GOM.cache.viewport,
          o = "",
          r = (500 * (a.w - Math.abs(u.VOM.swipePosX))) / a.w;
        if (
          (t > 0 &&
            ((r = Math.min((a.w - Math.abs(u.VOM.swipePosX)) / t, r)),
            (o = "linear")),
          null == u.CSStransformName)
        )
          et(i, 1), et(n, 1), Je(e);
        else
          switch (u.O.imageTransition) {
            case "SWIPE":
            case "SWIPE2":
              var l = "nextImage" == e ? -a.w : a.w;
              (i.$media[0].style[u.CSStransformName] =
                "translate(" + -l + "px, 0px) "),
                0 == t &&
                  (o =
                    "swipe" == u.O.imageTransition
                      ? "easeInOutSine"
                      : "easeOutCubic"),
                et(u.VOM.content.current, 1),
                (u.VOM.content.current.$media[0].style[u.CSStransformName] =
                  "translate(0px, 0px)"),
                et(i, 1),
                new NGTweenable().tween({
                  from: { t: u.VOM.swipePosX },
                  to: { t: "nextImage" == e ? -a.w : a.w },
                  attachment: {
                    dT: e,
                    new_content_item: i,
                    dir: l,
                    media_transition: i.NGY2Item().mediaTransition(),
                  },
                  duration: r,
                  easing: o,
                  step: function (e, t) {
                    if (
                      ((u.VOM.content.current.$media[0].style[
                        u.CSStransformName
                      ] = "translate(" + e.t + "px, 0px)"),
                      t.media_transition)
                    ) {
                      var n = Math.min(
                        Math.max(Math.abs(e.t) / u.VOM.window.lastWidth, 0.8),
                        1
                      );
                      "SWIPE" == u.O.imageTransition && (n = 1),
                        (t.new_content_item.$media[0].style[
                          u.CSStransformName
                        ] =
                          "translate(" +
                          (-t.dir + e.t) +
                          "px, 0px) scale(" +
                          n +
                          ")");
                    }
                  },
                  finish: function (e, t) {
                    (u.VOM.content.current.$media[0].style[u.CSStransformName] =
                      ""),
                      et(u.VOM.content.current, 0),
                      (t.new_content_item.$media[0].style[u.CSStransformName] =
                        ""),
                      Je(t.dT);
                  },
                });
              break;
            case "SLIDEAPPEAR":
            default:
              var s = Math.abs(u.VOM.swipePosX) / u.VOM.window.lastWidth;
              (i.$media[0].style[u.CSStransformName] = ""),
                0 == t && (o = "easeInOutSine"),
                new NGTweenable().tween({
                  from: { o: s, t: u.VOM.swipePosX },
                  to: { o: 1, t: "nextImage" == e ? -a.w : a.w },
                  attachment: {
                    dT: e,
                    new_content_item: i,
                    media_transition: i.NGY2Item().mediaTransition(),
                  },
                  delay: 30,
                  duration: r,
                  easing: o,
                  step: function (e, t) {
                    (u.VOM.content.current.$media[0].style[u.CSStransformName] =
                      "translate(" + e.t + "px, 0px)"),
                      t.media_transition && et(t.new_content_item, e.o);
                  },
                  finish: function (e, t) {
                    (u.VOM.content.current.$media[0].style[u.CSStransformName] =
                      ""),
                      Je(t.dT);
                  },
                });
          }
      }
    }
    function Je(e) {
      var t = 0;
      switch (e) {
        case "":
          t = u.VOM.content.current.vIdx;
          break;
        case "previousImage":
          t = u.VOM.content.previous.vIdx;
          break;
        default:
          t = u.VOM.content.next.vIdx;
      }
      (u.VOM.content.current.vIdx = t),
        (u.VOM.content.next.vIdx = u.VOM.IdxNext()),
        (u.VOM.content.previous.vIdx = u.VOM.IdxPrevious()),
        u.VOM.gallery.Resize(),
        u.VOM.gallery.SetThumbnailActive();
      var n = u.VOM.content.current.NGY2Item();
      je(),
        u.O.debugMode &&
          console.timeline &&
          console.timelineEnd("nanogallery2_viewer");
      var i = u.O.fnImgDisplayed;
      if (
        (null !== i && ("function" == typeof i ? i(n) : window[i](n)),
        (u.VOM.swipePosX = 0),
        "" != e)
      ) {
        u.VOM.content.current.$media.removeClass("imgCurrent");
        var a = u.VOM.content.current.$media;
        switch (e) {
          case "nextImage":
            (u.VOM.content.current.$media = u.VOM.content.next.$media),
              (u.VOM.content.next.$media = a);
            break;
          case "previousImage":
            (u.VOM.content.current.$media = u.VOM.content.previous.$media),
              (u.VOM.content.previous.$media = a);
        }
      }
      u.VOM.content.current.$media.addClass("imgCurrent");
      var o = u.VOM.$content.find(".nGY2ViewerMediaPan");
      u.VOM.content.current.$media.insertAfter(o.last()),
        "img" == n.mediaKind && 0 == n.imageWidth
          ? et(u.VOM.content.current, 0)
          : (u.VOM.content.current.$media
              .children()
              .eq(0)
              .attr("class", "nGY2ViewerMediaLoaderHidden"),
            et(u.VOM.content.current, 1)),
        u.VOM.content.next.$media.empty();
      var r = u.VOM.content.next.NGY2Item(),
        l = '<div class="nGY2ViewerMediaLoaderDisplayed"></div>';
      "img" == r.mediaKind &&
        0 != r.imageWidth &&
        0 != r.imageHeight &&
        (l = '<div class="nGY2ViewerMediaLoaderHidden"></div>'),
        u.VOM.content.next.$media.append(l + r.mediaMarkup),
        et(u.VOM.content.next, 0),
        et(u.VOM.content.previous, 0),
        "img" == r.mediaKind
          ? u.VOM.ImageLoader.loadImage(Ke, r)
          : Ce(u.VOM.content.next.$media),
        u.VOM.content.previous.$media.empty();
      var s = u.VOM.content.previous.NGY2Item();
      (l = '<div class="nGY2ViewerMediaLoaderDisplayed"></div>'),
        "img" == s.mediaKind &&
          0 != s.imageWidth &&
          0 != s.imageHeight &&
          (l = '<div class="nGY2ViewerMediaLoaderHidden"></div>'),
        u.VOM.content.previous.$media.append(l + s.mediaMarkup),
        et(u.VOM.content.previous, 0),
        et(u.VOM.content.next, 0),
        "img" == s.mediaKind
          ? u.VOM.ImageLoader.loadImage(Ke, s)
          : Ce(u.VOM.content.previous.$media),
        u.VOM.playSlideshow &&
          u.VOM.content.current.$media
            .children()
            .eq(1)
            .ngimagesLoaded()
            .always(function (e) {
              u.VOM.playSlideshow &&
                (u.VOM.playSlideshowTimerID = window.setTimeout(function () {
                  Qe();
                }, u.VOM.slideshowDelay));
            }),
        nt(),
        (u.VOM.viewerMediaIsChanged = !1),
        at("lightboxImageDisplayed");
    }
    function Ke(e, t, n, i) {
      (n.imageWidth = e),
        (n.imageHeight = t),
        u.VOM.content.current.NGY2Item() == n &&
          (u.VOM.content.current.$media
            .children()
            .eq(0)
            .attr("class", "nGY2ViewerMediaLoaderHidden"),
          et(u.VOM.content.current, 1),
          (u.VOM.zoom.userFactor = 1)),
        u.VOM.content.next.NGY2Item() == n &&
          u.VOM.content.next.$media
            .children()
            .eq(0)
            .attr("class", "nGY2ViewerMediaLoaderHidden"),
        u.VOM.content.previous.NGY2Item() == n &&
          u.VOM.content.previous.$media
            .children()
            .eq(0)
            .attr("class", "nGY2ViewerMediaLoaderHidden"),
        Le();
    }
    function et(e, t) {
      var n = e.NGY2Item(),
        i = e.$media;
      "img" != n.mediaKind || 0 != n.imageWidth
        ? 0 == t
          ? i.children().css({ opacity: 0, visibility: "hidden" })
          : i.children().css({ opacity: t, visibility: "visible" })
        : i.children().eq(1).css({ opacity: 0, visibility: "hidden" });
    }
    function tt(e) {
      if (
        (null == e && (e = u.VOM.content.current.vIdx),
        (u.VOM.viewerMediaIsChanged = !1),
        u.VOM.viewerDisplayed)
      ) {
        if (
          (jQuery("body").removeClass("nGY2_body_scrollbar"),
          jQuery("#nGY2_body_scrollbar_style").remove(),
          u.VOM.playSlideshow &&
            (window.clearTimeout(u.VOM.playSlideshowTimerID),
            (u.VOM.playSlideshow = !1)),
          u.VOM.hammertime.destroy(),
          (u.VOM.hammertime = null),
          ngscreenfull.enabled &&
            u.VOM.viewerIsFullscreen &&
            ((u.VOM.viewerIsFullscreen = !1), ngscreenfull.exit()),
          jQuery(".nGY2ViewerContainer").remove(),
          (u.VOM.$baseCont = null),
          (u.VOM.viewerDisplayed = !1),
          u.O.lightboxStandalone)
        )
          return;
        if (u.O.thumbnailAlbumDisplayImage)
          if (null == e);
          else {
            var t = u.I[u.VOM.items[e].ngy2ItemIdx],
              n = NGY2Item.Get(u, t.albumID);
            u.GOM.albumIdx != n.albumID
              ? g("-1", n.albumID)
              : (x(), rt("", ""), U());
          }
        else
          null != e &&
            (-1 == u.GOM.albumIdx
              ? g("", u.I[u.VOM.items[e].ngy2ItemIdx].albumID)
              : (x(), rt(u.I[u.VOM.items[e].ngy2ItemIdx].albumID, ""), U()));
        u.VOM.timeImgChanged = new Date().getTime();
      }
    }
    function nt(e) {
      if (((e = void 0 !== e && e), null !== u.VOM.$toolbar)) {
        var t = u.VOM.$viewer.width(),
          n = u.VOM.$viewer.height();
        if (
          null != u.VOM.content.current.$media.children().eq(1) &&
          -1 != u.VOM.content.current.vIdx &&
          (e || u.VOM.window.lastWidth != t || u.VOM.window.lastHeight != n)
        ) {
          (u.VOM.window.lastWidth = t), (u.VOM.window.lastHeight = n);
          var i = 0,
            a = 0;
          switch (
            ("none" != u.O.viewerGallery && (i = u.O.viewerGalleryTHeight + 10),
            "bottom" == u.O.viewerGallery && (a = i),
            u.O.viewerToolbar.position)
          ) {
            case "top":
            case "topOverImage":
              u.VOM.$content.css({ height: n, width: t, top: 0 }),
                u.VOM.$toolbar.css({ top: 0, bottom: "" });
              break;
            case "bottom":
            case "bottomOverImage":
            default:
              (n -= a),
                u.VOM.$content.css({ height: n, width: t, bottom: -a, top: 0 }),
                u.VOM.$toolbar.css({ bottom: i });
          }
          !u.VOM.viewerMediaIsChanged && u.VOM.zoom.isZooming
            ? Le()
            : u.VOM.zoom.isZooming ||
              (0 == u.VOM.zoom.userFactor &&
                0 == u.VOM.panPosX &&
                0 == u.VOM.panPosY &&
                0 == u.VOM.zoom.posX &&
                0 == u.VOM.zoom.posY)
            ? ((u.VOM.zoom.userFactor = 1),
              (u.VOM.zoom.isZooming = !1),
              (u.VOM.panPosX = 0),
              (u.VOM.panPosY = 0),
              (u.VOM.zoom.posX = 0),
              (u.VOM.zoom.posY = 0),
              Le())
            : ((u.VOM.zoom.isZooming = !0),
              new NGTweenable().tween({
                from: {
                  userFactor: u.VOM.zoom.userFactor,
                  panPosX: u.VOM.panPosX,
                  panPosY: u.VOM.panPosY,
                  zoomPosX: u.VOM.zoom.posX,
                  zoomPosY: u.VOM.zoom.posY,
                },
                to: {
                  userFactor: 1,
                  panPosX: 0,
                  panPosY: 0,
                  zoomPosX: 0,
                  zoomPosY: 0,
                },
                easing: "easeInOutSine",
                delay: 0,
                duration: 150,
                step: function (e) {
                  (u.VOM.zoom.userFactor = e.userFactor),
                    (u.VOM.panPosX = e.panPosX),
                    (u.VOM.panPosY = e.panPosY),
                    (u.VOM.zoom.posX = e.zoomPosX),
                    (u.VOM.zoom.posY = e.zoomPosY),
                    Le();
                },
                finish: function (e) {
                  u.VOM.zoom.isZooming = !1;
                },
              }));
        }
      }
    }
    function it(e) {
      const t = /(auto|scroll)/,
        n = (e, t) =>
          null === e.parentNode ? t : n(e.parentNode, t.concat([e])),
        i = (e, t) => getComputedStyle(e, null).getPropertyValue(t),
        a = (e) =>
          t.test(
            ((e) => i(e, "overflow") + i(e, "overflow-y") + i(e, "overflow-x"))(
              e
            )
          );
      return ((e) => {
        if (!(e instanceof HTMLElement || e instanceof SVGElement)) return;
        const t = n(e.parentNode, []);
        for (let e = 0; e < t.length; e += 1) {
          if (t[e] === document.body) return null;
          if (a(t[e])) return t[e];
        }
        return document.scrollingElement || document.documentElement;
      })(e);
    }
    function at(e) {
      var t = e + ".nanogallery2",
        n = null;
      try {
        n = new Event(t);
      } catch (e) {
        (n = document.createEvent("Event")).initEvent(t, !1, !1);
      }
      u.$E.base.trigger(t, n);
    }
    function ot() {
      if (!u.O.locationHash) return !1;
      var e = "#nanogallery/" + u.baseEltID + "/",
        t = location.hash;
      if (
        (u.O.debugMode &&
          (console.log("------------------------ PROCESS LOCATION HASH"),
          console.log("newLocationHash1: " + t),
          console.log("G.locationHashLastUsed: " + u.locationHashLastUsed)),
        "" == t && "" !== u.locationHashLastUsed)
      )
        return (
          u.O.debugMode && console.log("display root album"),
          (u.locationHashLastUsed = ""),
          u.O.debugMode &&
            console.log(
              "new3 G.locationHashLastUsed: " + u.locationHashLastUsed
            ),
          g("", "0"),
          !0
        );
      if (t != u.locationHashLastUsed) {
        if (0 == t.indexOf(e)) {
          var n = p(t.substring(e.length));
          return "0" != n.imageID
            ? (u.O.debugMode &&
                console.log("display image: " + n.albumID + "-" + n.imageID),
              Q(n.imageID, n.albumID),
              !0)
            : (u.O.debugMode && console.log("display album: " + n.albumID),
              g("-1", n.albumID),
              !0);
        }
        return !1;
      }
    }
    function rt(e, t) {
      if (!u.O.locationHash || u.O.lightboxStandalone) return !1;
      if (
        (u.O.debugMode &&
          console.log("------------------------ SET LOCATION HASH"),
        "" == t && ("-1" == e || "0" == e || u.O.album == e))
      )
        return (
          "" != location.hash &&
            ("pushState" in history
              ? history.pushState(
                  "",
                  document.title,
                  window.location.pathname + window.location.search
                )
              : (location.hash = "")),
          (u.locationHashLastUsed = ""),
          void (
            u.O.debugMode &&
            console.log(
              "new2 G.locationHashLastUsed: " + u.locationHashLastUsed
            )
          )
        );
      var n = "#nanogallery/" + u.baseEltID + "/" + e;
      "" != t && (n += "/" + t);
      var i = location.hash;
      if (
        (u.O.debugMode &&
          (console.log("newLocationHash2: " + n),
          console.log("location.hash: " + i)),
        (u.locationHashLastUsed = n),
        u.O.debugMode &&
          console.log("new G.locationHashLastUsed: " + u.locationHashLastUsed),
        "" == i || i != n)
      )
        try {
          top.location.hash = n;
        } catch (e) {
          u.O.locationHash = !1;
        }
    }
    function lt() {
      C();
      var e = u.GOM.curNavLevel,
        t = u.GOM.curWidth;
      if (u.VOM.viewerDisplayed) nt(), u.VOM.gallery.Resize();
      else if (u.galleryResizeEventEnabled) {
        var n = ht();
        if (-1 != u.GOM.albumIdx) {
          var i = u.tn.settings;
          if ("MOSAIC" == u.layout.engine) {
            if (
              JSON.stringify(i.mosaic[e][t]) !== JSON.stringify(i.mosaic[e][n])
            )
              return (
                (u.GOM.curWidth = n),
                (u.GOM.pagination.currentPage = 0),
                void w(u.GOM.albumIdx)
              );
          } else if (
            i.height[e][t] != i.height[e][n] ||
            i.width[e][t] != i.width[e][n] ||
            i.gutterHeight[e][t] != i.gutterHeight[e][n] ||
            i.gutterWidth[e][t] != i.gutterWidth[e][n]
          )
            return (
              (u.GOM.curWidth = n),
              (u.GOM.pagination.currentPage = 0),
              void w(u.GOM.albumIdx)
            );
        }
        x();
      }
    }
    function st() {
      u.VOM.viewerDisplayed || ut();
    }
    function ut() {
      0 == u.galleryResizeEventEnabled ? window.setTimeout(ut, 10) : x();
    }
    function ct(e, t) {
      return "" != u.i18nLang &&
        void 0 !== e[t + "_" + u.i18nLang] &&
        e[t + "_" + u.i18nLang].length > 0
        ? e[t + "_" + u.i18nLang]
        : e[t];
    }
    function ht() {
      var e = u.GOM.cache.viewport.w;
      return u.O.breakpointSizeSM > 0 && e < u.O.breakpointSizeSM
        ? "xs"
        : u.O.breakpointSizeME > 0 && e < u.O.breakpointSizeME
        ? "sm"
        : u.O.breakpointSizeLA > 0 && e < u.O.breakpointSizeLA
        ? "me"
        : u.O.breakpointSizeXL > 0 && e < u.O.breakpointSizeXL
        ? "la"
        : "xl";
    }
    function dt(e) {
      for (var t = document.createElement("div"), n = 0; n < e.length; ++n)
        if (void 0 !== t.style[e[n]]) return e[n];
      return null;
    }
  }
  /*!
   * imagesLoaded PACKAGED v4.1.1
   */ (e.nanogallery2 = function (e, t) {
    var i = this;
    (i.$e = jQuery(e)),
      (i.e = e),
      i.$e.data("nanogallery2data", i),
      (i.init = function () {
        void 0 === window.NGY2Item &&
          ((window.NGY2Tools = (function () {
            function e() {}
            return (
              (e.FilterAlbumName = function (e, t) {
                var n = e.toUpperCase();
                if (!(this.albumList.length > 0)) {
                  var i = !1;
                  if (null !== this.allowList) {
                    for (a = 0; a < this.allowList.length; a++)
                      -1 !== n.indexOf(this.allowList[a]) && (i = !0);
                    if (!i) return !1;
                  }
                  if (null !== this.blockList)
                    for (a = 0; a < this.blockList.length; a++)
                      if (-1 !== n.indexOf(this.blockList[a])) return !1;
                  return !0;
                }
                for (var a = 0; a < this.albumList.length; a++)
                  if (
                    n === this.albumList[a].toUpperCase() ||
                    t === this.albumList[a]
                  )
                    return !0;
              }),
              (e.NanoAlert = function (t, n, i) {
                e.NanoConsoleLog.call(t, n),
                  null != t.$E.conConsole &&
                    (t.$E.conConsole.css({
                      visibility: "visible",
                      minHeight: "100px",
                    }),
                    0 == i
                      ? t.$E.conConsole.append("<p>" + n + "</p>")
                      : t.$E.conConsole.append(
                          "<p>nanogallery2: " + n + " [" + t.baseEltID + "]</p>"
                        ));
              }),
              (e.NanoConsoleLog = function (e, t) {
                window.console &&
                  console.log("nanogallery2: " + t + " [" + e.baseEltID + "]");
              }),
              (e.PreloaderDisplay = function (e) {
                if (!0 === e) {
                  if (
                    (this.$E.conLoadingB
                      .removeClass("nanoGalleryLBarOff")
                      .addClass("nanoGalleryLBar"),
                    null != this.GOM.albumIdxLoading &&
                      -1 != this.GOM.albumIdxLoading)
                  ) {
                    this.I[this.GOM.albumIdxLoading].$Elts[
                      ".nGY2TnImg"
                    ].addClass("nGY2GThumbnailLoaderDisplayed");
                  }
                } else if (
                  (this.$E.conLoadingB
                    .removeClass("nanoGalleryLBar")
                    .addClass("nanoGalleryLBarOff"),
                  null != this.GOM.albumIdxLoading &&
                    -1 != this.GOM.albumIdxLoading)
                ) {
                  this.I[this.GOM.albumIdxLoading].$Elts[
                    ".nGY2TnImg"
                  ].removeClass("nGY2GThumbnailLoaderDisplayed");
                }
              }),
              (e.AreaShuffle = function (e) {
                for (
                  var t, n, i = e.length;
                  i;
                  t = Math.floor(Math.random() * i),
                    n = e[--i],
                    e[i] = e[t],
                    e[t] = n
                );
                return e;
              }),
              (e.GetImageTitleFromURL = function (e) {
                return "%filename" == this.O.thumbnailLabel.get("title")
                  ? e.split("/").pop().replace("_", " ")
                  : "%filenameNoExt" == this.O.thumbnailLabel.get("title")
                  ? e.split("/").pop().split(".").shift().replace("_", " ")
                  : "";
              }),
              (e.AlbumPostProcess = function (t) {
                var n = this.gallerySorting[this.GOM.curNavLevel],
                  i = this.galleryMaxItems[this.GOM.curNavLevel];
                if ("" != n || i > 0) {
                  var a = this.I.filter(function (e) {
                    return e.albumID == t && "albumUp" != e.kind;
                  });
                  switch (n) {
                    case "RANDOM":
                      a = e.AreaShuffle(a);
                      break;
                    case "REVERSED":
                      a = a.reverse();
                      break;
                    case "TITLEASC":
                      a.sort(function (e, t) {
                        return e.title.toUpperCase() < t.title.toUpperCase()
                          ? -1
                          : e.title.toUpperCase() > t.title.toUpperCase()
                          ? 1
                          : 0;
                      });
                      break;
                    case "TITLEDESC":
                      a.sort(function (e, t) {
                        return e.title.toUpperCase() > t.title.toUpperCase()
                          ? -1
                          : e.title.toUpperCase() < t.title.toUpperCase()
                          ? 1
                          : 0;
                      });
                  }
                  i > 0 && a.length > i && a.splice(i - 1, a.length - i),
                    this.I.removeIf(function (e) {
                      return e.albumID == t && "albumUp" != e.kind;
                    }),
                    this.I.push.apply(this.I, a);
                }
              }),
              e
            );
          })()),
          (window.NGY2Item = (function () {
            var e = 1;
            function t(t) {
              var n = 0;
              (n = null == t ? e++ : t),
                (this.GetID = function () {
                  return n;
                }),
                (this.kind = ""),
                (this.mediaKind = "img"),
                (this.mediaMarkup = ""),
                (this.G = null),
                (this.title = ""),
                (this.description = ""),
                (this.albumID = 0),
                (this.src = ""),
                (this.width = 0),
                (this.height = 0),
                (this.destinationURL = ""),
                (this.downloadURL = ""),
                (this.author = ""),
                (this.left = 0),
                (this.top = 0),
                (this.width = 0),
                (this.height = 0),
                (this.resizedContentWidth = 0),
                (this.resizedContentHeight = 0),
                (this.thumbs = {
                  url: {
                    l1: { xs: "", sm: "", me: "", la: "", xl: "" },
                    lN: { xs: "", sm: "", me: "", la: "", xl: "" },
                  },
                  width: {
                    l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                    lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                  },
                  height: {
                    l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                    lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                  },
                }),
                (this.thumbnailImgRevealed = !1),
                (this.imageDominantColors = null),
                (this.imageDominantColor = null),
                (this.featured = !1),
                (this.flickrThumbSizes = {}),
                (this.picasaThumbs = null),
                (this.hovered = !1),
                (this.hoverInitDone = !1),
                (this.contentIsLoaded = !1),
                (this.contentLength = 0),
                (this.numberItems = 0),
                (this.mediaNumber = 0),
                (this.mediaCounter = 0),
                (this.eltTransform = []),
                (this.eltFilter = []),
                (this.eltEffect = []),
                (this.paginationLastPage = 0),
                (this.paginationLastWidth = 0),
                (this.customData = {}),
                (this.selected = !1),
                (this.imageWidth = 0),
                (this.imageHeight = 0),
                (this.$elt = null),
                (this.$Elts = []),
                (this.tags = []),
                (this.albumTagList = []),
                (this.albumTagListSel = []),
                (this.exif = {
                  exposure: "",
                  flash: "",
                  focallength: "",
                  fstop: "",
                  iso: "",
                  model: "",
                  time: "",
                  location: "",
                }),
                (this.deleted = !1),
                (this.rotationAngle = 0);
            }
            (t.Get = function (e, t) {
              for (var n = e.I.length, i = 0; i < n; i++)
                if (e.I[i].GetID() == t) return e.I[i];
              return null;
            }),
              (t.GetIdx = function (e, t) {
                for (var n = e.I.length, i = 0; i < n; i++)
                  if (e.I[i].GetID() == t) return i;
                return -1;
              }),
              (t.New = function (e, n, i, o, r, l, s) {
                var u = t.Get(e, r);
                if (null !== e.O.titleTranslationMap) {
                  let t = e.O.titleTranslationMap.find((e) => e.title === n);
                  void 0 !== t && (n = t.replace);
                }
                if (
                  -1 != r &&
                  0 != r &&
                  "image gallery by nanogallery2 [build]" != n &&
                  e.O.thumbnailLevelUp &&
                  0 == u.getContentLength(!1) &&
                  "" == e.O.album
                ) {
                  let n = new t("0");
                  e.I.push(n),
                    (u.contentLength += 1),
                    (n.title = "UP"),
                    (n.albumID = r),
                    (n.kind = "albumUp"),
                    (n.G = e),
                    jQuery.extend(!0, n.thumbs.width, e.tn.defaultSize.width),
                    jQuery.extend(!0, n.thumbs.height, e.tn.defaultSize.height);
                }
                var c = t.Get(e, o);
                null === c &&
                  ((c = new t(o)),
                  e.I.push(c),
                  -1 != r &&
                    "image gallery by nanogallery2 [build]" != n &&
                    (u.contentLength += 1)),
                  (c.G = e),
                  (c.albumID = r),
                  (c.kind = l),
                  "image" == l &&
                    ((u.mediaCounter += 1), (c.mediaNumber = u.mediaCounter));
                var h = e.O.thumbnailFeaturedKeyword;
                if ("" != h) {
                  h = h.toUpperCase();
                  var d = n.toUpperCase().indexOf(h);
                  d > -1 &&
                    ((c.featured = !0),
                    (n =
                      n.substring(0, d) + n.substring(d + h.length, n.length))),
                    (d = i.toUpperCase().indexOf(h)) > -1 &&
                      ((c.featured = !0),
                      (i =
                        i.substring(0, d) +
                        i.substring(d + h.length, i.length)));
                }
                if ("string" == typeof e.galleryFilterTags.Get())
                  switch (e.galleryFilterTags.Get().toUpperCase()) {
                    case "TITLE": {
                      let e,
                        t = /(?:^|\W)#(\w+)(?!\w)/g,
                        i = [];
                      for (; (e = t.exec(n)); )
                        i.push(e[1].replace(/^\s*|\s*$/, ""));
                      c.setTags(i), (n = n.split("#").join(""));
                      break;
                    }
                    case "DESCRIPTION": {
                      let e,
                        t = /(?:^|\W)#(\w+)(?!\w)/g,
                        n = [];
                      for (; (e = t.exec(i)); )
                        n.push(e[1].replace(/^\s*|\s*$/, ""));
                      c.setTags(n), (i = i.split("#").join(""));
                      break;
                    }
                  }
                else "" != s && null != s && c.setTags(s.split(" "));
                return (c.title = a(e, n)), (c.description = a(e, i)), c;
              }),
              (t.prototype.delete = function () {
                (this.deleted = !0),
                  this.G.I[t.GetIdx(this.G, this.albumID)].contentLength--,
                  this.G.I[t.GetIdx(this.G, this.albumID)].numberItems--;
                for (
                  var e = this.G.GOM.items.length,
                    n = this.GetID(),
                    i = -1,
                    a = -1,
                    o = 0;
                  o < e;
                  o++
                ) {
                  var r = this.G.GOM.items[o],
                    l = this.G.I[r.thumbnailIdx];
                  l.GetID() == n
                    ? r.neverDisplayed || ((i = r.thumbnailIdx), (a = o))
                    : -1 != i &&
                      (r.neverDisplayed ||
                        (l.$getElt(".nGY2GThumbnail").data("index", o - 1),
                        l.$getElt(".nGY2GThumbnailImg").data("index", o - 1)));
                }
                if (-1 != i) {
                  var s = this.G;
                  1 == this.selected &&
                    ((this.selected = !1), s.GOM.nbSelected--),
                    null !== s.I[i].$elt && s.I[i].$elt.remove(),
                    s.GOM.items.splice(a, 1),
                    -1 != s.GOM.lastDisplayedIdx &&
                      (s.GOM.lastDisplayedIdx -= 1);
                }
              }),
              (t.prototype.addToGOM = function () {
                for (
                  var e = this.GetID(), t = this.G.I.length, n = 0;
                  n < t;
                  n++
                ) {
                  var i = this.G.I[n];
                  if (i.GetID() == e) {
                    var a = i.thumbImg().width,
                      o = i.thumbImg().height;
                    0 == o && (o = this.G.tn.defaultSize.getHeight()),
                      0 == a && (a = this.G.tn.defaultSize.getWidth());
                    var r = new this.G.GOM.GTn(n, a, o);
                    this.G.GOM.items.push(r);
                    break;
                  }
                }
              });
            var i = {
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
              "/": "&#x2F;",
              "`": "&#x60;",
              "=": "&#x3D;",
            };
            function a(e, t) {
              return 1 == e.O.allowHTMLinData
                ? t
                : String(t).replace(/[&<>"'`=\/]/g, function (e) {
                    return i[e];
                  });
            }
            function o(e, t) {
              if ("0" === (e = String(e)) || 1 == t) return e;
              var n = Number(e.replace(/[a-zA-Z]/g, "")),
                i = e.match(/([^\-0-9\.]+)/g),
                a = "";
              return (
                null != i && i.length > 0 && (a = i.join()),
                isNaN(n) || 0 == n ? e : (n *= t) + a
              );
            }
            return (
              (t.get_nextId = function () {
                return e;
              }),
              (t.prototype.$getElt = function (e, t) {
                return null == this.$elt
                  ? null
                  : ((void 0 !== this.$Elts[e] && 1 == !t) ||
                      (this.$Elts[e] =
                        ".nGY2GThumbnail" == e ? this.$elt : this.$elt.find(e)),
                    this.$Elts[e]);
              }),
              (t.prototype.removeElt = function (e) {
                if (null != this.$elt && null != this.$Elts[e]) {
                  this.$Elts[e].remove();
                  var t = this.$Elts.indexOf(e);
                  this.$Elts.splice(t, 1);
                }
              }),
              (t.prototype.album = function () {
                return this.G.I[t.GetIdx(this.G, this.albumID)];
              }),
              (t.prototype.mediaTransition = function () {
                return (
                  this.G.O.viewerTransitionMediaKind.indexOf(this.mediaKind) >
                  -1
                );
              }),
              (t.prototype.imageSet = function (e, t, n) {
                (this.src = e), (this.width = t), (this.height = n);
              }),
              (t.prototype.thumbSet = function (e, t, n, i, a) {
                var o = ["xs", "sm", "me", "la", "xl"];
                if (void 0 === i || "" == i || null == i)
                  for (var r = 0; r < o.length; r++)
                    void 0 === a || "" == a
                      ? ((this.thumbs.url.l1[o[r]] = e),
                        (this.thumbs.height.l1[o[r]] = n),
                        (this.thumbs.width.l1[o[r]] = t),
                        (this.thumbs.url.lN[o[r]] = e),
                        (this.thumbs.height.lN[o[r]] = n),
                        (this.thumbs.width.lN[o[r]] = t))
                      : ((this.thumbs.url[a][o[r]] = e),
                        (this.thumbs.height[a][o[r]] = n),
                        (this.thumbs.width[a][o[r]] = t));
                else
                  void 0 === a || "" == a || null == a
                    ? ((this.thumbs.url.l1[i] = e),
                      (this.thumbs.height.l1[i] = n),
                      (this.thumbs.width.l1[i] = t),
                      (this.thumbs.url.lN[i] = e),
                      (this.thumbs.height.lN[i] = n),
                      (this.thumbs.width.lN[i] = t))
                    : ((this.thumbs.url[a][i] = e),
                      (this.thumbs.height[a][i] = n),
                      (this.thumbs.width[a][i] = t));
                for (r = 0; r < o.length; r++) this.thumbs.height.l1[o[r]] = n;
                for (r = 0; r < o.length; r++)
                  this.G.tn.settings.height.lN[o[r]] ==
                    this.G.tn.settings.getH() &&
                    this.G.tn.settings.width.l1[o[r]] ==
                      this.G.tn.settings.getW() &&
                    (this.thumbs.height.lN[o[r]] = n);
              }),
              (t.prototype.thumbSetImgHeight = function (e) {
                for (
                  var t = ["xs", "sm", "me", "la", "xl"], n = 0;
                  n < t.length;
                  n++
                )
                  this.G.tn.settings.height.l1[t[n]] ==
                    this.G.tn.settings.getH() &&
                    this.G.tn.settings.width.l1[t[n]] ==
                      this.G.tn.settings.getW() &&
                    (this.thumbs.height.l1[t[n]] = e);
                for (n = 0; n < t.length; n++)
                  this.G.tn.settings.height.lN[t[n]] ==
                    this.G.tn.settings.getH() &&
                    this.G.tn.settings.width.l1[t[n]] ==
                      this.G.tn.settings.getW() &&
                    (this.thumbs.height.lN[t[n]] = e);
              }),
              (t.prototype.thumbSetImgWidth = function (e) {
                for (
                  var t = ["xs", "sm", "me", "la", "xl"], n = 0;
                  n < t.length;
                  n++
                )
                  this.G.tn.settings.height.l1[t[n]] ==
                    this.G.tn.settings.getH() &&
                    this.G.tn.settings.width.l1[t[n]] ==
                      this.G.tn.settings.getW() &&
                    (this.thumbs.width.l1[t[n]] = e);
                for (n = 0; n < t.length; n++)
                  this.G.tn.settings.height.lN[t[n]] ==
                    this.G.tn.settings.getH() &&
                    this.G.tn.settings.width.l1[t[n]] ==
                      this.G.tn.settings.getW() &&
                    (this.thumbs.width.lN[t[n]] = e);
              }),
              (t.prototype.thumbImg = function () {
                var e = { src: "", width: 0, height: 0 };
                return "image gallery by nanogallery2 [build]" == this.title
                  ? ((e.src = this.G.emptyGif), (e.url = this.G.emptyGif), e)
                  : ((e.src =
                      this.thumbs.url[this.G.GOM.curNavLevel][
                        this.G.GOM.curWidth
                      ]),
                    (e.width =
                      this.thumbs.width[this.G.GOM.curNavLevel][
                        this.G.GOM.curWidth
                      ]),
                    (e.height =
                      this.thumbs.height[this.G.GOM.curNavLevel][
                        this.G.GOM.curWidth
                      ]),
                    e);
              }),
              (t.prototype.setTags = function (e) {
                if (e.length > 0) {
                  this.tags = e;
                  for (
                    var t = this.album().albumTagList, n = 0;
                    n < e.length;
                    n++
                  ) {
                    for (var i = !1, a = 0; a < t.length; a++)
                      e[n].toUpperCase() == t[a].toUpperCase() && (i = !0);
                    0 == i && this.album().albumTagList.push(e[n]);
                  }
                }
              }),
              (t.prototype.checkTagFilter = function () {
                if (
                  0 != this.G.galleryFilterTags.Get() &&
                  this.album().albumTagList.length > 0
                ) {
                  if (this.G.O.thumbnailLevelUp && "albumUp" == this.kind)
                    return !0;
                  var e = !1,
                    t = this.album().albumTagListSel;
                  if (0 == t.length) return !0;
                  for (var n = 0; n < this.tags.length; n++)
                    for (var i = 0; i < t.length; i++)
                      if (this.tags[n].toUpperCase() == t[i].toUpperCase()) {
                        e = !0;
                        break;
                      }
                  return e;
                }
                return !0;
              }),
              (t.prototype.isSearchTagFound = function () {
                if ("" == this.G.GOM.albumSearchTags) return !0;
                if (this.G.O.thumbnailLevelUp && "albumUp" == this.kind)
                  return !0;
                for (var e = 0; e < this.tags.length; e++)
                  if (
                    this.tags[e]
                      .toUpperCase()
                      .indexOf(this.G.GOM.albumSearchTags) >= 0
                  )
                    return !0;
                return !1;
              }),
              (t.prototype.setMediaURL = function (e, t) {
                (this.src = e),
                  (this.mediaKind = t),
                  "img" == t &&
                    (this.mediaMarkup =
                      '<img class="nGY2ViewerMedia" src="' +
                      e +
                      '" alt=" " itemprop="contentURL" draggable="false">');
              }),
              (t.prototype.isToDisplay = function (e) {
                return (
                  this.albumID == e &&
                  this.checkTagFilter() &&
                  this.isSearchFound() &&
                  this.isSearchTagFound() &&
                  0 == this.deleted
                );
              }),
              (t.prototype.getContentLength = function (e) {
                if (
                  0 == e ||
                  0 == this.albumTagList.length ||
                  0 == this.G.galleryFilterTags.Get()
                )
                  return this.contentLength;
                for (
                  var t = this.G.I.length, n = 0, i = this.GetID(), a = 0;
                  a < t;
                  a++
                ) {
                  this.G.I[a].isToDisplay(i) && n++;
                }
                return n;
              }),
              (t.prototype.isSearchFound = function () {
                return (
                  "" == this.G.GOM.albumSearch ||
                  -1 != this.title.toUpperCase().indexOf(this.G.GOM.albumSearch)
                );
              }),
              (t.prototype.responsiveURL = function () {
                var e = "";
                switch (this.G.O.kind) {
                  case "":
                  case "flickr":
                    e = this.src;
                    break;
                  case "picasa":
                  case "google":
                  case "google2":
                  default:
                    e = this.src;
                }
                return e;
              }),
              (t.prototype.ThumbnailImageReveal = function () {
                0 == this.thumbnailImgRevealed &&
                  ((this.thumbnailImgRevealed = !0),
                  new NGTweenable().tween({
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                    attachment: { item: this },
                    delay: 30,
                    duration: 400,
                    easing: "easeOutQuart",
                    step: function (e, t) {
                      var n = t.item.$getElt(".nGY2TnImg");
                      null != n && n.css(e);
                    },
                  }));
              }),
              (t.prototype.CSSTransformApply = function (e) {
                var t = this.eltTransform[e];
                if (".nGY2GThumbnail" == e)
                  for (
                    var n = t.$elt.length - 1,
                      i = 1,
                      a = 1,
                      r = 1,
                      l = 1,
                      s = 1,
                      u = 1,
                      c = 1,
                      h = n;
                    h >= 0;
                    h--
                  ) {
                    var d =
                      "translateX(" +
                      o(t.translateX, i) +
                      ") translateY(" +
                      o(t.translateY, a) +
                      ") translateZ(" +
                      o(t.translateZ, r) +
                      ") scale(" +
                      o(t.scale, c) +
                      ") translate(" +
                      o(t.translate, 1) +
                      ")";
                    this.G.IE <= 9 || this.G.isGingerbread
                      ? (d += " rotate(" + o(t.rotateZ, u) + ")")
                      : (d +=
                          " rotateX(" +
                          o(t.rotateX, l) +
                          ") rotateY(" +
                          o(t.rotateY, s) +
                          ") rotateZ(" +
                          o(t.rotateZ, u) +
                          ") rotate(" +
                          o(t.rotate, 1) +
                          ")"),
                      (t.$elt[h].style[this.G.CSStransformName] = d),
                      n > 0 &&
                        ((i -= this.G.tn.opt.Get("stacksTranslateX")),
                        (a -= this.G.tn.opt.Get("stacksTranslateY")),
                        (r -= this.G.tn.opt.Get("stacksTranslateZ")),
                        (l -= this.G.tn.opt.Get("stacksRotateX")),
                        (s -= this.G.tn.opt.Get("stacksRotateY")),
                        (u -= this.G.tn.opt.Get("stacksRotateZ")),
                        (c -= this.G.tn.opt.Get("stacksScale")));
                  }
                else if (null != t.$elt)
                  for (h = 0; h < t.$elt.length; h++)
                    if (null != t.$elt[h]) {
                      d =
                        "translateX(" +
                        t.translateX +
                        ") translateY(" +
                        t.translateY +
                        ") translateZ(" +
                        t.translateZ +
                        ") scale(" +
                        t.scale +
                        ") translate(" +
                        t.translate +
                        ")";
                      this.G.IE <= 9 || this.G.isGingerbread
                        ? (d += " rotate(" + t.rotateZ + ")")
                        : (d +=
                            " rotateX(" +
                            t.rotateX +
                            ") rotateY(" +
                            t.rotateY +
                            ") rotateZ(" +
                            t.rotateZ +
                            ") rotate(" +
                            t.rotate +
                            ")"),
                        (t.$elt[h].style[this.G.CSStransformName] = d);
                    }
              }),
              (t.prototype.CSSTransformSet = function (e, t, n, i) {
                null == this.eltTransform[e] &&
                  ((this.eltTransform[e] = {
                    translateX: 0,
                    translateY: 0,
                    translateZ: 0,
                    rotateX: 0,
                    rotateY: 0,
                    rotateZ: 0,
                    scale: 1,
                    translate: "0px,0px",
                    rotate: 0,
                  }),
                  (this.eltTransform[e].$elt = this.$getElt(e))),
                  (this.eltTransform[e][t] = n),
                  !0 === i && (this.eltTransform[e].$elt = this.$getElt(e, !0));
              }),
              (t.prototype.CSSFilterApply = function (e) {
                var t = this.eltFilter[e],
                  n =
                    "blur(" +
                    t.blur +
                    ") brightness(" +
                    t.brightness +
                    ") grayscale(" +
                    t.grayscale +
                    ") sepia(" +
                    t.sepia +
                    ") contrast(" +
                    t.contrast +
                    ") opacity(" +
                    t.opacity +
                    ") saturate(" +
                    t.saturate +
                    ")";
                if (null != t.$elt)
                  for (var i = 0; i < t.$elt.length; i++)
                    null != t.$elt[i] &&
                      ((t.$elt[i].style.WebkitFilter = n),
                      (t.$elt[i].style.filter = n));
              }),
              (t.prototype.CSSFilterSet = function (e, t, n, i) {
                null == this.eltFilter[e] &&
                  ((this.eltFilter[e] = {
                    blur: 0,
                    brightness: "100%",
                    grayscale: "0%",
                    sepia: "0%",
                    contrast: "100%",
                    opacity: "100%",
                    saturate: "100%",
                  }),
                  (this.eltFilter[e].$elt = this.$getElt(e))),
                  (this.eltFilter[e][t] = n),
                  !0 === i && (this.eltTransform[e].$elt = this.$getElt(e, !0));
              }),
              (t.prototype.animate = function (e, t, i) {
                if (null != this.$getElt()) {
                  var a = {};
                  (a.G = this.G),
                    (a.item = this),
                    (a.effect = e),
                    (a.hoverIn = i),
                    (a.cssKind = ""),
                    i
                      ? (null == this.eltEffect[e.element] &&
                          (this.eltEffect[e.element] = []),
                        null == this.eltEffect[e.element][e.type] &&
                          (this.eltEffect[e.element][e.type] = {
                            initialValue: 0,
                            lastValue: 0,
                          }),
                        e.firstKeyframe &&
                          (this.eltEffect[e.element][e.type] = {
                            initialValue: e.from,
                            lastValue: e.from,
                          }),
                        (a.animeFrom = e.from),
                        (a.animeTo = e.to),
                        (a.animeDuration = parseInt(e.duration)),
                        (a.animeDelay = 30 + parseInt(e.delay + t)),
                        (a.animeEasing = e.easing))
                      : ((a.animeFrom =
                          this.eltEffect[e.element][e.type].lastValue),
                        (a.animeTo =
                          this.eltEffect[e.element][e.type].initialValue),
                        (a.animeDuration = parseInt(e.durationBack)),
                        (a.animeDelay = 30 + parseInt(e.delayBack + t)),
                        (a.animeEasing = e.easingBack));
                  for (
                    var o = [
                        "translateX",
                        "translateY",
                        "translateZ",
                        "scale",
                        "rotateX",
                        "rotateY",
                        "rotateZ",
                      ],
                      r = 0;
                    r < o.length;
                    r++
                  )
                    if (e.type == o[r]) {
                      a.cssKind = "transform";
                      break;
                    }
                  var l = [
                    "blur",
                    "brightness",
                    "grayscale",
                    "sepia",
                    "contrast",
                    "opacity",
                    "saturate",
                  ];
                  for (r = 0; r < l.length; r++)
                    if (e.type == l[r]) {
                      a.cssKind = "filter";
                      break;
                    }
                  !i ||
                    ".nGY2GThumbnail" != e.element ||
                    ("scale" != e.type && "rotateX" != e.type) ||
                    (this.G.GOM.lastZIndex++,
                    this.$getElt(e.element).css(
                      "z-index",
                      this.G.GOM.lastZIndex
                    ));
                  var s = new NGTweenable();
                  (a.tweenable = s),
                    s.tween({
                      attachment: a,
                      from: { v: a.animeFrom },
                      to: { v: a.animeTo },
                      duration: a.animeDuration,
                      delay: a.animeDelay,
                      easing: a.animeEasing,
                      step: function (e, t) {
                        if (null != t.item.$getElt())
                          if (!t.hoverIn || t.item.hovered) {
                            if (t.G.VOM.viewerDisplayed) t.tweenable.stop(!1);
                            else if (e.v != t.animeFrom) {
                              switch (t.cssKind) {
                                case "transform":
                                  t.item.CSSTransformSet(
                                    t.effect.element,
                                    t.effect.type,
                                    e.v
                                  ),
                                    t.item.CSSTransformApply(t.effect.element);
                                  break;
                                case "filter":
                                  t.item.CSSFilterSet(
                                    t.effect.element,
                                    t.effect.type,
                                    e.v
                                  ),
                                    t.item.CSSFilterApply(t.effect.element);
                                  break;
                                default:
                                  var a = e.v;
                                  ("rgb(" != e.v.substring(0, 4) &&
                                    "rgba(" != e.v.substring(0, 5)) ||
                                    (a = n(0, a)),
                                    t.item
                                      .$getElt(t.effect.element)
                                      .css(t.effect.type, a);
                              }
                              i &&
                                (t.item.eltEffect[t.effect.element][
                                  t.effect.type
                                ].lastValue = e.v);
                            }
                          } else t.tweenable.stop(!1);
                        else t.tweenable.stop(!1);
                      },
                      finish: function (e, t) {
                        if (
                          (i &&
                            (t.item.eltEffect[t.effect.element][
                              t.effect.type
                            ].lastValue = e.v),
                          null != t.item.$getElt() &&
                            (!t.hoverIn || t.item.hovered) &&
                            !t.G.VOM.viewerDisplayed)
                        )
                          switch (t.cssKind) {
                            case "transform":
                              t.item.CSSTransformSet(
                                t.effect.element,
                                t.effect.type,
                                t.animeTo
                              ),
                                t.item.CSSTransformApply(t.effect.element);
                              break;
                            case "filter":
                              t.item.CSSFilterSet(
                                t.effect.element,
                                t.effect.type,
                                t.animeTo
                              ),
                                t.item.CSSFilterApply(t.effect.element);
                              break;
                            default:
                              t.item
                                .$getElt(t.effect.element)
                                .css(t.effect.type, t.animeTo);
                          }
                      },
                    });
                }
              }),
              t
            );
          })())),
          (i.options = jQuery.extend(
            !0,
            {},
            jQuery.nanogallery2.defaultOptions,
            t
          )),
          (i.nG2 = null),
          (i.nG2 = new l()),
          i.nG2.initiateGallery2(i.e, i.options);
      }),
      (i.test = function () {}),
      i.init();
  }),
    (jQuery.nanogallery2.defaultOptions = {
      kind: "",
      userID: "",
      photoset: "",
      album: "",
      blockList: "scrapbook|profil|auto backup",
      tagBlockList: "",
      allowList: "",
      albumList: "",
      albumList2: null,
      RTL: !1,
      flickrSkipOriginal: !0,
      flickrAPIKey: "",
      breadcrumbAutoHideTopLevel: !0,
      displayBreadcrumb: !0,
      breadcrumbOnlyCurrentLevel: !0,
      breadcrumbHideIcons: !0,
      theme: "nGY2",
      galleryTheme: "dark",
      viewerTheme: "dark",
      items: null,
      itemsBaseURL: "",
      thumbnailSelectable: !1,
      dataProvider: "",
      allowHTMLinData: !1,
      locationHash: !0,
      slideshowDelay: 3e3,
      slideshowAutoStart: !1,
      debugMode: !1,
      titleTranslationMap: null,
      galleryDisplayMoreStep: 2,
      galleryDisplayMode: "fullContent",
      galleryL1DisplayMode: null,
      galleryPaginationMode: "rectangles",
      galleryPaginationTopButtons: !0,
      galleryMaxRows: 2,
      galleryL1MaxRows: null,
      galleryLastRowFull: !1,
      galleryL1LastRowFull: null,
      galleryLayoutEngine: "default",
      paginationSwipe: !0,
      paginationVisiblePages: 10,
      galleryFilterTags: !1,
      galleryL1FilterTags: null,
      galleryFilterTagsMode: "single",
      galleryL1FilterTagsMode: null,
      galleryMaxItems: 0,
      galleryL1MaxItems: null,
      gallerySorting: "",
      galleryL1Sorting: null,
      galleryDisplayTransition: "none",
      galleryL1DisplayTransition: null,
      galleryDisplayTransitionDuration: 1e3,
      galleryL1DisplayTransitionDuration: null,
      galleryResizeAnimation: !1,
      galleryRenderDelay: 10,
      thumbnailCrop: !0,
      thumbnailL1Crop: null,
      thumbnailCropScaleFactor: 1.5,
      thumbnailLevelUp: !1,
      thumbnailAlignment: "fillWidth",
      thumbnailWidth: 300,
      thumbnailL1Width: null,
      thumbnailHeight: 200,
      thumbnailL1Height: null,
      thumbnailBaseGridHeight: 0,
      thumbnailL1BaseGridHeight: null,
      thumbnailGutterWidth: 2,
      thumbnailL1GutterWidth: null,
      thumbnailGutterHeight: 2,
      thumbnailL1GutterHeight: null,
      thumbnailBorderVertical: 2,
      thumbnailL1BorderVertical: null,
      thumbnailBorderHorizontal: 2,
      thumbnailL1BorderHorizontal: null,
      thumbnailFeaturedKeyword: "*featured",
      thumbnailAlbumDisplayImage: !1,
      thumbnailHoverEffect2: "toolsAppear",
      thumbnailBuildInit2: "",
      thumbnailStacks: 0,
      thumbnailL1Stacks: null,
      thumbnailStacksTranslateX: 0,
      thumbnailL1StacksTranslateX: null,
      thumbnailStacksTranslateY: 0,
      thumbnailL1StacksTranslateY: null,
      thumbnailStacksTranslateZ: 0,
      thumbnailL1StacksTranslateZ: null,
      thumbnailStacksRotateX: 0,
      thumbnailL1StacksRotateX: null,
      thumbnailStacksRotateY: 0,
      thumbnailL1StacksRotateY: null,
      thumbnailStacksRotateZ: 0,
      thumbnailL1StacksRotateZ: null,
      thumbnailStacksScale: 0,
      thumbnailL1StacksScale: null,
      thumbnailDisplayOutsideScreen: !0,
      thumbnailWaitImageLoaded: !0,
      thumbnailSliderDelay: 2e3,
      galleryBuildInit2: "",
      portable: !1,
      eventsDebounceDelay: 10,
      touchAnimation: !1,
      touchAnimationL1: void 0,
      touchAutoOpenDelay: 0,
      thumbnailLabel: {
        position: "overImage",
        align: "center",
        valign: "bottom",
        display: !0,
        displayDescription: !1,
        titleMaxLength: 0,
        titleMultiLine: !1,
        descriptionMaxLength: 0,
        descriptionMultiLine: !1,
        hideIcons: !0,
        title: "",
      },
      thumbnailToolbarImage: { topLeft: "select", topRight: "featured" },
      thumbnailToolbarAlbum: { topLeft: "select", topRight: "counter" },
      thumbnailDisplayOrder: "",
      thumbnailL1DisplayOrder: null,
      thumbnailDisplayInterval: 15,
      thumbnailL1DisplayInterval: null,
      thumbnailDisplayTransition: "fadeIn",
      thumbnailL1DisplayTransition: null,
      thumbnailDisplayTransitionEasing: "easeOutQuart",
      thumbnailL1DisplayTransitionEasing: null,
      thumbnailDisplayTransitionDuration: 240,
      thumbnailL1DisplayTransitionDuration: null,
      thumbnailOpenInLightox: !0,
      thumbnailOpenOriginal: !1,
      lightboxStandalone: !1,
      viewer: "internal",
      viewerFullscreen: !1,
      imageTransition: "swipe2",
      viewerTransitionMediaKind: "img",
      viewerZoom: !0,
      viewerImageDisplay: "",
      openOnStart: "",
      viewerHideToolsDelay: 4e3,
      viewerToolbar: {
        display: !1,
        position: "bottom",
        fullWidth: !1,
        align: "center",
        autoMinimize: 0,
        standard: "minimizeButton,label",
        minimized:
          "minimizeButton,label,infoButton,shareButton,fullscreenButton",
      },
      viewerTools: {
        topLeft: "pageCounter,playPauseButton",
        topRight: "rotateLeft,rotateRight,fullscreenButton,closeButton",
      },
      viewerGallery: "bottomOverMedia",
      viewerGalleryTWidth: 40,
      viewerGalleryTHeight: 40,
      breakpointSizeSM: 480,
      breakpointSizeME: 992,
      breakpointSizeLA: 1200,
      breakpointSizeXL: 1800,
      fnThumbnailInit: null,
      fnThumbnailHoverInit: null,
      fnThumbnailHover: null,
      fnThumbnailHoverOut: null,
      fnThumbnailDisplayEffect: null,
      fnViewerInfo: null,
      fnImgToolbarCustInit: null,
      fnImgToolbarCustDisplay: null,
      fnImgToolbarCustClick: null,
      fnProcessData: null,
      fnThumbnailSelection: null,
      fnGalleryRenderStart: null,
      fnGalleryRenderEnd: null,
      fnGalleryObjectModelBuilt: null,
      fnGalleryLayoutApplied: null,
      fnThumbnailClicked: null,
      fnShoppingCartUpdated: null,
      fnThumbnailToolCustAction: null,
      fnThumbnailOpen: null,
      fnImgDisplayed: null,
      fnPopupMediaInfo: null,
      i18n: {
        breadcrumbHome: "Galleries",
        breadcrumbHome_FR: "Galeries",
        thumbnailImageTitle: "",
        thumbnailAlbumTitle: "",
        thumbnailImageDescription: "",
        thumbnailAlbumDescription: "",
        infoBoxPhoto: "Photo",
        infoBoxDate: "Date",
        infoBoxAlbum: "Album",
        infoBoxDimensions: "Dimensions",
        infoBoxFilename: "Filename",
        infoBoxFileSize: "File size",
        infoBoxCamera: "Camera",
        infoBoxFocalLength: "Focal length",
        infoBoxExposure: "Exposure",
        infoBoxFNumber: "F Number",
        infoBoxISO: "ISO",
        infoBoxMake: "Make",
        infoBoxFlash: "Flash",
        infoBoxViews: "Views",
        infoBoxComments: "Comments",
      },
      icons: {
        thumbnailAlbum: '<i class="nGY2Icon-folder-empty"></i>',
        thumbnailImage: '<i class="nGY2Icon-picture"></i>',
        breadcrumbAlbum: '<i class="nGY2Icon-folder-empty"></i>',
        breadcrumbHome: '<i class="nGY2Icon-home"></i>',
        breadcrumbSeparator: '<i class="nGY2Icon-left-open"></i>',
        breadcrumbSeparatorRtl: '<i class="nGY2Icon-right-open"></i>',
        navigationFilterSelected:
          '<i style="color:#fff;" class="nGY2Icon-ok"></i>',
        navigationFilterUnselected:
          '<i style="color:#ddd;opacity:0.3;" class="nGY2Icon-circle-empty"></i>',
        navigationFilterSelectedAll: '<i class="nGY2Icon-ccw"></i>',
        navigationPaginationPrevious:
          '<i class="nGY2Icon-ngy2_chevron-left"></i>',
        navigationPaginationNext: '<i class="nGY2Icon-ngy2_chevron-right"></i>',
        thumbnailSelected:
          '<i style="color:#bff;" class="nGY2Icon-ok-circled"></i>',
        thumbnailUnselected:
          '<i style="color:#bff;" class="nGY2Icon-circle-empty"></i>',
        thumbnailFeatured: '<i style="color:#dd5;" class="nGY2Icon-star"></i>',
        thumbnailCounter: '<i class="nGY2Icon-picture"></i>',
        thumbnailShare: '<i class="nGY2Icon-ngy2_share2"></i>',
        thumbnailDownload: '<i class="nGY2Icon-ngy2_download2"></i>',
        thumbnailInfo: '<i class="nGY2Icon-ngy2_info2"></i>',
        thumbnailShoppingcart: '<i class="nGY2Icon-basket"></i>',
        thumbnailDisplay: '<i class="nGY2Icon-resize-full"></i>',
        thumbnailCustomTool1: "T1",
        thumbnailCustomTool2: "T2",
        thumbnailCustomTool3: "T3",
        thumbnailCustomTool4: "T4",
        thumbnailCustomTool5: "T5",
        thumbnailCustomTool6: "T6",
        thumbnailCustomTool7: "T7",
        thumbnailCustomTool8: "T8",
        thumbnailCustomTool9: "T9",
        thumbnailCustomTool10: "T10",
        thumbnailAlbumUp:
          '<i style="font-size: 3em;" class="nGY2Icon-ngy2_chevron_up2"></i>',
        paginationNext: '<i class="nGY2Icon-right-open"></i>',
        paginationPrevious: '<i class="nGY2Icon-left-open"></i>',
        galleryMoreButton:
          '<i class="nGY2Icon-picture"></i> &nbsp; <i class="nGY2Icon-right-open"></i>',
        buttonClose: '<i class="nGY2Icon-ngy2_close2"></i>',
        viewerPrevious: '<i class="nGY2Icon-ngy2_chevron-left"></i>',
        viewerNext: '<i class="nGY2Icon-ngy2_chevron-right"></i>',
        viewerImgPrevious: '<i class="nGY2Icon-ngy2_chevron_left3"></i>',
        viewerImgNext: '<i class="nGY2Icon-ngy2_chevron_right3"></i>',
        viewerDownload: '<i class="nGY2Icon-ngy2_download2"></i>',
        viewerToolbarMin: '<i class="nGY2Icon-ellipsis-vert"></i>',
        viewerToolbarStd: '<i class="nGY2Icon-menu"></i>',
        viewerPlay: '<i class="nGY2Icon-play"></i>',
        viewerPause: '<i class="nGY2Icon-pause"></i>',
        viewerFullscreenOn: '<i class="nGY2Icon-resize-full"></i>',
        viewerFullscreenOff: '<i class="nGY2Icon-resize-small"></i>',
        viewerZoomIn: '<i class="nGY2Icon-ngy2_zoom_in2"></i>',
        viewerZoomOut: '<i class="nGY2Icon-ngy2_zoom_out2"></i>',
        viewerLinkOriginal: '<i class="nGY2Icon-ngy2_external2"></i>',
        viewerInfo: '<i class="nGY2Icon-ngy2_info2"></i>',
        viewerShare: '<i class="nGY2Icon-ngy2_share2"></i>',
        viewerRotateLeft: '<i class="nGY2Icon-ccw"></i>',
        viewerRotateRight: '<i class="nGY2Icon-cw"></i>',
        viewerShoppingcart: '<i class="nGY2Icon-basket"></i>',
        user: '<i class="nGY2Icon-user"></i>',
        location: '<i class="nGY2Icon-location"></i>',
        picture: '<i class="nGY2Icon-picture"></i>',
        config: '<i class="nGY2Icon-wrench"></i>',
        shareFacebook:
          '<i style="color:#3b5998;" class="nGY2Icon-facebook-squared"></i>',
        shareTwitter:
          '<i style="color:#00aced;" class="nGY2Icon-twitter-squared"></i>',
        shareTumblr:
          '<i style="color:#32506d;" class="nGY2Icon-tumblr-squared"></i>',
        sharePinterest:
          '<i style="color:#cb2027;" class="nGY2Icon-pinterest-squared"></i>',
        shareVK: '<i style="color:#3b5998;" class="nGY2Icon-vkontakte"></i>',
        shareMail: '<i style="color:#555;" class="nGY2Icon-mail-alt"></i>',
        viewerCustomTool1: "T1",
        viewerCustomTool2: "T2",
        viewerCustomTool3: "T3",
        viewerCustomTool4: "T4",
        viewerCustomTool5: "T5",
        viewerCustomTool6: "T6",
        viewerCustomTool7: "T7",
        viewerCustomTool8: "T8",
        viewerCustomTool9: "T9",
        viewerCustomTool10: "T10",
      },
    }),
    (jQuery.fn.nanogallery2 = function (t, n, i) {
      if (void 0 === jQuery(this).data("nanogallery2data")) {
        if ("destroy" == t) return;
        return this.each(function () {
          new jQuery.nanogallery2(this, t);
        });
      }
      var a = e(this).data("nanogallery2data").nG2;
      if (void 0 === t || !0 !== t.lightboxStandalone) {
        switch (t) {
          case "displayItem":
            a.DisplayItem(n);
            break;
          case "search":
            return a.Search(n);
          case "search2":
            return a.Search2(n, i);
          case "search2Execute":
            return a.Search2Execute();
          case "refresh":
            a.Refresh();
            break;
          case "resize":
            a.Resize();
            break;
          case "instance":
            return a;
          case "data":
            return (
              (a.data = {
                items: a.I,
                gallery: a.GOM,
                lightbox: a.VOM,
                shoppingcart: a.shoppingCart,
              }),
              a.data
            );
          case "reload":
            return a.ReloadAlbum(), e(this);
          case "itemsSelectedGet":
            return a.ItemsSelectedGet();
          case "itemsSetSelectedValue":
            a.ItemsSetSelectedValue(n, i);
            break;
          case "option":
            if (void 0 === i) return a.Get(n);
            a.Set(n, i),
              "demoViewportWidth" == n && e(window).trigger("resize");
            break;
          case "destroy":
            a.Destroy(), e(this).removeData("nanogallery2data");
            break;
          case "shoppingCartGet":
            return a.shoppingCart;
          case "shoppingCartUpdate":
            if (void 0 === i || void 0 === n) return !1;
            for (var o = n, r = i, l = 0; l < a.shoppingCart.length; l++)
              if (a.shoppingCart[l].ID == o) {
                a.shoppingCart[l].qty = r;
                let e = a.I[a.shoppingCart[l].idx];
                a.ThumbnailToolbarOneCartUpdate(e),
                  0 == r && a.shoppingCart.splice(l, 1),
                  null !== (u = a.O.fnShoppingCartUpdated) &&
                    ("function" == typeof u
                      ? u(a.shoppingCart, e, "api")
                      : window[u](a.shoppingCart, e, "api"));
                break;
              }
            return a.shoppingCart;
          case "shoppingCartRemove":
            if (void 0 === n) return !1;
            var s = n;
            for (l = 0; l < a.shoppingCart.length; l++)
              if (a.shoppingCart[l].ID == s) {
                var u,
                  c = a.I[a.shoppingCart[l].idx];
                (a.shoppingCart[l].qty = 0),
                  a.ThumbnailToolbarOneCartUpdate(c),
                  a.shoppingCart.splice(l, 1),
                  null !== (u = a.O.fnShoppingCartUpdated) &&
                    ("function" == typeof u
                      ? u(a.shoppingCart, c, "api")
                      : window[u](a.shoppingCart, c, "api"));
                break;
              }
            return a.shoppingCart;
          case "closeViewer":
            a.CloseViewer();
            break;
          case "minimizeToolbar":
            a.MinimizeToolbar();
            break;
          case "maximizeToolbar":
            a.MaximizeToolbar();
            break;
          case "paginationPreviousPage":
            a.PaginationPreviousPage();
            break;
          case "paginationNextPage":
            a.paginationNextPage();
            break;
          case "paginationGotoPage":
            a.PaginationGotoPage(n);
            break;
          case "paginationCountPages":
            a.PaginationCountPages();
        }
        return e(this);
      }
      a.LightboxReOpen();
    }),
    (("undefined" != typeof window ? window : this).ngEvEmitter = (function () {
      function e() {}
      var t = e.prototype;
      return (
        (t.on = function (e, t) {
          if (e && t) {
            var n = (this._events = this._events || {}),
              i = (n[e] = n[e] || []);
            return -1 == i.indexOf(t) && i.push(t), this;
          }
        }),
        (t.once = function (e, t) {
          if (e && t) {
            this.on(e, t);
            var n = (this._onceEvents = this._onceEvents || {});
            return ((n[e] = n[e] || {})[t] = !0), this;
          }
        }),
        (t.off = function (e, t) {
          var n = this._events && this._events[e];
          if (n && n.length) {
            var i = n.indexOf(t);
            return -1 != i && n.splice(i, 1), this;
          }
        }),
        (t.emitEvent = function (e, t) {
          var n = this._events && this._events[e];
          if (n && n.length) {
            var i = 0,
              a = n[i];
            t = t || [];
            for (var o = this._onceEvents && this._onceEvents[e]; a; ) {
              var r = o && o[a];
              r && (this.off(e, a), delete o[a]),
                a.apply(this, t),
                (a = n[(i += r ? 0 : 1)]);
            }
            return this;
          }
        }),
        e
      );
    })()),
    /*!
     * ngimagesLoaded v4.1.1
     */
    (function (e, t) {
      e.ngimagesLoaded = (function (e, t) {
        var n = jQuery,
          i = e.console;
        function a(e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        }
        function o(e, t, i) {
          if (!(this instanceof o)) return new o(e, t, i);
          "string" == typeof e && (e = document.querySelectorAll(e)),
            (this.elements = (function (e) {
              var t = [];
              if (Array.isArray(e)) t = e;
              else if ("number" == typeof e.length)
                for (var n = 0; n < e.length; n++) t.push(e[n]);
              else t.push(e);
              return t;
            })(e)),
            (this.options = a({}, this.options)),
            "function" == typeof t ? (i = t) : a(this.options, t),
            i && this.on("always", i),
            this.getImages(),
            n && (this.jqDeferred = new n.Deferred()),
            setTimeout(
              function () {
                this.check();
              }.bind(this)
            );
        }
        (o.prototype = Object.create(t.prototype)),
          (o.prototype.options = {}),
          (o.prototype.getImages = function () {
            (this.images = []),
              this.elements.forEach(this.addElementImages, this);
          }),
          (o.prototype.addElementImages = function (e) {
            "IMG" == e.nodeName && this.addImage(e),
              !0 === this.options.background &&
                this.addElementBackgroundImages(e);
            var t = e.nodeType;
            if (t && r[t]) {
              for (
                var n = e.querySelectorAll("img"), i = 0;
                i < n.length;
                i++
              ) {
                var a = n[i];
                this.addImage(a);
              }
              if ("string" == typeof this.options.background) {
                var o = e.querySelectorAll(this.options.background);
                for (i = 0; i < o.length; i++) {
                  var l = o[i];
                  this.addElementBackgroundImages(l);
                }
              }
            }
          });
        var r = { 1: !0, 9: !0, 11: !0 };
        function l(e) {
          this.img = e;
        }
        function s(e, t) {
          (this.url = e), (this.element = t), (this.img = new Image());
        }
        return (
          (o.prototype.addElementBackgroundImages = function (e) {
            var t = getComputedStyle(e);
            if (t)
              for (
                var n = /url\((['"])?(.*?)\1\)/gi,
                  i = n.exec(t.backgroundImage);
                null !== i;

              ) {
                var a = i && i[2];
                a && this.addBackground(a, e), (i = n.exec(t.backgroundImage));
              }
          }),
          (o.prototype.addImage = function (e) {
            var t = new l(e);
            this.images.push(t);
          }),
          (o.prototype.addBackground = function (e, t) {
            var n = new s(e, t);
            this.images.push(n);
          }),
          (o.prototype.check = function () {
            var e = this;
            function t(t, n, i) {
              setTimeout(function () {
                e.progress(t, n, i);
              });
            }
            (this.progressedCount = 0),
              (this.hasAnyBroken = !1),
              this.images.length
                ? this.images.forEach(function (e) {
                    e.once("progress", t), e.check();
                  })
                : this.complete();
          }),
          (o.prototype.progress = function (e, t, n) {
            this.progressedCount++,
              (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
              this.emitEvent("progress", [this, e, t]),
              this.jqDeferred &&
                this.jqDeferred.notify &&
                this.jqDeferred.notify(this, e),
              this.progressedCount == this.images.length && this.complete(),
              this.options.debug && i && i.log("progress: " + n, e, t);
          }),
          (o.prototype.complete = function () {
            var e = this.hasAnyBroken ? "fail" : "done";
            if (
              ((this.isComplete = !0),
              this.emitEvent(e, [this]),
              this.emitEvent("always", [this]),
              this.jqDeferred)
            ) {
              var t = this.hasAnyBroken ? "reject" : "resolve";
              this.jqDeferred[t](this);
            }
          }),
          (l.prototype = Object.create(t.prototype)),
          (l.prototype.check = function () {
            this.getIsImageComplete()
              ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
              : ((this.proxyImage = new Image()),
                this.proxyImage.addEventListener("load", this),
                this.proxyImage.addEventListener("error", this),
                this.img.addEventListener("load", this),
                this.img.addEventListener("error", this),
                (this.proxyImage.src = this.img.src));
          }),
          (l.prototype.getIsImageComplete = function () {
            return this.img.complete && void 0 !== this.img.naturalWidth;
          }),
          (l.prototype.confirm = function (e, t) {
            (this.isLoaded = e),
              this.emitEvent("progress", [this, this.img, t]);
          }),
          (l.prototype.handleEvent = function (e) {
            var t = "on" + e.type;
            this[t] && this[t](e);
          }),
          (l.prototype.onload = function () {
            this.confirm(!0, "onload"), this.unbindEvents();
          }),
          (l.prototype.onerror = function () {
            this.confirm(!1, "onerror"), this.unbindEvents();
          }),
          (l.prototype.unbindEvents = function () {
            this.proxyImage.removeEventListener("load", this),
              this.proxyImage.removeEventListener("error", this),
              this.img.removeEventListener("load", this),
              this.img.removeEventListener("error", this);
          }),
          (s.prototype = Object.create(l.prototype)),
          (s.prototype.check = function () {
            this.img.addEventListener("load", this),
              this.img.addEventListener("error", this),
              (this.img.src = this.url),
              this.getIsImageComplete() &&
                (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
                this.unbindEvents());
          }),
          (s.prototype.unbindEvents = function () {
            this.img.removeEventListener("load", this),
              this.img.removeEventListener("error", this);
          }),
          (s.prototype.confirm = function (e, t) {
            (this.isLoaded = e),
              this.emitEvent("progress", [this, this.element, t]);
          }),
          (o.makeJQueryPlugin = function (t) {
            (t = t || e.jQuery) &&
              ((n = t).fn.ngimagesLoaded = function (e, t) {
                return new o(this, e, t).jqDeferred.promise(n(this));
              });
          }),
          o.makeJQueryPlugin(),
          o
        );
      })(e, e.ngEvEmitter);
    })(window),
    (function () {
      var e =
          "undefined" != typeof window && void 0 !== window.document
            ? window.document
            : {},
        t = "undefined" != typeof module && module.exports,
        n = "undefined" != typeof Element && "ALLOW_KEYBOARD_INPUT" in Element,
        i = (function () {
          for (
            var t,
              n = [
                [
                  "requestFullscreen",
                  "exitFullscreen",
                  "fullscreenElement",
                  "fullscreenEnabled",
                  "fullscreenchange",
                  "fullscreenerror",
                ],
                [
                  "webkitRequestFullscreen",
                  "webkitExitFullscreen",
                  "webkitFullscreenElement",
                  "webkitFullscreenEnabled",
                  "webkitfullscreenchange",
                  "webkitfullscreenerror",
                ],
                [
                  "webkitRequestFullScreen",
                  "webkitCancelFullScreen",
                  "webkitCurrentFullScreenElement",
                  "webkitCancelFullScreen",
                  "webkitfullscreenchange",
                  "webkitfullscreenerror",
                ],
                [
                  "mozRequestFullScreen",
                  "mozCancelFullScreen",
                  "mozFullScreenElement",
                  "mozFullScreenEnabled",
                  "mozfullscreenchange",
                  "mozfullscreenerror",
                ],
                [
                  "msRequestFullscreen",
                  "msExitFullscreen",
                  "msFullscreenElement",
                  "msFullscreenEnabled",
                  "MSFullscreenChange",
                  "MSFullscreenError",
                ],
              ],
              i = 0,
              a = n.length,
              o = {};
            i < a;
            i++
          )
            if ((t = n[i]) && t[1] in e) {
              for (i = 0; i < t.length; i++) o[n[0][i]] = t[i];
              return o;
            }
          return !1;
        })(),
        a = { change: i.fullscreenchange, error: i.fullscreenerror },
        o = {
          request: function (t) {
            return new Promise(
              function (a) {
                var o = i.requestFullscreen,
                  r = function () {
                    this.off("change", r), a();
                  }.bind(this);
                (t = t || e.documentElement),
                  / Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)
                    ? t[o]()
                    : t[o](n ? Element.ALLOW_KEYBOARD_INPUT : {}),
                  this.on("change", r);
              }.bind(this)
            );
          },
          exit: function () {
            return new Promise(
              function (t) {
                if (this.isFullscreen) {
                  var n = function () {
                    this.off("change", n), t();
                  }.bind(this);
                  e[i.exitFullscreen](), this.on("change", n);
                } else t();
              }.bind(this)
            );
          },
          toggle: function (e) {
            return this.isFullscreen ? this.exit() : this.request(e);
          },
          onchange: function (e) {
            this.on("change", e);
          },
          onerror: function (e) {
            this.on("error", e);
          },
          on: function (t, n) {
            var i = a[t];
            i && e.addEventListener(i, n, !1);
          },
          off: function (t, n) {
            var i = a[t];
            i && e.removeEventListener(i, n, !1);
          },
          raw: i,
        };
      i
        ? (Object.defineProperties(o, {
            isFullscreen: {
              get: function () {
                return Boolean(e[i.fullscreenElement]);
              },
            },
            element: {
              enumerable: !0,
              get: function () {
                return e[i.fullscreenElement];
              },
            },
            enabled: {
              enumerable: !0,
              get: function () {
                return Boolean(e[i.fullscreenEnabled]);
              },
            },
          }),
          t ? (module.exports = o) : (window.ngscreenfull = o))
        : t
        ? (module.exports = !1)
        : (window.ngscreenfull = !1);
    })(),
    function () {
      var e,
        t = this || Function("return this")(),
        n = (function () {
          var e,
            n,
            i,
            a,
            o,
            r,
            l = Date.now
              ? Date.now
              : function () {
                  return +new Date();
                },
            s = "undefined" != typeof SHIFTY_DEBUG_NOW ? SHIFTY_DEBUG_NOW : l;
          function u() {}
          function c(e, t) {
            var n;
            for (n in e) Object.hasOwnProperty.call(e, n) && t(n);
          }
          function h(e, t) {
            return (
              c(t, function (n) {
                e[n] = t[n];
              }),
              e
            );
          }
          function d(e, t) {
            c(t, function (n) {
              void 0 === e[n] && (e[n] = t[n]);
            });
          }
          function m(t, n, i, a, o, r, l) {
            var s,
              u,
              c,
              h = t < r ? 0 : (t - r) / o;
            for (s in n)
              n.hasOwnProperty(s) &&
                ((c = "function" == typeof (u = l[s]) ? u : e[u]),
                (n[s] = p(i[s], a[s], c, h)));
            return n;
          }
          function p(e, t, n, i) {
            return e + (t - e) * n(i);
          }
          function g(e, t) {
            var n = v.prototype.filter,
              i = e._filterArgs;
            c(n, function (a) {
              void 0 !== n[a][t] && n[a][t].apply(e, i);
            });
          }
          function f(e, t, n, l, u, c, h, d, p, f, b) {
            (i = t + n + l),
              (a = Math.min(b || s(), i)),
              (o = a >= i),
              (r = l - (i - a)),
              e.isPlaying() &&
                (o
                  ? (p(h, e._attachment, r), e.stop(!0))
                  : ((e._scheduleId = f(e._timeoutHandler, 1e3 / 60)),
                    g(e, "beforeTween"),
                    a < t + n
                      ? m(1, u, c, h, 1, 1, d)
                      : m(a, u, c, h, l, t + n, d),
                    g(e, "afterTween"),
                    p(u, e._attachment, r)));
          }
          function b(e, t) {
            var n = {},
              i = typeof t;
            return (
              c(
                e,
                "string" === i || "function" === i
                  ? function (e) {
                      n[e] = t;
                    }
                  : function (e) {
                      n[e] || (n[e] = t[e] || "linear");
                    }
              ),
              n
            );
          }
          function v(e, t) {
            (this._currentState = e || {}),
              (this._configured = !1),
              (this._scheduleFunction = n),
              void 0 !== t && this.setConfig(t);
          }
          return (
            (n =
              ("undefined" != typeof window &&
                (window.requestAnimationFrame ||
                  window.webkitRequestAnimationFrame ||
                  window.oRequestAnimationFrame ||
                  window.msRequestAnimationFrame ||
                  (window.mozCancelRequestAnimationFrame &&
                    window.mozRequestAnimationFrame))) ||
              setTimeout),
            (v.prototype.tween = function (e) {
              return this._isTweening
                ? this
                : ((void 0 === e && this._configured) || this.setConfig(e),
                  (this._timestamp = s()),
                  this._start(this.get(), this._attachment),
                  this.resume());
            }),
            (v.prototype.setConfig = function (e) {
              (e = e || {}),
                (this._configured = !0),
                (this._attachment = e.attachment),
                (this._pausedAtTime = null),
                (this._scheduleId = null),
                (this._delay = e.delay || 0),
                (this._start = e.start || u),
                (this._step = e.step || u),
                (this._finish = e.finish || u),
                (this._duration = e.duration || 500),
                (this._currentState = h({}, e.from || this.get())),
                (this._originalState = this.get()),
                (this._targetState = h({}, e.to || this.get()));
              var t = this;
              this._timeoutHandler = function () {
                f(
                  t,
                  t._timestamp,
                  t._delay,
                  t._duration,
                  t._currentState,
                  t._originalState,
                  t._targetState,
                  t._easing,
                  t._step,
                  t._scheduleFunction
                );
              };
              var n = this._currentState,
                i = this._targetState;
              return (
                d(i, n),
                (this._easing = b(n, e.easing || "linear")),
                (this._filterArgs = [n, this._originalState, i, this._easing]),
                g(this, "tweenCreated"),
                this
              );
            }),
            (v.prototype.get = function () {
              return h({}, this._currentState);
            }),
            (v.prototype.set = function (e) {
              this._currentState = e;
            }),
            (v.prototype.pause = function () {
              return (this._pausedAtTime = s()), (this._isPaused = !0), this;
            }),
            (v.prototype.resume = function () {
              return (
                this._isPaused && (this._timestamp += s() - this._pausedAtTime),
                (this._isPaused = !1),
                (this._isTweening = !0),
                this._timeoutHandler(),
                this
              );
            }),
            (v.prototype.seek = function (e) {
              e = Math.max(e, 0);
              var t = s();
              return (
                this._timestamp + e === 0 ||
                  ((this._timestamp = t - e),
                  this.isPlaying() ||
                    ((this._isTweening = !0),
                    (this._isPaused = !1),
                    f(
                      this,
                      this._timestamp,
                      this._delay,
                      this._duration,
                      this._currentState,
                      this._originalState,
                      this._targetState,
                      this._easing,
                      this._step,
                      this._scheduleFunction,
                      t
                    ),
                    this.pause())),
                this
              );
            }),
            (v.prototype.stop = function (e) {
              return (
                (this._isTweening = !1),
                (this._isPaused = !1),
                (this._timeoutHandler = u),
                (
                  t.cancelAnimationFrame ||
                  t.webkitCancelAnimationFrame ||
                  t.oCancelAnimationFrame ||
                  t.msCancelAnimationFrame ||
                  t.mozCancelRequestAnimationFrame ||
                  t.clearTimeout
                )(this._scheduleId),
                e &&
                  (g(this, "beforeTween"),
                  m(
                    1,
                    this._currentState,
                    this._originalState,
                    this._targetState,
                    1,
                    0,
                    this._easing
                  ),
                  g(this, "afterTween"),
                  g(this, "afterTweenEnd"),
                  this._finish.call(
                    this,
                    this._currentState,
                    this._attachment
                  )),
                this
              );
            }),
            (v.prototype.isPlaying = function () {
              return this._isTweening && !this._isPaused;
            }),
            (v.prototype.setScheduleFunction = function (e) {
              this._scheduleFunction = e;
            }),
            (v.prototype.dispose = function () {
              var e;
              for (e in this) this.hasOwnProperty(e) && delete this[e];
            }),
            (v.prototype.filter = {}),
            (v.prototype.formula = {
              linear: function (e) {
                return e;
              },
            }),
            (e = v.prototype.formula),
            h(v, {
              now: s,
              each: c,
              tweenProps: m,
              tweenProp: p,
              applyFilter: g,
              shallowCopy: h,
              defaults: d,
              composeEasingObject: b,
            }),
            "function" == typeof SHIFTY_DEBUG_NOW && (t.timeoutHandler = f),
            "object" == typeof exports
              ? (module.exports = v)
              : "function" == typeof define && define.amdDISABLED
              ? define(function () {
                  return v;
                })
              : void 0 === t.NGTweenable && (t.NGTweenable = v),
            v
          );
        })();
      n.shallowCopy(n.prototype.formula, {
        easeInQuad: function (e) {
          return Math.pow(e, 2);
        },
        easeOutQuad: function (e) {
          return -(Math.pow(e - 1, 2) - 1);
        },
        easeInOutQuad: function (e) {
          return (e /= 0.5) < 1
            ? 0.5 * Math.pow(e, 2)
            : -0.5 * ((e -= 2) * e - 2);
        },
        easeInCubic: function (e) {
          return Math.pow(e, 3);
        },
        easeOutCubic: function (e) {
          return Math.pow(e - 1, 3) + 1;
        },
        easeInOutCubic: function (e) {
          return (e /= 0.5) < 1
            ? 0.5 * Math.pow(e, 3)
            : 0.5 * (Math.pow(e - 2, 3) + 2);
        },
        easeInQuart: function (e) {
          return Math.pow(e, 4);
        },
        easeOutQuart: function (e) {
          return -(Math.pow(e - 1, 4) - 1);
        },
        easeInOutQuart: function (e) {
          return (e /= 0.5) < 1
            ? 0.5 * Math.pow(e, 4)
            : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
        },
        easeInQuint: function (e) {
          return Math.pow(e, 5);
        },
        easeOutQuint: function (e) {
          return Math.pow(e - 1, 5) + 1;
        },
        easeInOutQuint: function (e) {
          return (e /= 0.5) < 1
            ? 0.5 * Math.pow(e, 5)
            : 0.5 * (Math.pow(e - 2, 5) + 2);
        },
        easeInSine: function (e) {
          return 1 - Math.cos(e * (Math.PI / 2));
        },
        easeOutSine: function (e) {
          return Math.sin(e * (Math.PI / 2));
        },
        easeInOutSine: function (e) {
          return -0.5 * (Math.cos(Math.PI * e) - 1);
        },
        easeInExpo: function (e) {
          return 0 === e ? 0 : Math.pow(2, 10 * (e - 1));
        },
        easeOutExpo: function (e) {
          return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
        },
        easeInOutExpo: function (e) {
          return 0 === e
            ? 0
            : 1 === e
            ? 1
            : (e /= 0.5) < 1
            ? 0.5 * Math.pow(2, 10 * (e - 1))
            : 0.5 * (2 - Math.pow(2, -10 * --e));
        },
        easeInCirc: function (e) {
          return -(Math.sqrt(1 - e * e) - 1);
        },
        easeOutCirc: function (e) {
          return Math.sqrt(1 - Math.pow(e - 1, 2));
        },
        easeInOutCirc: function (e) {
          return (e /= 0.5) < 1
            ? -0.5 * (Math.sqrt(1 - e * e) - 1)
            : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
        },
        easeOutBounce: function (e) {
          return e < 1 / 2.75
            ? 7.5625 * e * e
            : e < 2 / 2.75
            ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
            : e < 2.5 / 2.75
            ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
            : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
        },
        easeInBack: function (e) {
          var t = 1.70158;
          return e * e * ((t + 1) * e - t);
        },
        easeOutBack: function (e) {
          var t = 1.70158;
          return (e -= 1) * e * ((t + 1) * e + t) + 1;
        },
        easeInOutBack: function (e) {
          var t = 1.70158;
          return (e /= 0.5) < 1
            ? e * e * ((1 + (t *= 1.525)) * e - t) * 0.5
            : 0.5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
        },
        elastic: function (e) {
          return (
            -1 *
              Math.pow(4, -8 * e) *
              Math.sin(((6 * e - 1) * (2 * Math.PI)) / 2) +
            1
          );
        },
        swingFromTo: function (e) {
          var t = 1.70158;
          return (e /= 0.5) < 1
            ? e * e * ((1 + (t *= 1.525)) * e - t) * 0.5
            : 0.5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
        },
        swingFrom: function (e) {
          var t = 1.70158;
          return e * e * ((t + 1) * e - t);
        },
        swingTo: function (e) {
          var t = 1.70158;
          return (e -= 1) * e * ((t + 1) * e + t) + 1;
        },
        bounce: function (e) {
          return e < 1 / 2.75
            ? 7.5625 * e * e
            : e < 2 / 2.75
            ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
            : e < 2.5 / 2.75
            ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
            : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
        },
        bouncePast: function (e) {
          return e < 1 / 2.75
            ? 7.5625 * e * e
            : e < 2 / 2.75
            ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
            : e < 2.5 / 2.75
            ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
            : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
        },
        easeFromTo: function (e) {
          return (e /= 0.5) < 1
            ? 0.5 * Math.pow(e, 4)
            : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
        },
        easeFrom: function (e) {
          return Math.pow(e, 4);
        },
        easeTo: function (e) {
          return Math.pow(e, 0.25);
        },
      }),
        (function () {
          function e(e, t, n, i, a, o) {
            var r,
              l,
              s = 0,
              u = 0,
              c = 0,
              h = 0,
              d = 0,
              m = 0;
            function p(e) {
              return ((s * e + u) * e + c) * e;
            }
            function g(e) {
              return (3 * s * e + 2 * u) * e + c;
            }
            function f(e) {
              return e >= 0 ? e : 0 - e;
            }
            return (
              (s = 1 - (c = 3 * t) - (u = 3 * (i - t) - c)),
              (h = 1 - (m = 3 * n) - (d = 3 * (a - n) - m)),
              (r = e),
              (l = (function (e) {
                return 1 / (200 * e);
              })(o)),
              (function (e) {
                return ((h * e + d) * e + m) * e;
              })(
                (function (e, t) {
                  var n, i, a, o, r, l;
                  for (a = e, l = 0; l < 8; l++) {
                    if (f((o = p(a) - e)) < t) return a;
                    if (f((r = g(a))) < 1e-6) break;
                    a -= o / r;
                  }
                  if (((i = 1), (a = e) < (n = 0))) return n;
                  if (a > i) return i;
                  for (; n < i; ) {
                    if (f((o = p(a)) - e) < t) return a;
                    e > o ? (n = a) : (i = a), (a = 0.5 * (i - n) + n);
                  }
                  return a;
                })(r, l)
              )
            );
          }
          (n.setBezierFunction = function (t, i, a, o, r) {
            var l = (function (t, n, i, a) {
              return function (o) {
                return e(o, t, n, i, a, 1);
              };
            })(i, a, o, r);
            return (
              (l.displayName = t),
              (l.x1 = i),
              (l.y1 = a),
              (l.x2 = o),
              (l.y2 = r),
              (n.prototype.formula[t] = l)
            );
          }),
            (n.unsetBezierFunction = function (e) {
              delete n.prototype.formula[e];
            });
        })(),
        ((e = new n())._filterArgs = []),
        (n.interpolate = function (t, i, a, o, r) {
          var l = n.shallowCopy({}, t),
            s = r || 0,
            u = n.composeEasingObject(t, o || "linear");
          e.set({});
          var c = e._filterArgs;
          (c.length = 0),
            (c[0] = l),
            (c[1] = t),
            (c[2] = i),
            (c[3] = u),
            n.applyFilter(e, "tweenCreated"),
            n.applyFilter(e, "beforeTween");
          var h = (function (e, t, i, a, o, r) {
            return n.tweenProps(a, t, e, i, 1, r, o);
          })(t, l, i, a, u, s);
          return n.applyFilter(e, "afterTween"), h;
        }),
        (function (e) {
          var t = /(\d|\-|\.)/,
            n = /([^\-0-9\.]+)/g,
            i = /[0-9.\-]+/g,
            a = new RegExp(
              "rgb\\(" +
                i.source +
                /,\s*/.source +
                i.source +
                /,\s*/.source +
                i.source +
                "\\)",
              "g"
            ),
            o = /^.*\(/,
            r = /#([0-9]|[a-f]){3,6}/gi;
          function l(e, t) {
            var n,
              i = [],
              a = e.length;
            for (n = 0; n < a; n++) i.push("_" + t + "_" + n);
            return i;
          }
          function s(t) {
            e.each(t, function (e) {
              var n = t[e];
              "string" == typeof n && n.match(r) && (t[e] = d(r, n, u));
            });
          }
          function u(e) {
            var t = (function (e) {
              3 === (e = e.replace(/#/, "")).length &&
                (e = (e = e.split(""))[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
              return (
                (c[0] = h(e.substr(0, 2))),
                (c[1] = h(e.substr(2, 2))),
                (c[2] = h(e.substr(4, 2))),
                c
              );
            })(e);
            return "rgb(" + t[0] + "," + t[1] + "," + t[2] + ")";
          }
          var c = [];
          function h(e) {
            return parseInt(e, 16);
          }
          function d(e, t, n) {
            var i = t.match(e),
              a = t.replace(e, "VAL");
            if (i)
              for (var o, r = i.length, l = 0; l < r; l++)
                (o = i.shift()), (a = a.replace("VAL", n(o)));
            return a;
          }
          function m(e) {
            for (
              var t = e.match(i), n = t.length, a = e.match(o)[0], r = 0;
              r < n;
              r++
            )
              a += parseInt(t[r], 10) + ",";
            return (a = a.slice(0, -1) + ")");
          }
          function p(t, n) {
            e.each(n, function (e) {
              for (var i = b(t[e]), a = i.length, o = 0; o < a; o++)
                t[n[e].chunkNames[o]] = +i[o];
              delete t[e];
            });
          }
          function g(t, n) {
            e.each(n, function (e) {
              var i = t[e],
                o = (function (e, t) {
                  f.length = 0;
                  for (var n = t.length, i = 0; i < n; i++) f.push(e[t[i]]);
                  return f;
                })(
                  (function (e, t) {
                    for (var n, i = {}, a = t.length, o = 0; o < a; o++)
                      (n = t[o]), (i[n] = e[n]), delete e[n];
                    return i;
                  })(t, n[e].chunkNames),
                  n[e].chunkNames
                );
              (i = (function (e, t) {
                for (var n = e, i = t.length, a = 0; a < i; a++)
                  n = n.replace("VAL", +t[a].toFixed(4));
                return n;
              })(n[e].formatString, o)),
                (t[e] = d(a, i, m));
            });
          }
          var f = [];
          function b(e) {
            return e.match(i);
          }
          e.prototype.filter.token = {
            tweenCreated: function (i, a, o, r) {
              var u, c;
              s(i),
                s(a),
                s(o),
                (this._tokenData =
                  ((u = i),
                  (c = {}),
                  e.each(u, function (e) {
                    var i,
                      a,
                      o = u[e];
                    if ("string" == typeof o) {
                      var r = b(o);
                      c[e] = {
                        formatString:
                          ((i = o),
                          (a = i.match(n)),
                          a
                            ? (1 === a.length || i.charAt(0).match(t)) &&
                              a.unshift("")
                            : (a = ["", ""]),
                          a.join("VAL")),
                        chunkNames: l(r, e),
                      };
                    }
                  }),
                  c));
            },
            beforeTween: function (t, n, i, a) {
              !(function (t, n) {
                e.each(n, function (e) {
                  var i,
                    a = n[e].chunkNames,
                    o = a.length,
                    r = t[e];
                  if ("string" == typeof r) {
                    var l = r.split(" "),
                      s = l[l.length - 1];
                    for (i = 0; i < o; i++) t[a[i]] = l[i] || s;
                  } else for (i = 0; i < o; i++) t[a[i]] = r;
                  delete t[e];
                });
              })(a, this._tokenData),
                p(t, this._tokenData),
                p(n, this._tokenData),
                p(i, this._tokenData);
            },
            afterTween: function (t, n, i, a) {
              g(t, this._tokenData),
                g(n, this._tokenData),
                g(i, this._tokenData),
                (function (t, n) {
                  e.each(n, function (e) {
                    var i = n[e].chunkNames,
                      a = i.length,
                      o = t[i[0]];
                    if ("string" === typeof o) {
                      for (var r = "", l = 0; l < a; l++)
                        (r += " " + t[i[l]]), delete t[i[l]];
                      t[e] = r.substr(1);
                    } else t[e] = o;
                  });
                })(a, this._tokenData);
            },
          };
        })(n);
    }.call(null),
    /*! NGHammer.JS - v2.0.7 - 2016-04-22
     * Licensed under the MIT license */
    (function (e, t, n, i) {
      var a,
        o = ["", "webkit", "Moz", "MS", "ms", "o"],
        r = t.createElement("div"),
        l = Math.round,
        s = Math.abs,
        u = Date.now;
      function c(e, t, n) {
        return setTimeout(b(e, n), t);
      }
      function h(e, t, n) {
        return !!Array.isArray(e) && (d(e, n[t], n), !0);
      }
      function d(e, t, n) {
        var i;
        if (e)
          if (e.forEach) e.forEach(t, n);
          else if (void 0 !== e.length)
            for (i = 0; i < e.length; ) t.call(n, e[i], i, e), i++;
          else for (i in e) e.hasOwnProperty(i) && t.call(n, e[i], i, e);
      }
      function m(t, n, i) {
        var a = "DEPRECATED METHOD: " + n + "\n" + i + " AT \n";
        return function () {
          var n = new Error("get-stack-trace"),
            i =
              n && n.stack
                ? n.stack
                    .replace(/^[^\(]+?[\n$]/gm, "")
                    .replace(/^\s+at\s+/gm, "")
                    .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
                : "Unknown Stack Trace",
            o = e.console && (e.console.warn || e.console.log);
          return o && o.call(e.console, a, i), t.apply(this, arguments);
        };
      }
      a =
        "function" != typeof Object.assign
          ? function (e) {
              if (null == e)
                throw new TypeError(
                  "Cannot convert undefined or null to object"
                );
              for (var t = Object(e), n = 1; n < arguments.length; n++) {
                var i = arguments[n];
                if (null != i)
                  for (var a in i) i.hasOwnProperty(a) && (t[a] = i[a]);
              }
              return t;
            }
          : Object.assign;
      var p = m(
          function (e, t, n) {
            for (var i = Object.keys(t), a = 0; a < i.length; )
              (!n || (n && void 0 === e[i[a]])) && (e[i[a]] = t[i[a]]), a++;
            return e;
          },
          "extend",
          "Use `assign`."
        ),
        g = m(
          function (e, t) {
            return p(e, t, !0);
          },
          "merge",
          "Use `assign`."
        );
      function f(e, t, n) {
        var i,
          o = t.prototype;
        ((i = e.prototype = Object.create(o)).constructor = e),
          (i._super = o),
          n && a(i, n);
      }
      function b(e, t) {
        return function () {
          return e.apply(t, arguments);
        };
      }
      function v(e, t) {
        return "function" == typeof e ? e.apply((t && t[0]) || void 0, t) : e;
      }
      function O(e, t) {
        return void 0 === e ? t : e;
      }
      function y(e, t, n) {
        d(I(t), function (t) {
          e.addEventListener(t, n, !1);
        });
      }
      function G(e, t, n) {
        d(I(t), function (t) {
          e.removeEventListener(t, n, !1);
        });
      }
      function M(e, t) {
        for (; e; ) {
          if (e == t) return !0;
          e = e.parentNode;
        }
        return !1;
      }
      function w(e, t) {
        return e.indexOf(t) > -1;
      }
      function I(e) {
        return e.trim().split(/\s+/g);
      }
      function T(e, t, n) {
        if (e.indexOf && !n) return e.indexOf(t);
        for (var i = 0; i < e.length; ) {
          if ((n && e[i][n] == t) || (!n && e[i] === t)) return i;
          i++;
        }
        return -1;
      }
      function x(e) {
        return Array.prototype.slice.call(e, 0);
      }
      function S(e, t, n) {
        for (var i = [], a = [], o = 0; o < e.length; ) {
          var r = t ? e[o][t] : e[o];
          T(a, r) < 0 && i.push(e[o]), (a[o] = r), o++;
        }
        return (
          n &&
            (i = t
              ? i.sort(function (e, n) {
                  return e[t] > n[t];
                })
              : i.sort()),
          i
        );
      }
      function L(e, t) {
        for (
          var n, i, a = t[0].toUpperCase() + t.slice(1), r = 0;
          r < o.length;

        ) {
          if ((i = (n = o[r]) ? n + a : t) in e) return i;
          r++;
        }
      }
      var C = 1;
      function E(t) {
        var n = t.ownerDocument || t;
        return n.defaultView || n.parentWindow || e;
      }
      var k = "ontouchstart" in e,
        D =
          k &&
          /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
        N = ["x", "y"],
        V = ["clientX", "clientY"];
      function Y(e, t) {
        var n = this;
        (this.manager = e),
          (this.callback = t),
          (this.element = e.element),
          (this.target = e.options.inputTarget),
          (this.domHandler = function (t) {
            v(e.options.enable, [e]) && n.handler(t);
          }),
          this.init();
      }
      function A(e, t, n) {
        var i = n.pointers.length,
          a = n.changedPointers.length,
          o = 1 & t && i - a == 0,
          r = 12 & t && i - a == 0;
        (n.isFirst = !!o),
          (n.isFinal = !!r),
          o && (e.session = {}),
          (n.eventType = t),
          (function (e, t) {
            var n = e.session,
              i = t.pointers,
              a = i.length;
            n.firstInput || (n.firstInput = _(t));
            a > 1 && !n.firstMultiple
              ? (n.firstMultiple = _(t))
              : 1 === a && (n.firstMultiple = !1);
            var o = n.firstInput,
              r = n.firstMultiple,
              l = r ? r.center : o.center,
              c = (t.center = P(i));
            (t.timeStamp = u()),
              (t.deltaTime = t.timeStamp - o.timeStamp),
              (t.angle = z(l, c)),
              (t.distance = F(l, c)),
              (function (e, t) {
                var n = t.center,
                  i = e.offsetDelta || {},
                  a = e.prevDelta || {},
                  o = e.prevInput || {};
                (1 !== t.eventType && 4 !== o.eventType) ||
                  ((a = e.prevDelta = { x: o.deltaX || 0, y: o.deltaY || 0 }),
                  (i = e.offsetDelta = { x: n.x, y: n.y }));
                (t.deltaX = a.x + (n.x - i.x)), (t.deltaY = a.y + (n.y - i.y));
              })(n, t),
              (t.offsetDirection = $(t.deltaX, t.deltaY));
            var h = R(t.deltaTime, t.deltaX, t.deltaY);
            (t.overallVelocityX = h.x),
              (t.overallVelocityY = h.y),
              (t.overallVelocity = s(h.x) > s(h.y) ? h.x : h.y),
              (t.scale = r
                ? ((d = r.pointers),
                  (m = i),
                  F(m[0], m[1], V) / F(d[0], d[1], V))
                : 1),
              (t.rotation = r
                ? (function (e, t) {
                    return z(t[1], t[0], V) + z(e[1], e[0], V);
                  })(r.pointers, i)
                : 0),
              (t.maxPointers = n.prevInput
                ? t.pointers.length > n.prevInput.maxPointers
                  ? t.pointers.length
                  : n.prevInput.maxPointers
                : t.pointers.length),
              (function (e, t) {
                var n,
                  i,
                  a,
                  o,
                  r = e.lastInterval || t,
                  l = t.timeStamp - r.timeStamp;
                if (8 != t.eventType && (l > 25 || void 0 === r.velocity)) {
                  var u = t.deltaX - r.deltaX,
                    c = t.deltaY - r.deltaY,
                    h = R(l, u, c);
                  (i = h.x),
                    (a = h.y),
                    (n = s(h.x) > s(h.y) ? h.x : h.y),
                    (o = $(u, c)),
                    (e.lastInterval = t);
                } else
                  (n = r.velocity),
                    (i = r.velocityX),
                    (a = r.velocityY),
                    (o = r.direction);
                (t.velocity = n),
                  (t.velocityX = i),
                  (t.velocityY = a),
                  (t.direction = o);
              })(n, t);
            var d, m;
            var p = e.element;
            M(t.srcEvent.target, p) && (p = t.srcEvent.target);
            t.target = p;
          })(e, n),
          e.emit("hammer.input", n),
          e.recognize(n),
          (e.session.prevInput = n);
      }
      function _(e) {
        for (var t = [], n = 0; n < e.pointers.length; )
          (t[n] = {
            clientX: l(e.pointers[n].clientX),
            clientY: l(e.pointers[n].clientY),
          }),
            n++;
        return {
          timeStamp: u(),
          pointers: t,
          center: P(t),
          deltaX: e.deltaX,
          deltaY: e.deltaY,
        };
      }
      function P(e) {
        var t = e.length;
        if (1 === t) return { x: l(e[0].clientX), y: l(e[0].clientY) };
        for (var n = 0, i = 0, a = 0; a < t; )
          (n += e[a].clientX), (i += e[a].clientY), a++;
        return { x: l(n / t), y: l(i / t) };
      }
      function R(e, t, n) {
        return { x: t / e || 0, y: n / e || 0 };
      }
      function $(e, t) {
        return e === t ? 1 : s(e) >= s(t) ? (e < 0 ? 2 : 4) : t < 0 ? 8 : 16;
      }
      function F(e, t, n) {
        n || (n = N);
        var i = t[n[0]] - e[n[0]],
          a = t[n[1]] - e[n[1]];
        return Math.sqrt(i * i + a * a);
      }
      function z(e, t, n) {
        n || (n = N);
        var i = t[n[0]] - e[n[0]],
          a = t[n[1]] - e[n[1]];
        return (180 * Math.atan2(a, i)) / Math.PI;
      }
      Y.prototype = {
        handler: function () {},
        init: function () {
          this.evEl && y(this.element, this.evEl, this.domHandler),
            this.evTarget && y(this.target, this.evTarget, this.domHandler),
            this.evWin && y(E(this.element), this.evWin, this.domHandler);
        },
        destroy: function () {
          this.evEl && G(this.element, this.evEl, this.domHandler),
            this.evTarget && G(this.target, this.evTarget, this.domHandler),
            this.evWin && G(E(this.element), this.evWin, this.domHandler);
        },
      };
      var B = { mousedown: 1, mousemove: 2, mouseup: 4 };
      function H() {
        (this.evEl = "mousedown"),
          (this.evWin = "mousemove mouseup"),
          (this.pressed = !1),
          Y.apply(this, arguments);
      }
      f(H, Y, {
        handler: function (e) {
          var t = B[e.type];
          1 & t && 0 === e.button && (this.pressed = !0),
            2 & t && 1 !== e.which && (t = 4),
            this.pressed &&
              (4 & t && (this.pressed = !1),
              this.callback(this.manager, t, {
                pointers: [e],
                changedPointers: [e],
                pointerType: "mouse",
                srcEvent: e,
              }));
        },
      });
      var U = {
          pointerdown: 1,
          pointermove: 2,
          pointerup: 4,
          pointercancel: 8,
          pointerout: 8,
        },
        W = { 2: "touch", 3: "pen", 4: "mouse", 5: "kinect" },
        j = "pointerdown",
        X = "pointermove pointerup pointercancel";
      function Q() {
        (this.evEl = j),
          (this.evWin = X),
          Y.apply(this, arguments),
          (this.store = this.manager.session.pointerEvents = []);
      }
      e.MSPointerEvent &&
        !e.PointerEvent &&
        ((j = "MSPointerDown"),
        (X = "MSPointerMove MSPointerUp MSPointerCancel")),
        f(Q, Y, {
          handler: function (e) {
            var t = this.store,
              n = !1,
              i = e.type.toLowerCase().replace("ms", ""),
              a = U[i],
              o = W[e.pointerType] || e.pointerType,
              r = "touch" == o,
              l = T(t, e.pointerId, "pointerId");
            1 & a && (0 === e.button || r)
              ? l < 0 && (t.push(e), (l = t.length - 1))
              : 12 & a && (n = !0),
              l < 0 ||
                ((t[l] = e),
                this.callback(this.manager, a, {
                  pointers: t,
                  changedPointers: [e],
                  pointerType: o,
                  srcEvent: e,
                }),
                n && t.splice(l, 1));
          },
        });
      var q = { touchstart: 1, touchmove: 2, touchend: 4, touchcancel: 8 };
      function Z() {
        (this.evTarget = "touchstart"),
          (this.evWin = "touchstart touchmove touchend touchcancel"),
          (this.started = !1),
          Y.apply(this, arguments);
      }
      function J(e, t) {
        var n = x(e.touches),
          i = x(e.changedTouches);
        return 12 & t && (n = S(n.concat(i), "identifier", !0)), [n, i];
      }
      f(Z, Y, {
        handler: function (e) {
          var t = q[e.type];
          if ((1 === t && (this.started = !0), this.started)) {
            var n = J.call(this, e, t);
            12 & t && n[0].length - n[1].length == 0 && (this.started = !1),
              this.callback(this.manager, t, {
                pointers: n[0],
                changedPointers: n[1],
                pointerType: "touch",
                srcEvent: e,
              });
          }
        },
      });
      var K = { touchstart: 1, touchmove: 2, touchend: 4, touchcancel: 8 };
      function ee() {
        (this.evTarget = "touchstart touchmove touchend touchcancel"),
          (this.targetIds = {}),
          Y.apply(this, arguments);
      }
      function te(e, t) {
        var n = x(e.touches),
          i = this.targetIds;
        if (3 & t && 1 === n.length) return (i[n[0].identifier] = !0), [n, n];
        var a,
          o,
          r = x(e.changedTouches),
          l = [],
          s = this.target;
        if (
          ((o = n.filter(function (e) {
            return M(e.target, s);
          })),
          1 === t)
        )
          for (a = 0; a < o.length; ) (i[o[a].identifier] = !0), a++;
        for (a = 0; a < r.length; )
          i[r[a].identifier] && l.push(r[a]),
            12 & t && delete i[r[a].identifier],
            a++;
        return l.length ? [S(o.concat(l), "identifier", !0), l] : void 0;
      }
      f(ee, Y, {
        handler: function (e) {
          var t = K[e.type],
            n = te.call(this, e, t);
          n &&
            this.callback(this.manager, t, {
              pointers: n[0],
              changedPointers: n[1],
              pointerType: "touch",
              srcEvent: e,
            });
        },
      });
      function ne() {
        Y.apply(this, arguments);
        var e = b(this.handler, this);
        (this.touch = new ee(this.manager, e)),
          (this.mouse = new H(this.manager, e)),
          (this.primaryTouch = null),
          (this.lastTouches = []);
      }
      function ie(e, t) {
        1 & e
          ? ((this.primaryTouch = t.changedPointers[0].identifier),
            ae.call(this, t))
          : 12 & e && ae.call(this, t);
      }
      function ae(e) {
        var t = e.changedPointers[0];
        if (t.identifier === this.primaryTouch) {
          var n = { x: t.clientX, y: t.clientY };
          this.lastTouches.push(n);
          var i = this.lastTouches;
          setTimeout(function () {
            var e = i.indexOf(n);
            e > -1 && i.splice(e, 1);
          }, 2500);
        }
      }
      function oe(e) {
        for (
          var t = e.srcEvent.clientX, n = e.srcEvent.clientY, i = 0;
          i < this.lastTouches.length;
          i++
        ) {
          var a = this.lastTouches[i],
            o = Math.abs(t - a.x),
            r = Math.abs(n - a.y);
          if (o <= 25 && r <= 25) return !0;
        }
        return !1;
      }
      f(ne, Y, {
        handler: function (e, t, n) {
          var i = "touch" == n.pointerType,
            a = "mouse" == n.pointerType;
          if (
            !(
              a &&
              n.sourceCapabilities &&
              n.sourceCapabilities.firesTouchEvents
            )
          ) {
            if (i) ie.call(this, t, n);
            else if (a && oe.call(this, n)) return;
            this.callback(e, t, n);
          }
        },
        destroy: function () {
          this.touch.destroy(), this.mouse.destroy();
        },
      });
      var re = L(r.style, "touchAction"),
        le = void 0 !== re,
        se = (function () {
          if (!le) return !1;
          var t = {},
            n = e.CSS && e.CSS.supports;
          return (
            [
              "auto",
              "manipulation",
              "pan-y",
              "pan-x",
              "pan-x pan-y",
              "none",
            ].forEach(function (i) {
              t[i] = !n || e.CSS.supports("touch-action", i);
            }),
            t
          );
        })();
      function ue(e, t) {
        (this.manager = e), this.set(t);
      }
      ue.prototype = {
        set: function (e) {
          "compute" == e && (e = this.compute()),
            le &&
              this.manager.element.style &&
              se[e] &&
              (this.manager.element.style[re] = e),
            (this.actions = e.toLowerCase().trim());
        },
        update: function () {
          this.set(this.manager.options.touchAction);
        },
        compute: function () {
          var e = [];
          return (
            d(this.manager.recognizers, function (t) {
              v(t.options.enable, [t]) && (e = e.concat(t.getTouchAction()));
            }),
            (function (e) {
              if (w(e, "none")) return "none";
              var t = w(e, "pan-x"),
                n = w(e, "pan-y");
              if (t && n) return "none";
              if (t || n) return t ? "pan-x" : "pan-y";
              if (w(e, "manipulation")) return "manipulation";
              return "auto";
            })(e.join(" "))
          );
        },
        preventDefaults: function (e) {
          var t = e.srcEvent,
            n = e.offsetDirection;
          if (this.manager.session.prevented) t.preventDefault();
          else {
            var i = this.actions,
              a = w(i, "none") && !se.none,
              o = w(i, "pan-y") && !se["pan-y"],
              r = w(i, "pan-x") && !se["pan-x"];
            if (a) {
              var l = 1 === e.pointers.length,
                s = e.distance < 2,
                u = e.deltaTime < 250;
              if (l && s && u) return;
            }
            if (!r || !o)
              return a || (o && 6 & n) || (r && 24 & n)
                ? this.preventSrc(t)
                : void 0;
          }
        },
        preventSrc: function (e) {
          (this.manager.session.prevented = !0), e.preventDefault();
        },
      };
      function ce(e) {
        (this.options = a({}, this.defaults, e || {})),
          (this.id = C++),
          (this.manager = null),
          (this.options.enable = O(this.options.enable, !0)),
          (this.state = 1),
          (this.simultaneous = {}),
          (this.requireFail = []);
      }
      function he(e) {
        return 16 & e
          ? "cancel"
          : 8 & e
          ? "end"
          : 4 & e
          ? "move"
          : 2 & e
          ? "start"
          : "";
      }
      function de(e) {
        return 16 == e
          ? "down"
          : 8 == e
          ? "up"
          : 2 == e
          ? "left"
          : 4 == e
          ? "right"
          : "";
      }
      function me(e, t) {
        var n = t.manager;
        return n ? n.get(e) : e;
      }
      function pe() {
        ce.apply(this, arguments);
      }
      function ge() {
        pe.apply(this, arguments), (this.pX = null), (this.pY = null);
      }
      function fe() {
        pe.apply(this, arguments);
      }
      function be() {
        ce.apply(this, arguments), (this._timer = null), (this._input = null);
      }
      function ve() {
        pe.apply(this, arguments);
      }
      function Oe() {
        pe.apply(this, arguments);
      }
      function ye() {
        ce.apply(this, arguments),
          (this.pTime = !1),
          (this.pCenter = !1),
          (this._timer = null),
          (this._input = null),
          (this.count = 0);
      }
      function Ge(e, t) {
        return (
          ((t = t || {}).recognizers = O(t.recognizers, Ge.defaults.preset)),
          new Me(e, t)
        );
      }
      (ce.prototype = {
        defaults: {},
        set: function (e) {
          return (
            a(this.options, e),
            this.manager && this.manager.touchAction.update(),
            this
          );
        },
        recognizeWith: function (e) {
          if (h(e, "recognizeWith", this)) return this;
          var t = this.simultaneous;
          return (
            t[(e = me(e, this)).id] || ((t[e.id] = e), e.recognizeWith(this)),
            this
          );
        },
        dropRecognizeWith: function (e) {
          return (
            h(e, "dropRecognizeWith", this) ||
              ((e = me(e, this)), delete this.simultaneous[e.id]),
            this
          );
        },
        requireFailure: function (e) {
          if (h(e, "requireFailure", this)) return this;
          var t = this.requireFail;
          return (
            -1 === T(t, (e = me(e, this))) &&
              (t.push(e), e.requireFailure(this)),
            this
          );
        },
        dropRequireFailure: function (e) {
          if (h(e, "dropRequireFailure", this)) return this;
          e = me(e, this);
          var t = T(this.requireFail, e);
          return t > -1 && this.requireFail.splice(t, 1), this;
        },
        hasRequireFailures: function () {
          return this.requireFail.length > 0;
        },
        canRecognizeWith: function (e) {
          return !!this.simultaneous[e.id];
        },
        emit: function (e) {
          var t = this,
            n = this.state;
          function i(n) {
            t.manager.emit(n, e);
          }
          n < 8 && i(t.options.event + he(n)),
            i(t.options.event),
            e.additionalEvent && i(e.additionalEvent),
            n >= 8 && i(t.options.event + he(n));
        },
        tryEmit: function (e) {
          if (this.canEmit()) return this.emit(e);
          this.state = 32;
        },
        canEmit: function () {
          for (var e = 0; e < this.requireFail.length; ) {
            if (!(33 & this.requireFail[e].state)) return !1;
            e++;
          }
          return !0;
        },
        recognize: function (e) {
          var t = a({}, e);
          if (!v(this.options.enable, [this, t]))
            return this.reset(), void (this.state = 32);
          56 & this.state && (this.state = 1),
            (this.state = this.process(t)),
            30 & this.state && this.tryEmit(t);
        },
        process: function (e) {},
        getTouchAction: function () {},
        reset: function () {},
      }),
        f(pe, ce, {
          defaults: { pointers: 1 },
          attrTest: function (e) {
            var t = this.options.pointers;
            return 0 === t || e.pointers.length === t;
          },
          process: function (e) {
            var t = this.state,
              n = e.eventType,
              i = 6 & t,
              a = this.attrTest(e);
            return i && (8 & n || !a)
              ? 16 | t
              : i || a
              ? 4 & n
                ? 8 | t
                : 2 & t
                ? 4 | t
                : 2
              : 32;
          },
        }),
        f(ge, pe, {
          defaults: { event: "pan", threshold: 10, pointers: 1, direction: 30 },
          getTouchAction: function () {
            var e = this.options.direction,
              t = [];
            return 6 & e && t.push("pan-y"), 24 & e && t.push("pan-x"), t;
          },
          directionTest: function (e) {
            var t = this.options,
              n = !0,
              i = e.distance,
              a = e.direction,
              o = e.deltaX,
              r = e.deltaY;
            return (
              a & t.direction ||
                (6 & t.direction
                  ? ((a = 0 === o ? 1 : o < 0 ? 2 : 4),
                    (n = o != this.pX),
                    (i = Math.abs(e.deltaX)))
                  : ((a = 0 === r ? 1 : r < 0 ? 8 : 16),
                    (n = r != this.pY),
                    (i = Math.abs(e.deltaY)))),
              (e.direction = a),
              n && i > t.threshold && a & t.direction
            );
          },
          attrTest: function (e) {
            return (
              pe.prototype.attrTest.call(this, e) &&
              (2 & this.state || (!(2 & this.state) && this.directionTest(e)))
            );
          },
          emit: function (e) {
            (this.pX = e.deltaX), (this.pY = e.deltaY);
            var t = de(e.direction);
            t && (e.additionalEvent = this.options.event + t),
              this._super.emit.call(this, e);
          },
        }),
        f(fe, pe, {
          defaults: { event: "pinch", threshold: 0, pointers: 2 },
          getTouchAction: function () {
            return ["none"];
          },
          attrTest: function (e) {
            return (
              this._super.attrTest.call(this, e) &&
              (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state)
            );
          },
          emit: function (e) {
            if (1 !== e.scale) {
              var t = e.scale < 1 ? "in" : "out";
              e.additionalEvent = this.options.event + t;
            }
            this._super.emit.call(this, e);
          },
        }),
        f(be, ce, {
          defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
          getTouchAction: function () {
            return ["auto"];
          },
          process: function (e) {
            var t = this.options,
              n = e.pointers.length === t.pointers,
              i = e.distance < t.threshold,
              a = e.deltaTime > t.time;
            if (((this._input = e), !i || !n || (12 & e.eventType && !a)))
              this.reset();
            else if (1 & e.eventType)
              this.reset(),
                (this._timer = c(
                  function () {
                    (this.state = 8), this.tryEmit();
                  },
                  t.time,
                  this
                ));
            else if (4 & e.eventType) return 8;
            return 32;
          },
          reset: function () {
            clearTimeout(this._timer);
          },
          emit: function (e) {
            8 === this.state &&
              (e && 4 & e.eventType
                ? this.manager.emit(this.options.event + "up", e)
                : ((this._input.timeStamp = u()),
                  this.manager.emit(this.options.event, this._input)));
          },
        }),
        f(ve, pe, {
          defaults: { event: "rotate", threshold: 0, pointers: 2 },
          getTouchAction: function () {
            return ["none"];
          },
          attrTest: function (e) {
            return (
              this._super.attrTest.call(this, e) &&
              (Math.abs(e.rotation) > this.options.threshold || 2 & this.state)
            );
          },
        }),
        f(Oe, pe, {
          defaults: {
            event: "swipe",
            threshold: 10,
            velocity: 0.3,
            direction: 30,
            pointers: 1,
          },
          getTouchAction: function () {
            return ge.prototype.getTouchAction.call(this);
          },
          attrTest: function (e) {
            var t,
              n = this.options.direction;
            return (
              30 & n
                ? (t = e.overallVelocity)
                : 6 & n
                ? (t = e.overallVelocityX)
                : 24 & n && (t = e.overallVelocityY),
              this._super.attrTest.call(this, e) &&
                n & e.offsetDirection &&
                e.distance > this.options.threshold &&
                e.maxPointers == this.options.pointers &&
                s(t) > this.options.velocity &&
                4 & e.eventType
            );
          },
          emit: function (e) {
            var t = de(e.offsetDirection);
            t && this.manager.emit(this.options.event + t, e),
              this.manager.emit(this.options.event, e);
          },
        }),
        f(ye, ce, {
          defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10,
          },
          getTouchAction: function () {
            return ["manipulation"];
          },
          process: function (e) {
            var t = this.options,
              n = e.pointers.length === t.pointers,
              i = e.distance < t.threshold,
              a = e.deltaTime < t.time;
            if ((this.reset(), 1 & e.eventType && 0 === this.count))
              return this.failTimeout();
            if (i && a && n) {
              if (4 != e.eventType) return this.failTimeout();
              var o = !this.pTime || e.timeStamp - this.pTime < t.interval,
                r = !this.pCenter || F(this.pCenter, e.center) < t.posThreshold;
              if (
                ((this.pTime = e.timeStamp),
                (this.pCenter = e.center),
                r && o ? (this.count += 1) : (this.count = 1),
                (this._input = e),
                0 === this.count % t.taps)
              )
                return this.hasRequireFailures()
                  ? ((this._timer = c(
                      function () {
                        (this.state = 8), this.tryEmit();
                      },
                      t.interval,
                      this
                    )),
                    2)
                  : 8;
            }
            return 32;
          },
          failTimeout: function () {
            return (
              (this._timer = c(
                function () {
                  this.state = 32;
                },
                this.options.interval,
                this
              )),
              32
            );
          },
          reset: function () {
            clearTimeout(this._timer);
          },
          emit: function () {
            8 == this.state &&
              ((this._input.tapCount = this.count),
              this.manager.emit(this.options.event, this._input));
          },
        }),
        (Ge.VERSION = "2.0.7"),
        (Ge.defaults = {
          domEvents: !1,
          touchAction: "compute",
          enable: !0,
          inputTarget: null,
          inputClass: null,
          preset: [
            [ve, { enable: !1 }],
            [fe, { enable: !1 }, ["rotate"]],
            [Oe, { direction: 6 }],
            [ge, { direction: 6 }, ["swipe"]],
            [ye],
            [ye, { event: "doubletap", taps: 2 }, ["tap"]],
            [be],
          ],
          cssProps: {
            userSelect: "none",
            touchSelect: "none",
            touchCallout: "none",
            contentZooming: "none",
            userDrag: "none",
            tapHighlightColor: "rgba(0,0,0,0)",
          },
        });
      function Me(e, t) {
        var n;
        (this.options = a({}, Ge.defaults, t || {})),
          (this.options.inputTarget = this.options.inputTarget || e),
          (this.handlers = {}),
          (this.session = {}),
          (this.recognizers = []),
          (this.oldCssProps = {}),
          (this.element = e),
          (this.input = new ((n = this).options.inputClass ||
            (D ? ee : k ? ne : H))(n, A)),
          (this.touchAction = new ue(this, this.options.touchAction)),
          we(this, !0),
          d(
            this.options.recognizers,
            function (e) {
              var t = this.add(new e[0](e[1]));
              e[2] && t.recognizeWith(e[2]), e[3] && t.requireFailure(e[3]);
            },
            this
          );
      }
      function we(e, t) {
        var n,
          i = e.element;
        i.style &&
          (d(e.options.cssProps, function (a, o) {
            (n = L(i.style, o)),
              t
                ? ((e.oldCssProps[n] = i.style[n]), (i.style[n] = a))
                : (i.style[n] = e.oldCssProps[n] || "");
          }),
          t || (e.oldCssProps = {}));
      }
      (Me.prototype = {
        set: function (e) {
          return (
            a(this.options, e),
            e.touchAction && this.touchAction.update(),
            e.inputTarget &&
              (this.input.destroy(),
              (this.input.target = e.inputTarget),
              this.input.init()),
            this
          );
        },
        stop: function (e) {
          this.session.stopped = e ? 2 : 1;
        },
        recognize: function (e) {
          var t = this.session;
          if (!t.stopped) {
            var n;
            this.touchAction.preventDefaults(e);
            var i = this.recognizers,
              a = t.curRecognizer;
            (!a || (a && 8 & a.state)) && (a = t.curRecognizer = null);
            for (var o = 0; o < i.length; )
              (n = i[o]),
                2 === t.stopped || (a && n != a && !n.canRecognizeWith(a))
                  ? n.reset()
                  : n.recognize(e),
                !a && 14 & n.state && (a = t.curRecognizer = n),
                o++;
          }
        },
        get: function (e) {
          if (e instanceof ce) return e;
          for (var t = this.recognizers, n = 0; n < t.length; n++)
            if (t[n].options.event == e) return t[n];
          return null;
        },
        add: function (e) {
          if (h(e, "add", this)) return this;
          var t = this.get(e.options.event);
          return (
            t && this.remove(t),
            this.recognizers.push(e),
            (e.manager = this),
            this.touchAction.update(),
            e
          );
        },
        remove: function (e) {
          if (h(e, "remove", this)) return this;
          if ((e = this.get(e))) {
            var t = this.recognizers,
              n = T(t, e);
            -1 !== n && (t.splice(n, 1), this.touchAction.update());
          }
          return this;
        },
        on: function (e, t) {
          if (void 0 !== e && void 0 !== t) {
            var n = this.handlers;
            return (
              d(I(e), function (e) {
                (n[e] = n[e] || []), n[e].push(t);
              }),
              this
            );
          }
        },
        off: function (e, t) {
          if (void 0 !== e) {
            var n = this.handlers;
            return (
              d(I(e), function (e) {
                t ? n[e] && n[e].splice(T(n[e], t), 1) : delete n[e];
              }),
              this
            );
          }
        },
        emit: function (e, n) {
          this.options.domEvents &&
            (function (e, n) {
              var i = t.createEvent("Event");
              i.initEvent(e, !0, !0),
                (i.gesture = n),
                n.target.dispatchEvent(i);
            })(e, n);
          var i = this.handlers[e] && this.handlers[e].slice();
          if (i && i.length) {
            (n.type = e),
              (n.preventDefault = function () {
                n.srcEvent.preventDefault();
              });
            for (var a = 0; a < i.length; ) i[a](n), a++;
          }
        },
        destroy: function () {
          this.element && we(this, !1),
            (this.handlers = {}),
            (this.session = {}),
            this.input.destroy(),
            (this.element = null);
        },
      }),
        a(Ge, {
          INPUT_START: 1,
          INPUT_MOVE: 2,
          INPUT_END: 4,
          INPUT_CANCEL: 8,
          STATE_POSSIBLE: 1,
          STATE_BEGAN: 2,
          STATE_CHANGED: 4,
          STATE_ENDED: 8,
          STATE_RECOGNIZED: 8,
          STATE_CANCELLED: 16,
          STATE_FAILED: 32,
          DIRECTION_NONE: 1,
          DIRECTION_LEFT: 2,
          DIRECTION_RIGHT: 4,
          DIRECTION_UP: 8,
          DIRECTION_DOWN: 16,
          DIRECTION_HORIZONTAL: 6,
          DIRECTION_VERTICAL: 24,
          DIRECTION_ALL: 30,
          Manager: Me,
          Input: Y,
          TouchAction: ue,
          TouchInput: ee,
          MouseInput: H,
          PointerEventInput: Q,
          TouchMouseInput: ne,
          SingleTouchInput: Z,
          Recognizer: ce,
          AttrRecognizer: pe,
          Tap: ye,
          Pan: ge,
          Swipe: Oe,
          Pinch: fe,
          Rotate: ve,
          Press: be,
          on: y,
          off: G,
          each: d,
          merge: g,
          extend: p,
          assign: a,
          inherit: f,
          bindFn: b,
          prefixed: L,
        }),
        ((void 0 !== e ? e : "undefined" != typeof self ? self : {}).NGHammer =
          Ge),
        "function" == typeof define && define.amdDISABLED
          ? define(function () {
              return Ge;
            })
          : "undefined" != typeof module && module.exports
          ? (module.exports = Ge)
          : (e.NGHammer = Ge);
    })(window, document);
}),
  function () {
    "use strict";
    var e;
    (e = function () {
      for (
        var e = document.querySelectorAll("[data-nanogallery2]"), t = 0;
        t < e.length;
        t++
      )
        jQuery(e[t]).nanogallery2(jQuery(e[t]).data("nanogallery2"));
      for (
        e = document.querySelectorAll("[data-nanogallery2-lightbox]"), t = 0;
        t < e.length;
        t++
      )
        e[t].classList.add("NGY2ThumbnailLightbox"),
          e[t].addEventListener("click", function (e) {
            e.preventDefault();
            for (
              var t = {
                  lightboxStandalone: !0,
                  viewerToolbar: { display: !1 },
                },
                n = this.dataset.nanogallery2Lgroup,
                i = document.querySelectorAll("[data-nanogallery2-lightbox]"),
                a = 0;
              a < i.length;
              a++
            )
              if (
                i[a].dataset.nanogallery2Lgroup == n &&
                "" !== i[a].dataset.nanogallery2Lightbox
              ) {
                t = jQuery.extend(
                  !0,
                  {},
                  t,
                  jQuery(i[a]).data("nanogallery2Lightbox")
                );
                break;
              }
            jQuery(this).nanogallery2(t);
          });
    }),
      "loading" != document.readyState
        ? e()
        : document.addEventListener
        ? document.addEventListener("DOMContentLoaded", e)
        : document.attachEvent("onreadystatechange", function () {
            "complete" == document.readyState && e();
          });
  }.call(null),
  /**!
   */
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery", "nanogallery2"], e)
      : "object" == typeof exports && "function" == typeof require
      ? e(require(["jquery", "nanogallery2"]))
      : e(jQuery);
  })(function (e) {
    jQuery.nanogallery2.data_nano_photos_provider2 = function (e, t) {
      var n = e,
        i = function (t, i, s, c) {
          var h = NGY2Item.GetIdx(n, t);
          "" == e.I[h].title && (e.I[h].title = a(t));
          var d = n.O.dataProvider + "?albumID=" + t;
          (d += "&hxs=" + n.tn.settings.getH(n.GOM.curNavLevel, "xs")),
            (d += "&wxs=" + n.tn.settings.getW(n.GOM.curNavLevel, "xs")),
            (d += "&hsm=" + n.tn.settings.getH(n.GOM.curNavLevel, "sm")),
            (d += "&wsm=" + n.tn.settings.getW(n.GOM.curNavLevel, "sm")),
            (d += "&hme=" + n.tn.settings.getH(n.GOM.curNavLevel, "me")),
            (d += "&wme=" + n.tn.settings.getW(n.GOM.curNavLevel, "me")),
            (d += "&hla=" + n.tn.settings.getH(n.GOM.curNavLevel, "la")),
            (d += "&wla=" + n.tn.settings.getW(n.GOM.curNavLevel, "la")),
            (d += "&hxl=" + n.tn.settings.getH(n.GOM.curNavLevel, "xl")),
            (d += "&wxl=" + n.tn.settings.getW(n.GOM.curNavLevel, "xl")),
            r(!0),
            jQuery.ajaxSetup({ cache: !1 }),
            (jQuery.support.cors = !0);
          try {
            var m = setTimeout(function () {
              r(!1),
                l(n, "Could not retrieve nanoPhotosProvider2 data (timeout).");
            }, 6e4);
            n.O.debugMode && console.log("nanoPhotosProvider2 URL: " + d),
              jQuery
                .getJSON(d, function (e, a, d) {
                  clearTimeout(m),
                    r(!1),
                    o(h, e),
                    "ok" == e.nano_status
                      ? (u(t), null != i && i(s, c, null))
                      : l(
                          n,
                          "Could not retrieve nanoPhotosProvider2 data. Error: " +
                            e.nano_status +
                            " - " +
                            e.nano_message
                        );
                })
                .fail(function (e, t, i) {
                  clearTimeout(m), r(!1);
                  var a = "";
                  for (var o in e) a += o + "=" + e[o] + "<br>";
                  l(
                    n,
                    "Could not retrieve nanoPhotosProvider2 data. Error: " +
                      (t + ", " + i + " " + a + "<br><br>URL:" + d)
                  );
                });
          } catch (e) {
            l(n, "Could not retrieve nanoPhotosProvider2 data. Error: " + e);
          }
        };
      function a(e) {
        return decodeURIComponent(e);
      }
      function o(e, t) {
        n.O.debugMode &&
          (console.log("nanoPhotosProvider2 parse data:"), console.dir(t));
        jQuery.each(t.album_content, function (e, i) {
          var o = n.O.dataProvider.substring(
              0,
              n.O.dataProvider.indexOf("nano_photos_provider2.php")
            ),
            r = o + a(i.src),
            l = i.title,
            u = i.description.split("_").join(" "),
            c = "image";
          void 0 !== i.kind && i.kind.length > 0 && (c = i.kind);
          var h = i.ID,
            d = !1;
          if (
            ("album" == c &&
              (s(l, h) || (d = !0),
              ("" == n.O.album && "" == n.O.photoset) || (d = !0)),
            "image" == c || !d)
          ) {
            var m = 0;
            void 0 !== i.albumID && ((m = i.albumID), !0);
            var p = void 0 === i.tags ? "" : i.tags,
              g = NGY2Item.New(n, l.split("_").join(" "), u, h, m, c, p);
            g.setMediaURL(r, "img"),
              void 0 !== i.dcGIF &&
                (g.imageDominantColors = "data:image/gif;base64," + i.dcGIF),
              void 0 !== i.dc && "" !== i.dc && (g.imageDominantColor = i.dc),
              "album" == c
                ? (g.numberItems = i.cnt)
                : ((g.imageWidth = i.imgWidth), (g.imageHeight = i.imgHeight)),
              "" != i.originalURL && (g.downloadURL = o + a(i.originalURL));
            for (
              var f = n.GOM.curNavLevel,
                b = ["xs", "sm", "me", "la", "xl"],
                v = 0;
              v < b.length;
              v++
            )
              (g.thumbs.url[f][b[v]] = o + a(i.t_url[v])),
                (g.thumbs.width[f][b[v]] = parseInt(i.t_width[v])),
                (g.thumbs.height[f][b[v]] = parseInt(i.t_height[v]));
            var O = n.O.fnProcessData;
            null !== O &&
              ("function" == typeof O
                ? O(g, n.O.dataProvider, t)
                : window[O](g, n.O.dataProvider, t));
          }
        }),
          (n.I[e].contentIsLoaded = !0);
      }
      var r = NGY2Tools.PreloaderDisplay.bind(n),
        l = NGY2Tools.NanoAlert,
        s = NGY2Tools.FilterAlbumName.bind(n),
        u = NGY2Tools.AlbumPostProcess.bind(n);
      switch (t) {
        case "GetHiddenAlbums":
          break;
        case "AlbumGetContent":
          var c = arguments[2],
            h = arguments[3],
            d = arguments[4],
            m = arguments[5];
          i(c, h, d, m);
      }
    };
  }),
  /**!
   */
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery", "nanogallery2"], e)
      : "object" == typeof exports && "function" == typeof require
      ? e(require(["jquery", "nanogallery2"]))
      : e(jQuery);
  })(function (e) {
    jQuery.nanogallery2.data_google2 = function (e, t) {
      var n = e,
        i = function (e, t, i, o) {
          var s = "",
            u = "image",
            c = NGY2Item.GetIdx(n, e),
            d = "";
          n.galleryMaxItems.Get() > 0 &&
            (d = "&max-results=" + n.galleryMaxItems.Get());
          var m = "";
          "undefined" != typeof ngy2_pwa_at && (m = ngy2_pwa_at),
            0 == e
              ? ((s =
                  "" != m
                    ? "https://photoslibrary.googleapis.com/v1/albums"
                    : n.O.google2URL +
                      "?nguserid=" +
                      n.O.userID +
                      "&alt=json&v=3&kind=album" +
                      d +
                      "&rnd=" +
                      new Date().getTime()),
                (u = "album"))
              : (s =
                  "" != m
                    ? "https://photoslibrary.googleapis.com/v1/mediaItems:search"
                    : n.O.google2URL +
                      "?nguserid=" +
                      n.O.userID +
                      "&ngalbumid=" +
                      e +
                      "&alt=json&v=3&kind=photo&" +
                      d),
            n.O.debugMode && console.log("Google Photos URL: " + s),
            r(!0),
            jQuery.ajaxSetup({ cache: !1 }),
            (jQuery.support.cors = !0);
          try {
            var p = setTimeout(function () {
              r(!1), l("Could not retrieve AJAX data...");
            }, 6e4);
            jQuery
              .getJSON(s + "&callback=?", function (s) {
                if ("error" == s.nano_status)
                  return (
                    clearTimeout(p),
                    r(!1),
                    void l(
                      n,
                      "Could not retrieve Google data. Error: " + s.nano_message
                    )
                  );
                clearTimeout(p),
                  r(!1),
                  a(c, u, s),
                  h(e),
                  null != t && t(i, o, null);
              })
              .fail(function (e, t, i) {
                clearTimeout(p), r(!1);
                var a = "";
                for (var o in e) a += o + "=" + e[o] + "<br>";
                l(
                  n,
                  "Could not retrieve Google data. Error: " +
                    (t + ", " + i + " " + a + "<br><br>URL:" + s)
                );
              });
          } catch (e) {
            l(n, "Could not retrieve Google data. Error: " + e);
          }
        };
      function a(e, t, i) {
        n.O.debugMode && (console.log("Google Photos data:"), console.dir(i));
        var a = n.I[e].GetID();
        jQuery.each(i, function (e, i) {
          if ("object" == typeof i && null !== i) {
            var r = "",
              l = "";
            "image" == t
              ? (void 0 !== i.description && (r = i.description),
                "" != n.O.thumbnailLabel.get("title") && (l = u(i.filename)))
              : (l = i.title),
              null == l && (l = "");
            var h = i.id;
            if ("album" == t && (!c(l, h) || null == i.coverPhotoBaseUrl))
              return !0;
            var d = NGY2Item.New(n, l, r, h, a, t, ""),
              m = 0,
              p = 0,
              g = "";
            "image" == t
              ? ((g = i.baseUrl),
                n.O.viewerZoom || null == n.O.viewerZoom
                  ? (g +=
                      "=h" +
                      i.mediaMetadata.height +
                      "-w" +
                      i.mediaMetadata.width)
                  : window.screen.width > window.screen.height
                  ? (g += "=w" + window.screen.width)
                  : (g = s + "=h" + window.screen.height),
                d.setMediaURL(g, "img"),
                void 0 !== i.mediaMetadata.width &&
                  ((d.imageWidth = parseInt(i.mediaMetadata.width)),
                  (m = d.imageWidth)),
                void 0 !== i.mediaMetadata.height &&
                  ((d.imageHeight = parseInt(i.mediaMetadata.height)),
                  (p = d.imageHeight)),
                void 0 !== i.mediaMetadata.photo &&
                  (null != i.mediaMetadata.photo.exposureTime &&
                    (d.exif.exposure = i.mediaMetadata.photo.exposureTime),
                  null != i.mediaMetadata.photo.focalLength &&
                    (d.exif.focallength = i.mediaMetadata.photo.focalLength),
                  null != i.mediaMetadata.photo.apertureFNumber &&
                    (d.exif.fstop = i.mediaMetadata.photo.apertureFNumber),
                  null != i.mediaMetadata.photo.isoEquivalent &&
                    (d.exif.iso = i.mediaMetadata.photo.isoEquivalent),
                  null != i.mediaMetadata.photo.cameraModel &&
                    (d.exif.model = i.mediaMetadata.photo.cameraModel)),
                void 0 !== i.mediaMetadata.video &&
                  (null != i.mediaMetadata.video.cameraModel &&
                    (d.exif.model = i.mediaMetadata.video.cameraModel),
                  (d.downloadURL = i.baseUrl + "=dv")))
              : (d.numberItems = i.mediaItemsCount),
              (d.thumbs = o("l1", d.thumbs, i, t, p, m)),
              (d.thumbs = o("lN", d.thumbs, i, t, p, m));
            var f = n.O.fnProcessData;
            null !== f &&
              ("function" == typeof f
                ? f(d, "google2", i)
                : window[f](d, "google2", i));
          }
        }),
          (n.I[e].contentIsLoaded = !0);
      }
      function o(e, t, i, a, o, r) {
        for (var l = ["xs", "sm", "me", "la", "xl"], s = 0; s < l.length; s++) {
          if ("image" == a) {
            if ("auto" == n.tn.settings.width[e][l[s]]) {
              let a = r / o;
              (t.height[e][l[s]] = n.tn.settings.getH(e, l[s])),
                (t.width[e][l[s]] = n.tn.settings.getH(e, l[s]) * a),
                (t.url[e][l[s]] =
                  i.baseUrl + "=h" + n.tn.settings.getH(e, l[s]));
              continue;
            }
            if ("auto" == n.tn.settings.height[e][l[s]]) {
              let a = o / r;
              (t.width[e][l[s]] = n.tn.settings.getW(e, l[s])),
                (t.height[e][l[s]] = n.tn.settings.getW(e, l[s]) * a),
                (t.url[e][l[s]] =
                  i.baseUrl + "=w" + n.tn.settings.getW(e, l[s]));
              continue;
            }
            (t.height[e][l[s]] = n.tn.settings.getH(e, l[s])),
              (t.width[e][l[s]] = n.tn.settings.getW(e, l[s])),
              (t.url[e][l[s]] = i.baseUrl + "=w" + n.tn.settings.getW(e, l[s]));
          }
          if ("album" == a) {
            if ("auto" == n.tn.settings.width[e][l[s]]) {
              t.url[e][l[s]] =
                i.coverPhotoBaseUrl + "=h" + n.tn.settings.getH(e, l[s]);
              continue;
            }
            if ("auto" == n.tn.settings.height[e][l[s]]) {
              t.url[e][l[s]] =
                i.coverPhotoBaseUrl + "=w" + n.tn.settings.getW(e, l[s]);
              continue;
            }
            t.url[e][l[s]] =
              i.coverPhotoBaseUrl +
              "=h" +
              n.tn.settings.getH(e, l[s]) +
              "-w" +
              n.tn.settings.getW(e, l[s]);
          }
        }
        return t;
      }
      var r = NGY2Tools.PreloaderDisplay.bind(n),
        l = NGY2Tools.NanoAlert,
        u = NGY2Tools.GetImageTitleFromURL.bind(n),
        c = NGY2Tools.FilterAlbumName.bind(n),
        h = NGY2Tools.AlbumPostProcess.bind(n);
      switch (t) {
        case "AlbumGetContent":
          var d = arguments[2],
            m = arguments[3],
            p = arguments[4],
            g = arguments[5];
          i(d, m, p, g);
      }
    };
  }),
  /**!
   */
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery", "nanogallery2"], e)
      : "object" == typeof exports && "function" == typeof require
      ? e(require(["jquery", "nanogallery2"]))
      : e(jQuery);
  })(function (e) {
    jQuery.nanogallery2.data_flickr = function (e, t) {
      var n = e,
        i = {
          url: function () {
            return "https://api.flickr.com/services/rest/";
          },
          thumbSize: "               sq",
          thumbAvailableSizes: new Array(75, 100, 150, 240, 500, 640),
          thumbAvailableSizesStr: new Array("sq", "t", "q", "s", "m", "z"),
          photoSize: "0",
          photoAvailableSizes: new Array(
            75,
            100,
            150,
            240,
            500,
            640,
            1024,
            1024,
            1600,
            2048,
            1e4
          ),
          photoAvailableSizesStr: new Array(
            "sq",
            "t",
            "q",
            "s",
            "m",
            "z",
            "b",
            "l",
            "h",
            "k",
            "o"
          ),
        },
        a = function (e, t, a, l) {
          "" == n.O.flickrAPIKey &&
            h(n, "Please set your Flickr API Key (option flickrAPIKey)");
          var s = NGY2Item.GetIdx(n, e),
            d = "",
            m = "image";
          "NONE" == n.O.photoset.toUpperCase() ||
          "NONE" == n.O.album.toUpperCase()
            ? (d =
                i.url() +
                "?&method=flickr.people.getPublicPhotos&api_key=" +
                n.O.flickrAPIKey +
                "&user_id=" +
                n.O.userID +
                "&extras=description,views,tags,url_o,url_sq,url_t,url_q,url_s,url_m,url_z,url_b,url_h,url_k&per_page=500&format=json")
            : 0 == n.I[s].GetID()
            ? ((d =
                i.url() +
                "?&method=flickr.photosets.getList&api_key=" +
                n.O.flickrAPIKey +
                "&user_id=" +
                n.O.userID +
                "&per_page=500&primary_photo_extras=tags,url_o,url_sq,url_t,url_q,url_s,url_m,url_l,url_z,url_b,url_h,url_k&format=json"),
              (m = "album"))
            : (d =
                i.url() +
                "?&method=flickr.photosets.getPhotos&api_key=" +
                n.O.flickrAPIKey +
                "&photoset_id=" +
                n.I[s].GetID() +
                "&extras=description,views,tags,url_o,url_sq,url_t,url_q,url_s,url_m,url_l,url_z,url_b,url_h,url_k&format=json"),
            n.O.debugMode && console.log("Flickr URL: " + d),
            c(!0),
            jQuery.ajaxSetup({ cache: !1 }),
            (jQuery.support.cors = !0);
          var g = setTimeout(function () {
              c(!1), h(n, "Could not retrieve AJAX data...");
            }, 6e4),
            f = [],
            b = function (i, d) {
              jQuery
                .getJSON(
                  i + "&page=" + d + "&jsoncallback=?",
                  function (v, O, y) {
                    var G = 0;
                    if ("album" == m) {
                      if (void 0 !== v.stat && "fail" === v.stat)
                        return (
                          h(
                            n,
                            "Could not retrieve Flickr album list: " +
                              v.message +
                              " (code: " +
                              v.code +
                              ")."
                          ),
                          !1
                        );
                      (f = f.concat(v.photosets.photoset)),
                        (G = v.photosets.pages);
                    } else if (
                      "NONE" == n.O.photoset.toUpperCase() ||
                      "NONE" == n.O.album.toUpperCase()
                    )
                      (f = f.concat(v.photos.photo)), (G = v.photos.pages);
                    else {
                      if (void 0 !== v.stat && "fail" === v.stat)
                        return (
                          h(
                            n,
                            "Could not retrieve Flickr album: " +
                              v.message +
                              " (code: " +
                              v.code +
                              ")."
                          ),
                          !1
                        );
                      "" == n.I[s].title && (n.I[s].title = v.photoset.title),
                        (f = f.concat(v.photoset.photo)),
                        (G = v.photoset.pages);
                    }
                    G > d
                      ? b(i, d + 1)
                      : (clearTimeout(g),
                        c(!1),
                        (f = u(f, n.O.tagBlockList)),
                        "album" == m ? r(s, e, f) : o(s, e, f),
                        p(e),
                        null != t && t(a, l, null));
                  }
                )
                .fail(function (e, t, i) {
                  clearTimeout(g),
                    c(!1),
                    h(
                      n,
                      "Could not retrieve Flickr ajax data: " + t + ", " + i
                    );
                });
            };
          b(d, 1);
        };
      function o(e, t, a) {
        n.O.debugMode && (console.log("Flickr parse photos:"), console.dir(a)),
          jQuery.each(a, function (e, a) {
            var o = a.id,
              r = a.url_sq,
              s = a.title;
            "" != n.O.thumbnailLabel.get("title") && (s = d(r));
            var u = a.description._content,
              c = 75,
              h = 75,
              m = i.photoAvailableSizesStr.length - 1;
            n.O.flickrSkipOriginal && m--;
            for (e = m; e >= 0; e--)
              if (null != a["url_" + i.photoAvailableSizesStr[e]]) {
                (r = a["url_" + i.photoAvailableSizesStr[e]]),
                  (c = parseInt(a["width_" + i.photoAvailableSizesStr[e]])),
                  (h = parseInt(a["height_" + i.photoAvailableSizesStr[e]]));
                break;
              }
            var p = {};
            for (var g in a)
              (0 != g.indexOf("height_") &&
                0 != g.indexOf("width_") &&
                0 != g.indexOf("url_")) ||
                (p[g] = a[g]);
            var f = void 0 !== a.tags ? a.tags : "",
              b = NGY2Item.New(n, s, u, o, t, "image", f);
            b.setMediaURL(r, "img"), (b.imageWidth = c), (b.imageHeight = h);
            var v = {
              url: {
                l1: { xs: "", sm: "", me: "", la: "", xl: "" },
                lN: { xs: "", sm: "", me: "", la: "", xl: "" },
              },
              width: {
                l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
              },
              height: {
                l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
              },
            };
            (v = l(v, a, "l1")), (v = l(v, a, "lN")), (b.thumbs = v);
            var O = n.O.fnProcessData;
            null !== O &&
              ("function" == typeof O
                ? O(b, "flickr", a)
                : window[O](b, "flickr", a));
          }),
          (n.I[e].contentIsLoaded = !0);
      }
      function r(e, t, i) {
        n.O.debugMode &&
          (console.log("Flickr parse list of albums:"), console.dir(i)),
          jQuery.each(i, function (e, i) {
            var a = i.title._content;
            if (0 == i.visibility_can_see_set) return !0;
            if (m(a, i.id)) {
              var o = i.id,
                r =
                  null != i.description._content ? i.description._content : "",
                s = {};
              for (var u in i.primary_photo_extras)
                s[u] = i.primary_photo_extras[u];
              var c = "";
              void 0 !== i.primary_photo_extras &&
                void 0 !== i.primary_photo_extras.tags &&
                (c = i.primary_photo_extras.tags);
              var h = NGY2Item.New(n, a, r, o, t, "album", c);
              (h.numberItems = i.photos), (h.thumbSizes = s);
              var d = {
                url: {
                  l1: { xs: "", sm: "", me: "", la: "", xl: "" },
                  lN: { xs: "", sm: "", me: "", la: "", xl: "" },
                },
                width: {
                  l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                  lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                },
                height: {
                  l1: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                  lN: { xs: 0, sm: 0, me: 0, la: 0, xl: 0 },
                },
              };
              (d = l(d, i.primary_photo_extras, "l1")),
                (d = l(d, i.primary_photo_extras, "lN")),
                (h.thumbs = d);
              var p = n.O.fnProcessData;
              null !== p &&
                ("function" == typeof p
                  ? p(h, "flickr", i)
                  : window[p](h, "flickr", i));
            }
          }),
          (n.I[e].contentIsLoaded = !0);
      }
      function l(e, t, i) {
        var a = 1;
        !0 === n.tn.opt[i].crop && (a = n.O.thumbnailCropScaleFactor);
        for (var o = ["xs", "sm", "me", "la", "xl"], r = 0; r < o.length; r++)
          if (
            "auto" == n.tn.settings.width[i][o[r]] ||
            "" == n.tn.settings.width[i][o[r]]
          ) {
            let l = s(
              "height_",
              Math.ceil(
                n.tn.settings.height[i][o[r]] *
                  n.tn.scale *
                  a *
                  n.tn.settings.mosaic[i + "Factor"].h[o[r]]
              ),
              t
            );
            (e.url[i][o[r]] = l.url),
              (e.width[i][o[r]] = l.width),
              (e.height[i][o[r]] = l.height);
          } else if (
            "auto" == n.tn.settings.height[i][o[r]] ||
            "" == n.tn.settings.height[i][o[r]]
          ) {
            let l = s(
              "width_",
              Math.ceil(
                n.tn.settings.width[i][o[r]] *
                  n.tn.scale *
                  a *
                  n.tn.settings.mosaic[i + "Factor"].w[o[r]]
              ),
              t
            );
            (e.url[i][o[r]] = l.url),
              (e.width[i][o[r]] = l.width),
              (e.height[i][o[r]] = l.height);
          } else {
            let l = "height_",
              u = Math.ceil(
                n.tn.settings.height[i][o[r]] *
                  n.tn.scale *
                  a *
                  n.tn.settings.mosaic[i + "Factor"].h[o[r]]
              );
            n.tn.settings.width[i][o[r]] > n.tn.settings.height[i][o[r]] &&
              ((l = "width_"),
              (u = Math.ceil(
                n.tn.settings.width[i][o[r]] *
                  n.tn.scale *
                  a *
                  n.tn.settings.mosaic[i + "Factor"].w[o[r]]
              )));
            let c = s(l, u, t);
            (e.url[i][o[r]] = c.url),
              (e.width[i][o[r]] = c.width),
              (e.height[i][o[r]] = c.height);
          }
        return e;
      }
      function s(e, t, n) {
        for (
          var a = { url: "", width: 0, height: 0 }, o = 0, r = 0;
          r < i.thumbAvailableSizes.length;
          r++
        ) {
          var l = n[e + i.photoAvailableSizesStr[r]];
          if (null != l && ((o = r), l >= t)) break;
        }
        var s = i.photoAvailableSizesStr[o];
        return (
          (a.url = n["url_" + s]),
          (a.width = parseInt(n["width_" + s])),
          (a.height = parseInt(n["height_" + s])),
          a
        );
      }
      var u = function (e, t) {
        return (
          "" != t &&
            null != e &&
            (e = e.filter(function (e) {
              var n = new RegExp(t, "i"),
                i = [e.tags];
              return (
                Array.isArray(e.tags) && (i = e.tags),
                !i.some(function (e) {
                  return n.test(e);
                })
              );
            })),
          e
        );
      };
      var c = NGY2Tools.PreloaderDisplay.bind(n),
        h = NGY2Tools.NanoAlert,
        d = NGY2Tools.GetImageTitleFromURL.bind(n),
        m = NGY2Tools.FilterAlbumName.bind(n),
        p = NGY2Tools.AlbumPostProcess.bind(n);
      switch (t) {
        case "AlbumGetContent":
          var g = arguments[2],
            f = arguments[3],
            b = arguments[4],
            v = arguments[5];
          a(g, f, b, v);
      }
    };
  });

$(document).mouseup(function (e) {
  var container = $(".site_header_search_in_new");

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".site_header_search_main_new").removeClass("is-active");
    $(".site_header_search_main_new input[type='search']").val("");
  }
});

/*-Animation-*/
!(function (a, b) {
  if ("function" == typeof define && define.amd)
    define(["module", "exports"], b);
  else if ("undefined" != typeof exports) b(module, exports);
  else {
    var c = { exports: {} };
    b(c, c.exports), (a.WOW = c.exports);
  }
})(this, function (a, b) {
  "use strict";
  function c(a, b) {
    if (!(a instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function d(a, b) {
    return b.indexOf(a) >= 0;
  }
  function e(a, b) {
    for (var c in b)
      if (null == a[c]) {
        var d = b[c];
        a[c] = d;
      }
    return a;
  }
  function f(a) {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      a
    );
  }
  function g(a) {
    var b =
        arguments.length <= 1 || void 0 === arguments[1] ? !1 : arguments[1],
      c = arguments.length <= 2 || void 0 === arguments[2] ? !1 : arguments[2],
      d =
        arguments.length <= 3 || void 0 === arguments[3] ? null : arguments[3],
      e = void 0;
    return (
      null != document.createEvent
        ? ((e = document.createEvent("CustomEvent")),
          e.initCustomEvent(a, b, c, d))
        : null != document.createEventObject
        ? ((e = document.createEventObject()), (e.eventType = a))
        : (e.eventName = a),
      e
    );
  }
  function h(a, b) {
    null != a.dispatchEvent
      ? a.dispatchEvent(b)
      : b in (null != a)
      ? a[b]()
      : "on" + b in (null != a) && a["on" + b]();
  }
  function i(a, b, c) {
    null != a.addEventListener
      ? a.addEventListener(b, c, !1)
      : null != a.attachEvent
      ? a.attachEvent("on" + b, c)
      : (a[b] = c);
  }
  function j(a, b, c) {
    null != a.removeEventListener
      ? a.removeEventListener(b, c, !1)
      : null != a.detachEvent
      ? a.detachEvent("on" + b, c)
      : delete a[b];
  }
  function k() {
    return "innerHeight" in window
      ? window.innerHeight
      : document.documentElement.clientHeight;
  }
  Object.defineProperty(b, "__esModule", { value: !0 });
  var l,
    m,
    n = (function () {
      function a(a, b) {
        for (var c = 0; c < b.length; c++) {
          var d = b[c];
          (d.enumerable = d.enumerable || !1),
            (d.configurable = !0),
            "value" in d && (d.writable = !0),
            Object.defineProperty(a, d.key, d);
        }
      }
      return function (b, c, d) {
        return c && a(b.prototype, c), d && a(b, d), b;
      };
    })(),
    o =
      window.WeakMap ||
      window.MozWeakMap ||
      (function () {
        function a() {
          c(this, a), (this.keys = []), (this.values = []);
        }
        return (
          n(a, [
            {
              key: "get",
              value: function (a) {
                for (var b = 0; b < this.keys.length; b++) {
                  var c = this.keys[b];
                  if (c === a) return this.values[b];
                }
              },
            },
            {
              key: "set",
              value: function (a, b) {
                for (var c = 0; c < this.keys.length; c++) {
                  var d = this.keys[c];
                  if (d === a) return (this.values[c] = b), this;
                }
                return this.keys.push(a), this.values.push(b), this;
              },
            },
          ]),
          a
        );
      })(),
    p =
      window.MutationObserver ||
      window.WebkitMutationObserver ||
      window.MozMutationObserver ||
      ((m = l =
        (function () {
          function a() {
            c(this, a),
              "undefined" != typeof console &&
                null !== console &&
                (console.warn(
                  "MutationObserver is not supported by your browser."
                ),
                console.warn(
                  "WOW.js cannot detect dom mutations, please call .sync() after loading new content."
                ));
          }
          return n(a, [{ key: "observe", value: function () {} }]), a;
        })()),
      (l.notSupported = !0),
      m),
    q =
      window.getComputedStyle ||
      function (a) {
        var b = /(\-([a-z]){1})/g;
        return {
          getPropertyValue: function (c) {
            "float" === c && (c = "styleFloat"),
              b.test(c) &&
                c.replace(b, function (a, b) {
                  return b.toUpperCase();
                });
            var d = a.currentStyle;
            return (null != d ? d[c] : void 0) || null;
          },
        };
      },
    r = (function () {
      function a() {
        var b =
          arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
        c(this, a),
          (this.defaults = {
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: !0,
            live: !0,
            callback: null,
            scrollContainer: null,
            resetAnimation: !0,
          }),
          (this.animate = (function () {
            return "requestAnimationFrame" in window
              ? function (a) {
                  return window.requestAnimationFrame(a);
                }
              : function (a) {
                  return a();
                };
          })()),
          (this.vendors = ["moz", "webkit"]),
          (this.start = this.start.bind(this)),
          (this.resetAnimation = this.resetAnimation.bind(this)),
          (this.scrollHandler = this.scrollHandler.bind(this)),
          (this.scrollCallback = this.scrollCallback.bind(this)),
          (this.scrolled = !0),
          (this.config = e(b, this.defaults)),
          null != b.scrollContainer &&
            (this.config.scrollContainer = document.querySelector(
              b.scrollContainer
            )),
          (this.animationNameCache = new o()),
          (this.wowEvent = g(this.config.boxClass));
      }
      return (
        n(a, [
          {
            key: "init",
            value: function () {
              (this.element = window.document.documentElement),
                d(document.readyState, ["interactive", "complete"])
                  ? this.start()
                  : i(document, "DOMContentLoaded", this.start),
                (this.finished = []);
            },
          },
          {
            key: "start",
            value: function () {
              var a = this;
              if (
                ((this.stopped = !1),
                (this.boxes = [].slice.call(
                  this.element.querySelectorAll("." + this.config.boxClass)
                )),
                (this.all = this.boxes.slice(0)),
                this.boxes.length)
              )
                if (this.disabled()) this.resetStyle();
                else
                  for (var b = 0; b < this.boxes.length; b++) {
                    var c = this.boxes[b];
                    this.applyStyle(c, !0);
                  }
              if (
                (this.disabled() ||
                  (i(
                    this.config.scrollContainer || window,
                    "scroll",
                    this.scrollHandler
                  ),
                  i(window, "resize", this.scrollHandler),
                  (this.interval = setInterval(this.scrollCallback, 50))),
                this.config.live)
              ) {
                var d = new p(function (b) {
                  for (var c = 0; c < b.length; c++)
                    for (var d = b[c], e = 0; e < d.addedNodes.length; e++) {
                      var f = d.addedNodes[e];
                      a.doSync(f);
                    }
                });
                d.observe(document.body, { childList: !0, subtree: !0 });
              }
            },
          },
          {
            key: "stop",
            value: function () {
              (this.stopped = !0),
                j(
                  this.config.scrollContainer || window,
                  "scroll",
                  this.scrollHandler
                ),
                j(window, "resize", this.scrollHandler),
                null != this.interval && clearInterval(this.interval);
            },
          },
          {
            key: "sync",
            value: function () {
              p.notSupported && this.doSync(this.element);
            },
          },
          {
            key: "doSync",
            value: function (a) {
              if (
                (("undefined" != typeof a && null !== a) || (a = this.element),
                1 === a.nodeType)
              ) {
                a = a.parentNode || a;
                for (
                  var b = a.querySelectorAll("." + this.config.boxClass), c = 0;
                  c < b.length;
                  c++
                ) {
                  var e = b[c];
                  d(e, this.all) ||
                    (this.boxes.push(e),
                    this.all.push(e),
                    this.stopped || this.disabled()
                      ? this.resetStyle()
                      : this.applyStyle(e, !0),
                    (this.scrolled = !0));
                }
              }
            },
          },
          {
            key: "show",
            value: function (a) {
              return (
                this.applyStyle(a),
                (a.className = a.className + " " + this.config.animateClass),
                null != this.config.callback && this.config.callback(a),
                h(a, this.wowEvent),
                this.config.resetAnimation &&
                  (i(a, "animationend", this.resetAnimation),
                  i(a, "oanimationend", this.resetAnimation),
                  i(a, "webkitAnimationEnd", this.resetAnimation),
                  i(a, "MSAnimationEnd", this.resetAnimation)),
                a
              );
            },
          },
          {
            key: "applyStyle",
            value: function (a, b) {
              var c = this,
                d = a.getAttribute("data-wow-duration"),
                e = a.getAttribute("data-wow-delay"),
                f = a.getAttribute("data-wow-iteration");
              return this.animate(function () {
                return c.customStyle(a, b, d, e, f);
              });
            },
          },
          {
            key: "resetStyle",
            value: function () {
              for (var a = 0; a < this.boxes.length; a++) {
                var b = this.boxes[a];
                b.style.visibility = "visible";
              }
            },
          },
          {
            key: "resetAnimation",
            value: function (a) {
              if (a.type.toLowerCase().indexOf("animationend") >= 0) {
                var b = a.target || a.srcElement;
                b.className = b.className
                  .replace(this.config.animateClass, "")
                  .trim();
              }
            },
          },
          {
            key: "customStyle",
            value: function (a, b, c, d, e) {
              return (
                b && this.cacheAnimationName(a),
                (a.style.visibility = b ? "hidden" : "visible"),
                c && this.vendorSet(a.style, { animationDuration: c }),
                d && this.vendorSet(a.style, { animationDelay: d }),
                e && this.vendorSet(a.style, { animationIterationCount: e }),
                this.vendorSet(a.style, {
                  animationName: b ? "none" : this.cachedAnimationName(a),
                }),
                a
              );
            },
          },
          {
            key: "vendorSet",
            value: function (a, b) {
              for (var c in b)
                if (b.hasOwnProperty(c)) {
                  var d = b[c];
                  a["" + c] = d;
                  for (var e = 0; e < this.vendors.length; e++) {
                    var f = this.vendors[e];
                    a["" + f + c.charAt(0).toUpperCase() + c.substr(1)] = d;
                  }
                }
            },
          },
          {
            key: "vendorCSS",
            value: function (a, b) {
              for (
                var c = q(a), d = c.getPropertyCSSValue(b), e = 0;
                e < this.vendors.length;
                e++
              ) {
                var f = this.vendors[e];
                d = d || c.getPropertyCSSValue("-" + f + "-" + b);
              }
              return d;
            },
          },
          {
            key: "animationName",
            value: function (a) {
              var b = void 0;
              try {
                b = this.vendorCSS(a, "animation-name").cssText;
              } catch (c) {
                b = q(a).getPropertyValue("animation-name");
              }
              return "none" === b ? "" : b;
            },
          },
          {
            key: "cacheAnimationName",
            value: function (a) {
              return this.animationNameCache.set(a, this.animationName(a));
            },
          },
          {
            key: "cachedAnimationName",
            value: function (a) {
              return this.animationNameCache.get(a);
            },
          },
          {
            key: "scrollHandler",
            value: function () {
              this.scrolled = !0;
            },
          },
          {
            key: "scrollCallback",
            value: function () {
              if (this.scrolled) {
                this.scrolled = !1;
                for (var a = [], b = 0; b < this.boxes.length; b++) {
                  var c = this.boxes[b];
                  if (c) {
                    if (this.isVisible(c)) {
                      this.show(c);
                      continue;
                    }
                    a.push(c);
                  }
                }
                (this.boxes = a),
                  this.boxes.length || this.config.live || this.stop();
              }
            },
          },
          {
            key: "offsetTop",
            value: function (a) {
              for (; void 0 === a.offsetTop; ) a = a.parentNode;
              for (var b = a.offsetTop; a.offsetParent; )
                (a = a.offsetParent), (b += a.offsetTop);
              return b;
            },
          },
          {
            key: "isVisible",
            value: function (a) {
              var b = a.getAttribute("data-wow-offset") || this.config.offset,
                c =
                  (this.config.scrollContainer &&
                    this.config.scrollContainer.scrollTop) ||
                  window.pageYOffset,
                d = c + Math.min(this.element.clientHeight, k()) - b,
                e = this.offsetTop(a),
                f = e + a.clientHeight;
              return d >= e && f >= c;
            },
          },
          {
            key: "disabled",
            value: function () {
              return !this.config.mobile && f(navigator.userAgent);
            },
          },
        ]),
        a
      );
    })();
  (b["default"] = r), (a.exports = b["default"]);
});

new WOW().init();

/*!
 * fullPage 3.1.2
 */
!(function (e, t, n, o, r) {
  "function" == typeof define && define.amd
    ? define(function () {
        return (e.fullpage = o(t, n)), e.fullpage;
      })
    : "object" == typeof exports
    ? (module.exports = o(t, n))
    : (t.fullpage = o(t, n));
})(this, window, document, function (zt, jt) {
  "use strict";
  var Pt = "fullpage-wrapper",
    Dt = "." + Pt,
    Vt = "fp-responsive",
    Wt = "fp-notransition",
    Yt = "fp-destroyed",
    Ft = "fp-enabled",
    Ut = "fp-viewing",
    Xt = "active",
    Kt = "." + Xt,
    _t = "fp-completely",
    $t = "fp-section",
    qt = "." + $t,
    Qt = qt + Kt,
    Gt = "fp-tableCell",
    Jt = "." + Gt,
    Zt = "fp-auto-height",
    en = "fp-normal-scroll",
    tn = "fp-nav",
    nn = "#" + tn,
    on = "fp-tooltip",
    rn = "fp-slide",
    ln = "." + rn,
    an = ln + Kt,
    sn = "fp-slides",
    cn = "." + sn,
    un = "fp-slidesContainer",
    fn = "." + un,
    dn = "fp-table",
    vn = "fp-slidesNav",
    pn = "." + vn,
    hn = pn + " a",
    e = "fp-controlArrow",
    gn = "." + e,
    mn = "fp-prev",
    Sn = gn + ".fp-prev",
    wn = gn + ".fp-next";
  function bn(e, t) {
    zt.console && zt.console[e] && zt.console[e]("fullPage: " + t);
  }
  function yn(e, t) {
    return (t = 1 < arguments.length ? t : jt) ? t.querySelectorAll(e) : null;
  }
  function En(e) {
    e = e || {};
    for (var t = 1, n = arguments.length; t < n; ++t) {
      var o = arguments[t];
      if (o)
        for (var r in o)
          o.hasOwnProperty(r) &&
            ("[object Object]" !== Object.prototype.toString.call(o[r])
              ? (e[r] = o[r])
              : (e[r] = En(e[r], o[r])));
    }
    return e;
  }
  function Ln(e, t) {
    return (
      null != e &&
      (e.classList
        ? e.classList.contains(t)
        : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className))
    );
  }
  function xn() {
    return "innerHeight" in zt
      ? zt.innerHeight
      : jt.documentElement.offsetHeight;
  }
  function An() {
    return zt.innerWidth;
  }
  function Tn(e, t) {
    var n;
    for (n in ((e = l(e)), t))
      if (t.hasOwnProperty(n) && null !== n)
        for (var o = 0; o < e.length; o++) {
          e[o].style[n] = t[n];
        }
    return e;
  }
  function n(e, t, n) {
    for (var o = e[n]; o && !qn(o, t); ) o = o[n];
    return o;
  }
  function kn(e, t) {
    return n(e, t, "previousElementSibling");
  }
  function On(e, t) {
    return n(e, t, "nextElementSibling");
  }
  function Mn(e) {
    return e.previousElementSibling;
  }
  function Cn(e) {
    return e.nextElementSibling;
  }
  function Hn(e) {
    return e[e.length - 1];
  }
  function In(e, t) {
    e = i(e) ? e[0] : e;
    for (
      var n = null != t ? yn(t, e.parentNode) : e.parentNode.childNodes,
        o = 0,
        r = 0;
      r < n.length;
      r++
    ) {
      if (n[r] == e) return o;
      1 == n[r].nodeType && o++;
    }
    return -1;
  }
  function l(e) {
    return i(e) ? e : [e];
  }
  function Bn(e) {
    e = l(e);
    for (var t = 0; t < e.length; t++) e[t].style.display = "none";
    return e;
  }
  function Rn(e) {
    e = l(e);
    for (var t = 0; t < e.length; t++) e[t].style.display = "block";
    return e;
  }
  function i(e) {
    return (
      "[object Array]" === Object.prototype.toString.call(e) ||
      "[object NodeList]" === Object.prototype.toString.call(e)
    );
  }
  function Nn(e, t) {
    e = l(e);
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.classList ? o.classList.add(t) : (o.className += " " + t);
    }
    return e;
  }
  function zn(e, t) {
    e = l(e);
    for (var n = t.split(" "), o = 0; o < n.length; o++) {
      t = n[o];
      for (var r = 0; r < e.length; r++) {
        var i = e[r];
        i.classList
          ? i.classList.remove(t)
          : (i.className = i.className.replace(
              new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"),
              " "
            ));
      }
    }
    return e;
  }
  function jn(e, t) {
    t.appendChild(e);
  }
  function o(e, t, n) {
    var o;
    t = t || jt.createElement("div");
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      ((n && !r) || !n) &&
        ((o = t.cloneNode(!0)), i.parentNode.insertBefore(o, i)),
        o.appendChild(i);
    }
    return e;
  }
  function Pn(e, t) {
    o(e, t, !0);
  }
  function Dn(e, t) {
    for (
      "string" == typeof t && (t = Gn(t)), e.appendChild(t);
      e.firstChild !== t;

    )
      t.appendChild(e.firstChild);
  }
  function Vn(e) {
    for (var t = jt.createDocumentFragment(); e.firstChild; )
      t.appendChild(e.firstChild);
    e.parentNode.replaceChild(t, e);
  }
  function Wn(e, t) {
    return e && 1 === e.nodeType ? (qn(e, t) ? e : Wn(e.parentNode, t)) : null;
  }
  function Yn(e, t) {
    r(e, e.nextSibling, t);
  }
  function Fn(e, t) {
    r(e, e, t);
  }
  function r(e, t, n) {
    i(n) || ("string" == typeof n && (n = Gn(n)), (n = [n]));
    for (var o = 0; o < n.length; o++) e.parentNode.insertBefore(n[o], t);
  }
  function Un() {
    var e = jt.documentElement;
    return (zt.pageYOffset || e.scrollTop) - (e.clientTop || 0);
  }
  function Xn(t) {
    return Array.prototype.filter.call(t.parentNode.children, function (e) {
      return e !== t;
    });
  }
  function Kn(e) {
    e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
  }
  function _n(e) {
    if ("function" == typeof e) return !0;
    var t = Object.prototype.toString(e);
    return "[object Function]" === t || "[object GeneratorFunction]" === t;
  }
  function $n(e, t, n) {
    var o;
    (n = void 0 === n ? {} : n),
      "function" == typeof zt.CustomEvent
        ? (o = new CustomEvent(t, { detail: n }))
        : (o = jt.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, n),
      e.dispatchEvent(o);
  }
  function qn(e, t) {
    return (
      e.matches ||
      e.matchesSelector ||
      e.msMatchesSelector ||
      e.mozMatchesSelector ||
      e.webkitMatchesSelector ||
      e.oMatchesSelector
    ).call(e, t);
  }
  function Qn(e, t) {
    if ("boolean" == typeof t)
      for (var n = 0; n < e.length; n++)
        e[n].style.display = t ? "block" : "none";
    return e;
  }
  function Gn(e) {
    var t = jt.createElement("div");
    return (t.innerHTML = e.trim()), t.firstChild;
  }
  function Jn(e) {
    e = l(e);
    for (var t = 0; t < e.length; t++) {
      var n = e[t];
      n && n.parentElement && n.parentNode.removeChild(n);
    }
  }
  function a(e, t, n) {
    for (var o = e[n], r = []; o; )
      (qn(o, t) || null == t) && r.push(o), (o = o[n]);
    return r;
  }
  function Zn(e, t) {
    return a(e, t, "nextElementSibling");
  }
  function eo(e, t) {
    return a(e, t, "previousElementSibling");
  }
  return (
    zt.NodeList &&
      !NodeList.prototype.forEach &&
      (NodeList.prototype.forEach = function (e, t) {
        t = t || zt;
        for (var n = 0; n < this.length; n++) e.call(t, this[n], n, this);
      }),
    (zt.fp_utils = {
      $: yn,
      deepExtend: En,
      hasClass: Ln,
      getWindowHeight: xn,
      css: Tn,
      until: n,
      prevUntil: kn,
      nextUntil: On,
      prev: Mn,
      next: Cn,
      last: Hn,
      index: In,
      getList: l,
      hide: Bn,
      show: Rn,
      isArrayOrList: i,
      addClass: Nn,
      removeClass: zn,
      appendTo: jn,
      wrap: o,
      wrapAll: Pn,
      wrapInner: Dn,
      unwrap: Vn,
      closest: Wn,
      after: Yn,
      before: Fn,
      insertBefore: r,
      getScrollTop: Un,
      siblings: Xn,
      preventDefault: Kn,
      isFunction: _n,
      trigger: $n,
      matches: qn,
      toggle: Qn,
      createElementFromHTML: Gn,
      remove: Jn,
      filter: function (e, t) {
        Array.prototype.filter.call(e, t);
      },
      untilAll: a,
      nextAll: Zn,
      prevAll: eo,
      showError: bn,
    }),
    function (e, E) {
      var n =
          (E &&
            new RegExp(
              "([\\d\\w]{8}-){3}[\\d\\w]{8}|^(?=.*?[A-Y])(?=.*?[a-y])(?=.*?[0-8])(?=.*?[#?!@$%^&*-]).{8,}$"
            ).test(E.licenseKey)) ||
          -1 < jt.domain.indexOf("alvarotrigo.com"),
        h = yn("html, body"),
        u = yn("html")[0],
        L = yn("body")[0];
      if (!Ln(u, Ft)) {
        var g = {};
        E = En(
          {
            menu: !1,
            anchors: [],
            lockAnchors: !1,
            navigation: !1,
            navigationPosition: "right",
            navigationTooltips: [],
            showActiveTooltip: !1,
            slidesNavigation: !1,
            slidesNavPosition: "bottom",
            scrollBar: !1,
            hybrid: !1,
            css3: !0,
            scrollingSpeed: 700,
            autoScrolling: !0,
            fitToSection: !0,
            fitToSectionDelay: 1e3,
            easing: "easeInOutCubic",
            easingcss3: "ease",
            loopBottom: !1,
            loopTop: !1,
            loopHorizontal: !0,
            continuousVertical: !1,
            continuousHorizontal: !1,
            scrollHorizontally: !1,
            interlockedSlides: !1,
            dragAndMove: !1,
            offsetSections: !1,
            resetSliders: !1,
            fadingEffect: !1,
            normalScrollElements: null,
            scrollOverflow: !1,
            scrollOverflowReset: !1,
            scrollOverflowHandler: zt.fp_scrolloverflow
              ? zt.fp_scrolloverflow.iscrollHandler
              : null,
            scrollOverflowOptions: null,
            touchSensitivity: 5,
            touchWrapper: "string" == typeof e ? yn(e)[0] : e,
            bigSectionsDestination: null,
            keyboardScrolling: !0,
            animateAnchor: !0,
            recordHistory: !0,
            controlArrows: !0,
            controlArrowColor: "#fff",
            verticalCentered: !0,
            sectionsColor: [],
            paddingTop: 0,
            paddingBottom: 0,
            fixedElements: null,
            responsive: 0,
            responsiveWidth: 0,
            responsiveHeight: 0,
            responsiveSlides: !1,
            parallax: !1,
            parallaxOptions: {
              type: "reveal",
              percentage: 62,
              property: "translate",
            },
            cards: !1,
            cardsOptions: {
              perspective: 100,
              fadeContent: !0,
              fadeBackground: !0,
            },
            sectionSelector: ".section",
            slideSelector: ".slide",
            v2compatible: !1,
            afterLoad: null,
            onLeave: null,
            afterRender: null,
            afterResize: null,
            afterReBuild: null,
            afterSlideLoad: null,
            onSlideLeave: null,
            afterResponsive: null,
            lazyLoading: !0,
          },
          E
        );
        var x,
          i,
          c,
          f,
          a = !1,
          o = navigator.userAgent.match(
            /(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/
          ),
          r =
            "ontouchstart" in zt ||
            0 < navigator.msMaxTouchPoints ||
            navigator.maxTouchPoints,
          d = "string" == typeof e ? yn(e)[0] : e,
          A = xn(),
          s = An(),
          T = !1,
          t = !0,
          k = !0,
          v = [],
          p = { m: { up: !0, down: !0, left: !0, right: !0 } };
        p.k = En({}, p.m);
        var m,
          l,
          S,
          w,
          b,
          O,
          M,
          y,
          C,
          H = zt.PointerEvent
            ? { down: "pointerdown", move: "pointermove" }
            : { down: "MSPointerDown", move: "MSPointerMove" },
          I = {
            touchmove: "ontouchmove" in zt ? "touchmove" : H.move,
            touchstart: "ontouchstart" in zt ? "touchstart" : H.down,
          },
          B =
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]',
          R = !1;
        try {
          var N = Object.defineProperty({}, "passive", {
            get: function () {
              R = !0;
            },
          });
          zt.addEventListener("testPassive", null, N),
            zt.removeEventListener("testPassive", null, N);
        } catch (e) {}
        var z,
          j,
          P,
          D = En({}, E),
          V = !1,
          W = !0,
          Y = [
            "parallax",
            "scrollOverflowReset",
            "dragAndMove",
            "offsetSections",
            "fadingEffect",
            "responsiveSlides",
            "continuousHorizontal",
            "interlockedSlides",
            "scrollHorizontally",
            "resetSliders",
            "cards",
            "dropEffect",
            "waterEffect",
          ];
        Ct(),
          (zt.fp_easings = En(zt.fp_easings, {
            easeInOutCubic: function (e, t, n, o) {
              return (e /= o / 2) < 1
                ? (n / 2) * e * e * e + t
                : (n / 2) * ((e -= 2) * e * e + 2) + t;
            },
          })),
          d &&
            ((g.version = "3.1.1"),
            (g.setAutoScrolling = Z),
            (g.setRecordHistory = ee),
            (g.setScrollingSpeed = te),
            (g.setFitToSection = ne),
            (g.setLockAnchors = function (e) {
              E.lockAnchors = e;
            }),
            (g.setMouseWheelScrolling = oe),
            (g.setAllowScrolling = re),
            (g.setKeyboardScrolling = le),
            (g.moveSectionUp = ae),
            (g.moveSectionDown = se),
            (g.silentMoveTo = ce),
            (g.moveTo = ue),
            (g.moveSlideRight = fe),
            (g.moveSlideLeft = de),
            (g.fitToSection = xe),
            (g.reBuild = ve),
            (g.setResponsive = he),
            (g.getFullpageData = function () {
              return E;
            }),
            (g.destroy = function (e) {
              Z(!1, "internal"),
                re(!0),
                ie(!1),
                le(!1),
                Nn(d, Yt),
                [b, w, l, O, M, C, S, P].forEach(function (e) {
                  clearTimeout(e);
                }),
                zt.removeEventListener("scroll", Le),
                zt.removeEventListener("hashchange", qe),
                zt.removeEventListener("resize", at),
                jt.removeEventListener("keydown", Ge),
                jt.removeEventListener("keyup", Je),
                ["click", "touchstart"].forEach(function (e) {
                  jt.removeEventListener(e, ge);
                }),
                ["mouseenter", "touchstart", "mouseleave", "touchend"].forEach(
                  function (e) {
                    jt.removeEventListener(e, Se, !0);
                  }
                ),
                e &&
                  (Tt(0),
                  yn(
                    "img[data-src], source[data-src], audio[data-src], iframe[data-src]",
                    d
                  ).forEach(function (e) {
                    Ve(e, "src");
                  }),
                  yn("img[data-srcset]").forEach(function (e) {
                    Ve(e, "srcset");
                  }),
                  Jn(yn(nn + ", " + pn + ", " + gn)),
                  Tn(yn(qt), {
                    height: "",
                    "background-color": "",
                    padding: "",
                  }),
                  Tn(yn(ln), { width: "" }),
                  Tn(d, {
                    height: "",
                    position: "",
                    "-ms-touch-action": "",
                    "touch-action": "",
                  }),
                  Tn(h, { overflow: "", height: "" }),
                  zn(u, Ft),
                  zn(L, Vt),
                  L.className.split(/\s+/).forEach(function (e) {
                    0 === e.indexOf(Ut) && zn(L, e);
                  }),
                  yn(qt + ", " + ln).forEach(function (e) {
                    E.scrollOverflowHandler &&
                      E.scrollOverflow &&
                      E.scrollOverflowHandler.remove(e),
                      zn(e, dn + " " + Xt + " " + _t);
                    var t = e.getAttribute("data-fp-styles");
                    t &&
                      e.setAttribute("style", e.getAttribute("data-fp-styles")),
                      Ln(e, $t) && !V && e.removeAttribute("data-anchor");
                  }),
                  ft(d),
                  [Jt, fn, cn].forEach(function (e) {
                    yn(e, d).forEach(function (e) {
                      Vn(e);
                    });
                  }),
                  Tn(d, { "-webkit-transition": "none", transition: "none" }),
                  zt.scrollTo(0, 0),
                  [$t, rn, un].forEach(function (e) {
                    zn(yn("." + e), e);
                  }));
            }),
            (g.getActiveSection = function () {
              return new Rt(yn(Qt)[0]);
            }),
            (g.getActiveSlide = function () {
              return je(yn(an, yn(Qt)[0])[0]);
            }),
            (g.test = {
              top: "0px",
              translate3d: "translate3d(0px, 0px, 0px)",
              translate3dH: (function () {
                for (
                  var e = [], t = 0;
                  t < yn(E.sectionSelector, d).length;
                  t++
                )
                  e.push("translate3d(0px, 0px, 0px)");
                return e;
              })(),
              left: (function () {
                for (
                  var e = [], t = 0;
                  t < yn(E.sectionSelector, d).length;
                  t++
                )
                  e.push(0);
                return e;
              })(),
              options: E,
              setAutoScrolling: Z,
            }),
            (g.shared = { afterRenderActions: Ee, isNormalScrollElement: !1 }),
            (zt.fullpage_api = g),
            E.$ &&
              Object.keys(g).forEach(function (e) {
                E.$.fn.fullpage[e] = g[e];
              }),
            E.css3 &&
              (E.css3 = (function () {
                var e,
                  t = jt.createElement("p"),
                  n = {
                    webkitTransform: "-webkit-transform",
                    OTransform: "-o-transform",
                    msTransform: "-ms-transform",
                    MozTransform: "-moz-transform",
                    transform: "transform",
                  };
                for (var o in ((t.style.display = "block"),
                jt.body.insertBefore(t, null),
                n))
                  void 0 !== t.style[o] &&
                    ((t.style[o] = "translate3d(1px,1px,1px)"),
                    (e = zt.getComputedStyle(t).getPropertyValue(n[o])));
                return (
                  jt.body.removeChild(t),
                  void 0 !== e && 0 < e.length && "none" !== e
                );
              })()),
            (E.scrollBar = E.scrollBar || E.hybrid),
            (function () {
              if (!E.anchors.length) {
                var e = "[data-anchor]",
                  t = yn(E.sectionSelector.split(",").join(e + ",") + e, d);
                t.length &&
                  t.length === yn(E.sectionSelector, d).length &&
                  ((V = !0),
                  t.forEach(function (e) {
                    E.anchors.push(e.getAttribute("data-anchor").toString());
                  }));
              }
              if (!E.navigationTooltips.length) {
                var n = "[data-tooltip]",
                  o = yn(E.sectionSelector.split(",").join(n + ",") + n, d);
                o.length &&
                  o.forEach(function (e) {
                    E.navigationTooltips.push(
                      e.getAttribute("data-tooltip").toString()
                    );
                  });
              }
            })(),
            (function () {
              Tn(d, { height: "100%", position: "relative" }),
                Nn(d, Pt),
                Nn(u, Ft),
                (A = xn()),
                zn(d, Yt),
                Nn(yn(E.sectionSelector, d), $t),
                Nn(yn(E.slideSelector, d), rn);
              for (var e = yn(qt), t = 0; t < e.length; t++) {
                var n = t,
                  o = e[t],
                  r = yn(ln, o),
                  i = r.length;
                o.setAttribute("data-fp-styles", o.getAttribute("style")),
                  (s = o),
                  (c = n) || null != yn(Qt)[0] || Nn(s, Xt),
                  (f = yn(Qt)[0]),
                  Tn(s, { height: A + "px" }),
                  E.paddingTop && Tn(s, { "padding-top": E.paddingTop }),
                  E.paddingBottom &&
                    Tn(s, { "padding-bottom": E.paddingBottom }),
                  void 0 !== E.sectionsColor[c] &&
                    Tn(s, { "background-color": E.sectionsColor[c] }),
                  void 0 !== E.anchors[c] &&
                    s.setAttribute("data-anchor", E.anchors[c]),
                  (l = o),
                  (a = n),
                  void 0 !== E.anchors[a] && Ln(l, Xt) && dt(E.anchors[a], a),
                  E.menu &&
                    E.css3 &&
                    null != Wn(yn(E.menu)[0], Dt) &&
                    yn(E.menu).forEach(function (e) {
                      L.appendChild(e);
                    }),
                  0 < i ? be(o, r, i) : E.verticalCentered && pt(o);
              }
              var l, a, s, c;
              E.fixedElements &&
                E.css3 &&
                yn(E.fixedElements).forEach(function (e) {
                  L.appendChild(e);
                }),
                E.navigation &&
                  (function () {
                    var e = jt.createElement("div");
                    e.setAttribute("id", tn);
                    var t = jt.createElement("ul");
                    e.appendChild(t), jn(e, L);
                    var n = yn(nn)[0];
                    Nn(n, "fp-" + E.navigationPosition),
                      E.showActiveTooltip && Nn(n, "fp-show-active");
                    for (var o = "", r = 0; r < yn(qt).length; r++) {
                      var i = "";
                      E.anchors.length && (i = E.anchors[r]),
                        (o +=
                          '<li><a href="#' +
                          i +
                          '"><span class="fp-sr-only">' +
                          ye(r, "Section") +
                          "</span><span></span></a>");
                      var l = E.navigationTooltips[r];
                      void 0 !== l &&
                        "" !== l &&
                        (o +=
                          '<div class="' +
                          on +
                          " fp-" +
                          E.navigationPosition +
                          '">' +
                          l +
                          "</div>"),
                        (o += "</li>");
                    }
                    (yn("ul", n)[0].innerHTML = o),
                      Nn(yn("a", yn("li", yn(nn)[0])[In(yn(Qt)[0], qt)]), Xt);
                  })(),
                yn('iframe[src*="youtube.com/embed/"]', d).forEach(function (
                  e
                ) {
                  var t, n, o;
                  (n = "enablejsapi=1"),
                    (o = (t = e).getAttribute("src")),
                    t.setAttribute("src", o + (/\?/.test(o) ? "&" : "?") + n);
                }),
                E.scrollOverflow && (m = E.scrollOverflowHandler.init(E));
            })(),
            re(!0),
            ie(!0),
            Z(E.autoScrolling, "internal"),
            ct(),
            Lt(),
            "complete" === jt.readyState && $e(),
            zt.addEventListener("load", $e),
            E.scrollOverflow || Ee(),
            (function () {
              for (var e = 1; e < 4; e++) C = setTimeout(we, 350 * e);
            })(),
            zt.addEventListener("scroll", Le),
            zt.addEventListener("hashchange", qe),
            zt.addEventListener("focus", nt),
            zt.addEventListener("blur", ot),
            zt.addEventListener("resize", at),
            jt.addEventListener("keydown", Ge),
            jt.addEventListener("keyup", Je),
            ["click", "touchstart"].forEach(function (e) {
              jt.addEventListener(e, ge);
            }),
            E.normalScrollElements &&
              (["mouseenter", "touchstart"].forEach(function (e) {
                me(e, !1);
              }),
              ["mouseleave", "touchend"].forEach(function (e) {
                me(e, !0);
              })));
        var F = !1,
          U = 0,
          X = 0,
          K = 0,
          _ = 0,
          $ = 0,
          q = new Date().getTime(),
          Q = 0,
          G = 0,
          J = A;
        return g;
      }
      function Z(e, t) {
        e || Tt(0), Mt("autoScrolling", e, t);
        var n = yn(Qt)[0];
        if (E.autoScrolling && !E.scrollBar)
          Tn(h, { overflow: "hidden", height: "100%" }),
            ee(D.recordHistory, "internal"),
            Tn(d, { "-ms-touch-action": "none", "touch-action": "none" }),
            null != n && Tt(n.offsetTop);
        else if (
          (Tn(h, { overflow: "visible", height: "initial" }),
          ee(!!E.autoScrolling && D.recordHistory, "internal"),
          Tn(d, { "-ms-touch-action": "", "touch-action": "" }),
          null != n)
        ) {
          var o = Pe(n.offsetTop);
          o.element.scrollTo(0, o.options);
        }
      }
      function ee(e, t) {
        Mt("recordHistory", e, t);
      }
      function te(e, t) {
        Mt("scrollingSpeed", e, t);
      }
      function ne(e, t) {
        Mt("fitToSection", e, t);
      }
      function oe(e) {
        e
          ? ((function () {
              var e,
                t = "";
              zt.addEventListener
                ? (e = "addEventListener")
                : ((e = "attachEvent"), (t = "on"));
              var n =
                  "onwheel" in jt.createElement("div")
                    ? "wheel"
                    : void 0 !== jt.onmousewheel
                    ? "mousewheel"
                    : "DOMMouseScroll",
                o = !!R && { passive: !1 };
              "DOMMouseScroll" == n
                ? jt[e](t + "MozMousePixelScroll", He, o)
                : jt[e](t + n, He, o);
            })(),
            d.addEventListener("mousedown", Ze),
            d.addEventListener("mouseup", et))
          : (jt.addEventListener
              ? (jt.removeEventListener("mousewheel", He, !1),
                jt.removeEventListener("wheel", He, !1),
                jt.removeEventListener("MozMousePixelScroll", He, !1))
              : jt.detachEvent("onmousewheel", He),
            d.removeEventListener("mousedown", Ze),
            d.removeEventListener("mouseup", et));
      }
      function re(t, e) {
        void 0 !== e
          ? (e = e.replace(/ /g, "").split(",")).forEach(function (e) {
              Ot(t, e, "m");
            })
          : Ot(t, "all", "m");
      }
      function ie(e) {
        e
          ? (oe(!0),
            (function () {
              if (o || r) {
                E.autoScrolling &&
                  (L.removeEventListener(I.touchmove, Te, { passive: !1 }),
                  L.addEventListener(I.touchmove, Te, { passive: !1 }));
                var e = E.touchWrapper;
                e.removeEventListener(I.touchstart, Me),
                  e.removeEventListener(I.touchmove, ke, { passive: !1 }),
                  e.addEventListener(I.touchstart, Me),
                  e.addEventListener(I.touchmove, ke, { passive: !1 });
              }
            })())
          : (oe(!1),
            (function () {
              if (o || r) {
                E.autoScrolling &&
                  (L.removeEventListener(I.touchmove, ke, { passive: !1 }),
                  L.removeEventListener(I.touchmove, Te, { passive: !1 }));
                var e = E.touchWrapper;
                e.removeEventListener(I.touchstart, Me),
                  e.removeEventListener(I.touchmove, ke, { passive: !1 });
              }
            })());
      }
      function le(t, e) {
        void 0 !== e
          ? (e = e.replace(/ /g, "").split(",")).forEach(function (e) {
              Ot(t, e, "k");
            })
          : (Ot(t, "all", "k"), (E.keyboardScrolling = t));
      }
      function ae() {
        var e = kn(yn(Qt)[0], qt);
        e || (!E.loopTop && !E.continuousVertical) || (e = Hn(yn(qt))),
          null != e && Re(e, null, !0);
      }
      function se() {
        var e = On(yn(Qt)[0], qt);
        e || (!E.loopBottom && !E.continuousVertical) || (e = yn(qt)[0]),
          null != e && Re(e, null, !1);
      }
      function ce(e, t) {
        te(0, "internal"), ue(e, t), te(D.scrollingSpeed, "internal");
      }
      function ue(e, t) {
        var n = mt(e);
        void 0 !== t ? St(e, t) : null != n && Re(n);
      }
      function fe(e) {
        Ie("right", e);
      }
      function de(e) {
        Ie("left", e);
      }
      function ve(e) {
        if (!Ln(d, Yt)) {
          (T = !0), (A = xn()), (s = An());
          for (var t = yn(qt), n = 0; n < t.length; ++n) {
            var o = t[n],
              r = yn(cn, o)[0],
              i = yn(ln, o);
            E.verticalCentered && Tn(yn(Jt, o), { height: ht(o) + "px" }),
              Tn(o, { height: A + "px" }),
              1 < i.length && it(r, yn(an, r)[0]);
          }
          E.scrollOverflow && m.createScrollBarForAll();
          var l = In(yn(Qt)[0], qt);
          l && ce(l + 1),
            (T = !1),
            _n(E.afterResize) &&
              e &&
              E.afterResize.call(d, zt.innerWidth, zt.innerHeight),
            _n(E.afterReBuild) && !e && E.afterReBuild.call(d);
        }
      }
      function pe() {
        return Ln(L, Vt);
      }
      function he(e) {
        var t = pe();
        e
          ? t ||
            (Z(!1, "internal"),
            ne(!1, "internal"),
            Bn(yn(nn)),
            Nn(L, Vt),
            _n(E.afterResponsive) && E.afterResponsive.call(d, e),
            E.scrollOverflow && m.createScrollBarForAll())
          : t &&
            (Z(D.autoScrolling, "internal"),
            ne(D.autoScrolling, "internal"),
            Rn(yn(nn)),
            zn(L, Vt),
            _n(E.afterResponsive) && E.afterResponsive.call(d, e));
      }
      function ge(e) {
        var t = e.target;
        t && Wn(t, nn + " a")
          ? function (e) {
              Kn(e);
              var t = In(Wn(this, nn + " li"));
              Re(yn(qt)[t]);
            }.call(t, e)
          : qn(t, ".fp-tooltip")
          ? function () {
              $n(Mn(this), "click");
            }.call(t)
          : qn(t, gn)
          ? function () {
              var e = Wn(this, qt);
              Ln(this, mn) ? p.m.left && de(e) : p.m.right && fe(e);
            }.call(t, e)
          : qn(t, hn) || null != Wn(t, hn)
          ? function (e) {
              Kn(e);
              var t = yn(cn, Wn(this, qt))[0],
                n = yn(ln, t)[In(Wn(this, "li"))];
              it(t, n);
            }.call(t, e)
          : Wn(t, E.menu + " [data-menuanchor]") &&
            function (e) {
              !yn(E.menu)[0] ||
                (!E.lockAnchors && E.anchors.length) ||
                (Kn(e), ue(this.getAttribute("data-menuanchor")));
            }.call(t, e);
      }
      function me(e, t) {
        (jt["fp_" + e] = t), jt.addEventListener(e, Se, !0);
      }
      function Se(e) {
        var t = e.type,
          o = !1,
          r = E.scrollOverflow,
          i = "mouseleave" === t ? e.toElement || e.relatedTarget : e.target;
        if (i == jt || !i)
          return ie(!0), void (r && E.scrollOverflowHandler.setIscroll(i, !0));
        "touchend" === t &&
          ((W = !1),
          setTimeout(function () {
            W = !0;
          }, 800)),
          ("mouseenter" !== t || W) &&
            (E.normalScrollElements.split(",").forEach(function (e) {
              if (!o) {
                var t = qn(i, e),
                  n = Wn(i, e);
                (t || n) &&
                  (g.shared.isNormalScrollElement ||
                    (ie(!1), r && E.scrollOverflowHandler.setIscroll(i, !1)),
                  (g.shared.isNormalScrollElement = !0),
                  (o = !0));
              }
            }),
            !o &&
              g.shared.isNormalScrollElement &&
              (ie(!0),
              r && E.scrollOverflowHandler.setIscroll(i, !0),
              (g.shared.isNormalScrollElement = !1)));
      }
      function we() {
        var e = xn(),
          t = An();
        (A === e && s === t) || ((A = e), (s = t), ve(!0));
      }
      function be(e, t, n) {
        var o = 100 * n,
          r = 100 / n,
          i = jt.createElement("div");
        (i.className = sn), Pn(t, i);
        var l,
          a,
          s = jt.createElement("div");
        (s.className = un),
          Pn(t, s),
          Tn(yn(fn, e), { width: o + "%" }),
          1 < n &&
            (E.controlArrows &&
              ((l = e),
              (a = [
                Gn('<div class="fp-controlArrow fp-prev"></div>'),
                Gn('<div class="fp-controlArrow fp-next"></div>'),
              ]),
              Yn(yn(cn, l)[0], a),
              "#fff" !== E.controlArrowColor &&
                (Tn(yn(wn, l), {
                  "border-color":
                    "transparent transparent transparent " +
                    E.controlArrowColor,
                }),
                Tn(yn(Sn, l), {
                  "border-color":
                    "transparent " +
                    E.controlArrowColor +
                    " transparent transparent",
                })),
              E.loopHorizontal || Bn(yn(Sn, l))),
            E.slidesNavigation &&
              (function (e, t) {
                jn(Gn('<div class="' + vn + '"><ul></ul></div>'), e);
                var n = yn(pn, e)[0];
                Nn(n, "fp-" + E.slidesNavPosition);
                for (var o = 0; o < t; o++) {
                  var r = yn(ln, e)[o];
                  jn(
                    Gn(
                      '<li><a href="#"><span class="fp-sr-only">' +
                        ye(o, "Slide", r) +
                        "</span><span></span></a></li>"
                    ),
                    yn("ul", n)[0]
                  );
                }
                Tn(n, { "margin-left": "-" + n.innerWidth / 2 + "px" }),
                  Nn(yn("a", yn("li", n)[0]), Xt);
              })(e, n)),
          t.forEach(function (e) {
            Tn(e, { width: r + "%" }), E.verticalCentered && pt(e);
          });
        var c = yn(an, e)[0];
        null != c &&
        (0 !== In(yn(Qt), qt) || (0 === In(yn(Qt), qt) && 0 !== In(c)))
          ? At(c, "internal")
          : Nn(t[0], Xt);
      }
      function ye(e, t, n) {
        var o = "Section" === t ? E.anchors[e] : n.getAttribute("data-anchor");
        return E.navigationTooltips[e] || o || t + " " + (e + 1);
      }
      function Ee() {
        var e,
          t,
          n = yn(Qt)[0];
        Nn(n, _t),
          Ye(n),
          We(),
          Ue(n),
          E.scrollOverflow && E.scrollOverflowHandler.afterLoad(),
          (e = Qe()),
          (t = mt(e.section)),
          (e.section && t && (void 0 === t || In(t) !== In(f))) ||
            !_n(E.afterLoad) ||
            Ne("afterLoad", {
              activeSection: n,
              element: n,
              direction: null,
              anchorLink: n.getAttribute("data-anchor"),
              sectionIndex: In(n, qt),
            }),
          _n(E.afterRender) && Ne("afterRender");
      }
      function Le() {
        var e, t, n, o, r, i;
        if (!T && (!E.autoScrolling || E.scrollBar)) {
          var l = Un(),
            a = ((i = U < (r = l) ? "down" : "up"), (Q = U = r), i),
            s = 0,
            c = l + xn() / 2,
            u = L.offsetHeight - xn() === l,
            f = yn(qt);
          if (u) s = f.length - 1;
          else if (l)
            for (var d = 0; d < f.length; ++d) f[d].offsetTop <= c && (s = d);
          else s = 0;
          if (
            ((t = a),
            (n = yn(Qt)[0].offsetTop),
            (o = n + xn()),
            ("up" != t ? n <= Un() : o >= Un() + xn()) &&
              (Ln(yn(Qt)[0], _t) || (Nn(yn(Qt)[0], _t), zn(Xn(yn(Qt)[0]), _t))),
            !Ln((e = f[s]), Xt))
          ) {
            F = !0;
            var v,
              p,
              h = yn(Qt)[0],
              g = In(h, qt) + 1,
              m = vt(e),
              S = e.getAttribute("data-anchor"),
              w = In(e, qt) + 1,
              b = yn(an, e)[0],
              y = {
                activeSection: h,
                sectionIndex: w - 1,
                anchorLink: S,
                element: e,
                leavingSection: g,
                direction: m,
              };
            b && ((p = b.getAttribute("data-anchor")), (v = In(b))),
              k &&
                (Nn(e, Xt),
                zn(Xn(e), Xt),
                _n(E.onLeave) && Ne("onLeave", y),
                _n(E.afterLoad) && Ne("afterLoad", y),
                Ke(h),
                Ye(e),
                Ue(e),
                dt(S, w - 1),
                E.anchors.length && (x = S),
                bt(v, p, S)),
              clearTimeout(O),
              (O = setTimeout(function () {
                F = !1;
              }, 100));
          }
          E.fitToSection &&
            (clearTimeout(M),
            (M = setTimeout(function () {
              E.fitToSection && yn(Qt)[0].offsetHeight <= A && xe();
            }, E.fitToSectionDelay)));
        }
      }
      function xe() {
        k && ((T = !0), Re(yn(Qt)[0]), (T = !1));
      }
      function Ae(e) {
        if (p.m[e]) {
          var t = "down" === e ? se : ae;
          if (E.scrollOverflow) {
            var n = E.scrollOverflowHandler.scrollable(yn(Qt)[0]),
              o = "down" === e ? "bottom" : "top";
            if (null != n) {
              if (!E.scrollOverflowHandler.isScrolled(o, n)) return !0;
              t();
            } else t();
          } else t();
        }
      }
      function Te(e) {
        E.autoScrolling && Oe(e) && p.m.up && Kn(e);
      }
      function ke(e) {
        var t = Wn(e.target, qt) || yn(Qt)[0];
        if (Oe(e)) {
          E.autoScrolling && Kn(e);
          var n = xt(e);
          (_ = n.y),
            ($ = n.x),
            yn(cn, t).length && Math.abs(K - $) > Math.abs(X - _)
              ? !a &&
                Math.abs(K - $) > (An() / 100) * E.touchSensitivity &&
                ($ < K ? p.m.right && fe(t) : p.m.left && de(t))
              : E.autoScrolling &&
                k &&
                Math.abs(X - _) > (zt.innerHeight / 100) * E.touchSensitivity &&
                (_ < X ? Ae("down") : X < _ && Ae("up"));
        }
      }
      function Oe(e) {
        return void 0 === e.pointerType || "mouse" != e.pointerType;
      }
      function Me(e) {
        if ((E.fitToSection && (z = !1), Oe(e))) {
          var t = xt(e);
          (X = t.y), (K = t.x);
        }
      }
      function Ce(e, t) {
        for (
          var n = 0, o = e.slice(Math.max(e.length - t, 1)), r = 0;
          r < o.length;
          r++
        )
          n += o[r];
        return Math.ceil(n / t);
      }
      function He(e) {
        var t = new Date().getTime(),
          n = Ln(yn(".fp-completely")[0], en);
        if (!p.m.down && !p.m.up) return Kn(e), !1;
        if (E.autoScrolling && !c && !n) {
          var o = (e = e || zt.event).wheelDelta || -e.deltaY || -e.detail,
            r = Math.max(-1, Math.min(1, o)),
            i = void 0 !== e.wheelDeltaX || void 0 !== e.deltaX,
            l =
              Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta) ||
              Math.abs(e.deltaX) < Math.abs(e.deltaY) ||
              !i;
          149 < v.length && v.shift(),
            v.push(Math.abs(o)),
            E.scrollBar && Kn(e);
          var a = t - q;
          if (((q = t), 200 < a && (v = []), k)) {
            var s = Ce(v, 10);
            Ce(v, 70) <= s && l && Ae(r < 0 ? "down" : "up");
          }
          return !1;
        }
        E.fitToSection && (z = !1);
      }
      function Ie(e, t) {
        var n = null == t ? yn(Qt)[0] : t,
          o = yn(cn, n)[0];
        if (!(null == o || a || yn(ln, o).length < 2)) {
          var r = yn(an, o)[0],
            i = null;
          if (null == (i = "left" === e ? kn(r, ln) : On(r, ln))) {
            if (!E.loopHorizontal) return;
            var l = Xn(r);
            i = "left" === e ? l[l.length - 1] : l[0];
          }
          (a = !g.test.isTesting), it(o, i, e);
        }
      }
      function Be() {
        for (var e = yn(an), t = 0; t < e.length; t++) At(e[t], "internal");
      }
      function Re(e, t, n) {
        if (null != e) {
          var o,
            r,
            i,
            l,
            a,
            s,
            c,
            u,
            f,
            d = {
              element: e,
              callback: t,
              isMovementUp: n,
              dtop:
                ((r = (o = e).offsetHeight),
                (i = o.offsetTop),
                (a = Q < (l = i)),
                (s = l - A + r),
                (c = E.bigSectionsDestination),
                A < r
                  ? ((a || c) && "bottom" !== c) || (l = s)
                  : (a || (T && null == Cn(o))) && (l = s),
                (Q = l)),
              yMovement: vt(e),
              anchorLink: e.getAttribute("data-anchor"),
              sectionIndex: In(e, qt),
              activeSlide: yn(an, e)[0],
              activeSection: yn(Qt)[0],
              leavingSection: In(yn(Qt), qt) + 1,
              localIsResizing: T,
            };
          if (
            !(
              (d.activeSection == e && !T) ||
              (E.scrollBar && Un() === d.dtop && !Ln(e, Zt))
            )
          ) {
            if (
              (null != d.activeSlide &&
                ((u = d.activeSlide.getAttribute("data-anchor")),
                (f = In(d.activeSlide))),
              !d.localIsResizing)
            ) {
              var v = d.yMovement;
              if (
                (void 0 !== n && (v = n ? "up" : "down"),
                (d.direction = v),
                _n(E.onLeave) && !1 === Ne("onLeave", d))
              )
                return;
            }
            E.autoScrolling &&
              E.continuousVertical &&
              void 0 !== d.isMovementUp &&
              ((!d.isMovementUp && "up" == d.yMovement) ||
                (d.isMovementUp && "down" == d.yMovement)) &&
              ((p = d).isMovementUp
                ? Fn(yn(Qt)[0], Zn(p.activeSection, qt))
                : Yn(yn(Qt)[0], eo(p.activeSection, qt).reverse()),
              Tt(yn(Qt)[0].offsetTop),
              Be(),
              (p.wrapAroundElements = p.activeSection),
              (p.dtop = p.element.offsetTop),
              (p.yMovement = vt(p.element)),
              (d = p)),
              d.localIsResizing || Ke(d.activeSection),
              E.scrollOverflow && E.scrollOverflowHandler.beforeLeave(),
              Nn(e, Xt),
              zn(Xn(e), Xt),
              Ye(e),
              E.scrollOverflow && E.scrollOverflowHandler.onLeave(),
              (k = g.test.isTesting),
              bt(f, u, d.anchorLink, d.sectionIndex),
              (function (e) {
                var t = E.scrollingSpeed < 700,
                  n = t ? 700 : E.scrollingSpeed;
                if (E.css3 && E.autoScrolling && !E.scrollBar) {
                  var o =
                    "translate3d(0px, -" + Math.round(e.dtop) + "px, 0px)";
                  gt(o, !0),
                    E.scrollingSpeed
                      ? (clearTimeout(w),
                        (w = setTimeout(function () {
                          De(e), (k = !t);
                        }, E.scrollingSpeed)))
                      : De(e);
                } else {
                  var r = Pe(e.dtop);
                  (g.test.top = -e.dtop + "px"),
                    Tn(h, { "scroll-behavior": "unset" }),
                    Ht(r.element, r.options, E.scrollingSpeed, function () {
                      E.scrollBar
                        ? setTimeout(function () {
                            De(e);
                          }, 30)
                        : (De(e), (k = !t));
                    });
                }
                t &&
                  (clearTimeout(P),
                  (P = setTimeout(function () {
                    k = !0;
                  }, n)));
              })(d),
              (x = d.anchorLink),
              dt(d.anchorLink, d.sectionIndex);
          }
        }
        var p;
      }
      function Ne(e, t) {
        var n,
          o,
          r,
          i,
          l =
            ((o = e),
            (r = t),
            (i = E.v2compatible
              ? {
                  afterRender: function () {
                    return [d];
                  },
                  onLeave: function () {
                    return [
                      r.activeSection,
                      r.leavingSection,
                      r.sectionIndex + 1,
                      r.direction,
                    ];
                  },
                  afterLoad: function () {
                    return [r.element, r.anchorLink, r.sectionIndex + 1];
                  },
                  afterSlideLoad: function () {
                    return [
                      r.destiny,
                      r.anchorLink,
                      r.sectionIndex + 1,
                      r.slideAnchor,
                      r.slideIndex,
                    ];
                  },
                  onSlideLeave: function () {
                    return [
                      r.prevSlide,
                      r.anchorLink,
                      r.sectionIndex + 1,
                      r.prevSlideIndex,
                      r.direction,
                      r.slideIndex,
                    ];
                  },
                }
              : {
                  afterRender: function () {
                    return {
                      section: ze(yn(Qt)[0]),
                      slide: je(yn(an, yn(Qt)[0])[0]),
                    };
                  },
                  onLeave: function () {
                    return {
                      origin: ze(r.activeSection),
                      destination: ze(r.element),
                      direction: r.direction,
                    };
                  },
                  afterLoad: function () {
                    return i.onLeave();
                  },
                  afterSlideLoad: function () {
                    return {
                      section: ze(r.section),
                      origin: je(r.prevSlide),
                      destination: je(r.destiny),
                      direction: r.direction,
                    };
                  },
                  onSlideLeave: function () {
                    return i.afterSlideLoad();
                  },
                })[o]());
        if (E.v2compatible) {
          if (!1 === E[e].apply(l[0], l.slice(1))) return !1;
        } else if (
          ($n(d, e, l),
          !1 ===
            E[e].apply(
              l[Object.keys(l)[0]],
              ((n = l),
              Object.keys(n).map(function (e) {
                return n[e];
              }))
            ))
        )
          return !1;
        return !0;
      }
      function ze(e) {
        return e ? new Rt(e) : null;
      }
      function je(e) {
        return e ? new Nt(e) : null;
      }
      function Pe(e) {
        var t = {};
        return (
          E.autoScrolling && !E.scrollBar
            ? ((t.options = -e), (t.element = yn(Dt)[0]))
            : ((t.options = e), (t.element = zt)),
          t
        );
      }
      function De(e) {
        var t;
        null != (t = e).wrapAroundElements &&
          (t.isMovementUp
            ? Fn(yn(qt)[0], t.wrapAroundElements)
            : Yn(yn(qt)[yn(qt).length - 1], t.wrapAroundElements),
          Tt(yn(Qt)[0].offsetTop),
          Be()),
          _n(E.afterLoad) && !e.localIsResizing && Ne("afterLoad", e),
          E.scrollOverflow && E.scrollOverflowHandler.afterLoad(),
          e.localIsResizing || Ue(e.element),
          Nn(e.element, _t),
          zn(Xn(e.element), _t),
          We(),
          (k = !0),
          _n(e.callback) && e.callback();
      }
      function Ve(e, t) {
        e.setAttribute(t, e.getAttribute("data-" + t)),
          e.removeAttribute("data-" + t);
      }
      function We() {
        var e =
          yn(".fp-auto-height")[0] ||
          (pe() && yn(".fp-auto-height-responsive")[0]);
        E.lazyLoading &&
          e &&
          yn(qt + ":not(" + Kt + ")").forEach(function (e) {
            var t, n, o;
            (t = e.getBoundingClientRect()),
              (n = t.top),
              (o = t.bottom),
              ((n + 2 < A && 0 < n) || (2 < o && o < A)) && Ye(e);
          });
      }
      function Ye(o) {
        E.lazyLoading &&
          yn(
            "img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]",
            _e(o)
          ).forEach(function (n) {
            if (
              (["src", "srcset"].forEach(function (e) {
                var t = n.getAttribute("data-" + e);
                null != t &&
                  t &&
                  (Ve(n, e),
                  n.addEventListener("load", function () {
                    Fe(o);
                  }));
              }),
              qn(n, "source"))
            ) {
              var e = Wn(n, "video, audio");
              e &&
                (e.load(),
                (e.onloadeddata = function () {
                  Fe(o);
                }));
            }
          });
      }
      function Fe(e) {
        E.scrollOverflow &&
          (clearTimeout(j),
          (j = setTimeout(function () {
            Ln(L, Vt) || m.createScrollBar(e);
          }, 200)));
      }
      function Ue(e) {
        var t = _e(e);
        yn("video, audio", t).forEach(function (e) {
          e.hasAttribute("data-autoplay") &&
            "function" == typeof e.play &&
            e.play();
        }),
          yn('iframe[src*="youtube.com/embed/"]', t).forEach(function (e) {
            e.hasAttribute("data-autoplay") && Xe(e),
              (e.onload = function () {
                e.hasAttribute("data-autoplay") && Xe(e);
              });
          });
      }
      function Xe(e) {
        e.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      }
      function Ke(e) {
        var t = _e(e);
        yn("video, audio", t).forEach(function (e) {
          e.hasAttribute("data-keepplaying") ||
            "function" != typeof e.pause ||
            e.pause();
        }),
          yn('iframe[src*="youtube.com/embed/"]', t).forEach(function (e) {
            /youtube\.com\/embed\//.test(e.getAttribute("src")) &&
              !e.hasAttribute("data-keepplaying") &&
              e.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
              );
          });
      }
      function _e(e) {
        var t = yn(an, e);
        return t.length && (e = t[0]), e;
      }
      function $e() {
        var e = Qe(),
          t = e.section,
          n = e.slide;
        t && (E.animateAnchor ? St(t, n) : ce(t, n));
      }
      function qe() {
        if (!F && !E.lockAnchors) {
          var e = Qe(),
            t = e.section,
            n = e.slide,
            o = void 0 === x,
            r = void 0 === x && void 0 === n && !a;
          t &&
            t.length &&
            ((t && t !== x && !o) || r || (!a && i != n)) &&
            St(t, n);
        }
      }
      function Qe() {
        var e,
          t,
          n = zt.location.hash;
        if (n.length) {
          var o = n.replace("#", "").split("/"),
            r = -1 < n.indexOf("#/");
          e = r ? "/" + o[1] : decodeURIComponent(o[0]);
          var i = r ? o[2] : o[1];
          i && i.length && (t = decodeURIComponent(i));
        }
        return { section: e, slide: t };
      }
      function Ge(e) {
        clearTimeout(y);
        var t = jt.activeElement,
          n = e.keyCode;
        9 === n
          ? (function (e) {
              var t,
                n,
                o,
                r,
                i,
                l,
                a,
                s = e.shiftKey,
                c = jt.activeElement,
                u = tt(_e(yn(Qt)[0]));
              function f(e) {
                return Kn(e), u[0] ? u[0].focus() : null;
              }
              ((t = e),
              (n = tt(jt)),
              (o = n.indexOf(jt.activeElement)),
              (r = t.shiftKey ? o - 1 : o + 1),
              (i = n[r]),
              (l = je(Wn(i, ln))),
              (a = ze(Wn(i, qt))),
              l || a) &&
                (c
                  ? null == Wn(c, Qt + "," + Qt + " " + an) && (c = f(e))
                  : f(e),
                ((!s && c == u[u.length - 1]) || (s && c == u[0])) && Kn(e));
            })(e)
          : qn(t, "textarea") ||
            qn(t, "input") ||
            qn(t, "select") ||
            "true" === t.getAttribute("contentEditable") ||
            "" === t.getAttribute("contentEditable") ||
            !E.keyboardScrolling ||
            !E.autoScrolling ||
            (-1 < [40, 38, 32, 33, 34].indexOf(n) && Kn(e),
            (c = e.ctrlKey),
            (y = setTimeout(function () {
              !(function (e) {
                var t = e.shiftKey,
                  n = jt.activeElement,
                  o = qn(n, "video") || qn(n, "audio");
                if (k || !([37, 39].indexOf(e.keyCode) < 0))
                  switch (e.keyCode) {
                    case 38:
                    case 33:
                      p.k.up && ae();
                      break;
                    case 32:
                      if (t && p.k.up && !o) {
                        ae();
                        break;
                      }
                    case 40:
                    case 34:
                      p.k.down && ((32 === e.keyCode && o) || se());
                      break;
                    case 36:
                      p.k.up && ue(1);
                      break;
                    case 35:
                      p.k.down && ue(yn(qt).length);
                      break;
                    case 37:
                      p.k.left && de();
                      break;
                    case 39:
                      p.k.right && fe();
                  }
              })(e);
            }, 150)));
      }
      function Je(e) {
        t && (c = e.ctrlKey);
      }
      function Ze(e) {
        2 == e.which && ((G = e.pageY), d.addEventListener("mousemove", rt));
      }
      function et(e) {
        2 == e.which && d.removeEventListener("mousemove", rt);
      }
      function tt(e) {
        return [].slice.call(yn(B, e)).filter(function (e) {
          return "-1" !== e.getAttribute("tabindex") && null !== e.offsetParent;
        });
      }
      function nt() {
        t = !0;
      }
      function ot() {
        c = t = !1;
      }
      function rt(e) {
        E.autoScrolling &&
          (k &&
            (e.pageY < G && p.m.up ? ae() : e.pageY > G && p.m.down && se()),
          (G = e.pageY));
      }
      function it(e, t, n) {
        var o,
          r,
          i = Wn(e, qt),
          l = {
            slides: e,
            destiny: t,
            direction: n,
            destinyPos: { left: t.offsetLeft },
            slideIndex: In(t),
            section: i,
            sectionIndex: In(i, qt),
            anchorLink: i.getAttribute("data-anchor"),
            slidesNav: yn(pn, i)[0],
            slideAnchor: Et(t),
            prevSlide: yn(an, i)[0],
            prevSlideIndex: In(yn(an, i)[0]),
            localIsResizing: T,
          };
        (l.xMovement =
          ((o = l.prevSlideIndex),
          (r = l.slideIndex),
          o == r ? "none" : r < o ? "left" : "right")),
          (l.direction = l.direction ? l.direction : l.xMovement),
          l.localIsResizing || (k = !1),
          E.onSlideLeave &&
          !l.localIsResizing &&
          "none" !== l.xMovement &&
          _n(E.onSlideLeave) &&
          !1 === Ne("onSlideLeave", l)
            ? (a = !1)
            : (Nn(t, Xt),
              zn(Xn(t), Xt),
              l.localIsResizing || (Ke(l.prevSlide), Ye(t)),
              !E.loopHorizontal &&
                E.controlArrows &&
                (Qn(yn(Sn, i), 0 !== l.slideIndex),
                Qn(yn(wn, i), null != Cn(t))),
              Ln(i, Xt) &&
                !l.localIsResizing &&
                bt(l.slideIndex, l.slideAnchor, l.anchorLink, l.sectionIndex),
              (function (e, t, n) {
                var o = t.destinyPos;
                if (E.css3) {
                  var r =
                    "translate3d(-" + Math.round(o.left) + "px, 0px, 0px)";
                  (g.test.translate3dH[t.sectionIndex] = r),
                    Tn(ut(yn(fn, e)), kt(r)),
                    (b = setTimeout(function () {
                      n && lt(t);
                    }, E.scrollingSpeed));
                } else
                  (g.test.left[t.sectionIndex] = Math.round(o.left)),
                    Ht(e, Math.round(o.left), E.scrollingSpeed, function () {
                      n && lt(t);
                    });
              })(e, l, !0));
      }
      function lt(e) {
        var t, n;
        (t = e.slidesNav),
          (n = e.slideIndex),
          E.slidesNavigation &&
            null != t &&
            (zn(yn(Kt, t), Xt), Nn(yn("a", yn("li", t)[n]), Xt)),
          e.localIsResizing ||
            (_n(E.afterSlideLoad) && Ne("afterSlideLoad", e),
            (k = !0),
            Ue(e.destiny)),
          (a = !1);
      }
      function at() {
        clearTimeout(l),
          (l = setTimeout(function () {
            for (var e = 0; e < 4; e++) S = setTimeout(st, 200 * e);
          }, 200));
      }
      function st() {
        if (((T = !0), ct(), o)) {
          var e = jt.activeElement;
          if (!qn(e, "textarea") && !qn(e, "input") && !qn(e, "select")) {
            var t = xn();
            Math.abs(t - J) > (20 * Math.max(J, t)) / 100 && (ve(!0), (J = t));
          }
        } else we();
        T = !1;
      }
      function ct() {
        var e = E.responsive || E.responsiveWidth,
          t = E.responsiveHeight,
          n = e && zt.innerWidth < e,
          o = t && zt.innerHeight < t;
        e && t ? he(n || o) : e ? he(n) : t && he(o);
      }
      function ut(e) {
        var t = "all " + E.scrollingSpeed + "ms " + E.easingcss3;
        return zn(e, Wt), Tn(e, { "-webkit-transition": t, transition: t });
      }
      function ft(e) {
        return Nn(e, Wt);
      }
      function dt(e, t) {
        var n, o, r;
        (n = e),
          yn(E.menu).forEach(function (e) {
            E.menu &&
              null != e &&
              (zn(yn(Kt, e), Xt),
              Nn(yn('[data-menuanchor="' + n + '"]', e), Xt));
          }),
          (o = e),
          (r = t),
          E.navigation &&
            null != yn(nn)[0] &&
            (zn(yn(Kt, yn(nn)[0]), Xt),
            Nn(
              o
                ? yn('a[href="#' + o + '"]', yn(nn)[0])
                : yn("a", yn("li", yn(nn)[0])[r]),
              Xt
            ));
      }
      function vt(e) {
        var t = In(yn(Qt)[0], qt),
          n = In(e, qt);
        return t == n ? "none" : n < t ? "up" : "down";
      }
      function pt(e) {
        if (!Ln(e, dn)) {
          var t = jt.createElement("div");
          (t.className = Gt),
            (t.style.height = ht(e) + "px"),
            Nn(e, dn),
            Dn(e, t);
        }
      }
      function ht(e) {
        var t = A;
        if (E.paddingTop || E.paddingBottom) {
          var n = e;
          Ln(n, $t) || (n = Wn(e, qt));
          var o =
            parseInt(getComputedStyle(n)["padding-top"]) +
            parseInt(getComputedStyle(n)["padding-bottom"]);
          t = A - o;
        }
        return t;
      }
      function gt(e, t) {
        t ? ut(d) : ft(d),
          Tn(d, kt(e)),
          (g.test.translate3d = e),
          setTimeout(function () {
            zn(d, Wt);
          }, 10);
      }
      function mt(e) {
        var t = yn(qt + '[data-anchor="' + e + '"]', d)[0];
        if (!t) {
          var n = void 0 !== e ? e - 1 : 0;
          t = yn(qt)[n];
        }
        return t;
      }
      function St(e, t) {
        var n = mt(e);
        if (null != n) {
          var o,
            r,
            i,
            l =
              (null ==
                (i = yn(ln + '[data-anchor="' + (o = t) + '"]', (r = n))[0]) &&
                ((o = void 0 !== o ? o : 0), (i = yn(ln, r)[o])),
              i);
          Et(n) === x || Ln(n, Xt)
            ? wt(l)
            : Re(n, function () {
                wt(l);
              });
        }
      }
      function wt(e) {
        null != e && it(Wn(e, cn), e);
      }
      function bt(e, t, n, o) {
        var r = "";
        E.anchors.length &&
          !E.lockAnchors &&
          (e
            ? (null != n && (r = n),
              null == t && (t = e),
              yt(r + "/" + (i = t)))
            : (null != e && (i = t), yt(n))),
          Lt();
      }
      function yt(e) {
        if (E.recordHistory) location.hash = e;
        else if (o || r) zt.history.replaceState(void 0, void 0, "#" + e);
        else {
          var t = zt.location.href.split("#")[0];
          zt.location.replace(t + "#" + e);
        }
      }
      function Et(e) {
        if (!e) return null;
        var t = e.getAttribute("data-anchor"),
          n = In(e);
        return null == t && (t = n), t;
      }
      function Lt() {
        var e = yn(Qt)[0],
          t = yn(an, e)[0],
          n = Et(e),
          o = Et(t),
          r = String(n);
        t && (r = r + "-" + o), (r = r.replace("/", "-").replace("#", ""));
        var i = new RegExp("\\b\\s?" + Ut + "-[^\\s]+\\b", "g");
        (L.className = L.className.replace(i, "")), Nn(L, Ut + "-" + r);
      }
      function xt(e) {
        var t = [];
        return (
          (t.y =
            void 0 !== e.pageY && (e.pageY || e.pageX)
              ? e.pageY
              : e.touches[0].pageY),
          (t.x =
            void 0 !== e.pageX && (e.pageY || e.pageX)
              ? e.pageX
              : e.touches[0].pageX),
          r &&
            Oe(e) &&
            E.scrollBar &&
            void 0 !== e.touches &&
            ((t.y = e.touches[0].pageY), (t.x = e.touches[0].pageX)),
          t
        );
      }
      function At(e, t) {
        te(0, "internal"),
          void 0 !== t && (T = !0),
          it(Wn(e, cn), e),
          void 0 !== t && (T = !1),
          te(D.scrollingSpeed, "internal");
      }
      function Tt(e) {
        var t = Math.round(e);
        if (E.css3 && E.autoScrolling && !E.scrollBar)
          gt("translate3d(0px, -" + t + "px, 0px)", !1);
        else if (E.autoScrolling && !E.scrollBar)
          Tn(d, { top: -t + "px" }), (g.test.top = -t + "px");
        else {
          var n = Pe(t);
          It(n.element, n.options);
        }
      }
      function kt(e) {
        return {
          "-webkit-transform": e,
          "-moz-transform": e,
          "-ms-transform": e,
          transform: e,
        };
      }
      function Ot(t, e, n) {
        "all" !== e
          ? (p[n][e] = t)
          : Object.keys(p[n]).forEach(function (e) {
              p[n][e] = t;
            });
      }
      function Mt(e, t, n) {
        (E[e] = t), "internal" !== n && (D[e] = t);
      }
      function Ct() {
        var e = E.licenseKey,
          t = "font-size: 15px;background:yellow;";
        n
          ? e &&
            e.length < 20 &&
            (console.warn(
              "%c This website was made using fullPage.js slider. More info on the following website:",
              t
            ),
            console.warn("%c https://alvarotrigo.com/fullPage/", t))
          : (bn(
              "error",
              "Fullpage.js version 3 has changed its license to GPLv3 and it requires a `licenseKey` option. Read about it here:"
            ),
            bn("error", "https://github.com/alvarotrigo/fullPage.js#options")),
          Ln(u, Ft)
            ? bn(
                "error",
                "Fullpage.js can only be initialized once and you are doing it multiple times!"
              )
            : (E.continuousVertical &&
                (E.loopTop || E.loopBottom) &&
                ((E.continuousVertical = !1),
                bn(
                  "warn",
                  "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled"
                )),
              !E.scrollOverflow ||
                (!E.scrollBar && E.autoScrolling) ||
                bn(
                  "warn",
                  "Options scrollBar:true and autoScrolling:false are mutually exclusive with scrollOverflow:true. Sections with scrollOverflow might not work well in Firefox"
                ),
              !E.continuousVertical ||
                (!E.scrollBar && E.autoScrolling) ||
                ((E.continuousVertical = !1),
                bn(
                  "warn",
                  "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled"
                )),
              E.scrollOverflow &&
                null == E.scrollOverflowHandler &&
                ((E.scrollOverflow = !1),
                bn(
                  "error",
                  "The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js."
                )),
              Y.forEach(function (e) {
                E[e] &&
                  bn(
                    "warn",
                    "fullpage.js extensions require fullpage.extensions.min.js file instead of the usual fullpage.js. Requested: " +
                      e
                  );
              }),
              E.anchors.forEach(function (t) {
                var e = [].slice.call(yn("[name]")).filter(function (e) {
                    return (
                      e.getAttribute("name") &&
                      e.getAttribute("name").toLowerCase() == t.toLowerCase()
                    );
                  }),
                  n = [].slice.call(yn("[id]")).filter(function (e) {
                    return (
                      e.getAttribute("id") &&
                      e.getAttribute("id").toLowerCase() == t.toLowerCase()
                    );
                  });
                if (n.length || e.length) {
                  bn(
                    "error",
                    "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."
                  );
                  var o = n.length ? "id" : "name";
                  (n.length || e.length) &&
                    bn(
                      "error",
                      '"' +
                        t +
                        '" is is being used by another element `' +
                        o +
                        "` property"
                    );
                }
              }));
      }
      function Ht(t, n, o, r) {
        var e,
          i =
            (e = t).self != zt && Ln(e, sn)
              ? e.scrollLeft
              : !E.autoScrolling || E.scrollBar
              ? Un()
              : e.offsetTop,
          l = n - i,
          a = 0;
        z = !0;
        var s = function () {
          if (z) {
            var e = n;
            (a += 20),
              o && (e = zt.fp_easings[E.easing](a, i, l, o)),
              It(t, e),
              a < o ? setTimeout(s, 20) : void 0 !== r && r();
          } else a < o && r();
        };
        s();
      }
      function It(e, t) {
        !E.autoScrolling || E.scrollBar || (e.self != zt && Ln(e, sn))
          ? e.self != zt && Ln(e, sn)
            ? (e.scrollLeft = t)
            : e.scrollTo(0, t)
          : (e.style.top = t + "px");
      }
      function Bt(e, t) {
        (this.anchor = e.getAttribute("data-anchor")),
          (this.item = e),
          (this.index = In(e, t)),
          (this.isLast =
            this.index === e.parentElement.querySelectorAll(t).length - 1),
          (this.isFirst = !this.index);
      }
      function Rt(e) {
        Bt.call(this, e, qt);
      }
      function Nt(e) {
        Bt.call(this, e, ln);
      }
      Ct();
    }
  );
}),
  window.jQuery &&
    window.fullpage &&
    (function (t, n) {
      "use strict";
      t && n
        ? (t.fn.fullpage = function (e) {
            e = t.extend({}, e, { $: t });
            new n(this[0], e);
          })
        : window.fp_utils.showError(
            "error",
            "jQuery is required to use the jQuery fullpage adapter!"
          );
    })(window.jQuery, window.fullpage);
$("#fullpage").fullpage({
  anchors: [
    "page1",
    "page2",
    "page3",
    "page4",
    "page5",
    "page6",
    "page7",
    "page8",
    "page9",
  ],
  //sectionsColor: ['#C63D0F', '#1BBC9B', '#7E8F7C'],
  navigation: false,
  menu: "#menu",
  css3: true,
  easingcss3: "ease",
  easing: "easeInOutCubic",
});

setTimeout(function () {
  $(".product_left_icon_info_new").fadeOut();
}, 3000);
